import * as i2 from '@angular/common';
import { CommonModule, DatePipe } from '@angular/common';
import * as i1 from '@angular/common/http';
import { HttpHeaders, HttpParams, HttpRequest, HttpEventType, HttpClientModule, HttpUrlEncodingCodec } from '@angular/common/http';
import * as i0 from '@angular/core';
import { Injectable, Optional, InjectionToken, ApplicationRef, Injector, Inject, Component, EventEmitter, Directive, Output, NgModule, SkipSelf, Input, forwardRef, ChangeDetectionStrategy, ViewChild, inject, HostListener, ContentChild, APP_INITIALIZER } from '@angular/core';
import * as i2$2 from '@angular/router';
import { NavigationEnd, GuardsCheckStart, Router } from '@angular/router';
import * as i1$1 from '@gsa-sam/components';
import { SDS_DIALOG_DATA, SdsDialogModule, SDSAutocompletelConfiguration, SDSSelectedItemModel, SelectionMode, SdsAutocompleteModule, SdsToastModule, SdsStepArrowModule, SdsPopoverModule, SdsToastSettings, SdsDialogService } from '@gsa-sam/components';
import * as i3$1 from '@ng-idle/keepalive';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { Cookie } from 'ng2-cookies';
import * as i1$2 from 'ngx-bootstrap-icons';
import { NgxBootstrapIconsModule, threeDots, exclamationTriangle, dashCircle, hourglass, slashCircle, circle, checkSquareFill, circleFill, trash, pencilSquare, chevronDown, chevronUp, chatLeftDots, save, lightbulb, x, emojiSmile, emojiNeutral, emojiFrown, arrowRepeat } from 'ngx-bootstrap-icons';
import { shareReplay, first, mergeMap, map, tap, take, share, catchError, filter, debounce, timeout } from 'rxjs/operators';
import { defer, isObservable, of, BehaviorSubject, fromEvent, ReplaySubject, EMPTY, Subject, throwError, zip, timer, forkJoin } from 'rxjs';
import { UnleashClient } from 'unleash-proxy-client';
import * as i3 from '@gsa-sam/ngx-uswds-icons';
import { IconModule, alertWarning, alertError, check, checkCircle } from '@gsa-sam/ngx-uswds-icons';
import * as i2$1 from '@ng-idle/core';
import { DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { BroadcastChannel } from 'broadcast-channel';
import { DefaultPrivacyLevel, datadogRum } from '@datadog/browser-rum';
import * as i4 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule, FormGroup } from '@angular/forms';
import { A11yModule } from '@angular/cdk/a11y';
import * as i1$3 from '@gsa-sam/sam-formly';
import { AbstractSdsFormly, SdsFormlyModule, sdsWrappers, SdsFormlyTypes, FormlyUtilsService, multiCheckboxRequired } from '@gsa-sam/sam-formly';
import { merge, cloneDeep } from 'lodash';
import { ComponentPortal } from '@angular/cdk/portal';
import { filter as filter$1 } from 'lodash-es';
import { SdsLandingListComponent } from '@gsa-sam/layouts';
import * as i2$3 from 'ngx-toastr';
import { ToastrService, ToastrModule } from 'ngx-toastr';
import * as i1$4 from '@ngx-formly/core';
import { FieldWrapper, FormlyModule, FieldType } from '@ngx-formly/core';

class SessionConfig {
}

const AuthCookieName = 'SESSION';
const OppCookieName = 'OPP_FRONTEND_ACCESS';
const XsrfCookieName = 'XSRF-TOKEN';
class AuthService {
    constructor(config, http) {
        this.config = config;
        this.http = http;
        this.checkSession$ = null;
    }
    isSignedIn() {
        if (window.location.port === '4200') {
            return Cookie.check(AuthCookieName);
        }
        else {
            return Cookie.check(AuthCookieName) && Cookie.check(XsrfCookieName);
        }
    }
    isLoggedIn() {
        return this.isSignedIn();
    }
    signIn() {
        let path = this.loginProcess();
        if (window.location.port === '4200') {
            window.location.assign(`${path}/openid_connect_login`);
        }
        else {
            window.location.assign(`${path}/auth-terms-disclosure`);
        }
    }
    navigateToSignin() {
        let path = this.loginProcess();
        if (this.config.internalLoginHost === window.location.hostname) {
            window.location.assign(`${path}/oc_login_internal`);
        }
        else {
            window.location.assign(`${path}/openid_connect_login`);
        }
    }
    loginProcess() {
        Cookie.delete(OppCookieName);
        let path = '';
        if (window.location.port === '4200') {
            if (!this.config.gatewayUrl) {
                throw new Error('SessionModule requires a `gatewayUrl` in the configuration');
            }
            // This is done for local development only
            path = this.config.gatewayUrl;
        }
        return path;
    }
    signOut() {
        console.log('Auth service Signing out');
        Cookie.delete(OppCookieName);
        Cookie.delete('XSRF-TOKEN');
        Cookie.delete('S-CACHE');
        Cookie.delete('XSRF-TOKEN', "/");
        Cookie.delete('S-CACHE', "/");
        if (window.location.port === '4200') {
            // signout does not work locally because the auth token is required for signout, and we can't send the cookie
            // from local host to the auth server
            Cookie.delete(AuthCookieName);
            window.location.assign(``);
        }
        else {
            window.location.assign(`/signout`);
        }
    }
    signOutFrontendOnly() {
        Cookie.delete(OppCookieName);
        Cookie.delete(AuthCookieName);
        Cookie.delete(AuthCookieName, "/");
        Cookie.delete('XSRF-TOKEN');
        Cookie.delete('S-CACHE');
        Cookie.delete('XSRF-TOKEN', "/");
        Cookie.delete('S-CACHE', "/");
        Cookie.deleteAll("/");
        window.location.assign(`/`);
    }
    authToken() {
        return Cookie.get(AuthCookieName);
    }
    extendSession() {
        const random = new Date().getTime().toString();
        const params = {
            random
        };
        if (!this.config.production) {
            const apiKey = this.config.apiKey;
            params["api_key"] = apiKey;
        }
        const headers = {
            'X-Auth-Token': this.authToken()
        };
        const url = `${this.config.apiUrl}/iam/rms/v3/session`;
        this.http.get(url, { params, headers }).subscribe();
    }
    checkSession() {
        const random = new Date().getTime().toString();
        const params = {
            random
        };
        if (!this.config.production) {
            const apiKey = this.config.apiKey;
            params["api_key"] = apiKey;
        }
        const authToken = this.authToken();
        if (authToken) {
            const headers = {
                'X-Auth-Token': authToken
            };
            const url = `${this.config.apiUrl}/iam/rms/v4/session`;
            // Store V4 http call observable
            let session$;
            // Observable Factory function for RXJS Defer operator
            // If first operand is false, make a new V4 http call and assign it to 'session$'
            const createSession = () => session$ ||
                (session$ = this.http
                    .get(url, { params, headers })
                    .pipe(shareReplay(1, 3000))); // Share response with subsribers for 3 seconds
            // Make sure to provide the same checkSession Observable to every subscriber
            this.checkSession$ = this.checkSession$
                ? this.checkSession$
                : // We use defer operator to start the http call on subscription.
                    // session$ will live for 3 seconds and return one value, if it does not return a value
                    // it means that `session$` has expired and we need to create another defer observable
                    defer(createSession).pipe(first(null, defer(() => {
                        // This will make the first operand of CreateSession() false
                        // Thus triggering a new V4 http call
                        session$ = undefined;
                        // Pass observable factory function to defer
                        return createSession();
                    })), mergeMap((d) => (isObservable(d) ? d : of(d))));
            return this.checkSession$;
        }
        else {
            return of();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: AuthService, deps: [{ token: SessionConfig, optional: true }, { token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: AuthService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: AuthService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: SessionConfig, decorators: [{
                    type: Optional
                }] }, { type: i1.HttpClient }] });

// all angular environment variables only get processed as strings
class SystemConfigHeader {
}
class SystemConfigFooter {
}
class SystemAlertConfig {
}
const getExpiration = ((minutes) => {
    return new Date(new Date().getTime() + minutes * 60 * 1000);
});
const cookies = (minutes = 30) => {
    return {
        path: '/',
        expires: getExpiration(minutes),
    };
};

class WrapperService {
    constructor(_httpClient) {
        this._httpClient = _httpClient;
        this.APIs = {
            'avgWaitTime': "/helpdesk/v1",
            'contractOpportunity': '/opps/v2',
            'contractOpportunityV4': '/opps/v4',
            'opportunity3': '/opps/v3',
            'search': '/sgs/v1/search',
            'featuredSearch': '/sgs/v1/search/featured',
            'savedSearch': '/preferences/v1/search',
            'reportFavorites': '/preferences/v1/favorites',
            'reportSavedSearch': '/preferences/v1/report',
            'program': '/fac/v1/programs',
            'fh': '/federalorganizations/v1',
            'fh2': '/federalorganizations/v2',
            'federalHierarchy': '/federalorganizations/v1/organizations',
            'federalCreateOrg': '/federalorganizations/v1/organization',
            'federalHierarchyActive': '/federalorganizations/v1/activeorganizations',
            'featureToggle': '/feature/v1/read',
            'fhFeatureToggle': '/federalorganizations/feature/v1/read',
            'entityRegistration': '/view-details/v2/api/entity',
            'entities': '/view-details/v1/api/entity',
            'relatedEntities': '/entity-hierarchy/v1/api/exclusions-hierarchy',
            'exclusions': '/view-details/v1/api/exclusion',
            'awards': '/view-details/v1/api/award',
            'mydownloads': '/logging-service/v1/mydownloads-info',
            'downloadFile': '/logging-service/v1/file-download',
            'scrSubContractor': '/view-details/v2/api/entity/scr-sub-contractors',
            'bioProductsFor': '/view-details/v2/api/entity/bio-preferred-products',
            'deleteDownload': '/logging-service/v1/delete',
            'reRun': '/logging-service/v1/rerun',
            'unseenRecords': '/logging-service/v1/unseen-records',
            'alerts': '/alert/v2/alerts',
            'allAlerts': '/alert/v2/alerts/allAlerts',
            'suggestions': '/sgs/v1/suggestions',
            'functions': '/rms/v1/functions',
            'requestaccess': '/rms/v1/requestaccess',
            'accessstatus': '/rms/v1/accessstatus',
            'uiroles': '/rms/v2/uiroles',
            'permissions': '/rms/v1/permissions',
            'wageDetermination': '/wdol/v1',
            'modernizedWageDetermination': '/wdol',
            'location': '/locationservices/v1/api',
            'locationmock': '/locationservicesmock/v1/api',
            'domainDefinition': '/rms/v1/domaindefinition',
            'feedback': '/feedback/v1',
            'rms': '/rms/v1',
            'rms2': '/rms/v2',
            'sap': '/iam/cws/api/system-account-passwords',
            'relatedPrograms': '/fac/v1/programs/relatedprograms',
            'aac': '/aac/v1',
            'aac2': '/v2/aac',
            'searchDictionaries': '/sgs/v1/dictionaries',
            'preferences': '/preferences',
            'fileExtracts': '/fileextractservices/v1/api/listfiles',
            'fileExtractDownload': '/fileextractservices/v1/api/download',
            'userPicker': '/picker/v2/users',
            'userByEmail': '/rms/v1/userpickerdetails/',
            'userSearch': '/rms/v1/userpickerdetails/',
            'userFilter': '/rms/v1/userpicker/filter/',
            'iam': '/iam/auth/v4',
            'session': '/iam/rms/v4/session',
            'watchlist': '/watchlistservice/v1/api/recorddetail',
            'subscriptions': '/watchlistservice/v1/api/subscriptions',
            'myFeeds': '/feeds/v1',
            'gettoggeServices': '/feature/v1/',
            'cms': '/content/v1',
            'ui-export': '/ui-export-auth',
            'databank': '/databank/v1',
            'termsconditions': '/iam/cws/v1/applications/cwsterms-audit',
            'access': '/rms/v2/access',
            'logout': '/signout',
            'comment': '/comment/v1',
            'entity-information': '/entity-information/v1/api',
            'entity': '/rms/v1/autocomplete',
            'view-details': '/view-details/v1/api/entities'
        };
    }
    setEnvironment(env) {
        this.environment = env;
    }
    call(oApiParam, convertToJSON = true, queryEncoder = null, authenticatedCall = true) {
        return this.httpCall(oApiParam, convertToJSON, queryEncoder, authenticatedCall);
    }
    httpCall(oApiParam, convertToJSON = true, queryEncoder = null, authenticatedCall = true) {
        const method = oApiParam.method || 'GET';
        let responseType = oApiParam.responseType ? oApiParam.responseType : 'json';
        if (!convertToJSON && !oApiParam.responseType) {
            responseType = 'text';
        }
        let headers = new HttpHeaders(oApiParam.headers);
        let params = new HttpParams({
            encoder: queryEncoder
        });
        // add API-Umbrella key only in local development
        if (!this.environment.production) {
            params = params.set('api_key', this.environment.API_UMBRELLA_KEY);
        }
        // adding random parameter to fix IE caching issue
        if (method.toUpperCase() === 'GET') {
            params = params.set('random', new Date().getTime().toString());
        }
        // Adding X-Auth-Token to all calls
        if (!headers.has('X-Auth-Token') && authenticatedCall && Cookie.check('SESSION')) {
            headers = headers.append('X-Auth-Token', Cookie.get('SESSION'));
        }
        // loop through oParam & add them as request parameter
        for (const key in oApiParam.oParam) {
            let val = (typeof oApiParam.oParam[key] === 'object' && oApiParam.oParam[key] != null)
                ? JSON.stringify(oApiParam.oParam[key])
                : oApiParam.oParam[key];
            if (val === undefined || val === null) {
                val = '';
            }
            params = params.set(key, val);
        }
        const prefix = oApiParam.prefix || '';
        const middle = oApiParam.name ? this.APIs[oApiParam.name] : '';
        const suffix = oApiParam.suffix || '';
        let path = oApiParam.path
            ? `${this.environment.API_UMBRELLA_URL}${oApiParam.path}`
            : `${this.environment.API_UMBRELLA_URL}${prefix}${middle}${suffix}`;
        // DO this to point to local rms code
        // if (path.includes('/iam') || path.includes('/rms'))
        //     path = 'http://localhost:8083' + (oApiParam.path
        //         ? oApiParam.path
        //         : prefix+middle+suffix);
        let optionsObj = {
            headers: headers,
            observe: convertToJSON ? 'body' : 'response',
            reportProgress: oApiParam.reportProgress,
            params: params,
            body: oApiParam.method === 'DELETE' ? oApiParam.body : null,
            responseType: responseType,
            withCredentials: false
        };
        let addUnderscoreBody = res => {
            // legacy http code fix
            if (res && typeof res == 'object') {
                if (optionsObj.observe === 'response') {
                    res['_body'] = res['body'];
                }
                res.json = () => res.body;
            }
            return res;
        };
        if (oApiParam.reportProgress) {
            let oRequest = new HttpRequest(oApiParam.method, path, oApiParam.body, optionsObj);
            return this._httpClient
                .request(oRequest).pipe(map((res) => {
                if (res.type == HttpEventType.Response && convertToJSON) {
                    return res.body;
                }
                return res;
            }));
        }
        else {
            if (oApiParam && oApiParam.method && oApiParam.method.toUpperCase()) {
                oApiParam.method = oApiParam.method.toUpperCase();
            }
            switch (oApiParam.method) {
                case 'GET':
                    return this._httpClient.get(path, optionsObj).pipe(map(addUnderscoreBody));
                case 'POST':
                    return this._httpClient.post(path, oApiParam.body, optionsObj).pipe(map(addUnderscoreBody));
                case 'DELETE':
                    return this._httpClient.delete(path, optionsObj);
                case 'PATCH':
                    return this._httpClient.patch(path, oApiParam.body, optionsObj).pipe(map(addUnderscoreBody));
                case 'PUT':
                    return this._httpClient.put(path, oApiParam.body, optionsObj).pipe(map(addUnderscoreBody));
                case 'OPTIONS':
                    return this._httpClient.options(path, optionsObj);
                default:
                    return this._httpClient.get(path, optionsObj).pipe(map(addUnderscoreBody));
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: WrapperService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: WrapperService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: WrapperService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1.HttpClient }] });

const UnleashConfigToken = new InjectionToken('unleashConfig');

class UnleashToggleService {
    constructor(config, injector) {
        this.injector = injector;
        this.unleash = new UnleashClient(config);
        this.onReadySubject = new BehaviorSubject(null);
        this.onReadyObservable = this.onReadySubject.asObservable();
        fromEvent(this.unleash, 'ready').pipe(tap(() => {
            this.onReadySubject.next(true);
        })).subscribe();
        this.onInitialized = fromEvent(this.unleash, 'initialized').pipe(take(1), tap(() => {
            this.unleash.start();
        }), shareReplay({ bufferSize: 1, refCount: true }));
        this.onError = fromEvent(this.unleash, 'error').pipe(share());
        this.onUpdate = fromEvent(this.unleash, 'update').pipe(share());
        this.onImpression = fromEvent(this.unleash, 'impression').pipe(share());
        this.onUpdate.subscribe(() => {
            this.injector.get(ApplicationRef).tick();
        });
    }
    onReady() {
        return this.onReadyObservable;
    }
    isEnabled(toggleName) {
        return this.unleash.isEnabled(toggleName);
    }
    isEnabledObservable(toggleName) {
        const obs = new ReplaySubject(1);
        this.onReady().subscribe(isDone => {
            if (isDone) {
                obs.next(this.isEnabled(toggleName));
            }
        });
        return obs;
    }
    getVariant(toggleName) {
        return this.unleash.getVariant(toggleName);
    }
    updateContext(context) {
        return this.unleash.updateContext(context);
    }
    nonFedEnabled() {
        return this.unleash.isEnabled('rms_fe_non_fed_enabled');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: UnleashToggleService, deps: [{ token: UnleashConfigToken }, { token: Injector }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: UnleashToggleService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: UnleashToggleService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [UnleashConfigToken]
                }] }, { type: i0.Injector, decorators: [{
                    type: Inject,
                    args: [Injector]
                }] }] });

class FeatureToggleService {
    constructor(oAPIService, unleashToggleService) {
        this.oAPIService = oAPIService;
        this.unleashToggleService = unleashToggleService;
        // keyMap: any = {
        //   'fh': {prefix: '/federalorganizations', suffix: '/fhenabled'},
        //   'cms': {prefix: '/cms', suffix: '/cmsuienabled'},
        //   'cmsBtn': {prefix: '/cms', suffix: '/cmsbuttonsenabled'},
        //   'wl': {prefix: '/wl', suffix: '/enablesubscription'},
        //   'nonfed-rm': { prefix: '/role', suffix: '/nonfed_role_mgmt_fe'}
        // };
        this.cachedResponse$ = new Map();
    }
    checkFeatureToggle(prefix, suffix) {
        const cacheKey = `${prefix.replace('/', '')}|${suffix.replace('/', '')}`;
        const oApiParam = {
            prefix: prefix,
            name: 'featureToggle',
            suffix: suffix,
            oParam: {},
            method: 'GET'
        };
        if (this.getCacheItem(cacheKey)) {
            return this.getCacheItem(cacheKey);
        }
        const observable = this.oAPIService.call(oApiParam).pipe(shareReplay(1), catchError(err => {
            this.cachedResponse$.delete(cacheKey);
            return EMPTY;
        }));
        this.setCacheItem(cacheKey, observable);
        return observable;
    }
    nonFedEnabled() {
        return this.unleashToggleService.isEnabled('rms_fe_non_fed_enabled');
    }
    setEnvironment(environment) {
        this.oAPIService.setEnvironment(environment);
    }
    getFeatureToggleList() {
        var oApiParam = {
            name: 'featureToggle',
            oParam: {},
            method: 'GET'
        };
        return this.oAPIService.call(oApiParam);
    }
    getCacheItem(key) {
        const cacheItem = this.cachedResponse$.get(key);
        if (!cacheItem) {
            return null;
        }
        // delete the cache item if it has expired
        if (cacheItem.expires <= Date.now()) {
            this.cachedResponse$.delete(key);
            return null;
        }
        return cacheItem?.observable;
    }
    setCacheItem(key, value) {
        const EXPIRES = Date.now() + 15000;
        this.cachedResponse$.set(key, { expires: EXPIRES, observable: value });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: FeatureToggleService, deps: [{ token: WrapperService }, { token: UnleashToggleService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: FeatureToggleService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: FeatureToggleService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: WrapperService }, { type: UnleashToggleService }] });

class LoginModalComponent {
    constructor(locationStrategy, dialogRef, authService, config, featureToggleService, unleashToggleService, data) {
        this.locationStrategy = locationStrategy;
        this.dialogRef = dialogRef;
        this.authService = authService;
        this.config = config;
        this.featureToggleService = featureToggleService;
        this.unleashToggleService = unleashToggleService;
        this.data = data;
        this.acceptButton = 'Agree';
        this.allowLogin = true;
        this.showLoginDisabledMessage = false;
        this.termsOfUseUrl = '/content/about/terms-of-use';
        this.featureToggleService.setEnvironment({
            "production": config.production,
            "API_UMBRELLA_KEY": config.apiKey,
            "API_UMBRELLA_URL": config.apiUrl
        });
        if (!this.unleashToggleService.isEnabled('rms_fe_allow_login')) {
            this.allowLogin = false;
            this.acceptButton = 'Disabled';
            this.showLoginDisabledMessage = true;
        }
        if (this.unleashToggleService.isEnabled('sam_ui_common_enable_alerts_cms')) {
            this.termsOfUseUrl = '/about/terms-of-use';
        }
    }
    ngOnInit() {
        this.logoSrc = this.locationStrategy.getBaseHref() + (this.data.assetsUrl || 'assets/img/trademark-logo-sam.svg');
    }
    onAccept() {
        this.authService.navigateToSignin();
    }
    onCancel() {
        this.dialogRef.close();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: LoginModalComponent, deps: [{ token: i2.LocationStrategy }, { token: i1$1.SdsDialogRef }, { token: AuthService }, { token: SystemConfigHeader }, { token: FeatureToggleService }, { token: UnleashToggleService }, { token: SDS_DIALOG_DATA }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: LoginModalComponent, selector: "ng-component", ngImport: i0, template: "<div class=\"sds-dialog-section--centered margin-y-205\">\r\n  <img src=\"{{ logoSrc }}\" alt=\"sam.gov logo\" width=\"170\" />\r\n</div>\r\n\r\n<div\r\n  sds-dialog-subtitle\r\n  class=\"sds-dialog-section font-sans-2xs text-semibold font-sans-md padding-left-1\"\r\n>\r\n  You must agree to the SAM.gov\r\n  <a href=\"{{termsOfUseUrl}}\" target=\"_blank\"\r\n    >Terms of Use\r\n    <span class=\"padding-right-1 usa-link--external font-body-md\"\r\n      ><span class=\"usa-sr-only\">- opens in a new window</span>\r\n    </span></a\r\n  >\r\n  to sign in. If you violate our Terms of Use, you may lose access to SAM.gov\r\n  and we may take other legal action.\r\n</div>\r\n\r\n<div sds-dialog-content class=\"sds-dialog-content--centered\">\r\n  <div\r\n    class=\"text-left padding-left-2 padding-top-2 font-sans-2xs line-height-sans-6 text-base\"\r\n  >\r\n    <p style=\"color: red\" *ngIf=\"showLoginDisabledMessage\">\r\n      <strong\r\n        ><em\r\n          >Login is currently disabled due to maintenance. Please try again\r\n          later!</em\r\n        ></strong\r\n      >\r\n    </p>\r\n  </div>\r\n  <div class=\"text-center padding-left-2 padding-top-1 font-sans-2xs\">\r\n    <div\r\n      class=\"grid-container border-2px padding-bottom-1 padding-left-1 padding-top-1 border-gold radius-md\"\r\n    >\r\n      <div class=\"grid-row grid-gap-2px\">\r\n        <div class=\"tablet:grid-col-1 mobile-lg:grid-col-6\">\r\n          <usa-icon [icon]=\"'alert-warning'\" class=\"text-warning\" [size]=\"'3x'\">\r\n          </usa-icon>\r\n        </div>\r\n        <div class=\"tablet:grid-col-11 mobile-lg:grid-col-6\">\r\n          <div class=\"font-sans-2xs font-sans-md text-left\">\r\n            Using another person\u2019s email address and password to access SAM.gov\r\n            is prohibited.\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<div sds-dialog-actions class=\"sds-dialog-section--centered margin-top-0\">\r\n  <button\r\n    class=\"usa-button usa-button--base bg-base-lighter\"\r\n    (click)=\"onCancel()\"\r\n  >\r\n    Cancel\r\n  </button>\r\n  <button\r\n    cdkFocusInitial\r\n    class=\"usa-button\"\r\n    (click)=\"onAccept()\"\r\n    *ngIf=\"allowLogin; else loginDisabled\"\r\n  >\r\n    {{ acceptButton }}\r\n  </button>\r\n  <ng-template #loginDisabled>\r\n    <button cdkFocusInitial class=\"usa-button usa-button--disabled\">\r\n      {{ acceptButton }}\r\n    </button>\r\n  </ng-template>\r\n</div>\r\n", dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.SdsDialogSubtitleDirective, selector: "[sds-dialog-subtitle], sds-dialog-subtitle, [sdsDialogSubtitle]" }, { kind: "directive", type: i1$1.SdsDialogContentDirective, selector: "[sds-dialog-content], sds-dialog-content, [sdsDialogContent]" }, { kind: "directive", type: i1$1.SdsDialogActionsDirective, selector: "[sds-dialog-actions], sds-dialog-actions, [sdsDialogActions]" }, { kind: "component", type: i3.IconComponent, selector: "usa-icon", inputs: ["icon", "rotate", "size", "classes", "skew"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: LoginModalComponent, decorators: [{
            type: Component,
            args: [{ template: "<div class=\"sds-dialog-section--centered margin-y-205\">\r\n  <img src=\"{{ logoSrc }}\" alt=\"sam.gov logo\" width=\"170\" />\r\n</div>\r\n\r\n<div\r\n  sds-dialog-subtitle\r\n  class=\"sds-dialog-section font-sans-2xs text-semibold font-sans-md padding-left-1\"\r\n>\r\n  You must agree to the SAM.gov\r\n  <a href=\"{{termsOfUseUrl}}\" target=\"_blank\"\r\n    >Terms of Use\r\n    <span class=\"padding-right-1 usa-link--external font-body-md\"\r\n      ><span class=\"usa-sr-only\">- opens in a new window</span>\r\n    </span></a\r\n  >\r\n  to sign in. If you violate our Terms of Use, you may lose access to SAM.gov\r\n  and we may take other legal action.\r\n</div>\r\n\r\n<div sds-dialog-content class=\"sds-dialog-content--centered\">\r\n  <div\r\n    class=\"text-left padding-left-2 padding-top-2 font-sans-2xs line-height-sans-6 text-base\"\r\n  >\r\n    <p style=\"color: red\" *ngIf=\"showLoginDisabledMessage\">\r\n      <strong\r\n        ><em\r\n          >Login is currently disabled due to maintenance. Please try again\r\n          later!</em\r\n        ></strong\r\n      >\r\n    </p>\r\n  </div>\r\n  <div class=\"text-center padding-left-2 padding-top-1 font-sans-2xs\">\r\n    <div\r\n      class=\"grid-container border-2px padding-bottom-1 padding-left-1 padding-top-1 border-gold radius-md\"\r\n    >\r\n      <div class=\"grid-row grid-gap-2px\">\r\n        <div class=\"tablet:grid-col-1 mobile-lg:grid-col-6\">\r\n          <usa-icon [icon]=\"'alert-warning'\" class=\"text-warning\" [size]=\"'3x'\">\r\n          </usa-icon>\r\n        </div>\r\n        <div class=\"tablet:grid-col-11 mobile-lg:grid-col-6\">\r\n          <div class=\"font-sans-2xs font-sans-md text-left\">\r\n            Using another person\u2019s email address and password to access SAM.gov\r\n            is prohibited.\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<div sds-dialog-actions class=\"sds-dialog-section--centered margin-top-0\">\r\n  <button\r\n    class=\"usa-button usa-button--base bg-base-lighter\"\r\n    (click)=\"onCancel()\"\r\n  >\r\n    Cancel\r\n  </button>\r\n  <button\r\n    cdkFocusInitial\r\n    class=\"usa-button\"\r\n    (click)=\"onAccept()\"\r\n    *ngIf=\"allowLogin; else loginDisabled\"\r\n  >\r\n    {{ acceptButton }}\r\n  </button>\r\n  <ng-template #loginDisabled>\r\n    <button cdkFocusInitial class=\"usa-button usa-button--disabled\">\r\n      {{ acceptButton }}\r\n    </button>\r\n  </ng-template>\r\n</div>\r\n" }]
        }], ctorParameters: () => [{ type: i2.LocationStrategy }, { type: i1$1.SdsDialogRef }, { type: AuthService }, { type: SystemConfigHeader }, { type: FeatureToggleService }, { type: UnleashToggleService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [SDS_DIALOG_DATA]
                }] }] });

class SessionService {
    constructor(config, idle, keepalive) {
        this.config = config;
        this.idle = idle;
        this.keepalive = keepalive;
        // 10 seconds is to account for time skew and lag between server and frontend, we get strange results if we call
        // /logout after we are logged out
        this._idleSeconds = 25 * 60 - 10;
        this._timeoutSeconds = 5 * 60 - 10;
        this._keepaliveSeconds = 25 * 60;
        // private _idleSeconds = 13 * 60 - 10;
        // private _timeoutSeconds = 2 * 60 - 10;
        // private _keepaliveSeconds = 13 * 60;
        // private _idleSeconds = 1 * 30;
        // private _timeoutSeconds = 1 * 30;
        // private _keepaliveSeconds = 1 * 30;
        this.idleState = 'Init';
        this.lastPing = new Date();
        this.sessionTimeout = new EventEmitter();
        this.sessionIdle = new EventEmitter();
        this.sessionPing = new EventEmitter();
        this.channel = new BroadcastChannel('SAM');
        if (config) {
            if (config.idleSeconds) {
                this._idleSeconds = config.idleSeconds;
            }
            if (config.timeoutSeconds) {
                this._timeoutSeconds = config.timeoutSeconds;
            }
            if (config.keepaliveSeconds) {
                this._keepaliveSeconds = config.keepaliveSeconds;
            }
            if (config.dataDog) {
                this.dataDog(config.dataDog);
            }
        }
        // after N seconds of inactivity, onIdleStart emits an event
        idle.setIdle(this._idleSeconds);
        // after N seconds of inactivity onTimeout emits an event
        idle.setTimeout(this._timeoutSeconds);
        // if the user is active, call onPing every N seconds
        keepalive.interval(this._keepaliveSeconds);
        idle.onInterrupt.subscribe(() => {
            this.postMessage('SAM Active');
        });
        idle.onIdleStart.subscribe(() => {
            this.idleState = 'Idle';
            this.sessionIdle.emit();
        });
        idle.onIdleEnd.subscribe(() => {
            this.idleState = 'Active';
        });
        idle.onTimeout.subscribe(() => {
            this.idleState = 'TimedOut';
            this.sessionTimeout.emit();
            this.idle.stop();
        });
        keepalive.onPing.subscribe(() => {
            this.lastPing = new Date();
            this.sessionPing.emit();
        });
        // setInterval(() => {
        //   this.debug();
        // }, 5000);
        /* This is useful if you want to present a countdown to the user */
        // idle.onTimeoutWarning.subscribe((countdown) => {
        //   this.idleState = 'Warning';
        //   console.log('onTimeoutWarning');
        //   //this.idleState = 'You will time out in ' + countdown + ' seconds!';
        //   //console.log(this.idleState);
        // });
        this.channel.onmessage = msg => {
            if (msg === 'MSTR Active' || msg.data === 'MSTR Active') {
                this.idle.watch();
            }
        };
    }
    start() {
        // sets the default interrupts, in this case, things like clicks, scrolls, and touches to the document
        this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
        this.idle.watch();
        this.idleState = 'Active';
    }
    clearInterrupts() {
        this.idle.clearInterrupts();
    }
    debug() {
        const now = new Date().toLocaleTimeString();
        const lastPing = this.lastPing ? this.lastPing.toLocaleTimeString() : '----------';
        let timeoutTime = localStorage.getItem('ng2Idle.main.expiry') || 0;
        if (timeoutTime) {
            timeoutTime = parseInt(timeoutTime, 10);
        }
        const timeoutString = new Date(timeoutTime).toLocaleTimeString();
        const state = this.idleState;
        console.log(`[${now}]\t${state}\tlastPing: ${lastPing}\ttimeoutAt: ${timeoutString}`);
    }
    postMessage(message) {
        this.channel.postMessage(message);
    }
    dataDog(config) {
        const defaultConfig = {
            applicationId: 'cfd5d0ea-6329-4017-97df-b52c8f17b941',
            clientToken: 'pub257f83118a7a5da1c7c6198954372b70',
            site: 'ddog-gov.com',
            service: 'sam-frontend',
            sessionSampleRate: 25,
            version: '1.0.0',
            sessionReplaySampleRate: 100,
            trackUserInteractions: true,
            trackResources: true,
            trackLongTasks: true,
            allowedTracingUrls: ["https://sam.gov/api"],
            defaultPrivacyLevel: DefaultPrivacyLevel.MASK,
        };
        if (config.env === 'disabled') {
            console.warn("[DataDog]: disabled");
        }
        else {
            datadogRum.init({ ...defaultConfig, ...config });
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SessionService, deps: [{ token: SessionConfig, optional: true }, { token: i2$1.Idle }, { token: i3$1.Keepalive }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.5", type: SessionService, outputs: { sessionTimeout: "sessionTimeout", sessionIdle: "sessionIdle", sessionPing: "sessionPing" }, ngImport: i0 }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SessionService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SessionService, decorators: [{
            type: Directive
        }, {
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: SessionConfig, decorators: [{
                    type: Optional
                }] }, { type: i2$1.Idle }, { type: i3$1.Keepalive }], propDecorators: { sessionTimeout: [{
                type: Output
            }], sessionIdle: [{
                type: Output
            }], sessionPing: [{
                type: Output
            }] } });

class TimeoutWarningModalComponent {
    constructor(dialogRef) {
        this.dialogRef = dialogRef;
        this.logout = new EventEmitter();
    }
    ngOnInit() {
    }
    onLogout() {
        this.logout.emit();
    }
    onContinue() {
        this.dialogRef.close();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: TimeoutWarningModalComponent, deps: [{ token: i1$1.SdsDialogRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: TimeoutWarningModalComponent, selector: "ng-component", outputs: { logout: "logout" }, ngImport: i0, template: "<div sds-dialog-title>\r\n  User Session Timeout\r\n</div>\r\n<div sds-dialog-content>\r\n  Your login session will expire in 5 mins due to inactivity. Do you want to stay signed in?\r\n</div>\r\n<div sds-dialog-actions>\r\n  <button class=\"usa-button usa-button--base bg-base-lighter\" (click)=\"onLogout()\">Logout</button>\r\n  <button cdkFocusInitial class=\"usa-button\" (click)=\"onContinue()\">Continue</button>\r\n</div>\r\n", dependencies: [{ kind: "directive", type: i1$1.SdsDialogTitleDirective, selector: "[sds-dialog-title], [sdsDialogTitle]", inputs: ["id"], exportAs: ["sdsDialogTitle"] }, { kind: "directive", type: i1$1.SdsDialogContentDirective, selector: "[sds-dialog-content], sds-dialog-content, [sdsDialogContent]" }, { kind: "directive", type: i1$1.SdsDialogActionsDirective, selector: "[sds-dialog-actions], sds-dialog-actions, [sdsDialogActions]" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: TimeoutWarningModalComponent, decorators: [{
            type: Component,
            args: [{ template: "<div sds-dialog-title>\r\n  User Session Timeout\r\n</div>\r\n<div sds-dialog-content>\r\n  Your login session will expire in 5 mins due to inactivity. Do you want to stay signed in?\r\n</div>\r\n<div sds-dialog-actions>\r\n  <button class=\"usa-button usa-button--base bg-base-lighter\" (click)=\"onLogout()\">Logout</button>\r\n  <button cdkFocusInitial class=\"usa-button\" (click)=\"onContinue()\">Continue</button>\r\n</div>\r\n" }]
        }], ctorParameters: () => [{ type: i1$1.SdsDialogRef }], propDecorators: { logout: [{
                type: Output
            }] } });

class SessionModule {
    constructor(parentModule, sessionService, authService, route, router, dialog) {
        this.sessionService = sessionService;
        this.authService = authService;
        this.route = route;
        this.router = router;
        this.dialog = dialog;
        this.RouteHistoryKey = 'lastVisitedRoute'; // this needs to be the same as what's in sam-front-end3 for handling route history
        this.IsIE = !!document['documentMode'];
        if (parentModule) {
            throw new Error('SessionModule is already loaded. Import it in the AppModule only');
        }
        // This is only necessary for local dev because our login service can't set cross domain cookies
        this.route.queryParams.subscribe(params => {
            if (params.xwq) {
                Cookie.set('SESSION', params.xwq);
                window.location.assign('/');
            }
        });
        // set the last visited route variable so that we can redirect back to the last visited page after login
        this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event) => {
            const pathAndParams = window.location.pathname + window.location.search + window.location.hash;
            this.setLastVisitedRoute(window.location.pathname, pathAndParams);
        });
        this.router.events.pipe(filter(event => event instanceof GuardsCheckStart)).subscribe({
            next: value => {
                const pathAndParams = window.location.pathname + window.location.search + window.location.hash;
                this.setLastVisitedRoute(window.location.pathname, pathAndParams);
            },
            error: err => { console.error('RouterEvent error: '); console.log(err); },
            complete: () => console.log('RouterEvent Completed')
        });
        if (this.authService.isLoggedIn()) {
            this.authService.checkSession().subscribe(succ => {
                // session was successfully extended
                this.sessionService.start();
            }, error => {
                this.authService.signOutFrontendOnly();
            });
        }
        else {
            Cookie.delete('SESSION');
        }
        this.sessionService.sessionPing.subscribe(() => {
            this.authService.extendSession();
        });
        this.sessionService.sessionIdle.subscribe(() => {
            this.sessionService.clearInterrupts();
            const modal = this.dialog.open(TimeoutWarningModalComponent, { width: 'small', alert: 'warning', disableClose: true });
            modal.componentInstance.logout.subscribe(() => {
                this.authService.signOut();
            });
            modal.afterClosed().subscribe(() => {
                this.sessionService.start();
            });
        });
        this.sessionService.sessionTimeout.subscribe(() => {
            this.authService.signOut();
        });
    }
    setLastVisitedRoute(baseUrl, url) {
        if (this.sessionService.config.lastVisitedRouteIgnored === undefined || this.sessionService.config.lastVisitedRouteIgnored.indexOf(baseUrl) === -1) {
            Cookie.set(this.RouteHistoryKey, url.toString(), 300, '/');
            if (this.IsIE) {
                localStorage.setItem(this.RouteHistoryKey, url);
            }
            else {
                sessionStorage.setItem(this.RouteHistoryKey, url);
            }
        }
    }
    static forRoot(config) {
        return {
            ngModule: SessionModule,
            providers: [
                { provide: SessionConfig, useValue: config }
            ]
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SessionModule, deps: [{ token: SessionModule, optional: true, skipSelf: true }, { token: SessionService }, { token: AuthService }, { token: i2$2.ActivatedRoute }, { token: i2$2.Router }, { token: i1$1.SdsDialogService }], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: SessionModule, declarations: [LoginModalComponent, TimeoutWarningModalComponent], imports: [CommonModule,
            SdsDialogModule,
            HttpClientModule,
            IconModule, i1$2.NgxBootstrapIconsModule, i3$1.NgIdleKeepaliveModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SessionModule, imports: [CommonModule,
            SdsDialogModule,
            HttpClientModule,
            IconModule,
            NgxBootstrapIconsModule.pick({ alertWarning }),
            NgIdleKeepaliveModule.forRoot()] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SessionModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [LoginModalComponent, TimeoutWarningModalComponent],
                    exports: [],
                    imports: [
                        CommonModule,
                        SdsDialogModule,
                        HttpClientModule,
                        IconModule,
                        NgxBootstrapIconsModule.pick({ alertWarning }),
                        NgIdleKeepaliveModule.forRoot()
                    ]
                }]
        }], ctorParameters: () => [{ type: SessionModule, decorators: [{
                    type: Optional
                }, {
                    type: SkipSelf
                }] }, { type: SessionService }, { type: AuthService }, { type: i2$2.ActivatedRoute }, { type: i2$2.Router }, { type: i1$1.SdsDialogService }] });

class SdsTextChildComponent {
    constructor() {
        this.itemsChange = new EventEmitter();
    }
    // Method to remove an item from the items array, emits an event that the parent component is listening for
    removeItem(index) {
        this.items.splice(index, 1);
        this.itemsChange.emit(this.items);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SdsTextChildComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: SdsTextChildComponent, selector: "sds-text-child", inputs: { items: "items" }, outputs: { itemsChange: "itemsChange" }, ngImport: i0, template: `
    <ng-container *ngIf="items">
      <span class="sds-tag sds-tag--chip margin-x-05" style="cursor:pointer;" *ngFor="let item of items; let i=index" (click)="removeItem(i)">{{item}} <small class="margin-left-05">(x)</small></span>
    </ng-container>
  `, isInline: true, dependencies: [{ kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SdsTextChildComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sds-text-child',
                    template: `
    <ng-container *ngIf="items">
      <span class="sds-tag sds-tag--chip margin-x-05" style="cursor:pointer;" *ngFor="let item of items; let i=index" (click)="removeItem(i)">{{item}} <small class="margin-left-05">(x)</small></span>
    </ng-container>
  `
                }]
        }], propDecorators: { items: [{
                type: Input
            }], itemsChange: [{
                type: Output
            }] } });

class SdsTextComponent {
    constructor(cd) {
        this.cd = cd;
        this.items = [];
        this.multiple = true;
        this._onChange = (_) => { };
        this._onTouched = () => { };
    }
    // Helper method to programatically add a value to the existing items array
    addItem(val) {
        if (this.multiple) {
            this.items = [...this.items, val];
            this.updateModel();
        }
    }
    // Method that is fired when the child component event notifies us that the items array has been modified within the child component
    updateItems($event) {
        this.updateModel();
    }
    // Helper method that gets a new instance of the model and notifies ControlValueAccessor that we have a new model for this FormControl (our custom component)
    updateModel() {
        const model = this.getModel();
        this._onChange(model);
    }
    // Helper method to return a new instance of an array that contains our items
    getModel() {
        return [...this.items];
    }
    // ControlValueAccessor (and Formly) is trying to update the value of the FormControl (our custom component) programatically
    // If there is a value we will just overwrite items
    // If there is no value we reset the items array to be empty
    writeValue(value) {
        if (value && value.length && this.items !== value) {
            this.items = value;
            this.cd.markForCheck();
        }
        else {
            this.items = [];
            this.cd.markForCheck();
        }
    }
    // ControlValueAccessor hook that lets us call this._onChange(var) to let the form know our variable has changed (in this case model)
    registerOnChange(fn) {
        this._onChange = fn;
    }
    // ControlValueAccessor hook (not used)
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SdsTextComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: SdsTextComponent, selector: "sds-text", providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => SdsTextComponent),
                multi: true
            }
        ], ngImport: i0, template: `
    <div>
      <input #searchInput class="usa-input display-inline-block" />
      <button class="usa-button margin-left-05 display-inline-block" (click)="addItem(searchInput.value); searchInput.value=''">Add Item</button>
    </div>

    <h4>Component Items</h4>
    <pre>{{ items | json }}</pre>

    <hr />

    <h4>Child Component Items <small>(click to remove)</small></h4>
    <sds-text-child [(items)]="items" (itemsChange)="updateItems($event)"></sds-text-child>
  `, isInline: true, dependencies: [{ kind: "component", type: SdsTextChildComponent, selector: "sds-text-child", inputs: ["items"], outputs: ["itemsChange"] }, { kind: "pipe", type: i2.JsonPipe, name: "json" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SdsTextComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sds-text',
                    template: `
    <div>
      <input #searchInput class="usa-input display-inline-block" />
      <button class="usa-button margin-left-05 display-inline-block" (click)="addItem(searchInput.value); searchInput.value=''">Add Item</button>
    </div>

    <h4>Component Items</h4>
    <pre>{{ items | json }}</pre>

    <hr />

    <h4>Child Component Items <small>(click to remove)</small></h4>
    <sds-text-child [(items)]="items" (itemsChange)="updateItems($event)"></sds-text-child>
  `,
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => SdsTextComponent),
                            multi: true
                        }
                    ],
                    changeDetection: ChangeDetectionStrategy.OnPush
                }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }] });

class SdsTextModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SdsTextModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: SdsTextModule, declarations: [SdsTextComponent, SdsTextChildComponent], imports: [CommonModule, A11yModule, FormsModule], exports: [SdsTextComponent, SdsTextChildComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SdsTextModule, imports: [CommonModule, A11yModule, FormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SdsTextModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, A11yModule, FormsModule],
                    exports: [SdsTextComponent, SdsTextChildComponent],
                    declarations: [SdsTextComponent, SdsTextChildComponent],
                    providers: []
                }]
        }] });

let apiKitGlobals = {
    requiresMstrLogout: false,
    requiredADCMstrLogout: false
};

class TabCommunicationService {
    constructor() {
        this.channel = new BroadcastChannel('SAM-TABS');
        this.subject = new Subject();
        this.channel.onmessage = msg => {
            this.subject.next(msg);
        };
    }
    listen() {
        return this.subject;
    }
    send(message) {
        this.channel.postMessage(message);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: TabCommunicationService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: TabCommunicationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: TabCommunicationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [] });

class AuthUserService {
    constructor(tabcommuncationservice) {
        this.tabcommuncationservice = tabcommuncationservice;
        this.userId = '';
    }
    setEnvironment(env) {
        this.environment = env;
    }
    isLoggedIn() {
        return Cookie.check('SESSION');
    }
    cleanUpLeftoverCookies() {
        if (!Cookie.check('SESSION')) {
            Cookie.delete('iPlanetDirectoryPro');
            Cookie.delete('IAMSession');
        }
        return;
    }
    clearSessionCookie() {
        Cookie.delete('SESSION');
        return;
    }
    signInUser() {
        // delete in case value is persisting from previous session, this will get reset
        let x = 2;
        Cookie.delete('OPP_FRONTEND_ACCESS');
        let path = '';
        // This is done for localhost:4200 developmenet only
        if (!this.environment.production && window.location.port !== '8080') {
            path = this.environment.LOCAL_DEV_GATEWAY_URL;
        }
        window.location.assign(`${path}/openid_connect_login`);
    }
    signInUserIAL2() {
        // delete in case value is persisting from previous session, this will get reset
        Cookie.delete('OPP_FRONTEND_ACCESS');
        Cookie.delete('SESSION');
        Cookie.delete('XSRF-TOKEN');
        let path = '';
        // This is done for localhost:4200 developmenet only
        if (!this.environment.production && window.location.port !== '8080') {
            path = this.environment.LOCAL_DEV_GATEWAY_URL;
        }
        window.location.assign(`${path}/identity-proof`);
    }
    signOutUser() {
        let path = '';
        console.log('Auth user service Signingout');
        this.mstrLogout();
        this.mstrADCLogout();
        Cookie.delete('OPP_FRONTEND_ACCESS');
        // This is done for localhost:4200 development only
        if (!this.environment.production && window.location.port !== '8080') {
            this.clearSessionCookie();
            path = this.environment.LOCAL_DEV_GATEWAY_URL;
        }
        this.tabcommuncationservice.channel.postMessage('LOGOUT');
        window.location.assign(`${path}/signout`);
    }
    getAuthToken() {
        if (Cookie.check('SESSION')) {
            return Cookie.get('SESSION');
        }
        return '';
    }
    setUserId(userId) {
        this.userId = userId;
    }
    getLoggedInUserId() {
        return this.userId;
    }
    setIsTempProfile(isTempProfile) {
        this.isTempProfile = isTempProfile;
    }
    getIsTempProfile() {
        return this.isTempProfile;
    }
    setIsUatSigned(isUatSigned) {
        this.isUatSigned = isUatSigned;
    }
    getIsUatSigned() {
        return this.isUatSigned;
    }
    setIsProfileComplete(isProfileComplete) {
        this.isProfileComplete = isProfileComplete;
    }
    getIsProfileComplete() {
        return this.isProfileComplete;
    }
    mstrLogout() {
        if (apiKitGlobals.requiresMstrLogout) {
            let logoutFrame = document.getElementById('mstrLogoutFrame');
            // create iframe if it doesn't exist
            if (!logoutFrame) {
                logoutFrame = document.createElement('iframe');
            }
            logoutFrame.setAttribute('hidden', 'true');
            logoutFrame.setAttribute('id', 'mstrLogoutFrame');
            logoutFrame.setAttribute('src', this.environment.REPORT_MICRO_STRATEGY_URL + this.environment.REPORT_MICRO_STRATEGY_SERVER + '&evt=3008&src=mstrWeb.3008');
            document.body.appendChild(logoutFrame);
            // remove the mstr-logout-iframe after 1 seconds
            setTimeout(() => {
                document.body.removeChild(logoutFrame);
            }, 1000);
            apiKitGlobals.requiresMstrLogout = false;
        }
    }
    mstrADCLogout() {
        if (apiKitGlobals.requiredADCMstrLogout) {
            let logoutFrame = document.getElementById('mstrADCLogoutFrame');
            let logoutOTDFrame = document.getElementById('mstrOTDLogoutFrame');
            // create iframe if it doesn't exist
            if (!logoutFrame) {
                logoutFrame = document.createElement('iframe');
            }
            if (!logoutOTDFrame) {
                logoutOTDFrame = document.createElement('iframe');
            }
            logoutFrame.setAttribute('hidden', 'true');
            logoutFrame.setAttribute('id', 'mstrADCLogoutFrame');
            logoutFrame.setAttribute('src', this.environment.REPORT_MICRO_STRATEGY_ADHOC_URL + this.environment.REPORT_MICRO_STRATEGY_SERVER + '&evt=3008&src=mstrWeb.3008');
            logoutOTDFrame.setAttribute('hidden', 'true');
            logoutOTDFrame.setAttribute('id', 'mstrOTDLogoutFrame');
            logoutOTDFrame.setAttribute('src', this.environment.REPORT_MICRO_STRATEGY_OTD_URL + this.environment.REPORT_MICRO_STRATEGY_SERVER + '&evt=3008&src=mstrWeb.3008');
            document.body.appendChild(logoutFrame);
            document.body.appendChild(logoutOTDFrame);
            // remove the mstr-logout-iframe after 1 seconds
            setTimeout(() => {
                document.body.removeChild(logoutFrame);
                document.body.removeChild(logoutOTDFrame);
            }, 1000);
            apiKitGlobals.requiredADCMstrLogout = false;
        }
    }
    setOppFrontEndAccess(value) {
        Cookie.set("OPP_FRONTEND_ACCESS", value.toString());
    }
    getOppFrontEndAccess() {
        return Cookie.get("OPP_FRONTEND_ACCESS") === 'true' ? true : false;
    }
    checkOppFrontEndAccessCookie() {
        return Cookie.check("OPP_FRONTEND_ACCESS");
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: AuthUserService, deps: [{ token: TabCommunicationService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: AuthUserService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: AuthUserService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: TabCommunicationService }] });

// In order to support '+' in query params...
class EmailAddressQueryEncoder extends HttpUrlEncodingCodec {
    encodeKey(k) {
        return encodeURIComponent(k);
    }
    encodeValue(v) {
        return encodeURIComponent(v);
    }
}
class UserAccessService {
    constructor(apiService, router, route, authUserService, auth) {
        this.apiService = apiService;
        this.router = router;
        this.route = route;
        this.authUserService = authUserService;
        this.auth = auth;
    }
    setEnvironment(env) {
        let wrapperEnv = { production: env.production, API_UMBRELLA_KEY: env.apiKey, API_UMBRELLA_URL: env.apiUrl };
        this.apiService.setEnvironment(wrapperEnv);
    }
    onSemDvModalConfirm() {
        let apiOptions = {
            name: 'rms',
            suffix: `/access/confirm/modal`,
            method: 'PUT',
        };
        return this.callApi(apiOptions, true);
    }
    getPendingInvites() {
        let apiOptions = {
            name: 'rms',
            suffix: '/invites/pending',
            method: 'GET',
            oParam: {},
        };
        return this.callApi(apiOptions, true, new EmailAddressQueryEncoder());
    }
    callApi(oApiParam, convertToJSON = true, queryEncoder = null) {
        this.addAuthHeader(oApiParam);
        return this.apiService.call(oApiParam, convertToJSON, queryEncoder).pipe(catchError((res) => {
            if (res && res.status === 401) {
                if (!this.router.url.match(/\/workspace/i)) {
                    let options = {
                        queryParams: merge({
                            redirect: this.router.url.replace(/\?.+$/, ''),
                        }, this.route.snapshot.queryParams),
                    };
                }
            }
            return throwError(res);
        }));
    }
    addAuthHeader(options) {
        options.headers = options.headers || {};
    }
    getUserDetailsFromSession() {
        return this.auth
            .checkSession()
            .pipe(tap((response) => {
            this.authUserService.setUserId(response['email']);
            this.authUserService.setIsTempProfile(response['isTempProfile']);
            this.authUserService.setIsUatSigned(response['isUatSigned']);
            this.authUserService.setIsProfileComplete(response['isProfileComplete']);
        }));
    }
    getUserInfoDetails(email) {
        let apiOptions = {
            name: 'rms',
            suffix: `/userinfo/${email}/`,
            method: 'GET',
        };
        return this.callApi(apiOptions, false);
    }
    updateUserDetails(email, body) {
        let apiOptions = {
            name: 'rms',
            suffix: `/updateuserprofile/${email}/`,
            method: 'PUT',
            body: body,
        };
        return this.callApi(apiOptions, false);
    }
    getFeatureToggle(flag) {
        let apiOptions = {
            prefix: '/role',
            name: 'featureToggle',
            suffix: `/${flag}`,
            method: 'GET',
        };
        return this.callApi(apiOptions, true);
    }
    getUserDomainTermsAgreement(loginId, domainId) {
        let apiOptions = {
            name: 'rms',
            suffix: `/userdomainterms/user/${loginId}/`,
            method: 'GET',
            oParam: {
                loginid: loginId,
                domainid: domainId,
            },
        };
        return this.callApi(apiOptions, true);
    }
    updateUserDomainTermsAgreement(loginId, domainId, termsAccepted) {
        let apiOptions = {
            name: 'rms',
            suffix: `/userdomainterms/create`,
            method: 'POST',
            oParam: {
                loginid: loginId,
                domainId: domainId,
                termsAccepted: termsAccepted,
            },
        };
        return this.callApi(apiOptions, true);
    }
    deactivateAccount(email) {
        let apiOptions = {
            name: 'rms',
            suffix: `/deleteuser/${email}/`,
            method: 'DELETE',
        };
        return this.callApi(apiOptions, false);
    }
    getAccess(userId, filterOptions, toJson) {
        toJson = toJson || false;
        let apiOptions = {
            name: 'access',
            suffix: '/' + userId + '/',
            method: 'GET',
            oParam: { fetchNames: 'true' },
        };
        if (filterOptions) {
            apiOptions.oParam = merge(apiOptions.oParam, filterOptions);
        }
        return this.callApi(apiOptions, toJson);
    }
    getDomains() {
        let apiOptions = {
            name: 'rms',
            method: 'GET',
            suffix: '/domains/',
        };
        this.addAuthHeader(apiOptions);
        return this.callApi(apiOptions);
    }
    getPermissions() {
        let apiOptions = {
            name: 'permissions',
            method: 'GET',
            suffix: '',
        };
        return this.callApi(apiOptions);
    }
    getFunctionById(id) {
        let apiOptions = {
            name: 'functions',
            method: 'GET',
            suffix: '/' + id + '/',
        };
        return this.callApi(apiOptions);
    }
    getRolesHistory(userId) {
        let apiOptions = {
            name: 'rms',
            method: 'GET',
            suffix: `/access/${userId}/timeline/`,
        };
        return this.callApi(apiOptions);
    }
    getRolesHistoryById(userId, historyId) {
        let apiOptions = {
            name: 'rms',
            method: 'GET',
            suffix: `/access/${userId}/timeline/${historyId}/`,
        };
        return this.callApi(apiOptions, true, new EmailAddressQueryEncoder());
    }
    // Deprecated but functional as of today
    postAccessDeprecated(body, userName, queryParams = {}) {
        let suffix = userName ? '/access/' + userName + '/' : '/access/';
        let apiOptions = {
            name: 'rms',
            suffix: suffix,
            method: 'POST',
            body: body,
            oParam: queryParams,
        };
        return this.callApi(apiOptions, false);
    }
    postAccess(body, queryParams = {}) {
        let suffix = '/access';
        let apiOptions = {
            name: 'rms',
            suffix: suffix,
            method: 'POST',
            body: body,
            oParam: queryParams,
        };
        return this.callApi(apiOptions, false);
    }
    validateORD(body, queryParams = {}) {
        let suffix = '/access/validate';
        let apiOptions = {
            name: 'rms',
            suffix: suffix,
            method: 'POST',
            body: body,
            oParam: queryParams,
        };
        return this.callApi(apiOptions, false);
    }
    putAccess(body) {
        let suffix = '/access';
        let apiOptions = {
            name: 'rms',
            suffix: suffix,
            method: 'PUT',
            body: body,
            oParam: {},
        };
        return this.callApi(apiOptions, false);
    }
    deleteAccess(body) {
        let apiOptions = {
            name: 'rms',
            suffix: '/access',
            method: 'DELETE',
            body: body,
            oParam: {},
        };
        return this.callApi(apiOptions, false);
    }
    postDomain(domain) {
        let apiOptions = {
            name: 'rms',
            suffix: '/domains/',
            method: 'POST',
            body: domain,
        };
        return this.callApi(apiOptions, false);
    }
    getDomainDefinition(mode, domainKey, roleKey, orgKey, userName) {
        let apiOptions = {
            name: 'domainDefinition',
            suffix: '/',
            method: 'GET',
            oParam: {},
        };
        if (mode) {
            apiOptions.oParam.mode = mode;
        }
        if (domainKey && domainKey.length > 0) {
            apiOptions.oParam.domainKey = domainKey;
        }
        if (roleKey) {
            apiOptions.oParam.roleKey = '' + roleKey;
        }
        if (orgKey) {
            apiOptions.oParam.orgKey = '' + orgKey;
        }
        if (userName) {
            apiOptions.oParam.user = userName;
        }
        return this.callApi(apiOptions, true, new EmailAddressQueryEncoder());
    }
    createObject(domainId, objectName, permissions, objectId) {
        let apiOptions = {
            name: 'domainDefinition',
            suffix: '/',
            method: 'POST',
            oParam: {},
        };
        let fun = {};
        if (objectId) {
            fun['id'] = objectId;
        }
        if (objectName) {
            fun['val'] = objectName;
        }
        apiOptions.body = {
            domain: {
                id: domainId,
            },
            functionMapContent: [
                {
                    function: fun,
                    permission: permissions,
                },
            ],
        };
        return this.callApi(apiOptions, false);
    }
    requestAccess(req, userName) {
        let apiOptions = {
            name: 'requestaccess',
            suffix: '/',
            method: 'POST',
            body: req,
        };
        return this.callApi(apiOptions, false);
    }
    putRole(obj) {
        let apiOptions = {
            name: 'domainDefinition',
            suffix: '/',
            method: 'POST',
            oParam: {},
            body: obj,
        };
        return this.callApi(apiOptions, false);
    }
    deleteFunction(domainKey, functionId) {
        let apiOptions = {
            name: 'functions',
            suffix: '/' + functionId + '/',
            method: 'Delete',
            oParam: {},
        };
        apiOptions.oParam.domainKey = domainKey;
        return this.callApi(apiOptions, false);
    }
    getPendingRequests(userId, queryParams = {}) {
        let apiOptions = {
            name: 'requestaccess',
            suffix: '/',
            method: 'GET',
            oParam: queryParams,
        };
        apiOptions.oParam.user = userId;
        return this.callApi(apiOptions, false).pipe(map((res) => {
            if (res.status === 204) {
                return [];
            }
            else {
                return res.json().userAccessRequestList;
            }
        }));
    }
    getPendingRequestById(requestId) {
        let apiOptions = {
            name: 'requestaccess',
            suffix: '/' + requestId + '/',
            method: 'GET',
            oParam: {},
        };
        return this.callApi(apiOptions);
    }
    getAccessStatus(view) {
        let apiOptions = {
            name: 'rms',
            suffix: '/accessstatus/',
            method: 'GET',
            oParam: {},
        };
        apiOptions.oParam.view = view;
        return this.callApi(apiOptions);
    }
    getRequestStatuses() {
        let apiOptions = {
            name: 'accessstatus',
            suffix: '/',
            method: 'GET',
            oParam: {},
        };
        return this.callApi(apiOptions);
    }
    updateRequest(requestId, updatedRequest) {
        let apiOptions = {
            name: 'requestaccess',
            suffix: '/' + requestId + '/',
            method: 'PUT',
            oParam: {},
            body: updatedRequest,
        };
        return this.callApi(apiOptions, false);
    }
    getAllRoles() {
        let apiOptions = {
            name: 'rms',
            suffix: '/roles/',
            method: 'GET',
            oParam: {},
        };
        return this.callApi(apiOptions);
    }
    getRequestorIds() {
        let apiOptions = {
            name: 'rms',
            suffix: '/autocomplete/requestorids/',
            method: 'GET',
            oParam: {},
        };
        return this.callApi(apiOptions);
    }
    getRequestAccess(username, statusKey, domainKey, order, page) {
        let apiOptions = {
            name: 'rms',
            suffix: '/requestaccess/',
            method: 'GET',
            oParam: {},
        };
        if (statusKey.length > 0) {
            apiOptions.oParam.statusKey = statusKey;
        }
        if (domainKey.length > 0) {
            apiOptions.oParam.domainKey = domainKey;
        }
        if (username.length) {
            apiOptions.oParam.user = username;
        }
        apiOptions.oParam.order = order;
        apiOptions.oParam.page = page;
        return this.callApi(apiOptions, true, new EmailAddressQueryEncoder());
    }
    validateUserInDirectory(id) {
        let apiOptions = {
            name: 'rms',
            suffix: '/userdirectory/email/validate',
            method: 'GET',
            oParam: {
                beenInvitedUserEmail: id,
            },
        };
        return this.callApi(apiOptions, true, new EmailAddressQueryEncoder());
    }
    // Get an array of users and show the access and show the Org, domains for that org, and roles for that domains
    getUserDirectory(filterOptions = {}, version = 'rms2', convertToJSON = true) {
        let apiOptions = {
            name: version,
            suffix: '/userdirectory/',
            method: 'GET',
            oParam: {},
        };
        if (filterOptions) {
            apiOptions.oParam = merge(apiOptions.oParam, filterOptions);
        }
        if (filterOptions['export'] === 'pdf') {
            apiOptions.responseType = 'blob';
            return this.callApi(apiOptions, convertToJSON, new EmailAddressQueryEncoder());
        }
        return this.callApi(apiOptions, convertToJSON, new EmailAddressQueryEncoder());
    }
    getAllUserRoles(uid, queryParams = {}) {
        let apiOptions = {
            name: 'rms',
            suffix: '/userprofile/' + uid + '/',
            method: 'GET',
            oParam: queryParams,
        };
        return this.callApi(apiOptions);
    }
    // used to determine admin level of logged in user
    getWidget() {
        let apiOptions = {
            name: 'rms',
            suffix: '/widget/',
            method: 'GET',
            oParam: {},
        };
        return this.callApi(apiOptions);
    }
    // used to determine admin level of logged in user
    getAdminLevel() {
        let apiOptions = {
            name: 'rms',
            suffix: '/checkaccess/',
            method: 'GET',
            oParam: {},
        };
        return this.callApi(apiOptions);
    }
    // used to determine whether the logged in user
    checkAccess(pageName, userId = '', requestId = '') {
        let apiOptions = {
            name: 'rms',
            suffix: '/checkaccess/',
            method: 'GET',
            oParam: {
                pageName: pageName,
            },
        };
        if (pageName.includes('users') && userId != null && userId !== '') {
            apiOptions.oParam.userId = userId;
        }
        if (requestId != null && requestId !== '')
            apiOptions.oParam.requestId = requestId;
        return this.callApi(apiOptions, false, new EmailAddressQueryEncoder());
    }
    getDomainCategoriesAndRoles() {
        let apiOptions = {
            name: 'rms',
            suffix: '/requestaccess/roles/',
            method: 'GET',
            oParam: {},
        };
        return this.callApi(apiOptions);
    }
    getUsers(queryParams = {}) {
        let apiOptions = {
            name: 'rms2',
            suffix: '/users/',
            method: 'GET',
            oParam: queryParams,
        };
        return this.callApi(apiOptions);
    }
    getUsersV1(queryParams = {}, orgs = []) {
        let apiOptions = {
            name: 'rms',
            suffix: '/users/',
            method: 'POST',
            oParam: queryParams,
            body: orgs,
        };
        return this.callApi(apiOptions);
    }
    findUsers(queryParams = {}) {
        let apiOptions = {
            name: 'rms',
            suffix: '/users/',
            method: 'GET',
            oParam: queryParams,
        };
        return this.callApi(apiOptions);
    }
    getOpenRequests(userId) {
        let apiOptions = {
            name: 'rms',
            suffix: '/openrequests/',
            method: 'GET',
            oParam: {},
        };
        apiOptions.oParam.user = userId;
        return this.callApi(apiOptions, true, new EmailAddressQueryEncoder());
    }
    getUserAutoComplete(query, isGov = true, page = 1, limit = 10) {
        let apiOptions = {
            name: 'rms',
            suffix: '/autocomplete/',
            method: 'GET',
            oParam: {},
        };
        apiOptions.oParam.query = query;
        if (!isGov) {
            apiOptions.oParam.limit = +limit;
            apiOptions.oParam.page = page;
        }
        return this.callApi(apiOptions);
    }
    getEntityAutoComplete(query, isGov = true, page = 1, limit = 10, isDefaultOrg = false, isAssignableOrg = false, userId = '', options = {}) {
        let apiOptions = {
            name: 'rms',
            suffix: '/autocomplete/entity',
            method: 'GET',
            oParam: {},
        };
        apiOptions.oParam = { ...options };
        apiOptions.oParam.query = query;
        apiOptions.oParam.isGov = isGov;
        apiOptions.oParam.isDefaultOrg = isDefaultOrg;
        apiOptions.oParam.isAssignedOrgs = isAssignableOrg;
        if (!isGov) {
            apiOptions.oParam.limit = +limit;
            apiOptions.oParam.page = page;
        }
        if (userId !== '') {
            apiOptions.oParam.userId = userId;
        }
        return this.callApi(apiOptions, true, new EmailAddressQueryEncoder());
    }
    getEntityById(entityId) {
        let apiOptions = {
            name: 'rms',
            suffix: '/entity/' + entityId,
            method: 'GET',
            oParam: {},
        };
        return this.callApi(apiOptions);
    }
    postRequestComment(requestId, message) {
        let suffix = `/requestaccess/${requestId}/comments/`;
        let apiOptions = {
            name: 'rms',
            suffix: suffix,
            method: 'POST',
            body: {
                content: message,
            },
        };
        return this.callApi(apiOptions);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: UserAccessService, deps: [{ token: WrapperService }, { token: i2$2.Router }, { token: i2$2.ActivatedRoute }, { token: AuthUserService }, { token: AuthService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: UserAccessService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: UserAccessService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: WrapperService }, { type: i2$2.Router }, { type: i2$2.ActivatedRoute }, { type: AuthUserService }, { type: AuthService }] });

class FHService {
    constructor(oAPIService, router, route, authUserService) {
        this.oAPIService = oAPIService;
        this.router = router;
        this.route = route;
        this.authUserService = authUserService;
    }
    setEnvironment(environment) {
        this.oAPIService.setEnvironment(environment);
        this.authUserService.setEnvironment(environment);
    }
    getOrganizations(queryParams = {}) {
        let oApiParam = {
            name: 'federalHierarchy',
            suffix: '',
            oParam: queryParams,
            method: 'GET'
        };
        return this.oAPIService.call(oApiParam);
    }
    getAccess(orgKey, toJson = false) {
        let apiOptions = {
            name: 'fh',
            suffix: '/admin/checkAccess',
            method: 'GET',
            oParam: {}
        };
        if (orgKey !== "") {
            apiOptions.oParam['orgKey'] = orgKey;
        }
        return this.callApi(apiOptions, toJson);
    }
    validateAAC(aacCode, fullParentPath) {
        let oApiParam = {
            name: 'fh2',
            suffix: '/validateAAC',
            oParam: {
                aacCode,
                fullParentPath
            },
            method: 'GET'
        };
        this.addAuthHeader(oApiParam);
        return this.oAPIService.call(oApiParam);
    }
    getFeatureToggle(toggle) {
        let oApiParam = {
            name: 'fhFeatureToggle',
            suffix: `/${toggle.toUpperCase()}`,
            oParam: {},
            method: 'GET'
        };
        this.addAuthHeader(oApiParam);
        return this.oAPIService.call(oApiParam);
    }
    getAccessV2(pageName, orgKey, toJson) {
        toJson = toJson || false;
        let apiOptions = {
            name: 'fh2',
            suffix: '/admin/checkAccess',
            method: 'GET',
            oParam: {
                pageName: pageName,
                orgKey: orgKey
            }
        };
        return this.callApi(apiOptions, toJson);
    }
    getOrganization(params) {
        let apiOptions = {
            name: 'fh',
            suffix: '/organizations',
            oParam: params,
            method: 'GET'
        };
        return this.callApi(apiOptions);
    }
    getValidateDomain$(domain, params) {
        return this.oAPIService.call({
            name: 'fh',
            suffix: '/organizations/validatedomain',
            method: 'GET',
            oParam: merge({ domain: domain }, params),
        }).pipe(catchError(response => {
            let data, observable;
            switch (response.status) {
                // Disable Toggle for Dev and Test Environemnts Catch (404 Status Codes)
                case 404:
                    observable = of({});
                    break;
                default:
                    data = response.json();
                    observable = throwError(data);
            }
            return observable;
        }));
    }
    validateDomain(orgKey, domain) {
        return this.getValidateDomain$(domain, { orgkey: orgKey });
    }
    validateDomainByFPDS(fpds, domain) {
        return this.getValidateDomain$(domain, { fpdscode: fpds });
    }
    // gets hierarchy details for new request officeTypeList
    // gets office details for update office request
    getOrgDetailsById(id, requestType) {
        let apiOptions = {
            name: 'fh2',
            suffix: '/profileDetails',
            oParam: { 'mode': requestType, 'orgKey': id },
            method: 'GET'
        };
        return this.callApi(apiOptions);
    }
    //gets organization with heirarchy data
    getOrganizationById(id, includeChildrenLevels, includeOrgTypes = false, status = 'all', pageSize = 10, pageNum = 1, orderBy = "asc", hasFPDS = false, sortBy = 'name') {
        var oApiParam = {
            name: '',
            suffix: '',
            oParam: {},
            method: 'GET'
        };
        // organizationId length >= 30 -> call opportunity org End Point
        if (id.length >= 30) {
            oApiParam.name = 'contractOpportunity';
            oApiParam.suffix = '/opportunities/organizations/' + id;
        }
        else { //organizationId less than 30 character then call Octo's FH End point
            oApiParam.name = 'federalHierarchy';
            oApiParam.suffix = ((includeChildrenLevels) ? '/hierarchy/' : '/') + id;
            oApiParam.oParam = {
                'sort': sortBy,
                'mode': 'slim'
            };
        }
        if (includeOrgTypes) {
            oApiParam.oParam['types'] = 'true';
        }
        if (status !== 'all') {
            oApiParam.oParam['status'] = status;
        }
        if (includeChildrenLevels) {
            oApiParam.oParam['limit'] = pageSize;
            oApiParam.oParam['offset'] = pageNum;
            oApiParam.oParam['order'] = orderBy;
        }
        if (hasFPDS) {
            oApiParam.oParam['has-fpds'] = 'true';
        }
        return this.oAPIService.call(oApiParam);
    }
    // TODO need to create common method for this with getOrganizationById having parameter slim mode on/off
    getOrganizationByIdForOpps(id, includeChildrenLevels, includeOrgTypes = false, status = 'all', pageSize = 10, pageNum = 1, orderBy = "asc", hasFPDS = false, sortBy = 'name') {
        var oApiParam = {
            name: '',
            suffix: '',
            oParam: {},
            method: 'GET'
        };
        // organizationId length >= 30 -> call opportunity org End Point
        if (id.length >= 30) {
            oApiParam.name = 'contractOpportunity';
            oApiParam.suffix = '/opportunities/organizations/' + id;
        }
        else { //organizationId less than 30 character then call Octo's FH End point
            oApiParam.name = 'federalHierarchy';
            oApiParam.suffix = ((includeChildrenLevels) ? '/hierarchy/' : '/') + id;
            oApiParam.oParam = {
                'sort': sortBy,
            };
        }
        if (includeOrgTypes) {
            oApiParam.oParam['types'] = 'true';
        }
        if (status !== 'all') {
            oApiParam.oParam['status'] = status;
        }
        if (includeChildrenLevels) {
            oApiParam.oParam['limit'] = pageSize;
            oApiParam.oParam['offset'] = pageNum;
            oApiParam.oParam['order'] = orderBy;
        }
        if (hasFPDS) {
            oApiParam.oParam['has-fpds'] = 'true';
        }
        return this.oAPIService.call(oApiParam);
    }
    // gets organization with heirarchy data
    getFHOrganizationById(id, includeChildrenLevels, includeOrgTypes = false, status = 'all', pageSize = 10, pageNum = 1, orderBy = "asc", hasFPDS = false) {
        var oApiParam = {
            name: '',
            suffix: '',
            oParam: {},
            method: 'GET'
        };
        // organizationId length >= 30 -> call opportunity org End Point
        if (id.length >= 30) {
            oApiParam.name = 'contractOpportunity';
            oApiParam.suffix = '/opportunities/organizations/' + id;
        }
        else { //organizationId less than 30 character then call Octo's FH End point
            oApiParam.name = 'federalHierarchy';
            oApiParam.suffix = ((includeChildrenLevels) ? '/hierarchy/' : '/') + id;
            oApiParam.oParam = {
                'sort': 'name',
                'mode': 'slim'
            };
        }
        if (includeOrgTypes) {
            oApiParam.oParam['types'] = 'true';
        }
        if (status !== 'all') {
            oApiParam.oParam['status'] = status;
        }
        if (includeChildrenLevels) {
            oApiParam.oParam['limit'] = pageSize;
            oApiParam.oParam['offset'] = pageNum;
            oApiParam.oParam['order'] = orderBy;
        }
        if (hasFPDS) {
            oApiParam.oParam['has-fpds'] = 'true';
        }
        return this.oAPIService.call(oApiParam);
    }
    getOrganizationsByIds(ids) {
        var oApiParam = {
            name: 'federalHierarchy',
            suffix: '',
            oParam: {
                'orgKey': ids,
                'sort': 'name',
                'mode': 'slim'
            },
            method: 'GET'
        };
        return this.oAPIService.call(oApiParam);
    }
    getOrganizationDetail(id) {
        var oApiParam = {
            name: 'fh2',
            suffix: '/organizations/' + id,
            oParam: {},
            method: 'GET'
        };
        return this.callApi(oApiParam, true);
    }
    getOrganizationView(id) {
        let oApiParam = {
            name: 'fh2',
            suffix: '/organizations/view/' + id,
            oParam: {},
            method: 'GET'
        };
        return this.callApi(oApiParam, true);
    }
    getOrganizationLogo(organizationAPI, cbSuccessFn, cbErrorFn) {
        organizationAPI.subscribe(org => {
            // Do some basic null checks
            if (org == null || org['_embedded'] == null || org['_embedded'][0] == null) {
                cbSuccessFn(null);
                return;
            }
            // base when no logo for a department
            if (typeof org['_embedded'][0]['_link']['logo'] == 'undefined' && org['_embedded'][0]['org'] != null && typeof org['_embedded'][0]['org']['parentOrgKey'] == 'undefined') {
                cbSuccessFn(null);
                return;
            }
            // Base case: If logo exists, save it to a variable and exit
            if (org['_embedded'][0]['_link'] != null && org['_embedded'][0]['_link']['logo'] != null && org['_embedded'][0]['_link']['logo']['href'] != null) {
                let response = {};
                let data = org['_embedded'][0]['org'];
                response['logo'] = org['_embedded'][0]['_link']['logo']['href'];
                response['info'] = (data['agencyName'] || data['name'] || data['orgKey'] || 'Organization') + ' Logo';
                cbSuccessFn(response);
                return;
            }
            // Recursive case: If parent orgranization exists, recursively try to load its logo
            if (org['_embedded'][0]['org'] != null && org['_embedded'][0]['org']['parentOrgKey'] != null) {
                this.getOrganizationLogo(this.getOrganizationById(org['_embedded'][0]['org']['parentOrgKey'], false), cbSuccessFn, cbErrorFn);
            }
        }, err => {
            cbErrorFn(err);
        });
    }
    getDepartments(hasFPDS = false) {
        let oApiParam = {
            name: 'federalHierarchy',
            suffix: '/departments/',
            method: 'GET',
            oParam: {}
        };
        if (hasFPDS) {
            oApiParam.oParam['has-fpds'] = 'true';
        }
        return this.oAPIService.call(oApiParam);
    }
    getDepartmentsByStatus(status) {
        let oApiParam = {
            name: 'federalHierarchy',
            suffix: '/activedepartment/',
            method: 'GET',
            oParam: {}
        };
        if (status !== 'active') {
            oApiParam.oParam['status'] = status;
        }
        return this.callApi(oApiParam, true);
    }
    getDepartmentAdminLanding(status) {
        let oApiParam = {
            name: 'fh',
            suffix: '/myOrganizations',
            method: 'GET',
            oParam: {}
        };
        if (status !== 'active') {
            oApiParam.oParam['status'] = status;
        }
        return this.callApi(oApiParam, true);
    }
    search(oData) {
        let oApiParam = {
            name: 'search',
            suffix: '/',
            oParam: {
                index: "fh",
                q: oData.keyword
            },
            method: 'GET'
        };
        if (oData['pageNum']) {
            oApiParam.oParam['page'] = oData['pageNum'];
        }
        if (oData['pageSize']) {
            oApiParam.oParam['size'] = oData['pageSize'];
        }
        if (oData['parentOrganizationId']) {
            oApiParam.oParam['qFilters'] = {
                parentOrganizationId: oData['parentOrganizationId']
            };
        }
        return this.oAPIService.call(oApiParam);
    }
    updateOrganization(org, isMove = false) {
        let apiOptions = {
            name: 'fh',
            suffix: '/org',
            method: 'PUT',
            oParam: {},
            body: org
        };
        if (isMove) {
            apiOptions.oParam['isMove'] = isMove;
        }
        return this.callApi(apiOptions, false);
    }
    updateOrganizationV2(org, isMove, movingOrgId, newParentOrgId, endDate) {
        let apiOptions = {
            name: 'fh2',
            suffix: '/org',
            method: 'PUT',
            oParam: {},
            body: org
        };
        if (isMove) {
            apiOptions.oParam['isMove'] = isMove;
        }
        if (movingOrgId) {
            apiOptions.oParam['movingOrgId'] = movingOrgId;
        }
        if (newParentOrgId) {
            apiOptions.oParam['newParentOrgId'] = newParentOrgId;
        }
        if (endDate) {
            apiOptions.oParam['endDate'] = endDate;
        }
        return this.callApi(apiOptions, true);
    }
    updateOrganizationSection(org, section, isMove, movingOrgId, newParentOrgId, endDate) {
        let apiOptions = {
            name: 'fh2',
            suffix: '/updateOrg',
            method: 'PUT',
            oParam: {},
            body: org
        };
        if (section) {
            apiOptions.oParam['section'] = section;
        }
        if (isMove) {
            apiOptions.oParam['isMove'] = isMove;
        }
        if (movingOrgId) {
            apiOptions.oParam['movingOrgId'] = movingOrgId;
        }
        if (newParentOrgId) {
            apiOptions.oParam['newParentOrgId'] = newParentOrgId;
        }
        if (endDate) {
            apiOptions.oParam['endDate'] = endDate;
        }
        return this.callApi(apiOptions, true);
    }
    createOrganization(org, fullParentPath, fullParentPathName) {
        let apiOptions = {
            name: 'federalCreateOrg',
            suffix: '',
            method: 'POST',
            body: org,
            oParam: {}
        };
        if (org.type !== "DEPARTMENT") {
            apiOptions.oParam = {
                'fullParentPath': fullParentPath,
                'fullParentPathName': fullParentPathName
            };
        }
        return this.callApi(apiOptions, true);
    }
    getFHSearchParams(myOrg, status, orderBy, sortBy, pageNum, limit, keyword, orgTypes, typeLookUp, orgAdmin) {
        let oParam = {};
        if (myOrg)
            oParam['myOrg'] = myOrg;
        if (status)
            oParam['status'] = status;
        if (orderBy)
            oParam['orderBy'] = orderBy;
        if (sortBy)
            oParam['sortBy'] = sortBy;
        if (pageNum)
            oParam['pageNum'] = pageNum;
        if (limit)
            oParam['limit'] = limit;
        if (keyword)
            oParam['q'] = keyword;
        if (orgTypes && orgTypes.length)
            oParam['orgTypes'] = orgTypes;
        if (typeLookUp)
            oParam['typeLookUp'] = typeLookUp;
        if (orgAdmin)
            oParam['orgAdmin'] = orgAdmin;
        return oParam;
    }
    getLandingPage(params) {
        let apiOptions = {
            name: 'fh2',
            suffix: '/landingPage',
            method: 'GET',
            oParam: params
        };
        return this.callApi(apiOptions, true);
    }
    createOrganizationV2(org, fullParentPath, fullParentPathName) {
        let apiOptions = {
            name: 'fh2',
            suffix: '/organization',
            method: 'POST',
            body: org,
            oParam: {}
        };
        if (org.type !== 'Dept/Ind Agency') {
            apiOptions.oParam = {
                'fullParentPath': fullParentPath,
                'fullParentPathName': fullParentPathName
            };
        }
        return this.callApi(apiOptions, true);
    }
    createOrganizationV2_New(org, fullParentPath, fullParentPathName) {
        let apiOptions = {
            name: 'fh2',
            suffix: '/createOrg',
            method: 'POST',
            body: org,
            oParam: {}
        };
        if (org.type !== 'Dept/Ind Agency') {
            apiOptions.oParam = {
                'fullParentPath': fullParentPath,
                'fullParentPathName': fullParentPathName
            };
        }
        return this.callApi(apiOptions, true);
    }
    validateOrganizationV2(org, fullParentPath, fullParentPathName) {
        let apiOptions = {
            name: 'fh2',
            suffix: '/validateOrg',
            method: 'POST',
            body: org,
            oParam: {}
        };
        if (org.type !== 'Dept/Ind Agency') {
            apiOptions.oParam = {
                'fullParentPath': fullParentPath,
                'fullParentPathName': fullParentPathName
            };
        }
        return this.callApi(apiOptions, true);
    }
    validateOfficeDetails(org, fullParentPath, fullParentPathName) {
        let apiOptions = {
            name: 'fh',
            suffix: '/requestOrg/validate',
            method: 'POST',
            body: org,
            oParam: {}
        };
        apiOptions.oParam = {
            'fullParentPath': fullParentPath,
            'fullParentPathName': fullParentPathName
        };
        return this.callApi(apiOptions, true);
    }
    submitOfficeRequest(org, fullParentPath, fullParentPathName) {
        let apiOptions = {
            name: 'fh',
            suffix: '/requestOrg',
            method: 'POST',
            body: org,
            oParam: {}
        };
        apiOptions.oParam = {
            'fullParentPath': fullParentPath,
            'fullParentPathName': fullParentPathName
        };
        return this.callApi(apiOptions, true);
    }
    getOfficeTypes() {
        let apiOptions = {
            name: 'fh2',
            suffix: '/officeTypeList',
            method: 'GET',
            oParam: {}
        };
        return this.callApi(apiOptions);
    }
    fhWidgetPageData(params) {
        const defaults = {
            pageNum: 1,
            limit: 10,
            days: 90,
            orderBy: 'name',
            sortBy: 'asc',
        };
        const options = {
            name: 'fh2',
            suffix: '/FHWidgetPageData',
            oParam: { ...defaults, ...params },
        };
        return this.callApi(options);
    }
    fhSearch2(params, options = {}) {
        let apiOptions = {
            name: 'fh',
            suffix: '/search',
            method: 'GET',
            oParam: {
                'q': params['q'],
                'pageNum': params['pageNum'],
                'pageSize': params['pageSize'],
                'orderBy': params['sort'],
                'ascending': 'asc',
            }
        };
        if (params['levels'] !== null)
            apiOptions.oParam['levels'] = params['levels'];
        if (params['status'] !== null)
            apiOptions.oParam['status'] = params['status'];
        if (params['orgType'] && params['orgType'].length > 0)
            apiOptions.oParam['orgType'] = params['orgType'].join(',');
        if (params['searchType'])
            apiOptions.oParam['searchType'] = params['searchType'];
        else
            apiOptions.oParam['searchType'] = 'general';
        if (params['parent'])
            apiOptions.oParam['parent'] = params['parent'];
        if (params['isDefaultDept'])
            apiOptions.oParam['defaultDept'] = 'true';
        if (params['depth'] !== 0)
            apiOptions.oParam['depth'] = params['depth'];
        if (params['exclusive'] !== null)
            apiOptions.oParam['exclusive'] = params['exclusive'];
        if (params['defaultRoles']) {
            apiOptions.oParam['defaultRoles'] = true;
            if (params['domain']) {
                apiOptions.oParam['domain'] = params['domain'];
            }
        }
        if (params['adminHierarchy']) {
            apiOptions.oParam['adminHierarchy'] = true;
            apiOptions.oParam['defaultRoles'] = false;
            if (params['domain']) {
                apiOptions.oParam['domain'] = params['domain'];
            }
        }
        if (params['adminRolesHierarchy']) {
            apiOptions.oParam['adminRolesHierarchy'] = params['adminRolesHierarchy'];
        }
        if ((params['adminRolesHierarchy'] && params['adminRolesHierarchy'] === 'hierarchy') ||
            params['adminHierarchy']) {
            if (params['domain']) {
                apiOptions.oParam['domain'] = params['domain'];
            }
            if (params['role']) {
                apiOptions.oParam['role'] = params['role'];
            }
        }
        if (options && options.withCount) {
            let countApiOptions = cloneDeep(apiOptions);
            countApiOptions.suffix = '/search/count';
            return zip(this.callApi(apiOptions, true), this.callApi(countApiOptions, true));
        }
        else {
            return this.callApi(apiOptions, true);
        }
    }
    fhSearch(q, pageNum, pageSize, status, levels, orgType, emailDomain = '', isCode = false, parent = null, isDefaultDept = false, depth = 0, exclusive = null, sort = 'level', isNameSearchType = false, defaultRoles = false, adminHierarchy = false, adminRolesHierarchy = '') {
        let apiOptions = {
            name: 'fh',
            suffix: '/search',
            method: 'GET',
            oParam: {
                'q': q,
                'pageNum': pageNum,
                'pageSize': pageSize,
                'orderBy': sort,
                'ascending': 'asc',
                'searchType': 'general'
            }
        };
        if (emailDomain !== '') {
            apiOptions.oParam['emailDomain'] = emailDomain;
        }
        if (levels !== null)
            apiOptions.oParam['levels'] = levels;
        if (status.length === 1)
            apiOptions.oParam['status'] = status[0];
        if (orgType && orgType.length > 0)
            apiOptions.oParam['orgType'] = orgType.join(',');
        if (isNameSearchType)
            apiOptions.oParam['searchType'] = 'name';
        if (isCode)
            apiOptions.oParam['searchType'] = 'code';
        if (parent)
            apiOptions.oParam['parent'] = parent;
        if (isDefaultDept)
            apiOptions.oParam['defaultDept'] = 'true';
        if (depth !== 0)
            apiOptions.oParam['depth'] = depth;
        if (exclusive !== null)
            apiOptions.oParam['exclusive'] = exclusive;
        if (defaultRoles) {
            apiOptions.oParam['defaultRoles'] = true;
        }
        if (adminHierarchy) {
            apiOptions.oParam['adminHierarchy'] = true;
            apiOptions.oParam['defaultRoles'] = false;
        }
        if (adminRolesHierarchy) {
            apiOptions.oParam['adminRolesHierarchy'] = adminRolesHierarchy;
        }
        return this.callApi(apiOptions, true);
    }
    fhSearchCount(q, searchType, status, levels, orgType, isCode = false, parent = null, isDefaultDept = false) {
        let apiOptions = {
            name: 'fh',
            suffix: '/search/count',
            method: 'GET',
            oParam: {
                'q': q,
                'searchType': searchType,
                'defaultDept': isDefaultDept,
            }
        };
        if (status.length === 1)
            apiOptions.oParam['status'] = status[0];
        if (orgType.length > 0)
            apiOptions.oParam['orgType'] = orgType.join(',');
        if (isCode)
            apiOptions.oParam['searchType'] = 'code';
        if (parent)
            apiOptions.oParam['parent'] = parent;
        return this.callApi(apiOptions, true);
    }
    getMyOrganization(orgKey, orgType) {
        if (orgType[0] === '2' || orgType.length === 0) {
            return this.getOrganizationById(orgKey, true);
        }
        else {
            return of({});
        }
    }
    getSearchFilterTypes() {
        let apiOptions = {
            name: 'federalHierarchy',
            suffix: '/type',
            method: 'GET',
            oParam: {}
        };
        return this.callApi(apiOptions, true);
    }
    getFHWidgetInfo(day) {
        const apiOptions = {
            name: 'fh2',
            suffix: '/FHWidget',
            method: 'GET',
            oParam: {
                days: day
            }
        };
        return this.callApi(apiOptions, true);
    }
    uploadAACFile(files) {
        let apiOptions = {
            name: 'fh',
            suffix: '/requestOrg/processXML',
            method: 'POST',
            body: files,
            oParam: {}
        };
        return this.callApi(apiOptions, true);
    }
    getSignedUrlForUploadAAC(filePath) {
        return this._callUrlService(filePath, 'PUT');
    }
    _callUrlService(path, method) {
        const apiOptions = {
            name: 'fh',
            suffix: '/requestOrg/presignedUrl',
            method: 'GET',
            oParam: {
                method: method,
                key: path,
            },
        };
        // const withHeader = this._addAuthHeader(params);
        return this.callApi(apiOptions, true);
        // return this.api.call(withHeader);
    }
    getFHSearchResultsDownloadLink(params) {
        const apiOptions = {
            name: 'fh2',
            suffix: '/orgdownload',
            method: 'GET',
            oParam: params,
            responseType: 'blob'
        };
        return this.callApi(apiOptions, true);
    }
    requestAAC(orgId, customAacCode) {
        let apiOptions = {
            name: 'fh2',
            suffix: '/aac',
            method: 'POST',
            oParam: {
                // nonproc: isProcure,
                orgKey: orgId,
                aacCode: customAacCode
            }
        };
        return this.callApi(apiOptions, true);
    }
    getAACDetail(orgId) {
        let oApiParam = {
            name: 'fh2',
            suffix: '/getAacDetails',
            oParam: { orgKey: orgId },
            method: 'GET'
        };
        return this.callApi(oApiParam, true);
    }
    moveOrganization(org, queryParams) {
        let oApiParam = {
            name: 'fh2',
            suffix: '/moveOrg',
            body: org,
            oParam: queryParams,
            method: 'PUT'
        };
        return this.callApi(oApiParam, true);
    }
    getOrganizationsForRoles() {
        let apiOptions = {
            name: 'fh',
            suffix: '/getOrgs',
            method: 'GET',
            oParam: {}
        };
        return this.callApi(apiOptions, true);
    }
    addAuthHeader(options) {
        let superToken = Cookie.get('superFHToken');
        let iPlanetCookie = this.authUserService.getAuthToken();
        if (iPlanetCookie) {
            Cookie.delete('superFHToken');
        }
        if (!iPlanetCookie && !superToken) {
            return;
        }
        options.headers = options.headers || {};
        options.headers['X-Auth-Token'] = iPlanetCookie || '***' + superToken;
    }
    callApi(oApiParam, convertToJSON = true) {
        this.addAuthHeader(oApiParam);
        return this.oAPIService
            .call(oApiParam, convertToJSON).pipe(catchError(res => {
            if (res.status === 401) {
                if (!this.router.url.match(/\/workspace/i)) {
                    this.authUserService.signInUser();
                }
            }
            return throwError(res);
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: FHService, deps: [{ token: WrapperService }, { token: i2$2.Router }, { token: i2$2.ActivatedRoute }, { token: AuthUserService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: FHService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: FHService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: WrapperService }, { type: i2$2.Router }, { type: i2$2.ActivatedRoute }, { type: AuthUserService }] });

let HierarchyLabels = [
    'Federal Hierarchy',
    'Dept / Ind. Agency',
    'Subtier',
    'Major Command',
    'Sub Command 1',
    'Sub Command 2',
    'Sub Command 3',
    'Office'
];

class AgencyPickerService {
    constructor() {
        /**
         * Filter update subject
         */
        this.updateFilterSource = new Subject();
        /**
         * Filter update subject
         */
        this.updateSelectionSource = new Subject();
        /**
         * Observable to subscribe to for get updates of the filter
         */
        this.filterUpdate = this.updateFilterSource.asObservable();
        /**
         * Observable to subscribe to for get updates of selections
         */
        this.selectionUpdate = this.updateSelectionSource.asObservable();
    }
    /**
     * Update the filter
     * @param filterData
     */
    updateFilter(filterData) {
        this.updateFilterSource.next(filterData);
    }
    /**
     * Update the selections
     * @param filterData
     */
    updateSelections(selectionData) {
        this.updateSelectionSource.next(selectionData);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: AgencyPickerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: AgencyPickerService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: AgencyPickerService, decorators: [{
            type: Injectable
        }] });

class HierarchyService {
    constructor(fhService) {
        this.fhService = fhService;
        this.level = 0;
        this.page = 1;
        this.pageSize = 25;
        this.internalCount = 0;
        this.ob = null;
        this.searchValue = null;
        this.endOfList = false;
        this.countFieldLevel = 7;
        this.simpleResponse = false; // true: limits model response to key/text fields. False: full model returned.
    }
    setEnvironment(environment) {
        this.fhService.setEnvironment(environment);
    }
    /**
     * Gets called by autocomplete components
     */
    getDataByText(currentItems, searchValue) {
        let status = "active";
        if (this.status && this.status.length > 0) {
            status = this.status;
        }
        if (currentItems > 0) {
            this.page += 1;
        }
        if (currentItems == 0) {
            this.page = 1;
            this.internalCount = 0;
            this.endOfList = false;
        }
        if (this.searchValue != searchValue) {
            this.endOfList = false;
        }
        if (this.filter && this.filter.status) {
            status = this.filter.status;
        }
        let requestObj = {
            q: searchValue,
            pageNum: this.page,
            pageSize: this.pageSize,
            status: status,
            orgType: []
        };
        if (this.level != 0) {
            switch (this.level) {
                case 1:
                    requestObj['orgType'].push('Dept/Ind Agency');
                    break;
                case 2:
                    requestObj['orgType'].push('Sub-Tier');
                    break;
                case 3:
                    requestObj['orgType'].push('Maj Command');
                    break;
                case 4:
                    requestObj['orgType'].push('Sub-Command 1');
                    if (this.hasFpds) {
                        requestObj['orgType'].push('Sub-Command 2');
                        requestObj['orgType'].push('Sub-Command 3');
                    }
                    break;
                case 5:
                    requestObj['orgType'].push('Sub-Command 2');
                    break;
                case 6:
                    requestObj['orgType'].push('Sub-Command 3');
                    break;
                case 7:
                    requestObj['orgType'].push('Office');
                    break;
            }
            requestObj['sort'] = 'level';
        }
        else {
            switch (this.countFieldLevel) {
                case 1:
                    requestObj['orgType'].push('Dept/Ind Agency');
                    break;
                case 2:
                    requestObj['orgType'].push('Dept/Ind Agency');
                    requestObj['orgType'].push('Sub-Tier');
                    break;
                case 3:
                    requestObj['orgType'].push('Dept/Ind Agency');
                    requestObj['orgType'].push('Sub-Tier');
                    requestObj['orgType'].push('Maj Command');
                    break;
                case 4:
                    requestObj['orgType'].push('Dept/Ind Agency');
                    requestObj['orgType'].push('Sub-Tier');
                    requestObj['orgType'].push('Maj Command');
                    requestObj['orgType'].push('Sub-Command 1');
                    break;
                case 5:
                    requestObj['orgType'].push('Dept/Ind Agency');
                    requestObj['orgType'].push('Sub-Tier');
                    requestObj['orgType'].push('Maj Command');
                    requestObj['orgType'].push('Sub-Command 1');
                    requestObj['orgType'].push('Sub-Command 2');
                    break;
                case 6:
                    requestObj['orgType'].push('Dept/Ind Agency');
                    requestObj['orgType'].push('Sub-Tier');
                    requestObj['orgType'].push('Maj Command');
                    requestObj['orgType'].push('Sub-Command 1');
                    requestObj['orgType'].push('Sub-Command 2');
                    requestObj['orgType'].push('Sub-Command 3');
                    break;
                case 7:
                    requestObj['orgType'].push('Dept/Ind Agency');
                    requestObj['orgType'].push('Sub-Tier');
                    requestObj['orgType'].push('Maj Command');
                    requestObj['orgType'].push('Sub-Command 1');
                    requestObj['orgType'].push('Sub-Command 2');
                    requestObj['orgType'].push('Sub-Command 3');
                    requestObj['orgType'].push('Office');
                    break;
            }
            requestObj['sort'] = 'type';
        }
        // this is needed for main autocomplete, NOT advanced filters
        if (this.excludesNamedOrg) {
            requestObj['parent'] = this.excludesNamedOrg;
        }
        // this is needed for advanced modal filters
        if (this.parent) {
            requestObj['parent'] = this.parent;
        }
        if (this.isDefaultDept) {
            requestObj['isDefaultDept'] = this.isDefaultDept;
        }
        if (this.lockOnRoleAdminHierarchy) {
            if (this.lockOnRoleAdminHierarchy == 'hierarchyBelow') {
                requestObj['adminHierarchy'] = true;
            }
            else {
                requestObj['adminRolesHierarchy'] = this.lockOnRoleAdminHierarchy;
            }
        }
        if (this.domain) {
            requestObj['domain'] = this.domain;
        }
        if (this.role) {
            requestObj['role'] = this.role;
        }
        if (this.levels) {
            requestObj['levels'] = this.levels;
        }
        if (this.adminHierarchy) {
            requestObj['adminHierarchy'] = this.adminHierarchy;
        }
        if (this.defaultRoles) {
            requestObj['defaultRoles'] = this.defaultRoles;
        }
        if (!this.endOfList || !this.ob) {
            this.searchValue = searchValue;
            this.ob = this.fhService.fhSearch2(requestObj, {
                withCount: true
            }).pipe(debounce(() => timer(1000)), map(response => {
                let data = response[0];
                let totalCount = response[1];
                let result = [];
                if (data && data['_embedded']) {
                    result = data['_embedded'].map(item => {
                        //temporary until fixed in common component
                        item['org']['code,name'] = item['org']['code'];
                        return item['org'];
                    });
                }
                this.internalCount += result.length;
                this.ob = null;
                if (result.length == 0) {
                    this.endOfList = true;
                }
                else {
                    result = this.getResponseArraySelector(result, this.simpleResponse);
                }
                return {
                    items: result,
                    totalItems: totalCount
                };
            }));
            return this.ob;
        }
        return of({
            items: [],
            totalItems: this.internalCount
        });
    }
    getResponseArraySelector(result, returnSimpleResponse) {
        let newArray = new Array();
        for (let fullObj of result) {
            newArray.push(this.getResponseObject(fullObj, returnSimpleResponse));
        }
        return newArray;
    }
    getResponseObject(fullObj, returnSimpleResponse) {
        const orgText = this.getOrgLabelSelector(fullObj);
        const levelText = this.getLevelLabelSelector(fullObj);
        if (returnSimpleResponse) { // Return only key/text fields; add text properties
            let obj = {};
            obj['orgKey'] = fullObj['orgKey'];
            obj['orgText'] = orgText;
            obj['levelText'] = levelText;
            return obj;
        }
        else { // Return full object, add text properties
            fullObj['orgText'] = orgText;
            fullObj['levelText'] = levelText;
            return fullObj;
        }
    }
    getOrgLabelSelector(item) {
        //{{getOrgLabel(item,'code')}} - {{getOrgLabel(item,'name')}}
        let label = "";
        if (item['modStatus'] == 'INACTIVE') {
            label += "*";
        }
        let code = "";
        if (this.hasFpds) {
            if (item && item["type"] === 'OFFICE') {
                code = item["aacCode"] || item["fpdsOrgId"] || item["fpdsCode"] || item["code"] || item["cfdaCode"];
            }
            else if (item && (item["type"] !== "DEPARTMENT" && item["type"] !== "AGENCY")) {
                code = item["fpdsOrgId"] || item["fpdsCode"] || item["code"] || item["cfdaCode"];
            }
            else {
                code = item["fpdsCode"] || item["fpdsOrgId"] || item["code"] || item["cfdaCode"];
            }
        }
        else {
            code = item["code"];
        }
        if (code) {
            label += code;
        }
        if (item['name']) {
            label += ' - ' + item['name'];
        }
        return label;
    }
    getLevelLabelSelector(item) {
        if (item == null)
            return "";
        let actualLevel = item.level;
        if (item.type === "OFFICE") {
            actualLevel = 7;
        }
        return HierarchyLabels[actualLevel];
    }
    /**
     * Gets called by table component
     */
    // tslint:disable-next-line: max-line-length
    getDataSearchTerms(filterParams, currentItems, searchValue, countFieldLevel) {
        this.filter = filterParams;
        let status = "active";
        if (this.status && this.status.length > 0) {
            status = this.status;
        }
        if (currentItems > 0) {
            this.page += 1;
        }
        if (currentItems == 0) {
            this.page = 1;
            this.internalCount = 0;
            this.endOfList = false;
        }
        if (this.filter && this.filter.status) {
            status = this.filter.status;
        }
        let requestObj = {
            pageNum: this.page,
            pageSize: this.pageSize,
            status: status,
            sort: 'type'
        };
        if (countFieldLevel != 0) {
            requestObj['orgType'] = [];
            if (countFieldLevel == 1) {
                requestObj['orgType'].push('Dept/Ind Agency');
            }
            else if (countFieldLevel == 2) {
                requestObj['orgType'].push('Dept/Ind Agency');
                requestObj['orgType'].push('Sub-Tier');
            }
            else if (countFieldLevel == 3) {
                requestObj['orgType'].push('Dept/Ind Agency');
                requestObj['orgType'].push('Sub-Tier');
                requestObj['orgType'].push('Maj Command');
            }
            else if (countFieldLevel == 4) {
                requestObj['orgType'].push('Dept/Ind Agency');
                requestObj['orgType'].push('Sub-Tier');
                requestObj['orgType'].push('Maj Command');
                requestObj['orgType'].push('Sub-Command 1');
            }
            else if (countFieldLevel == 5) {
                requestObj['orgType'].push('Dept/Ind Agency');
                requestObj['orgType'].push('Sub-Tier');
                requestObj['orgType'].push('Maj Command');
                requestObj['orgType'].push('Sub-Command 1');
                requestObj['orgType'].push('Sub-Command 2');
            }
            else if (countFieldLevel == 6) {
                requestObj['orgType'].push('Dept/Ind Agency');
                requestObj['orgType'].push('Sub-Tier');
                requestObj['orgType'].push('Maj Command');
                requestObj['orgType'].push('Sub-Command 1');
                requestObj['orgType'].push('Sub-Command 2');
                requestObj['orgType'].push('Sub-Command 3');
            }
            else if (countFieldLevel == 7) {
                requestObj['orgType'].push('Dept/Ind Agency');
                requestObj['orgType'].push('Sub-Tier');
                requestObj['orgType'].push('Maj Command');
                requestObj['orgType'].push('Sub-Command 1');
                requestObj['orgType'].push('Sub-Command 2');
                requestObj['orgType'].push('Sub-Command 3');
                requestObj['orgType'].push('Office');
            }
        }
        if (filterParams) {
            if (this.excludesNamedOrg) {
                requestObj['parent'] = this.excludesNamedOrg;
            }
            else if (this.extractOrgFromFilter('1')) {
                requestObj['parent'] = this.extractOrgFromFilter('1');
            }
            if (this.extractOrgFromFilter('2')) {
                requestObj['parent'] = this.extractOrgFromFilter('2');
            }
            if (this.extractOrgFromFilter('3')) {
                requestObj['parent'] = this.extractOrgFromFilter('3');
            }
            if (this.extractOrgFromFilter('4')) {
                requestObj['parent'] = this.extractOrgFromFilter('4');
            }
            if (this.extractOrgFromFilter('5')) {
                requestObj['parent'] = this.extractOrgFromFilter('5');
            }
            if (this.extractOrgFromFilter('6')) {
                requestObj['parent'] = this.extractOrgFromFilter('6');
            }
            if (this.extractOrgFromFilter('7')) {
                requestObj['parent'] = this.extractOrgFromFilter('7');
            }
        }
        if (this.isDefaultDept) {
            requestObj['isDefaultDept'] = this.isDefaultDept;
        }
        if (this.lockOnRoleAdminHierarchy) {
            if (this.lockOnRoleAdminHierarchy == 'hierarchyBelow') {
                requestObj['adminHierarchy'] = true;
            }
            else {
                requestObj['adminRolesHierarchy'] = this.lockOnRoleAdminHierarchy;
            }
        }
        if (this.domain) {
            requestObj['domain'] = this.domain;
        }
        if (this.role) {
            requestObj['role'] = this.role;
        }
        if (this.adminHierarchy) {
            requestObj['adminHierarchy'] = this.adminHierarchy;
        }
        if (this.defaultRoles) {
            requestObj['defaultRoles'] = this.defaultRoles;
        }
        if (!this.endOfList || !this.ob) {
            this.ob = this.fhService.fhSearch2(requestObj).pipe(map(data => {
                let result = [];
                if (data && data['_embedded']) {
                    result = data['_embedded'].map(item => {
                        return item['org'];
                    });
                }
                if (this.page == 1) {
                    if (this.filter && this.filter['7'] && this.filter['7'] && this.filter['7'].length > 0) {
                        result.unshift(this.filter['7'][0]);
                    }
                    else if (this.filter && this.filter['4'] && this.filter['4'] && this.filter['4'].length > 0) {
                        result.unshift(this.filter['4'][0]);
                    }
                    else if (this.filter && this.filter['3'] && this.filter['3'] && this.filter['3'].length > 0) {
                        result.unshift(this.filter['3'][0]);
                    }
                    else if (this.filter && this.filter['2'] && this.filter['2'] && this.filter['2'].length > 0) {
                        result.unshift(this.filter['2'][0]);
                    }
                    else if (this.filter && this.filter['1'] && this.filter['1'] && this.filter['1'].length > 0) {
                        result.unshift(this.filter['1'][0]);
                    }
                }
                this.internalCount += result.length;
                this.ob = null;
                if (result.length == 0) {
                    this.endOfList = true;
                }
                let totalItems = this.endOfList ? this.internalCount : this.internalCount + 1;
                return {
                    items: result,
                    totalItems: totalItems
                };
            }));
            return this.ob;
        }
        return of({
            items: [],
            totalItems: this.internalCount
        });
    }
    extractOrgFromFilter(level) {
        if (this.filter[level] && this.filter[level] && this.filter[level].length > 0) {
            return this.filter[level][0]['orgKey'];
        }
        return null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: HierarchyService, deps: [{ token: FHService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: HierarchyService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: HierarchyService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: FHService }] });

class AgencyTableComponent {
    constructor(service, agencyPickerService) {
        this.service = service;
        this.agencyPickerService = agencyPickerService;
        this.settings = new SDSAutocompletelConfiguration(); //TODO SamHierarchicalConfiguration = new SamHierarchicalConfiguration();
        this.filter = {};
        this.checkedCounter = 0;
        this.scrollCall = false;
        this.isResultsLoaded = false;
        this.level = 0;
        this.inputType = "checkbox";
        this.excludesNamedOrg = '';
        this.isDefaultDept = false;
        this.lockOnRoleAdminHierarchy = '';
        this.adminHierarchy = false;
        this.defaultRoles = false;
        this.domain = '';
        this.status = 'active';
        this.itemChecked = new EventEmitter;
        this.countFieldLevel = 7;
        this.hasFpds = false;
        this.role = '';
        this.service.level = this.level;
    }
    ngOnChanges(c) {
        if (c['lockOnRoleAdminHierarchy']) {
            this.service.lockOnRoleAdminHierarchy = this.lockOnRoleAdminHierarchy;
        }
        if (c['excludesNamedOrg']) {
            this.service.excludesNamedOrg = this.excludesNamedOrg;
        }
        if (c['isDefaultDept']) {
            this.service.isDefaultDept = this.isDefaultDept;
        }
        if (c['status']) {
            this.service.status = this.status;
        }
        if (c['domain']) {
            this.service.domain = this.domain;
        }
        if (c['role']) {
            this.service.role = this.role;
        }
        if (c['adminHierarchy']) {
            this.service.adminHierarchy = this.adminHierarchy;
        }
        if (c['defaultRoles']) {
            this.service.defaultRoles = this.defaultRoles;
        }
    }
    ngAfterViewInit() {
        this.subscription = this.agencyPickerService.filterUpdate.subscribe((filter) => {
            this.checkedCounter = this.result.filter(i => {
                return i.isChecked;
            }).length;
            this.radioVal = null;
            this.filter = filter;
            if (this.resultsListElement && this.resultsListElement.nativeElement) {
                this.resultsListElement.nativeElement.scrollTop = 0;
            }
            this.updateFilter(filter);
            this.updateResults();
        });
        this.updateResults();
    }
    ngOnDestroy() {
        this.removeSubscription();
    }
    removeSubscription() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    updateResults() {
        this.service.getDataSearchTerms(this.filter, 0, "", this.countFieldLevel).subscribe((result) => {
            this.isResultsLoaded = true;
            if (this.checkedCounter > 0) {
                this.result = this.result.filter(i => {
                    return i.isChecked;
                }).concat(result.items);
            }
            else {
                this.result = result.items;
            }
        }, error => {
            this.isResultsLoaded = true;
            console.error('error retrieving agency data', error);
        });
    }
    onScroll() {
        let scrollAreaHeight = this.resultsListElement.nativeElement.offsetHeight;
        let scrollTopPos = this.resultsListElement.nativeElement.scrollTop;
        let scrollAreaMaxHeight = this.resultsListElement.nativeElement.scrollHeight;
        if ((scrollTopPos + scrollAreaHeight * 2) >= scrollAreaMaxHeight && !this.scrollCall) {
            this.scrollCall = true;
            // tslint:disable-next-line: max-line-length
            this.service.getDataSearchTerms(this.filter, this.result.length, "", this.countFieldLevel).subscribe((result) => {
                this.result = this.result.concat(result.items);
            }, (e) => {
                console.error("scroll:", e);
            }, () => {
                this.scrollCall = false;
            });
        }
    }
    getLabel(level, type) {
        let actualLevel = level;
        if (type === "OFFICE") {
            actualLevel = 7;
        }
        return HierarchyLabels[actualLevel];
    }
    getOrgLabel(item) {
        if (this.hasFpds) {
            if (item && item["type"] === 'OFFICE') {
                return item["aacCode"] || item["fpdsOrgId"] || item["fpdsCode"] || item["code"] || item["cfdaCode"];
            }
            else if (item && (item["type"] !== "DEPARTMENT" && item["type"] !== "AGENCY")) {
                return item["fpdsOrgId"] || item["fpdsCode"] || item["code"] || item["cfdaCode"];
            }
            else {
                return item["fpdsCode"] || item["fpdsOrgId"] || item["code"] || item["cfdaCode"];
            }
        }
        else {
            return item["code"];
        }
    }
    updateFilter(filter) {
        this.filter = filter;
        this.service.filter = filter;
    }
    trackChecked(isChecked) {
        if (isChecked) {
            this.checkedCounter++;
        }
        else {
            this.checkedCounter--;
        }
    }
    clearSelections() {
        if (this.inputType == 'checkbox') {
            this.checkedCounter = 0;
            for (let i = 0; i < this.result.length; i++) {
                let item = this.result[i];
                if (item.isChecked) {
                    item.isChecked = false;
                }
            }
        }
        else if (this.inputType == 'radio') {
            this.radioVal = null;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: AgencyTableComponent, deps: [{ token: HierarchyService }, { token: AgencyPickerService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: AgencyTableComponent, selector: "sds-agency-table", inputs: { level: "level", inputType: "inputType", excludesNamedOrg: "excludesNamedOrg", isDefaultDept: "isDefaultDept", lockOnRoleAdminHierarchy: "lockOnRoleAdminHierarchy", adminHierarchy: "adminHierarchy", defaultRoles: "defaultRoles", domain: "domain", status: "status", countFieldLevel: "countFieldLevel", hasFpds: "hasFpds", role: "role" }, outputs: { itemChecked: "itemChecked" }, viewQueries: [{ propertyName: "resultsListElement", first: true, predicate: ["resultsList"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div class=\"display-flex flex-wrap margin-bottom-05\">\r\n  <div class=\"text-semibold tablet:grid-col-fill margin-0\">\r\n    Selected Values\r\n    <span *ngIf=\"inputType=='checkbox'\">({{checkedCounter}})</span>\r\n  </div>\r\n  <div class=\"tablet:grid-col-auto\">\r\n      <button class=\"usa-button usa-button bg-primary-lighter\" (click)=\"clearSelections()\" >{{inputType =='checkbox' ? 'Clear all' : 'Clear'}}</button>\r\n  </div>\r\n</div>\r\n<div class=\"desktop-width overflow-scroll height-mobile display-block position-relative\" (scroll)=\"onScroll()\" #resultsList>\r\n  <table class=\"sds-table width-full\" role=\"presentation\">\r\n    <caption class=\"usa-sr-only\">Selected values table</caption>\r\n    <thead>\r\n      <tr>\r\n        <th class=\"width-4\" scope=\"col\"><span class=\"usa-sr-only\">Selection</span></th>\r\n        <th class=\"width-10\" scope=\"col\">Code</th>\r\n        <th class=\"\" scope=\"col\">Name</th>\r\n        <th class=\"width-15\" scope=\"col\">Level</th>\r\n      </tr>\r\n    </thead>\r\n    <tbody *ngIf=\"isResultsLoaded\">\r\n      <ng-container *ngIf=\"result && result.length > 0; else no_results\">\r\n        <tr *ngFor=\"let item of result\" >\r\n          <td class=\"width-4 text-left font-body-3xs\" role=\"cell\">\r\n            <ng-container *ngIf=\"inputType=='checkbox'\">\r\n              <input id=\"{{item.orgKey}}\" value=\"{{item.orgkey}}\" class=\"usa-checkbox__input position-static\" type=\"checkbox\" [(ngModel)]=\"item.isChecked\" (ngModelChange)=\"trackChecked($event)\">\r\n              <label class=\"usa-checkbox__input\" for=\"{{item.orgKey}}\"><span class=\"usa-sr-only\">{{item.name}}</span></label>\r\n            </ng-container>\r\n            <ng-container *ngIf=\"inputType=='radio'\">\r\n              <input id=\"{{item.orgKey}}\" name=\"radiolist\" value=\"{{item.orgKey}}\" class=\"usa-radio__input position-static\" type=\"radio\" [(ngModel)]=\"radioVal\">\r\n              <label class=\"usa-radio__input\" for=\"{{item.orgKey}}\"><span class=\"usa-sr-only\">{{item.name}}</span></label>\r\n            </ng-container>\r\n          </td>\r\n          <td class=\"width-10 text-left font-body-3xs\" >\r\n            <ng-container *ngIf=\"item.modStatus == 'ACTIVE'\">{{getOrgLabel(item)}}</ng-container>\r\n            <ng-container *ngIf=\"item.modStatus == 'INACTIVE'\">*</ng-container>\r\n            <ng-container *ngIf=\"item.modStatus == 'INACTIVE' && (item.code || (hasFpds && (item.aacCode || item.fpdsCode || item.fpdsOrgId || item.cfdaCode)))\">{{getOrgLabel(item)}}</ng-container>\r\n          </td>\r\n          <td class=\"text-left font-body-3xs\" >{{item.name}}</td>\r\n          <td class=\"width-15 text-left font-body-3xs\" >{{getLabel(item.level, item.type)}}</td>\r\n        </tr>\r\n      </ng-container>\r\n      <ng-template #no_results>\r\n        <tr>\r\n          <td class=\"font-body-3xs text-center\" colspan=\"4\">\r\n            No results found\r\n          </td>\r\n        </tr>\r\n      </ng-template>\r\n    </tbody>\r\n  </table>\r\n</div>\r\n<div class=\"width-mobile overflow-scroll height-mobile display-block position-relative\" (scroll)=\"onScroll()\" #resultsList>\r\n  <table class=\"usa-table usa-table--stacked-header usa-table--borderless\">\r\n    <thead>\r\n      <tr>\r\n        <th scope=\"col\">Org Information</th>\r\n        <th scope=\"col\">Level</th>\r\n      </tr>\r\n    </thead>\r\n    <tbody *ngIf=\"isResultsLoaded\">\r\n      <ng-container *ngIf=\"result && result.length > 0; else no_results\">\r\n        <tr *ngFor=\"let item of result\">\r\n          <th data-label=\"Org Information\" scope=\"row\">\r\n            <div class=\"usa-radio\">\r\n              <input\r\n                class=\"usa-radio__input\"\r\n                id=\"id_{{item.orgKey}}\"\r\n                type=\"radio\"\r\n                name=\"{{item.orgKey}}\"\r\n                value=\"{{item.orgKey}}\"\r\n                [(ngModel)]=\"radioVal\"\r\n              />\r\n              <label class=\"usa-checkbox__label\" for=\"id_{{item.orgKey}}\">\r\n                <ng-container *ngIf=\"item.modStatus == 'ACTIVE'\"><h4>{{getOrgLabel(item)}} - {{item.name}}</h4></ng-container>\r\n                <ng-container *ngIf=\"item.modStatus == 'INACTIVE'\"><h4>*</h4></ng-container>\r\n                <ng-container *ngIf=\"item.modStatus == 'INACTIVE' && (item.code || (hasFpds && (item.aacCode || item.fpdsCode || item.fpdsOrgId || item.cfdaCode)))\"><h4>{{getOrgLabel(item)}} - {{item.name}}</h4></ng-container>\r\n              </label>\r\n            </div>\r\n          </th>\r\n          <td data-label=\"Org Level\">\r\n            {{getLabel(item.level, item.type)}}\r\n          </td>\r\n        </tr>\r\n      </ng-container>\r\n      <ng-template #no_results>\r\n        <tr>\r\n          <td colspan=\"4\" class=\"centered\">\r\n            No results found\r\n          </td>\r\n        </tr>\r\n      </ng-template>\r\n    </tbody>\r\n  </table>\r\n</div>", styles: ["@media screen and (min-width: 640px){.width-mobile{display:none!important}}@media screen and (max-width: 640px){.desktop-width{display:none!important}.width-mobile{max-height:350px;height:auto!important;overflow:scroll;margin-top:30px;width:100%!important;border:1px solid #C9C9C9}.width-mobile [type=checkbox]:not(.align-right)+label:before{width:18px;height:18px;margin-top:.2rem}.width-mobile [type=checkbox]+label{margin-bottom:.2rem}.width-mobile .usa-radio__input:checked+[class*=__label]:before{background-color:#70e17b!important;box-shadow:0 0 0 2px #70e17b,inset 0 0 0 2px #fff}.width-mobile .usa-table{margin-top:0}.width-mobile .usa-checkbox__label{margin-top:.2rem}.width-mobile .usa-table--stacked-header tr:first-child th:first-child{border-top:0!important}.width-mobile .usa-table--stacked-header tr th:first-child{padding:.3rem!important}.width-mobile .usa-table--stacked-header td[data-label]:before{font-weight:400!important;padding-top:0!important}.width-mobile .usa-table--stacked-header td[data-label]{font-weight:700!important;border-top:1px solid #979797!important}.width-mobile .usa-table--stacked-header tr{border-bottom:0!important}.width-mobile h4{font-family:Source Sans Pro Web;font-style:normal;font-weight:600;font-size:16px;line-height:24px;color:#454540}}\n"], dependencies: [{ kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i4.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i4.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { kind: "directive", type: i4.RadioControlValueAccessor, selector: "input[type=radio][formControlName],input[type=radio][formControl],input[type=radio][ngModel]", inputs: ["name", "formControlName", "value"] }, { kind: "directive", type: i4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i4.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: AgencyTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sds-agency-table', template: "<div class=\"display-flex flex-wrap margin-bottom-05\">\r\n  <div class=\"text-semibold tablet:grid-col-fill margin-0\">\r\n    Selected Values\r\n    <span *ngIf=\"inputType=='checkbox'\">({{checkedCounter}})</span>\r\n  </div>\r\n  <div class=\"tablet:grid-col-auto\">\r\n      <button class=\"usa-button usa-button bg-primary-lighter\" (click)=\"clearSelections()\" >{{inputType =='checkbox' ? 'Clear all' : 'Clear'}}</button>\r\n  </div>\r\n</div>\r\n<div class=\"desktop-width overflow-scroll height-mobile display-block position-relative\" (scroll)=\"onScroll()\" #resultsList>\r\n  <table class=\"sds-table width-full\" role=\"presentation\">\r\n    <caption class=\"usa-sr-only\">Selected values table</caption>\r\n    <thead>\r\n      <tr>\r\n        <th class=\"width-4\" scope=\"col\"><span class=\"usa-sr-only\">Selection</span></th>\r\n        <th class=\"width-10\" scope=\"col\">Code</th>\r\n        <th class=\"\" scope=\"col\">Name</th>\r\n        <th class=\"width-15\" scope=\"col\">Level</th>\r\n      </tr>\r\n    </thead>\r\n    <tbody *ngIf=\"isResultsLoaded\">\r\n      <ng-container *ngIf=\"result && result.length > 0; else no_results\">\r\n        <tr *ngFor=\"let item of result\" >\r\n          <td class=\"width-4 text-left font-body-3xs\" role=\"cell\">\r\n            <ng-container *ngIf=\"inputType=='checkbox'\">\r\n              <input id=\"{{item.orgKey}}\" value=\"{{item.orgkey}}\" class=\"usa-checkbox__input position-static\" type=\"checkbox\" [(ngModel)]=\"item.isChecked\" (ngModelChange)=\"trackChecked($event)\">\r\n              <label class=\"usa-checkbox__input\" for=\"{{item.orgKey}}\"><span class=\"usa-sr-only\">{{item.name}}</span></label>\r\n            </ng-container>\r\n            <ng-container *ngIf=\"inputType=='radio'\">\r\n              <input id=\"{{item.orgKey}}\" name=\"radiolist\" value=\"{{item.orgKey}}\" class=\"usa-radio__input position-static\" type=\"radio\" [(ngModel)]=\"radioVal\">\r\n              <label class=\"usa-radio__input\" for=\"{{item.orgKey}}\"><span class=\"usa-sr-only\">{{item.name}}</span></label>\r\n            </ng-container>\r\n          </td>\r\n          <td class=\"width-10 text-left font-body-3xs\" >\r\n            <ng-container *ngIf=\"item.modStatus == 'ACTIVE'\">{{getOrgLabel(item)}}</ng-container>\r\n            <ng-container *ngIf=\"item.modStatus == 'INACTIVE'\">*</ng-container>\r\n            <ng-container *ngIf=\"item.modStatus == 'INACTIVE' && (item.code || (hasFpds && (item.aacCode || item.fpdsCode || item.fpdsOrgId || item.cfdaCode)))\">{{getOrgLabel(item)}}</ng-container>\r\n          </td>\r\n          <td class=\"text-left font-body-3xs\" >{{item.name}}</td>\r\n          <td class=\"width-15 text-left font-body-3xs\" >{{getLabel(item.level, item.type)}}</td>\r\n        </tr>\r\n      </ng-container>\r\n      <ng-template #no_results>\r\n        <tr>\r\n          <td class=\"font-body-3xs text-center\" colspan=\"4\">\r\n            No results found\r\n          </td>\r\n        </tr>\r\n      </ng-template>\r\n    </tbody>\r\n  </table>\r\n</div>\r\n<div class=\"width-mobile overflow-scroll height-mobile display-block position-relative\" (scroll)=\"onScroll()\" #resultsList>\r\n  <table class=\"usa-table usa-table--stacked-header usa-table--borderless\">\r\n    <thead>\r\n      <tr>\r\n        <th scope=\"col\">Org Information</th>\r\n        <th scope=\"col\">Level</th>\r\n      </tr>\r\n    </thead>\r\n    <tbody *ngIf=\"isResultsLoaded\">\r\n      <ng-container *ngIf=\"result && result.length > 0; else no_results\">\r\n        <tr *ngFor=\"let item of result\">\r\n          <th data-label=\"Org Information\" scope=\"row\">\r\n            <div class=\"usa-radio\">\r\n              <input\r\n                class=\"usa-radio__input\"\r\n                id=\"id_{{item.orgKey}}\"\r\n                type=\"radio\"\r\n                name=\"{{item.orgKey}}\"\r\n                value=\"{{item.orgKey}}\"\r\n                [(ngModel)]=\"radioVal\"\r\n              />\r\n              <label class=\"usa-checkbox__label\" for=\"id_{{item.orgKey}}\">\r\n                <ng-container *ngIf=\"item.modStatus == 'ACTIVE'\"><h4>{{getOrgLabel(item)}} - {{item.name}}</h4></ng-container>\r\n                <ng-container *ngIf=\"item.modStatus == 'INACTIVE'\"><h4>*</h4></ng-container>\r\n                <ng-container *ngIf=\"item.modStatus == 'INACTIVE' && (item.code || (hasFpds && (item.aacCode || item.fpdsCode || item.fpdsOrgId || item.cfdaCode)))\"><h4>{{getOrgLabel(item)}} - {{item.name}}</h4></ng-container>\r\n              </label>\r\n            </div>\r\n          </th>\r\n          <td data-label=\"Org Level\">\r\n            {{getLabel(item.level, item.type)}}\r\n          </td>\r\n        </tr>\r\n      </ng-container>\r\n      <ng-template #no_results>\r\n        <tr>\r\n          <td colspan=\"4\" class=\"centered\">\r\n            No results found\r\n          </td>\r\n        </tr>\r\n      </ng-template>\r\n    </tbody>\r\n  </table>\r\n</div>", styles: ["@media screen and (min-width: 640px){.width-mobile{display:none!important}}@media screen and (max-width: 640px){.desktop-width{display:none!important}.width-mobile{max-height:350px;height:auto!important;overflow:scroll;margin-top:30px;width:100%!important;border:1px solid #C9C9C9}.width-mobile [type=checkbox]:not(.align-right)+label:before{width:18px;height:18px;margin-top:.2rem}.width-mobile [type=checkbox]+label{margin-bottom:.2rem}.width-mobile .usa-radio__input:checked+[class*=__label]:before{background-color:#70e17b!important;box-shadow:0 0 0 2px #70e17b,inset 0 0 0 2px #fff}.width-mobile .usa-table{margin-top:0}.width-mobile .usa-checkbox__label{margin-top:.2rem}.width-mobile .usa-table--stacked-header tr:first-child th:first-child{border-top:0!important}.width-mobile .usa-table--stacked-header tr th:first-child{padding:.3rem!important}.width-mobile .usa-table--stacked-header td[data-label]:before{font-weight:400!important;padding-top:0!important}.width-mobile .usa-table--stacked-header td[data-label]{font-weight:700!important;border-top:1px solid #979797!important}.width-mobile .usa-table--stacked-header tr{border-bottom:0!important}.width-mobile h4{font-family:Source Sans Pro Web;font-style:normal;font-weight:600;font-size:16px;line-height:24px;color:#454540}}\n"] }]
        }], ctorParameters: () => [{ type: HierarchyService }, { type: AgencyPickerService }], propDecorators: { level: [{
                type: Input
            }], inputType: [{
                type: Input
            }], excludesNamedOrg: [{
                type: Input
            }], isDefaultDept: [{
                type: Input
            }], lockOnRoleAdminHierarchy: [{
                type: Input
            }], adminHierarchy: [{
                type: Input
            }], defaultRoles: [{
                type: Input
            }], domain: [{
                type: Input
            }], status: [{
                type: Input
            }], itemChecked: [{
                type: Output
            }], resultsListElement: [{
                type: ViewChild,
                args: ['resultsList']
            }], countFieldLevel: [{
                type: Input
            }], hasFpds: [{
                type: Input
            }], role: [{
                type: Input
            }] } });

class AgencyFilterComponent {
    constructor(agencyPickerService) {
        this.agencyPickerService = agencyPickerService;
        this.showInactive = false;
        this.filter = {};
        this.simpleResponse = false; // Need full response for filter interaction with table
        this.excludesNamedOrg = '';
        this.isDefaultDept = false;
        this.lockOnRoleAdminHierarchy = '';
        this.adminHierarchy = false;
        this.defaultRoles = false;
        this.domain = '';
        this.status = 'active';
        this.inactiveToggle = true;
        this.countFieldLevel = 7;
        this.hasFpds = false;
        this.environment = {};
        this.role = '';
    }
    ngOnInit() {
        this.agencyPickerService.filterUpdate.subscribe((filter) => {
            this.filter = filter;
        });
    }
    inactiveFilterChange(value) {
        this.showInactive = value;
        this.filter._meta = {
            src: "status"
        };
        this.filter.status = !this.showInactive ? "active" : "everything";
        this.status = this.filter.status;
        this.agencyPickerService.updateFilter(this.filter);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: AgencyFilterComponent, deps: [{ token: AgencyPickerService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: AgencyFilterComponent, selector: "sds-agency-filter", inputs: { excludesNamedOrg: "excludesNamedOrg", isDefaultDept: "isDefaultDept", lockOnRoleAdminHierarchy: "lockOnRoleAdminHierarchy", adminHierarchy: "adminHierarchy", defaultRoles: "defaultRoles", domain: "domain", status: "status", inactiveToggle: "inactiveToggle", countFieldLevel: "countFieldLevel", hasFpds: "hasFpds", environment: "environment", role: "role" }, ngImport: i0, template: "<div class=\"margin-0 text-semibold margin-bottom-05 display-inline-block\">Filter By</div>\r\n<sds-agency-selector tabindex=\"1\" *ngIf=\"!excludesNamedOrg && countFieldLevel>0\" [isDefaultDept]=\"isDefaultDept\" [role]=\"role\" [lockOnRoleAdminHierarchy]=\"lockOnRoleAdminHierarchy\" [defaultRoles]=\"defaultRoles\" [adminHierarchy]=\"adminHierarchy\" [domain]=\"domain\" [status]=\"status\" [hasFpds]=\"hasFpds\" [level]=\"1\" [selectionMode]=\"0\" [environment]=\"environment\" [simpleResponse]=\"simpleResponse\"></sds-agency-selector>\r\n<sds-agency-selector tabindex=\"2\" *ngIf=\"countFieldLevel>1\" [isDefaultDept]=\"isDefaultDept\" [role]=\"role\" [lockOnRoleAdminHierarchy]=\"lockOnRoleAdminHierarchy\" [domain]=\"domain\" [defaultRoles]=\"defaultRoles\" [adminHierarchy]=\"adminHierarchy\" [excludesNamedOrg]=\"excludesNamedOrg\" [status]=\"status\" [hasFpds]=\"hasFpds\" [level]=\"2\" [selectionMode]=\"0\" [environment]=\"environment\" [simpleResponse]=\"simpleResponse\"></sds-agency-selector>\r\n<sds-agency-selector tabindex=\"3\" *ngIf=\"countFieldLevel>2\" [isDefaultDept]=\"isDefaultDept\" [role]=\"role\" [lockOnRoleAdminHierarchy]=\"lockOnRoleAdminHierarchy\" [domain]=\"domain\" [defaultRoles]=\"defaultRoles\" [adminHierarchy]=\"adminHierarchy\" [excludesNamedOrg]=\"excludesNamedOrg\" [status]=\"status\" [hasFpds]=\"hasFpds\" [level]=\"3\" [selectionMode]=\"0\" [environment]=\"environment\" [simpleResponse]=\"simpleResponse\"></sds-agency-selector>\r\n<sds-agency-selector tabindex=\"4\" *ngIf=\"countFieldLevel>3\" [isDefaultDept]=\"isDefaultDept\" [role]=\"role\" [lockOnRoleAdminHierarchy]=\"lockOnRoleAdminHierarchy\" [domain]=\"domain\" [defaultRoles]=\"defaultRoles\" [adminHierarchy]=\"adminHierarchy\" [excludesNamedOrg]=\"excludesNamedOrg\" [status]=\"status\" [hasFpds]=\"hasFpds\" [level]=\"4\" [selectionMode]=\"0\" [environment]=\"environment\" [simpleResponse]=\"simpleResponse\"></sds-agency-selector>\r\n<sds-agency-selector tabindex=\"5\" *ngIf=\"countFieldLevel>4\" [isDefaultDept]=\"isDefaultDept\" [role]=\"role\" [lockOnRoleAdminHierarchy]=\"lockOnRoleAdminHierarchy\" [domain]=\"domain\" [defaultRoles]=\"defaultRoles\" [adminHierarchy]=\"adminHierarchy\" [excludesNamedOrg]=\"excludesNamedOrg\" [status]=\"status\" [hasFpds]=\"hasFpds\" [level]=\"7\" [selectionMode]=\"0\" [environment]=\"environment\" [simpleResponse]=\"simpleResponse\"></sds-agency-selector>\r\n<div class=\"usa-checkbox\" *ngIf=\"inactiveToggle\">\r\n  <input class=\"usa-checkbox__input\" id=\"showInactive\" type=\"checkbox\" name=\"historical-figures-1\" [ngModel]=\"showInactive\" (ngModelChange)=\"inactiveFilterChange($event)\" />\r\n  <label class=\"usa-checkbox__label\" for=\"showInactive\">Show Inactive</label>\r\n</div>\r\n", dependencies: [{ kind: "directive", type: i0.forwardRef(() => i2.NgIf), selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i0.forwardRef(() => i4.CheckboxControlValueAccessor), selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { kind: "directive", type: i0.forwardRef(() => i4.NgControlStatus), selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i0.forwardRef(() => i4.NgModel), selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i0.forwardRef(() => SdsAgencySelectorComponent), selector: "sds-agency-selector", inputs: ["level", "defaultAgency", "selectionMode", "excludesNamedOrg", "isDefaultDept", "lockOnRoleAdminHierarchy", "adminHierarchy", "defaultRoles", "domain", "role", "disabled", "status", "errorMessage", "label", "hint", "settings", "prefix", "agencyButtonId", "requiredFlag", "fieldLevels", "hasFpds", "displayAdvanceButton", "countFieldLevel", "modalHint", "inputType", "inactiveToggle", "environment", "simpleResponse"], outputs: ["advanceClick"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: AgencyFilterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sds-agency-filter', template: "<div class=\"margin-0 text-semibold margin-bottom-05 display-inline-block\">Filter By</div>\r\n<sds-agency-selector tabindex=\"1\" *ngIf=\"!excludesNamedOrg && countFieldLevel>0\" [isDefaultDept]=\"isDefaultDept\" [role]=\"role\" [lockOnRoleAdminHierarchy]=\"lockOnRoleAdminHierarchy\" [defaultRoles]=\"defaultRoles\" [adminHierarchy]=\"adminHierarchy\" [domain]=\"domain\" [status]=\"status\" [hasFpds]=\"hasFpds\" [level]=\"1\" [selectionMode]=\"0\" [environment]=\"environment\" [simpleResponse]=\"simpleResponse\"></sds-agency-selector>\r\n<sds-agency-selector tabindex=\"2\" *ngIf=\"countFieldLevel>1\" [isDefaultDept]=\"isDefaultDept\" [role]=\"role\" [lockOnRoleAdminHierarchy]=\"lockOnRoleAdminHierarchy\" [domain]=\"domain\" [defaultRoles]=\"defaultRoles\" [adminHierarchy]=\"adminHierarchy\" [excludesNamedOrg]=\"excludesNamedOrg\" [status]=\"status\" [hasFpds]=\"hasFpds\" [level]=\"2\" [selectionMode]=\"0\" [environment]=\"environment\" [simpleResponse]=\"simpleResponse\"></sds-agency-selector>\r\n<sds-agency-selector tabindex=\"3\" *ngIf=\"countFieldLevel>2\" [isDefaultDept]=\"isDefaultDept\" [role]=\"role\" [lockOnRoleAdminHierarchy]=\"lockOnRoleAdminHierarchy\" [domain]=\"domain\" [defaultRoles]=\"defaultRoles\" [adminHierarchy]=\"adminHierarchy\" [excludesNamedOrg]=\"excludesNamedOrg\" [status]=\"status\" [hasFpds]=\"hasFpds\" [level]=\"3\" [selectionMode]=\"0\" [environment]=\"environment\" [simpleResponse]=\"simpleResponse\"></sds-agency-selector>\r\n<sds-agency-selector tabindex=\"4\" *ngIf=\"countFieldLevel>3\" [isDefaultDept]=\"isDefaultDept\" [role]=\"role\" [lockOnRoleAdminHierarchy]=\"lockOnRoleAdminHierarchy\" [domain]=\"domain\" [defaultRoles]=\"defaultRoles\" [adminHierarchy]=\"adminHierarchy\" [excludesNamedOrg]=\"excludesNamedOrg\" [status]=\"status\" [hasFpds]=\"hasFpds\" [level]=\"4\" [selectionMode]=\"0\" [environment]=\"environment\" [simpleResponse]=\"simpleResponse\"></sds-agency-selector>\r\n<sds-agency-selector tabindex=\"5\" *ngIf=\"countFieldLevel>4\" [isDefaultDept]=\"isDefaultDept\" [role]=\"role\" [lockOnRoleAdminHierarchy]=\"lockOnRoleAdminHierarchy\" [domain]=\"domain\" [defaultRoles]=\"defaultRoles\" [adminHierarchy]=\"adminHierarchy\" [excludesNamedOrg]=\"excludesNamedOrg\" [status]=\"status\" [hasFpds]=\"hasFpds\" [level]=\"7\" [selectionMode]=\"0\" [environment]=\"environment\" [simpleResponse]=\"simpleResponse\"></sds-agency-selector>\r\n<div class=\"usa-checkbox\" *ngIf=\"inactiveToggle\">\r\n  <input class=\"usa-checkbox__input\" id=\"showInactive\" type=\"checkbox\" name=\"historical-figures-1\" [ngModel]=\"showInactive\" (ngModelChange)=\"inactiveFilterChange($event)\" />\r\n  <label class=\"usa-checkbox__label\" for=\"showInactive\">Show Inactive</label>\r\n</div>\r\n" }]
        }], ctorParameters: () => [{ type: AgencyPickerService }], propDecorators: { excludesNamedOrg: [{
                type: Input
            }], isDefaultDept: [{
                type: Input
            }], lockOnRoleAdminHierarchy: [{
                type: Input
            }], adminHierarchy: [{
                type: Input
            }], defaultRoles: [{
                type: Input
            }], domain: [{
                type: Input
            }], status: [{
                type: Input
            }], inactiveToggle: [{
                type: Input
            }], countFieldLevel: [{
                type: Input
            }], hasFpds: [{
                type: Input
            }], environment: [{
                type: Input
            }], role: [{
                type: Input
            }] } });
class SdsAgencySelectorComponent {
    constructor(service, agencyPickerService, cdr) {
        this.service = service;
        this.agencyPickerService = agencyPickerService;
        this.cdr = cdr;
        this.model = [];
        this.newModel = new SDSSelectedItemModel();
        this.filter = {};
        /**
         *
         */
        this.level = 0;
        this.defaultAgency = [];
        this.selectionMode = SelectionMode.SINGLE;
        this.excludesNamedOrg = '';
        this.isDefaultDept = false;
        this.lockOnRoleAdminHierarchy = '';
        this.adminHierarchy = false;
        this.defaultRoles = false;
        this.domain = '';
        this.role = '';
        this.disabled = false;
        this.status = 'active';
        this.errorMessage = "";
        this.label = "Federal Hierarchy";
        this.hint = "Enter your Department, Ind. Agency, Subtier, Office, or other organization.";
        this.settings = new SDSAutocompletelConfiguration();
        this.prefix = "";
        this.agencyButtonId = "agency-modal-button";
        this.requiredFlag = false;
        this.fieldLevels = '';
        this.hasFpds = false;
        this.displayAdvanceButton = true;
        this.countFieldLevel = 7;
        this.modalHint = "";
        this.inputType = 'checkbox';
        this.inactiveToggle = true;
        this.environment = {};
        this.simpleResponse = false; // true: limits model response to key/text fields. False: full model returned.
        this.advanceClick = new EventEmitter();
        this.multiple = true;
        this._onChange = (_) => { };
        this.agencyPickerService.filterUpdate.subscribe((filter) => {
            this.updateFilter(filter);
            // tslint:disable-next-line: triple-equals
            if (this.level != 0 &&
                this.filter &&
                this.filter._meta &&
                this.filter._meta.src &&
                // tslint:disable-next-line: triple-equals
                this.filter._meta.src == "selector" &&
                this.filter._meta.level &&
                this.filter._meta.level <= this.level) {
                const level = this.filter._meta.level;
                // tslint:disable-next-line: triple-equals
                const higherLevelFilterItemAdded = level != this.level && this.filter[level] && this.filter[level].length > 0;
                const currentLevelFilterHasValue = this.filter[this.level] && this.filter[this.level].length > 0;
                if (higherLevelFilterItemAdded || (!higherLevelFilterItemAdded && !currentLevelFilterHasValue)) {
                    this.model = [];
                    this.parent = this.getClosestParentFromFilter();
                    this.service.parent = this.parent;
                    if (this.cdr && !this.cdr['destroyed']) {
                        this.cdr.detectChanges();
                    }
                }
                // tslint:disable-next-line: triple-equals
            }
            else if (this.level != 0 &&
                this.filter &&
                this.filter._meta &&
                this.filter._meta.src &&
                // tslint:disable-next-line: triple-equals
                this.filter._meta.src == "modal") {
                this.model = [];
                this.parent = null;
                this.service.parent = this.parent;
                if (this.cdr && !this.cdr['destroyed']) {
                    this.cdr.detectChanges();
                }
            }
        });
    }
    setEnvironment(env) {
        this.service.setEnvironment(this.environment);
    }
    // Helper method to programatically add a value to the existing items array
    addItem(item) {
        //from SFE3
        if (item) {
            this.model = cloneDeep(this.model);
        }
        else {
            this.model = [];
        }
        if (this.cdr && !this.cdr['destroyed']) {
            this.cdr.detectChanges();
        }
        this.updateModel(); //TODO
    }
    // Method that is fired when the child component event notifies us that the items array has been modified within the child component
    updateItems($event) {
        setTimeout(() => {
            this.updateModel();
        }, 0);
    }
    // Helper method that gets a new instance of the model and notifies ControlValueAccessor that we have a new model for this FormControl (our custom component)
    updateModel() {
        const model = this.getModel();
        this._onChange(model);
    }
    // Helper method to return a new instance of an array that contains our items
    getModel() {
        return this.newModel;
    }
    // ControlValueAccessor (and Formly) is trying to update the value of the FormControl (our custom component) programatically
    // If there is a value we will just overwrite items
    // If there is no value we reset the items array to be empty
    writeValue(value) {
        if (value && value.length && this.newModel !== value) {
            this.newModel = value;
            this.cdr.markForCheck();
        }
        else {
            this.newModel = new SDSSelectedItemModel();
            this.cdr.markForCheck();
        }
    }
    // ControlValueAccessor hook that lets us call this._onChange(var) to let the form know our variable has changed (in this case model)
    registerOnChange(fn) {
        this._onChange = fn;
    }
    // ControlValueAccessor hook (not used)
    registerOnTouched(fn) {
        //this._onTouched = fn;
    }
    /****** */
    setupWrapper(control) {
        this.control = control;
    }
    getClosestParentFromFilter() {
        for (let i = this.level - 1; i > 0; i--) {
            if (this.filter && this.filter[i] && this.filter[i].length > 0) {
                return this.filter[i][0]['orgKey'];
            }
        }
        return null;
    }
    updateFilter(filter) {
        this.filter = filter;
        this.service.filter = filter;
    }
    ngOnChanges(c) {
        if (c['lockOnRoleAdminHierarchy']) {
            this.service.lockOnRoleAdminHierarchy = this.lockOnRoleAdminHierarchy;
        }
        if (c['excludesNamedOrg']) {
            this.service.excludesNamedOrg = this.excludesNamedOrg;
        }
        if (c['isDefaultDept']) {
            this.service.isDefaultDept = this.isDefaultDept;
        }
        if (c['status']) {
            this.service.status = this.status;
        }
        if (c['hasFpds']) {
            this.service.hasFpds = this.hasFpds;
        }
        if (c['domain']) {
            this.service.domain = this.domain;
        }
        if (c['role']) {
            this.service.role = this.role;
        }
        if (c['adminHierarchy']) {
            this.service.adminHierarchy = this.adminHierarchy;
        }
        if (c['defaultRoles']) {
            this.service.defaultRoles = this.defaultRoles;
        }
    }
    ngAfterViewInit() {
        if (this.level === 0) {
            this.agencyPickerService.advanceButton = this.advanceButton;
        }
        /* TODO
        if(this.control){
          this.control.statusChanges.subscribe(() => {
            //TODO this.wrapper.formatErrors(this.control);
          });
          //TODO this.wrapper.formatErrors(this.control);
        }
        */
    }
    updateSelectedItems(list) {
        if (Array.isArray(list)) {
            list.forEach(item => {
                this.selectorAutocomplete.addItem(item);
            });
        }
    }
    ngOnInit() {
        this.setup();
        this.service.level = this.level;
        this.service.levels = this.fieldLevels;
        this.service.countFieldLevel = this.countFieldLevel;
        // this.firstSetup = false;
        this.service.simpleResponse = this.simpleResponse;
    }
    setupSettings(labelText, controlId) {
        this.settings.primaryKeyField = 'orgKey';
        this.settings.id = this.prefix + controlId;
        this.settings.labelText = labelText;
        this.settings.primaryTextField = 'orgText';
        this.settings.selectionMode = this.selectionMode;
        //this.selectModel.treeMode = this.selectionMode;
        this.settings.autocompletePlaceHolderText = 'Enter Code or Name';
        this.settings.ariaLabelText = this.label && this.level === 0 ? this.label : labelText;
        this.settings.ariaLabelText = this.requiredFlag ? `${this.settings.ariaLabelText} required` : this.settings.ariaLabelText;
    }
    setup() {
        switch (this.level) {
            case 0:
                this.setupSettings('Federal Hierarchy', 'federalHierarchy');
                break;
            case 1:
                this.setupSettings('Dept / Ind. Agency', 'dept');
                break;
            case 2:
                this.setupSettings('Subtier', 'subtier');
                break;
            case 3:
                this.setupSettings('Major Command', 'major');
                break;
            case 4:
            case 5:
            case 6:
                this.setupSettings('Sub Command', 'subcomm');
                break;
            case 7:
                this.setupSettings('Office', 'office');
                break;
            default:
                break;
        }
    }
    change(value) {
        // tslint:disable-next-line: triple-equals
        if (this.filter && this.level != 0) {
            this.filter[this.level] = value;
            if (value && value.length > 0) {
                this.removeLowerLevelFilters();
            }
            this.filter._meta = {
                src: "selector",
                level: this.level
            };
            this.agencyPickerService.updateFilter(this.filter);
        }
        // tslint:disable-next-line: triple-equals
        if (this.level == 0) {
            this.agencyPickerService.updateSelections(this.model);
        }
        if (value) {
            const selectedOrgs = value;
            let srMessage = '';
            if (selectedOrgs.length === 0 && this.previouslySelectedValues) {
                this.previouslySelectedValues.forEach((item) => {
                    srMessage += `${item['orgText']} removed. `;
                });
            }
            else {
                value.forEach((item) => {
                    srMessage += `${item['orgText']} selected. `;
                });
            }
            this.addSROnlyMessage(srMessage);
        }
        this.previouslySelectedValues = [...value];
    }
    removeLowerLevelFilters() {
        for (let i = this.level + 1; i <= 7; i++) {
            if (this.filter[i] && this.filter[i].length > 0) {
                this.filter[i] = [];
            }
        }
    }
    advancedClicked() {
        if (!this.disabled) {
            this.advanceClick.emit(null);
        }
    }
    addSROnlyMessage(message) {
        this.srOnlyText = message;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SdsAgencySelectorComponent, deps: [{ token: HierarchyService }, { token: AgencyPickerService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: SdsAgencySelectorComponent, selector: "sds-agency-selector", inputs: { level: "level", defaultAgency: "defaultAgency", selectionMode: "selectionMode", excludesNamedOrg: "excludesNamedOrg", isDefaultDept: "isDefaultDept", lockOnRoleAdminHierarchy: "lockOnRoleAdminHierarchy", adminHierarchy: "adminHierarchy", defaultRoles: "defaultRoles", domain: "domain", role: "role", disabled: "disabled", status: "status", errorMessage: "errorMessage", label: "label", hint: "hint", settings: "settings", prefix: "prefix", agencyButtonId: "agencyButtonId", requiredFlag: "requiredFlag", fieldLevels: "fieldLevels", hasFpds: "hasFpds", displayAdvanceButton: "displayAdvanceButton", countFieldLevel: "countFieldLevel", modalHint: "modalHint", inputType: "inputType", inactiveToggle: "inactiveToggle", environment: "environment", simpleResponse: "simpleResponse" }, outputs: { advanceClick: "advanceClick" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => SdsAgencySelectorComponent),
                multi: true
            },
            HierarchyService
        ], viewQueries: [{ propertyName: "advanceButton", first: true, predicate: ["advanceButton"], descendants: true }, { propertyName: "selectorAutocomplete", first: true, predicate: ["selectorAutocomplete"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<ng-container *ngIf=\"level == 0\">\r\n\t<div class=\"display-flex grid-row\"> <!-- usa-grid  grid-gap-05-->\r\n\t\t<div class=\"tablet-lg:flex-1 tablet:flex-1 desktop:flex-11 tablet:grid-col\"> <!-- usa-width-two-thirds-->\r\n\t\t\t<sds-autocomplete [disabled]=\"disabled\" \r\n\t\t\t\t\t\t\t  [service]=\"service\" \r\n\t\t\t\t\t          (ngModelChange)=\"updateItems($event)\" \r\n\t\t\t\t\t\t\t  [(ngModel)]=\"newModel\" #selectorAutocomplete\r\n\t\t\t\t\t\t\t  [configuration]=\"settings\"\r\n\t\t\t\t\t\t\t  [suggestionTemplate]=\"suggesttemp\" \r\n\t\t\t\t\t\t\t  [selectedItemTemplate]=\"selecttemp\"></sds-autocomplete>\r\n\t\t</div>\r\n\t\t<div *ngIf=\"displayAdvanceButton\" class=\"flex-1 tablet:grid-col-auto padding-top-105\"> <!--class=\"usa-width-one-third\"-->\r\n\t\t\t<sds-agency-modal #agencyModal\r\n\t\t\t[excludesNamedOrg]=\"excludesNamedOrg\"\r\n\t\t\t[isDefaultDept]=\"isDefaultDept\"\r\n\t\t\t[countFieldLevel]=\"countFieldLevel\"\r\n\t\t\t[lockOnRoleAdminHierarchy]=\"lockOnRoleAdminHierarchy\"\r\n      [adminHierarchy]=\"adminHierarchy\"\r\n      [defaultRoles]=\"defaultRoles\"\r\n\t\t\t[domain]=\"domain\"\r\n\t\t\t[modalHint]=\"modalHint\"\r\n\t\t\t[hasFpds]=\"hasFpds\"\r\n\t\t\t[inputType]=\"inputType\"\r\n\t\t\t[inactiveToggle]=\"inactiveToggle\"\r\n\t\t\t(selectedOrganization)='updateSelectedItems($event)'\r\n\t\t\t[status]=\"status\"\t\t\t\r\n\t\t\t[environment]=\"environment\"\r\n\t\t\t[disabled]=\"disabled\"\r\n\t\t\t[agencyButtonId]=\"agencyButtonId\"\r\n\t\t\t[simpleResponse]=\"simpleResponse\"\r\n      [role]=\"role\"></sds-agency-modal>\r\n\t\t</div>\r\n\t</div>\r\n</ng-container>\r\n<ng-container *ngIf=\"level != 0\">\r\n\t<label class=\"usa-label margin-top-1\" id=\"{{settings.id}}-label\" for=\"{{settings.id}}\">{{settings.labelText}}</label>\r\n\t<sds-autocomplete [service]=\"service\" (ngModelChange)=\"change($event)\" [(ngModel)]=\"model\"\r\n\t\t[configuration]=\"settings\" [suggestionTemplate]=\"suggesttemp\" [selectedItemTemplate]=\"selecttemp\"></sds-autocomplete>\r\n</ng-container>\r\n<ng-template #temp let-item>\r\n\t<div class=\"grid-row line-height-sans-1\">\r\n\t\t<div class=\"grid-col-auto text-semibold font-body-3xs\">{{item['orgText']}}</div>\r\n\t</div>\r\n\t<div class=\"font-body-3xs text-italic text-base\">{{item['levelText']}}</div>\r\n</ng-template>\r\n\r\n<ng-template #single let-item>\r\n\t<span>{{item['orgText']}}</span>\r\n</ng-template>\r\n\r\n<ng-template #suggesttemp let-item>\r\n\t<div class=\"grid-row line-height-sans-1 padding-05\">\r\n\t\t<div class=\"grid-col-auto text-semibold font-body-3xs\" id=\"{{settings.id}}_{{item['orgKey']}}\" >{{item['orgText']}}</div>\r\n\t</div>\r\n\t<div class=\"grid-row\">\r\n\t\t<div class=\"grid-col-fill text-light font-body-3xs text-italic\">{{item['levelText']}}</div>\r\n\t</div>\r\n</ng-template>\r\n\r\n<ng-template #selecttemp let-item>\r\n\t<div class=\"grid-row line-height-sans-1 padding-05\">\r\n\t\t<div class=\"grid-col-8 text-semibold font-body-3xs\" id=\"{{settings.id}}_{{item['orgKey']}}\" >{{item['orgText']}}</div>\r\n\t\t<div class=\"grid-col-3 text-light font-body-3xs text-italic\">{{item['levelText']}}</div> <!-- Use grid-col-3 to leave space for the X icon on the chip -->\r\n\t</div>\r\n</ng-template>\r\n\r\n<span class=\"usa-sr-only\" aria-live=\"polite\">{{srOnlyText}}</span>\r\n", dependencies: [{ kind: "directive", type: i0.forwardRef(() => i2.NgIf), selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i0.forwardRef(() => i1$1.SDSAutocompleteComponent), selector: "sds-autocomplete", inputs: ["suggestionTemplate", "selectedItemTemplate", "configuration", "essentialModelFields", "service"] }, { kind: "directive", type: i0.forwardRef(() => i4.NgControlStatus), selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i0.forwardRef(() => i4.NgModel), selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i0.forwardRef(() => AgencyModalComponent), selector: "sds-agency-modal", inputs: ["inputType", "excludesNamedOrg", "modalHint", "isDefaultDept", "lockOnRoleAdminHierarchy", "adminHierarchy", "defaultRoles", "domain", "inactiveToggle", "status", "countFieldLevel", "hasFpds", "environment", "disabled", "agencyButtonId", "simpleResponse", "role"], outputs: ["selectedOrganization"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SdsAgencySelectorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sds-agency-selector', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => SdsAgencySelectorComponent),
                            multi: true
                        },
                        HierarchyService
                    ], changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"level == 0\">\r\n\t<div class=\"display-flex grid-row\"> <!-- usa-grid  grid-gap-05-->\r\n\t\t<div class=\"tablet-lg:flex-1 tablet:flex-1 desktop:flex-11 tablet:grid-col\"> <!-- usa-width-two-thirds-->\r\n\t\t\t<sds-autocomplete [disabled]=\"disabled\" \r\n\t\t\t\t\t\t\t  [service]=\"service\" \r\n\t\t\t\t\t          (ngModelChange)=\"updateItems($event)\" \r\n\t\t\t\t\t\t\t  [(ngModel)]=\"newModel\" #selectorAutocomplete\r\n\t\t\t\t\t\t\t  [configuration]=\"settings\"\r\n\t\t\t\t\t\t\t  [suggestionTemplate]=\"suggesttemp\" \r\n\t\t\t\t\t\t\t  [selectedItemTemplate]=\"selecttemp\"></sds-autocomplete>\r\n\t\t</div>\r\n\t\t<div *ngIf=\"displayAdvanceButton\" class=\"flex-1 tablet:grid-col-auto padding-top-105\"> <!--class=\"usa-width-one-third\"-->\r\n\t\t\t<sds-agency-modal #agencyModal\r\n\t\t\t[excludesNamedOrg]=\"excludesNamedOrg\"\r\n\t\t\t[isDefaultDept]=\"isDefaultDept\"\r\n\t\t\t[countFieldLevel]=\"countFieldLevel\"\r\n\t\t\t[lockOnRoleAdminHierarchy]=\"lockOnRoleAdminHierarchy\"\r\n      [adminHierarchy]=\"adminHierarchy\"\r\n      [defaultRoles]=\"defaultRoles\"\r\n\t\t\t[domain]=\"domain\"\r\n\t\t\t[modalHint]=\"modalHint\"\r\n\t\t\t[hasFpds]=\"hasFpds\"\r\n\t\t\t[inputType]=\"inputType\"\r\n\t\t\t[inactiveToggle]=\"inactiveToggle\"\r\n\t\t\t(selectedOrganization)='updateSelectedItems($event)'\r\n\t\t\t[status]=\"status\"\t\t\t\r\n\t\t\t[environment]=\"environment\"\r\n\t\t\t[disabled]=\"disabled\"\r\n\t\t\t[agencyButtonId]=\"agencyButtonId\"\r\n\t\t\t[simpleResponse]=\"simpleResponse\"\r\n      [role]=\"role\"></sds-agency-modal>\r\n\t\t</div>\r\n\t</div>\r\n</ng-container>\r\n<ng-container *ngIf=\"level != 0\">\r\n\t<label class=\"usa-label margin-top-1\" id=\"{{settings.id}}-label\" for=\"{{settings.id}}\">{{settings.labelText}}</label>\r\n\t<sds-autocomplete [service]=\"service\" (ngModelChange)=\"change($event)\" [(ngModel)]=\"model\"\r\n\t\t[configuration]=\"settings\" [suggestionTemplate]=\"suggesttemp\" [selectedItemTemplate]=\"selecttemp\"></sds-autocomplete>\r\n</ng-container>\r\n<ng-template #temp let-item>\r\n\t<div class=\"grid-row line-height-sans-1\">\r\n\t\t<div class=\"grid-col-auto text-semibold font-body-3xs\">{{item['orgText']}}</div>\r\n\t</div>\r\n\t<div class=\"font-body-3xs text-italic text-base\">{{item['levelText']}}</div>\r\n</ng-template>\r\n\r\n<ng-template #single let-item>\r\n\t<span>{{item['orgText']}}</span>\r\n</ng-template>\r\n\r\n<ng-template #suggesttemp let-item>\r\n\t<div class=\"grid-row line-height-sans-1 padding-05\">\r\n\t\t<div class=\"grid-col-auto text-semibold font-body-3xs\" id=\"{{settings.id}}_{{item['orgKey']}}\" >{{item['orgText']}}</div>\r\n\t</div>\r\n\t<div class=\"grid-row\">\r\n\t\t<div class=\"grid-col-fill text-light font-body-3xs text-italic\">{{item['levelText']}}</div>\r\n\t</div>\r\n</ng-template>\r\n\r\n<ng-template #selecttemp let-item>\r\n\t<div class=\"grid-row line-height-sans-1 padding-05\">\r\n\t\t<div class=\"grid-col-8 text-semibold font-body-3xs\" id=\"{{settings.id}}_{{item['orgKey']}}\" >{{item['orgText']}}</div>\r\n\t\t<div class=\"grid-col-3 text-light font-body-3xs text-italic\">{{item['levelText']}}</div> <!-- Use grid-col-3 to leave space for the X icon on the chip -->\r\n\t</div>\r\n</ng-template>\r\n\r\n<span class=\"usa-sr-only\" aria-live=\"polite\">{{srOnlyText}}</span>\r\n" }]
        }], ctorParameters: () => [{ type: HierarchyService }, { type: AgencyPickerService }, { type: i0.ChangeDetectorRef }], propDecorators: { level: [{
                type: Input
            }], defaultAgency: [{
                type: Input
            }], selectionMode: [{
                type: Input
            }], excludesNamedOrg: [{
                type: Input
            }], isDefaultDept: [{
                type: Input
            }], lockOnRoleAdminHierarchy: [{
                type: Input
            }], adminHierarchy: [{
                type: Input
            }], defaultRoles: [{
                type: Input
            }], domain: [{
                type: Input
            }], role: [{
                type: Input
            }], disabled: [{
                type: Input
            }], status: [{
                type: Input
            }], errorMessage: [{
                type: Input
            }], label: [{
                type: Input
            }], hint: [{
                type: Input
            }], settings: [{
                type: Input
            }], prefix: [{
                type: Input
            }], agencyButtonId: [{
                type: Input
            }], requiredFlag: [{
                type: Input
            }], fieldLevels: [{
                type: Input
            }], hasFpds: [{
                type: Input
            }], displayAdvanceButton: [{
                type: Input
            }], countFieldLevel: [{
                type: Input
            }], modalHint: [{
                type: Input
            }], inputType: [{
                type: Input
            }], inactiveToggle: [{
                type: Input
            }], environment: [{
                type: Input
            }], simpleResponse: [{
                type: Input
            }], advanceClick: [{
                type: Output
            }], advanceButton: [{
                type: ViewChild,
                args: ['advanceButton']
            }], selectorAutocomplete: [{
                type: ViewChild,
                args: ['selectorAutocomplete']
            }] } });
class AgencyModalComponent {
    constructor(dialog) {
        this.dialog = dialog;
        this.inputType = "radio";
        this.excludesNamedOrg = '';
        this.modalHint = '';
        this.isDefaultDept = false;
        this.lockOnRoleAdminHierarchy = '';
        this.adminHierarchy = false;
        this.defaultRoles = false;
        this.domain = '';
        this.inactiveToggle = true;
        this.status = 'active';
        this.countFieldLevel = 7;
        this.hasFpds = false;
        this.environment = {};
        this.disabled = false;
        this.agencyButtonId = "agency-modal-button";
        this.simpleResponse = false; // true: limits model response to key/text fields. False: full model returned.
        this.role = '';
        this.selectedOrganization = new EventEmitter();
    }
    openDialog() {
        const dialogRef = this.dialog.open(AgencyPickerModalDialog, {
            width: 'large',
            data: { selectedOrg: null,
                inputType: this.inputType,
                excludesNamedOrg: this.excludesNamedOrg,
                modalHint: this.modalHint,
                isDefaultDept: this.isDefaultDept,
                lockOnRoleAdminHierarchy: this.lockOnRoleAdminHierarchy,
                domain: this.domain,
                inactiveToggle: this.inactiveToggle,
                status: this.status,
                countFieldLevel: this.countFieldLevel,
                hasFpds: this.hasFpds,
                environment: this.environment,
                simpleResponse: this.simpleResponse,
                role: this.role,
                adminHierarchy: this.adminHierarchy,
                defaultRoles: this.defaultRoles
            },
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result !== undefined && result.selectedOrg !== undefined) {
                this.selectedOrganization.emit(result.selectedOrg);
            }
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: AgencyModalComponent, deps: [{ token: i1$1.SdsDialogService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: AgencyModalComponent, selector: "sds-agency-modal", inputs: { inputType: "inputType", excludesNamedOrg: "excludesNamedOrg", modalHint: "modalHint", isDefaultDept: "isDefaultDept", lockOnRoleAdminHierarchy: "lockOnRoleAdminHierarchy", adminHierarchy: "adminHierarchy", defaultRoles: "defaultRoles", domain: "domain", inactiveToggle: "inactiveToggle", status: "status", countFieldLevel: "countFieldLevel", hasFpds: "hasFpds", environment: "environment", disabled: "disabled", agencyButtonId: "agencyButtonId", simpleResponse: "simpleResponse", role: "role" }, outputs: { selectedOrganization: "selectedOrganization" }, viewQueries: [{ propertyName: "agencyTable", first: true, predicate: ["agencyTable"], descendants: true }, { propertyName: "agencyFilter", first: true, predicate: ["agencyFilter"], descendants: true }, { propertyName: "resultsListElement", first: true, predicate: ["resultsList"], descendants: true }], ngImport: i0, template: "<button #advanceButton type=\"button\" class=\"sds-button--circle\"\r\n    [attr.disabled]=\"disabled?'disabled':undefined\"\r\n    [ngClass]=\"{'disabled':disabled}\"\r\n    (click)=\"openDialog()\"\r\n    [id]=\"agencyButtonId\">\r\n    <span class=\"usa-sr-only\">open advanced</span>\r\n    <usa-icon [icon]=\"'three-dots'\" class=\"margin-top-05 margin-left-1px\"></usa-icon>\r\n</button>\r\n", dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: i3.IconComponent, selector: "usa-icon", inputs: ["icon", "rotate", "size", "classes", "skew"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: AgencyModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sds-agency-modal', template: "<button #advanceButton type=\"button\" class=\"sds-button--circle\"\r\n    [attr.disabled]=\"disabled?'disabled':undefined\"\r\n    [ngClass]=\"{'disabled':disabled}\"\r\n    (click)=\"openDialog()\"\r\n    [id]=\"agencyButtonId\">\r\n    <span class=\"usa-sr-only\">open advanced</span>\r\n    <usa-icon [icon]=\"'three-dots'\" class=\"margin-top-05 margin-left-1px\"></usa-icon>\r\n</button>\r\n" }]
        }], ctorParameters: () => [{ type: i1$1.SdsDialogService }], propDecorators: { inputType: [{
                type: Input
            }], excludesNamedOrg: [{
                type: Input
            }], modalHint: [{
                type: Input
            }], isDefaultDept: [{
                type: Input
            }], lockOnRoleAdminHierarchy: [{
                type: Input
            }], adminHierarchy: [{
                type: Input
            }], defaultRoles: [{
                type: Input
            }], domain: [{
                type: Input
            }], inactiveToggle: [{
                type: Input
            }], status: [{
                type: Input
            }], countFieldLevel: [{
                type: Input
            }], hasFpds: [{
                type: Input
            }], environment: [{
                type: Input
            }], disabled: [{
                type: Input
            }], agencyButtonId: [{
                type: Input
            }], simpleResponse: [{
                type: Input
            }], role: [{
                type: Input
            }], agencyTable: [{
                type: ViewChild,
                args: ['agencyTable']
            }], agencyFilter: [{
                type: ViewChild,
                args: ['agencyFilter']
            }], resultsListElement: [{
                type: ViewChild,
                args: ['resultsList']
            }], selectedOrganization: [{
                type: Output
            }] } });
class AgencyPickerModalDialog {
    constructor(dialogRef, data, agencyPickerService, hierarchyService, cdr) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.agencyPickerService = agencyPickerService;
        this.hierarchyService = hierarchyService;
        this.cdr = cdr;
        this.filter = {};
        this.inputValue = '';
        this.modalWindowConfig = {
            type: "plain",
            select: "Select",
            cancel: "Cancel",
            title: "Federal Organizations"
        };
        this.isOpen = true;
        hierarchyService.setEnvironment(data.environment);
        this.subscription = this.agencyPickerService.filterUpdate.subscribe((filter) => {
            this.filter = filter;
            this.updateFilter(filter);
        });
    }
    onNoClick() {
        this.dialogRef.close();
        this.updateFilter({
            _meta: {
                src: "modal"
            }
        });
        this.removeSubscription();
        this.agencyPickerService.updateFilter(this.filter);
        this.isOpen = false;
        if (this.agencyPickerService && this.agencyPickerService.advanceButton) {
            this.agencyPickerService.advanceButton.nativeElement.focus();
        }
    }
    ngOnInit() {
        this.filter._meta = {
            src: "modal"
        };
        this.agencyPickerService.updateFilter(this.filter);
    }
    ngOnDestroy() {
        this.removeSubscription();
    }
    removeSubscription() {
        if (this.subscription) {
            if (this.agencyTable) {
                this.agencyTable.removeSubscription();
            }
            this.subscription.unsubscribe();
        }
    }
    updateFilter(filter) {
        this.filter = filter;
        this.hierarchyService.filter = filter;
    }
    getLabel(level) {
        return HierarchyLabels[level];
    }
    selectClick() {
        this.data.selectedOrg = [];
        if (this.data.inputType === "checkbox") {
            for (let i = 0; i < this.agencyTable.result.length; i++) {
                const item = this.agencyTable.result[i];
                if (item.isChecked) {
                    item.isChecked = false;
                    this.data.selectedOrg.push(item);
                }
            }
        }
        else if (this.data.inputType === "radio") {
            const item = this.agencyTable.result.find(item2 => {
                // tslint:disable-next-line: triple-equals
                if (item2.orgKey == this.agencyTable.radioVal) { // Cannot use triple equals here
                    return true;
                }
            });
            this.data.selectedOrg.push(item);
        }
        this.data.selectedOrg = this.hierarchyService.getResponseArraySelector(this.data.selectedOrg, this.data.simpleResponse);
        this.updateFilter({
            _meta: {
                src: "modal"
            }
        });
        this.removeSubscription();
        //TODO this.agencyModal.closeModal();
        this.isOpen = false;
        this.agencyPickerService.updateFilter(this.filter);
        if (this.agencyPickerService && this.agencyPickerService.advanceButton) {
            this.agencyPickerService.advanceButton.nativeElement.focus();
        }
    }
    get isSubmissionReady() {
        if (this.agencyTable) {
            if ((this.data.inputType === 'checkbox' && this.agencyTable.checkedCounter > 0)
                || (this.data.inputType === 'radio' && this.agencyTable.radioVal)) {
                return true;
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: AgencyPickerModalDialog, deps: [{ token: i1$1.SdsDialogRef }, { token: SDS_DIALOG_DATA }, { token: AgencyPickerService }, { token: HierarchyService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: AgencyPickerModalDialog, selector: "sds-agency-modal-contents", viewQueries: [{ propertyName: "agencyTable", first: true, predicate: ["agencyTable"], descendants: true }, { propertyName: "agencyFilter", first: true, predicate: ["agencyFilter"], descendants: true }, { propertyName: "resultsListElement", first: true, predicate: ["resultsList"], descendants: true }], ngImport: i0, template: "<div sds-dialog-title>{{modalWindowConfig.title}}</div>\r\n<div sds-dialog-content>\r\n  <div class=\"grid-row grid-gap-3\">\r\n    <div class=\"tablet:grid-col-4\">\r\n      <sds-agency-filter #agencyFilter [inactiveToggle]=\"data.inactiveToggle\" [excludesNamedOrg]=\"data.excludesNamedOrg\"\r\n        [isDefaultDept]=\"data.isDefaultDept\" [lockOnRoleAdminHierarchy]=\"data.lockOnRoleAdminHierarchy\" [adminHierarchy]=\"data.adminHierarchy\"\r\n        [defaultRoles]=\"data.defaultRoles\" [domain]=\"data.domain\" [status]=\"data.status\" [hasFpds]=\"data.hasFpds\" [countFieldLevel]=\"data.countFieldLevel\"\r\n      [role]=\"data.role\">\r\n      </sds-agency-filter>\r\n    </div>\r\n    <div class=\"tablet:grid-col-8\">\r\n      <div>\r\n        <sds-agency-table #agencyTable [excludesNamedOrg]=\"data.excludesNamedOrg\" [isDefaultDept]=\"data.isDefaultDept\"\r\n          [lockOnRoleAdminHierarchy]=\"data.lockOnRoleAdminHierarchy\" [domain]=\"data.domain\" [adminHierarchy]=\"data.adminHierarchy\" [status]=\"data.status\"\r\n          [defaultRoles]=\"data.defaultRoles\" [inputType]=\"data.inputType\" [hasFpds]=\"data.hasFpds\" [countFieldLevel]=\"data.countFieldLevel\" [role]=\"data.role\">\r\n        </sds-agency-table>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div sds-dialog-actions>\r\n  <button class=\"usa-button usa-button--base bg-base-lighter\" (click)=\"onNoClick()\">\r\n    {{modalWindowConfig.cancel}}\r\n  </button>\r\n  <button class=\"usa-button\" (click)=\"selectClick()\" [sds-dialog-close]=\"data\" cdkFocusInitial>\r\n    {{modalWindowConfig.select}}\r\n  </button>\r\n</div>\r\n", dependencies: [{ kind: "directive", type: i1$1.SdsDialogCloseDirective, selector: "button[sds-dialog-close], button[sdsDialogClose]", inputs: ["aria-label", "sds-dialog-close", "sdsDialogClose"], exportAs: ["sdsDialogClose"] }, { kind: "directive", type: i1$1.SdsDialogTitleDirective, selector: "[sds-dialog-title], [sdsDialogTitle]", inputs: ["id"], exportAs: ["sdsDialogTitle"] }, { kind: "directive", type: i1$1.SdsDialogContentDirective, selector: "[sds-dialog-content], sds-dialog-content, [sdsDialogContent]" }, { kind: "directive", type: i1$1.SdsDialogActionsDirective, selector: "[sds-dialog-actions], sds-dialog-actions, [sdsDialogActions]" }, { kind: "component", type: AgencyFilterComponent, selector: "sds-agency-filter", inputs: ["excludesNamedOrg", "isDefaultDept", "lockOnRoleAdminHierarchy", "adminHierarchy", "defaultRoles", "domain", "status", "inactiveToggle", "countFieldLevel", "hasFpds", "environment", "role"] }, { kind: "component", type: AgencyTableComponent, selector: "sds-agency-table", inputs: ["level", "inputType", "excludesNamedOrg", "isDefaultDept", "lockOnRoleAdminHierarchy", "adminHierarchy", "defaultRoles", "domain", "status", "countFieldLevel", "hasFpds", "role"], outputs: ["itemChecked"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: AgencyPickerModalDialog, decorators: [{
            type: Component,
            args: [{ selector: 'sds-agency-modal-contents', template: "<div sds-dialog-title>{{modalWindowConfig.title}}</div>\r\n<div sds-dialog-content>\r\n  <div class=\"grid-row grid-gap-3\">\r\n    <div class=\"tablet:grid-col-4\">\r\n      <sds-agency-filter #agencyFilter [inactiveToggle]=\"data.inactiveToggle\" [excludesNamedOrg]=\"data.excludesNamedOrg\"\r\n        [isDefaultDept]=\"data.isDefaultDept\" [lockOnRoleAdminHierarchy]=\"data.lockOnRoleAdminHierarchy\" [adminHierarchy]=\"data.adminHierarchy\"\r\n        [defaultRoles]=\"data.defaultRoles\" [domain]=\"data.domain\" [status]=\"data.status\" [hasFpds]=\"data.hasFpds\" [countFieldLevel]=\"data.countFieldLevel\"\r\n      [role]=\"data.role\">\r\n      </sds-agency-filter>\r\n    </div>\r\n    <div class=\"tablet:grid-col-8\">\r\n      <div>\r\n        <sds-agency-table #agencyTable [excludesNamedOrg]=\"data.excludesNamedOrg\" [isDefaultDept]=\"data.isDefaultDept\"\r\n          [lockOnRoleAdminHierarchy]=\"data.lockOnRoleAdminHierarchy\" [domain]=\"data.domain\" [adminHierarchy]=\"data.adminHierarchy\" [status]=\"data.status\"\r\n          [defaultRoles]=\"data.defaultRoles\" [inputType]=\"data.inputType\" [hasFpds]=\"data.hasFpds\" [countFieldLevel]=\"data.countFieldLevel\" [role]=\"data.role\">\r\n        </sds-agency-table>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div sds-dialog-actions>\r\n  <button class=\"usa-button usa-button--base bg-base-lighter\" (click)=\"onNoClick()\">\r\n    {{modalWindowConfig.cancel}}\r\n  </button>\r\n  <button class=\"usa-button\" (click)=\"selectClick()\" [sds-dialog-close]=\"data\" cdkFocusInitial>\r\n    {{modalWindowConfig.select}}\r\n  </button>\r\n</div>\r\n" }]
        }], ctorParameters: () => [{ type: i1$1.SdsDialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [SDS_DIALOG_DATA]
                }] }, { type: AgencyPickerService }, { type: HierarchyService }, { type: i0.ChangeDetectorRef }], propDecorators: { agencyTable: [{
                type: ViewChild,
                args: ['agencyTable']
            }], agencyFilter: [{
                type: ViewChild,
                args: ['agencyFilter']
            }], resultsListElement: [{
                type: ViewChild,
                args: ['resultsList']
            }] } });

class SystemConfig {
}

class SdsAgencyPickerComponent {
    constructor(config, cd, agencyPickerService, authUserService, userAccessService, fhService, wrapper) {
        this.config = config;
        this.cd = cd;
        this.agencyPickerService = agencyPickerService;
        this.authUserService = authUserService;
        this.userAccessService = userAccessService;
        this.fhService = fhService;
        this.wrapper = wrapper;
        this.environment = {};
        this.model = {};
        this.multiple = true;
        this.filter = {};
        this.disabled = false;
        this.rootLevel = 0;
        /**
         * Set selection type for picker, multiple - checkbox, single - radio
         */
        this.selectionType = 'radio';
        /**
         * load organizations based on user role
         * hierarchyBelow - get roles orgs and children
         * hierarchy - get roles orgs, parents, and children
         * roles - get only role orgs
         */
        this.lockOnRoleAdminHierarchy = '';
        /**
         * Only get the children org below the orgID input here
         */
        this.excludesNamedOrg = '';
        /**
         * Lock the search results to the user's hierarchy only
         */
        this.isDefaultDept = false;
        /**
         * sets label text
         */
        this.label = "Federal Hierarchy";
        /**
         * sets hint text
         */
        this.hint = "Enter your Department, Ind. Agency, Subtier, Office, or other organization.";
        /**
         * sets hint text
         */
        this.modalHint = "";
        /**
         * sets error message in label wrapper
         */
        this.errorMessage = "";
        /**
         * sets required marker
         */
        this.requiredFlag = false;
        /**
         * sets prefix text on 508 ids to help keep them unique when multiple instances exist
         */
        this.prefix = "";
        /**
         * hides inactive toggle filter
         */
        this.inactiveToggle = true;
        this.lockOnRoleAdminHierarchyInitialEmit = true;
        this.adminHierarchy = false;
        this.defaultRoles = false;
        /**
         * Display on the required number of levels.
         */
        this.countFieldLevel = 7;
        /**
         * load organizations based on the status
         */
        this.status = "active";
        /**
         * agency picker domain.
         */
        this.domain = '';
        /**
         * agency picker role.
         */
        this.role = '';
        /**
         * display fpds code instead of code on items display
         */
        this.hasFpds = false;
        this.fieldLevels = '';
        /**
         * Toggle for displaying advance agency selector modal
         */
        this.displayAdvanceButton = true;
        /**
         * true: limits model response to key/text fields. False: full model returned. Default is false.
         */
        this.simpleResponse = false;
        this._onChange = (_) => { };
        this._onTouched = () => { };
        if (config != null) {
            this.environment = config.environment;
        }
        else {
            this.environment = SdsAgencyPickerComponent.testEnv;
        }
        this.fhService.setEnvironment(this.environment);
    }
    static { this.testEnv = {}; }
    static setEnvironment(env) {
        this.testEnv = env;
    }
    // Method that is fired when the child component event notifies us that the items array has been modified within the child component
    updateItems($event) {
        setTimeout(() => {
            this.updateModel();
        }, 0);
    }
    // Helper method that gets a new instance of the selectModel and notifies ControlValueAccessor that we have a new selectModel for this FormControl (our custom component)
    updateModel() {
        const selectModel = this.getSelectModel();
        this._onChange(selectModel);
    }
    // Helper method to return a new instance of an array that contains our items
    getSelectModel() {
        return [...this.model];
    }
    writeValue(value) {
        if (value && value.length && this.model !== value) {
            this.model = value;
            this.cd.markForCheck();
        }
        else {
            this.model = {};
            this.cd.markForCheck();
        }
    }
    // ControlValueAccessor hook that lets us call this._onChange(var) to let the form know our variable has changed (in this case selectModel)
    registerOnChange(fn) {
        this._onChange = fn;
    }
    // ControlValueAccessor hook (not used)
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
    /********* */
    ngOnChanges(c) {
        if (c['lockOnRoleAdminHierarchy']) {
            if (this.lockOnRoleAdminHierarchy) {
                // tslint:disable-next-line: prefer-const
                let userId = this.authUserService.getLoggedInUserId();
                if (userId) {
                    this.fhService.getOrganizationsForRoles().subscribe(data => {
                        // if only one role org
                        // tslint:disable-next-line: triple-equals
                        if (data.orgKey != null) {
                            // tslint:disable-next-line: prefer-const
                            let org = data.orgKey;
                            this.fhService.getFHOrganizationById(org, true).subscribe(data2 => {
                                //if orgsOnly or 'all' and no children
                                if (this.lockOnRoleAdminHierarchy === 'roles' ||
                                    (this.lockOnRoleAdminHierarchy === 'hierarchyBelow'
                                        && data2._embedded
                                        && data2._embedded[0]['org']['hierarchy']
                                        && data2._embedded[0]['org']['hierarchy'].length === 0)) {
                                    //add the only possible selection and disable
                                    const org2 = data2._embedded.map(item => {
                                        if (item) {
                                            return item.org;
                                        }
                                    });
                                    this.agencySelector.addItem(org2[0]);
                                    if (this.lockOnRoleAdminHierarchyInitialEmit) {
                                        this._onChange(this.agencySelector.model);
                                    }
                                    this.setDisabledState(true);
                                }
                                else if (this.lockOnRoleAdminHierarchy === 'hierarchy') {
                                    this.setDisabledState(false);
                                }
                            });
                        }
                    });
                }
            }
        }
    }
    ngOnInit() {
        // Fix Input types, in case they came in as string
        this.isDefaultDept = this.getBooleanValue(this.isDefaultDept);
        this.requiredFlag = this.getBooleanValue(this.requiredFlag);
        this.inactiveToggle = this.getBooleanValue(this.inactiveToggle);
        this.lockOnRoleAdminHierarchyInitialEmit = this.getBooleanValue(this.lockOnRoleAdminHierarchyInitialEmit);
        this.hasFpds = this.getBooleanValue(this.hasFpds);
        this.defaultRoles = this.getBooleanValue(this.defaultRoles);
        this.adminHierarchy = this.getBooleanValue(this.adminHierarchy);
        this.displayAdvanceButton = this.getBooleanValue(this.displayAdvanceButton);
        this.simpleResponse = this.getBooleanValue(this.simpleResponse);
        this.countFieldLevel = this.getNumberValue(this.countFieldLevel);
        // handles organizations added from main selector
        this.agencyPickerService.selectionUpdate.subscribe(data => {
            if (data && Array.isArray(data)) {
                data = data.slice(0);
            }
            this._onChange(data);
        });
    }
    getBooleanValue(value) {
        return typeof (value) === "boolean" ? value : value === "true";
    }
    getNumberValue(value) {
        return typeof (value) === "number" ? value : +value;
    }
    ngAfterViewInit() {
        if (this.control) {
            this.agencySelector.setupWrapper(this.control);
        }
        this.agencySelector.setEnvironment(this.environment);
    }
    advanceClick() {
        this._onTouched();
        if (!this.disabled) {
            this.agencyModal.openModal();
        }
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SdsAgencyPickerComponent, deps: [{ token: SystemConfig, optional: true }, { token: i0.ChangeDetectorRef }, { token: AgencyPickerService }, { token: AuthUserService }, { token: UserAccessService }, { token: FHService }, { token: WrapperService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: SdsAgencyPickerComponent, selector: "sds-agency-picker", inputs: { selectionType: "selectionType", lockOnRoleAdminHierarchy: "lockOnRoleAdminHierarchy", excludesNamedOrg: "excludesNamedOrg", isDefaultDept: "isDefaultDept", control: "control", label: "label", hint: "hint", modalHint: "modalHint", errorMessage: "errorMessage", requiredFlag: "requiredFlag", prefix: "prefix", inactiveToggle: "inactiveToggle", lockOnRoleAdminHierarchyInitialEmit: "lockOnRoleAdminHierarchyInitialEmit", adminHierarchy: "adminHierarchy", defaultRoles: "defaultRoles", countFieldLevel: "countFieldLevel", status: "status", domain: "domain", role: "role", hasFpds: "hasFpds", fieldLevels: "fieldLevels", displayAdvanceButton: "displayAdvanceButton", simpleResponse: "simpleResponse" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => SdsAgencyPickerComponent),
                multi: true
            }
        ], viewQueries: [{ propertyName: "agencySelector", first: true, predicate: ["agencySelector"], descendants: true }, { propertyName: "resultsListElement", first: true, predicate: ["resultsList"], descendants: true }, { propertyName: "agencyModal", first: true, predicate: ["agencyModal"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "    <sds-agency-selector #agencySelector *ngIf=\"environment != undefined\"\r\n      [label]=\"label\" \r\n      [errorMessage]=\"errorMessage\" \r\n      [hint]=\"hint\"\r\n      [excludesNamedOrg]=\"excludesNamedOrg\" \r\n      [isDefaultDept]=\"isDefaultDept\"\r\n      [lockOnRoleAdminHierarchy]=\"lockOnRoleAdminHierarchy\"\r\n      [defaultRoles]=\"defaultRoles\"\r\n      [adminHierarchy]=\"adminHierarchy\"\r\n      [domain]=\"domain\" \r\n      [role]=\"role\"\r\n      [status]=\"status\" \r\n      [level]=\"rootLevel\"\r\n      [fieldLevels]=\"fieldLevels\" \r\n      [hasFpds]=\"hasFpds\" \r\n      [prefix]=\"prefix\" \r\n      [requiredFlag]=\"requiredFlag\"\r\n      [disabled]=\"disabled\" \r\n      [selectionMode]=\"selectionType == 'radio' ? 0 : 1\"\r\n      [displayAdvanceButton]=\"displayAdvanceButton\" \r\n      (advanceClick)=\"advanceClick()\"\r\n      [countFieldLevel]=\"countFieldLevel\" \r\n      [modalHint]=\"modalHint\" \r\n      [inputType]=\"selectionType\"\r\n      [inactiveToggle]=\"inactiveToggle\"\r\n      [simpleResponse]=\"simpleResponse\"\r\n      [(ngModel)]=\"model\" (ngModelChange)=\"updateItems($event)\"\r\n      [environment]=\"environment\"></sds-agency-selector>\r\n", dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i4.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: SdsAgencySelectorComponent, selector: "sds-agency-selector", inputs: ["level", "defaultAgency", "selectionMode", "excludesNamedOrg", "isDefaultDept", "lockOnRoleAdminHierarchy", "adminHierarchy", "defaultRoles", "domain", "role", "disabled", "status", "errorMessage", "label", "hint", "settings", "prefix", "agencyButtonId", "requiredFlag", "fieldLevels", "hasFpds", "displayAdvanceButton", "countFieldLevel", "modalHint", "inputType", "inactiveToggle", "environment", "simpleResponse"], outputs: ["advanceClick"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SdsAgencyPickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sds-agency-picker', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => SdsAgencyPickerComponent),
                            multi: true
                        }
                    ], changeDetection: ChangeDetectionStrategy.OnPush, template: "    <sds-agency-selector #agencySelector *ngIf=\"environment != undefined\"\r\n      [label]=\"label\" \r\n      [errorMessage]=\"errorMessage\" \r\n      [hint]=\"hint\"\r\n      [excludesNamedOrg]=\"excludesNamedOrg\" \r\n      [isDefaultDept]=\"isDefaultDept\"\r\n      [lockOnRoleAdminHierarchy]=\"lockOnRoleAdminHierarchy\"\r\n      [defaultRoles]=\"defaultRoles\"\r\n      [adminHierarchy]=\"adminHierarchy\"\r\n      [domain]=\"domain\" \r\n      [role]=\"role\"\r\n      [status]=\"status\" \r\n      [level]=\"rootLevel\"\r\n      [fieldLevels]=\"fieldLevels\" \r\n      [hasFpds]=\"hasFpds\" \r\n      [prefix]=\"prefix\" \r\n      [requiredFlag]=\"requiredFlag\"\r\n      [disabled]=\"disabled\" \r\n      [selectionMode]=\"selectionType == 'radio' ? 0 : 1\"\r\n      [displayAdvanceButton]=\"displayAdvanceButton\" \r\n      (advanceClick)=\"advanceClick()\"\r\n      [countFieldLevel]=\"countFieldLevel\" \r\n      [modalHint]=\"modalHint\" \r\n      [inputType]=\"selectionType\"\r\n      [inactiveToggle]=\"inactiveToggle\"\r\n      [simpleResponse]=\"simpleResponse\"\r\n      [(ngModel)]=\"model\" (ngModelChange)=\"updateItems($event)\"\r\n      [environment]=\"environment\"></sds-agency-selector>\r\n" }]
        }], ctorParameters: () => [{ type: SystemConfig, decorators: [{
                    type: Optional
                }] }, { type: i0.ChangeDetectorRef }, { type: AgencyPickerService }, { type: AuthUserService }, { type: UserAccessService }, { type: FHService }, { type: WrapperService }], propDecorators: { selectionType: [{
                type: Input
            }], lockOnRoleAdminHierarchy: [{
                type: Input
            }], excludesNamedOrg: [{
                type: Input
            }], isDefaultDept: [{
                type: Input
            }], control: [{
                type: Input
            }], label: [{
                type: Input
            }], hint: [{
                type: Input
            }], modalHint: [{
                type: Input
            }], errorMessage: [{
                type: Input
            }], requiredFlag: [{
                type: Input
            }], prefix: [{
                type: Input
            }], inactiveToggle: [{
                type: Input
            }], lockOnRoleAdminHierarchyInitialEmit: [{
                type: Input
            }], adminHierarchy: [{
                type: Input
            }], defaultRoles: [{
                type: Input
            }], countFieldLevel: [{
                type: Input
            }], status: [{
                type: Input
            }], domain: [{
                type: Input
            }], role: [{
                type: Input
            }], hasFpds: [{
                type: Input
            }], fieldLevels: [{
                type: Input
            }], displayAdvanceButton: [{
                type: Input
            }], simpleResponse: [{
                type: Input
            }], agencySelector: [{
                type: ViewChild,
                args: ['agencySelector']
            }], resultsListElement: [{
                type: ViewChild,
                args: ['resultsList']
            }], agencyModal: [{
                type: ViewChild,
                args: ["agencyModal"]
            }] } });

class SdsAgencyPickersModule {
    static forRoot(config) {
        return {
            ngModule: SdsAgencyPickersModule,
            providers: [
                { provide: SystemConfig, useValue: config }
            ]
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SdsAgencyPickersModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: SdsAgencyPickersModule, declarations: [SdsAgencyPickerComponent,
            SdsAgencySelectorComponent,
            AgencyModalComponent,
            AgencyPickerModalDialog,
            AgencyFilterComponent,
            AgencyTableComponent], imports: [CommonModule,
            A11yModule,
            IconModule,
            SdsAutocompleteModule,
            SdsDialogModule,
            FormsModule,
            ReactiveFormsModule, i1$2.NgxBootstrapIconsModule], exports: [SdsAgencyPickerComponent,
            SdsAgencySelectorComponent,
            AgencyModalComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SdsAgencyPickersModule, providers: [
            AuthUserService,
            FHService,
            WrapperService,
            HierarchyService,
            AgencyPickerService,
            UserAccessService
        ], imports: [CommonModule,
            A11yModule,
            IconModule,
            SdsAutocompleteModule,
            SdsDialogModule,
            FormsModule,
            ReactiveFormsModule,
            NgxBootstrapIconsModule.pick({ threeDots })] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SdsAgencyPickersModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        A11yModule,
                        IconModule,
                        SdsAutocompleteModule,
                        SdsDialogModule,
                        FormsModule,
                        ReactiveFormsModule,
                        NgxBootstrapIconsModule.pick({ threeDots }),
                    ],
                    providers: [
                        AuthUserService,
                        FHService,
                        WrapperService,
                        HierarchyService,
                        AgencyPickerService,
                        UserAccessService
                    ],
                    exports: [
                        SdsAgencyPickerComponent,
                        SdsAgencySelectorComponent,
                        AgencyModalComponent
                    ],
                    declarations: [
                        SdsAgencyPickerComponent,
                        SdsAgencySelectorComponent,
                        AgencyModalComponent,
                        AgencyPickerModalDialog,
                        AgencyFilterComponent,
                        AgencyTableComponent
                    ]
                }]
        }] });

class FormlyFieldSdsAgencyPickerComponent extends AbstractSdsFormly {
    constructor(_cdr) {
        super(); /* istanbul ignore next */
        this.defaultOptions = {
            props: {
                selectionType: 'radio',
                lockOnRoleAdminHierarchy: '',
                excludesNamedOrg: '',
                isDefaultDept: false,
                label: 'Federal Hierarchy',
                hint: 'Enter your Department, Ind. Agency, Subtier, Office, or other organization.',
                modalHint: '',
                errorMessage: '',
                requiredFlag: false,
                prefix: '',
                inactiveToggle: true,
                lockOnRoleAdminHierarchyInitialEmit: true,
                adminHierarchy: false,
                defaultRoles: false,
                countFieldLevel: 7,
                status: 'active',
                domain: '',
                role: '',
                hasFpds: false,
                fieldLevels: '',
                displayAdvanceButton: true,
                simpleResponse: false
            },
        };
        this.cdr = _cdr;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: FormlyFieldSdsAgencyPickerComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: FormlyFieldSdsAgencyPickerComponent, selector: "ng-component", viewQueries: [{ propertyName: "template", first: true, predicate: SdsAgencyPickerComponent, descendants: true, static: true }], usesInheritance: true, ngImport: i0, template: `
   <sds-agency-picker [formControl]="formControl"
      [selectionType]="to.selectionType"
      [lockOnRoleAdminHierarchy]="to.lockOnRoleAdminHierarchy"
      [defaultRoles]="to.defaultRoles"
      [adminHierarchy]="to.adminHierarchy"
      [excludesNamedOrg]="to.excludesNamedOrg"
      [isDefaultDept]="to.isDefaultDept"
      [control]="formControl"
      [label]="to.label"
      [hint]="to.hint"
      [modalHint]="to.modalHint"
      [errorMessage]="to.errorMessage"
      [requiredFlag]="to.requiredFlag"
      [prefix]="to.prefix"
      [inactiveToggle]="to.inactiveToggle"
      [lockOnRoleAdminHierarchyInitialEmit]="to.lockOnRoleAdminHierarchyInitialEmit"
      [countFieldLevel]="to.countFieldLevel"
      [status]="to.status"
      [domain]="to.domain"
      [role]="to.role"
      [hasFpds]="to.hasFpds"
      [fieldLevels]="to.fieldLevels"
      [simpleResponse]="to.simpleResponse"
      [displayAdvanceButton]="to.displayAdvanceButton">
    </sds-agency-picker>
    `, isInline: true, dependencies: [{ kind: "directive", type: i4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "component", type: SdsAgencyPickerComponent, selector: "sds-agency-picker", inputs: ["selectionType", "lockOnRoleAdminHierarchy", "excludesNamedOrg", "isDefaultDept", "control", "label", "hint", "modalHint", "errorMessage", "requiredFlag", "prefix", "inactiveToggle", "lockOnRoleAdminHierarchyInitialEmit", "adminHierarchy", "defaultRoles", "countFieldLevel", "status", "domain", "role", "hasFpds", "fieldLevels", "displayAdvanceButton", "simpleResponse"] }, { kind: "directive", type: i4.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: FormlyFieldSdsAgencyPickerComponent, decorators: [{
            type: Component,
            args: [{
                    template: `
   <sds-agency-picker [formControl]="formControl"
      [selectionType]="to.selectionType"
      [lockOnRoleAdminHierarchy]="to.lockOnRoleAdminHierarchy"
      [defaultRoles]="to.defaultRoles"
      [adminHierarchy]="to.adminHierarchy"
      [excludesNamedOrg]="to.excludesNamedOrg"
      [isDefaultDept]="to.isDefaultDept"
      [control]="formControl"
      [label]="to.label"
      [hint]="to.hint"
      [modalHint]="to.modalHint"
      [errorMessage]="to.errorMessage"
      [requiredFlag]="to.requiredFlag"
      [prefix]="to.prefix"
      [inactiveToggle]="to.inactiveToggle"
      [lockOnRoleAdminHierarchyInitialEmit]="to.lockOnRoleAdminHierarchyInitialEmit"
      [countFieldLevel]="to.countFieldLevel"
      [status]="to.status"
      [domain]="to.domain"
      [role]="to.role"
      [hasFpds]="to.hasFpds"
      [fieldLevels]="to.fieldLevels"
      [simpleResponse]="to.simpleResponse"
      [displayAdvanceButton]="to.displayAdvanceButton">
    </sds-agency-picker>
    `,
                    changeDetection: ChangeDetectionStrategy.OnPush
                }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }], propDecorators: { template: [{
                type: ViewChild,
                args: [SdsAgencyPickerComponent, { static: true }]
            }] } });

class SharedFormlyModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SharedFormlyModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: SharedFormlyModule, declarations: [FormlyFieldSdsAgencyPickerComponent], imports: [CommonModule,
            FormsModule,
            SdsAgencyPickersModule,
            ReactiveFormsModule, i1$3.SdsFormlyModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SharedFormlyModule, imports: [CommonModule,
            FormsModule,
            SdsAgencyPickersModule,
            ReactiveFormsModule,
            SdsFormlyModule.forChild({
                types: [{
                        name: 'agency-picker',
                        component: FormlyFieldSdsAgencyPickerComponent,
                        wrappers: sdsWrappers
                    }]
            })] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SharedFormlyModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        FormlyFieldSdsAgencyPickerComponent
                    ],
                    imports: [
                        CommonModule,
                        FormsModule,
                        SdsAgencyPickersModule,
                        ReactiveFormsModule,
                        SdsFormlyModule.forChild({
                            types: [{
                                    name: 'agency-picker',
                                    component: FormlyFieldSdsAgencyPickerComponent,
                                    wrappers: sdsWrappers
                                }]
                        }),
                    ]
                }]
        }] });

class ApiInterceptor {
    constructor(config) {
        this.config = config;
    }
    intercept(req, next) {
        req = req.clone({
            setParams: { 'api-key': this.config.apiKey },
            url: this.config.apiUrl + req.url,
        });
        return next.handle(req);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: ApiInterceptor, deps: [{ token: SessionConfig }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: ApiInterceptor }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: ApiInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: SessionConfig }] });

class ApiNoCacheInterceptor {
    constructor(config) {
        this.config = config;
    }
    intercept(req, next) {
        const random = new Date().getTime().toString();
        req = req.clone({
            setParams: { random: random },
        });
        return next.handle(req);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: ApiNoCacheInterceptor, deps: [{ token: SessionConfig }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: ApiNoCacheInterceptor }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: ApiNoCacheInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: SessionConfig }] });

class AuthInterceptor {
    constructor(authService) {
        this.authService = authService;
    }
    intercept(req, next) {
        const token = this.authService.authToken();
        if (token) {
            req = req.clone({
                setHeaders: { 'X-Auth-Token': token }
            });
        }
        return next.handle(req);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: AuthInterceptor, deps: [{ token: AuthService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: AuthInterceptor }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: AuthInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: AuthService }] });

class AuthErrorInterceptor {
    constructor(authService) {
        this.authService = authService;
    }
    intercept(req, next) {
        return next.handle(req).pipe(catchError((res) => {
            console.log('error: ', res);
            if (res.status === 401) {
                this.authService.signIn();
            }
            else if (res.status === 403) {
                window.location.assign('/403');
            }
            return throwError(res);
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: AuthErrorInterceptor, deps: [{ token: AuthService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: AuthErrorInterceptor }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: AuthErrorInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: AuthService }] });

class IENoCacheInterceptor {
    intercept(req, next) {
        const nextReq = req.clone({
            headers: req.headers.set('Cache-Control', 'no-cache')
                .set('Pragma', 'no-cache')
                .set('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT')
                .set('If-Modified-Since', '0')
        });
        return next.handle(nextReq);
    }
}

class FeedbackService {
    constructor(oAPIService) {
        this.oAPIService = oAPIService;
    }
    getAllQuestions(status = 'active') {
        var oApiParam = {
            name: 'feedback',
            suffix: '/question',
            oParam: { status },
            method: 'GET'
        };
        return this.oAPIService.call(oApiParam);
    }
    createFeedback(feedbacks) {
        const apiOptions = {
            name: 'feedback',
            suffix: '/feedback',
            method: 'POST',
            body: feedbacks
        };
        return this.oAPIService.call(apiOptions);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: FeedbackService, deps: [{ token: WrapperService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: FeedbackService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: FeedbackService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: WrapperService }] });

/*
 Usage: Add the FeatureToggleGuard to the route, when feature toggle for the page is needed. It will make feature toggle api call to decide whether hide the page for current environment or not.
 Please define the 'featureToggleKey' in the routes to enable this guard, in order to use that for checking feature toggle result from api
 export const routes: Routes = [{
 path: 'profile',
 canActivate: [ FeatureToggleGuard ],
 }]

 */
function featureToggleGuard() {
    (route, state) => {
        const featureToggleService = inject(FeatureToggleService);
        const router = inject(Router);
        let togglePrefix = route.data['featureTogglePrefix'];
        let toggleSuffix = route.data['featureToggleSuffix'];
        if (!togglePrefix || !toggleSuffix) {
            throw new Error('Must define a toggle feature Prefix and Suffix property for this route');
        }
        return featureToggleService.checkFeatureToggle(togglePrefix, toggleSuffix).pipe(map(res => {
            return res;
        }), catchError(error => {
            let status = error.status;
            if (status === 401) {
                // this.authUserService.signInUser(false, state.url);
                console.log("Feature Toggle Guard - You must be logged in to perform his action.");
                // this.alertFooter.registerFooterAlert({
                //   title: "",
                //   description: "You must be logged in to perform his action.",
                //   type: 'error',
                //   timer: 3200
                // });
                return of(false);
            }
            else if (status === 403) {
                router.navigate(['/403']);
                return of(false);
            }
            else {
                console.log("Feature Toggle Guard - You may not have the neccessary permission to perform this action.");
                // this.alertFooter.registerFooterAlert({
                //   title: "",
                //   description: "You may not have the neccessary permission to perform this action.",
                //   type: 'error',
                //   timer: 3200
                // });
                return of(false);
            }
        }));
    };
}

function authRedirectGuard() {
    return (route) => {
        const auth = inject(AuthService);
        if (auth.isSignedIn()) {
            return true;
        }
        else {
            auth.signIn();
            // throw an error to prevent page from loading
            throw new Error('redirect to signin');
        }
    };
}

class SystemAlertsService {
    constructor(apiService) {
        this.apiService = apiService;
    }
    setEnvironment(env) {
        let wrapperEnv = { production: env.production, API_UMBRELLA_KEY: env.apiKey, API_UMBRELLA_URL: env.apiUrl };
        this.apiService.setEnvironment(wrapperEnv);
    }
    getActive(limit, offset) {
        let apiOptions = {
            name: 'alerts',
            suffix: '',
            method: 'GET',
            oParam: {}
        };
        // specify defaults
        apiOptions.oParam.limit = limit || 2;
        apiOptions.oParam.offset = offset || 0;
        this.addAuthHeader(apiOptions);
        return this.apiService.call(apiOptions);
    }
    /**
     *
     * @param limit: the number of alerts to fetch
     * @param offset: for paging, the first page
     * @param archived: array of statuses to include in the results. Status is Y for active and N for inactive.
     * @param severity: array of types to include in results. warning|error|informational
     * @param published: the number of days in the past to include in the result. Valid values: 30d|90d|6m|1y
     * @param sort: the sort column. offset|severity|published...
     * @param order: asc or desc
     * @returns {Observable<>}
     */
    getAll(limit, offset, status, severity, published, sort, order) {
        let apiOptions = {
            name: 'allAlerts',
            suffix: '',
            method: 'GET',
            oParam: {}
        };
        // specify defaults
        apiOptions.oParam.limit = limit || 5;
        apiOptions.oParam.offset = offset || 0;
        if (status && status.length) {
            apiOptions.oParam.status = status.join(',');
        }
        if (severity && severity.length) {
            apiOptions.oParam.severity = severity.join(',');
        }
        if (published) {
            apiOptions.oParam.published = published;
        }
        if (sort) {
            apiOptions.oParam.sort = sort;
        }
        if (order) {
            apiOptions.oParam.order = order;
        }
        this.addAuthHeader(apiOptions);
        return this.apiService.call(apiOptions);
    }
    updateAlert(alert) {
        const apiOptions = {
            name: 'alerts',
            suffix: '/' + alert.alertId,
            method: 'PUT',
            body: alert
        };
        this.addAuthHeader(apiOptions);
        return this.apiService.call(apiOptions);
    }
    createAlert(alert) {
        const apiOptions = {
            name: 'alerts',
            suffix: '',
            method: 'POST',
            body: alert
        };
        this.addAuthHeader(apiOptions);
        return this.apiService.call(apiOptions);
    }
    deleteAlert(id) {
        const apiOptions = {
            name: 'alerts',
            suffix: '',
            method: 'DELETE',
            body: {
                alertId: id
            }
        };
        return this.apiService.call(apiOptions);
    }
    getAlertTypes() {
        let apiOptions = {
            name: 'alerts',
            suffix: '/alerttypes',
            method: 'GET',
            oParam: {}
        };
        return this.apiService.call(apiOptions);
    }
    addAuthHeader(options) {
        let iPlanetCookie = Cookie.getAll().SESSION;
        if (!iPlanetCookie) {
            return;
        }
        options.headers = options.headers || {};
        options.headers['X-Auth-Token'] = iPlanetCookie;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SystemAlertsService, deps: [{ token: WrapperService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SystemAlertsService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SystemAlertsService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: WrapperService }] });

class SemDVModalComponent {
    constructor(dialogRef, authService, router, useraccessService) {
        this.dialogRef = dialogRef;
        this.authService = authService;
        this.router = router;
        this.useraccessService = useraccessService;
    }
    ngOnInit() {
        this.useraccessService.getPendingInvites().subscribe((res) => {
            this.invitorName = res[0].invitorName;
        });
    }
    onSkip() {
        this.dialogRef.close();
    }
    onAccept() {
        this.router.navigate(['workspace/myfeed/requests']);
        this.dialogRef.close();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SemDVModalComponent, deps: [{ token: i1$1.SdsDialogRef }, { token: AuthService }, { token: i2$2.Router }, { token: UserAccessService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: SemDVModalComponent, selector: "ng-component", ngImport: i0, template: "<div sds-dialog-title class=\"sds-dialog-title\">\r\n  Sensitive Role Assignment\r\n</div>\r\n\r\n<div sds-dialog-content class=\"sds-dialog-content\">\r\n  <div class=\"line-height-2 margin-bottom-2 margin-top-1 font-sans-md\">\r\n    {{invitorName}} has assigned you a role with access to sensitive data.\r\n    Before receiving this access, you must agree to Terms of Use to accept the role.\r\n  </div>\r\n  <div class=\"font-sans-md\">Select <strong>Go to Requests</strong> to view and respond to this assignment.</div>\r\n  <div class=\"font-sans-md margin-bottom-2\">Select <strong>Skip</strong> to respond later from your Workspace</div>\r\n  <div class=\"font-sans-md\">If you have questions about a role assignment,contact your admininstrator.</div>\r\n</div>\r\n\r\n<div sds-dialog-actions class=\"sds-dialog-actions\">\r\n  <button class=\"usa-button usa-button--base bg-base-lighter\" (click)=\"onSkip()\">\r\n    Skip\r\n  </button>\r\n  <button cdkFocusInitial class=\"usa-button\" (click)=\"onAccept()\">\r\n    Go to Requests\r\n  </button>\r\n</div>\r\n" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SemDVModalComponent, decorators: [{
            type: Component,
            args: [{ template: "<div sds-dialog-title class=\"sds-dialog-title\">\r\n  Sensitive Role Assignment\r\n</div>\r\n\r\n<div sds-dialog-content class=\"sds-dialog-content\">\r\n  <div class=\"line-height-2 margin-bottom-2 margin-top-1 font-sans-md\">\r\n    {{invitorName}} has assigned you a role with access to sensitive data.\r\n    Before receiving this access, you must agree to Terms of Use to accept the role.\r\n  </div>\r\n  <div class=\"font-sans-md\">Select <strong>Go to Requests</strong> to view and respond to this assignment.</div>\r\n  <div class=\"font-sans-md margin-bottom-2\">Select <strong>Skip</strong> to respond later from your Workspace</div>\r\n  <div class=\"font-sans-md\">If you have questions about a role assignment,contact your admininstrator.</div>\r\n</div>\r\n\r\n<div sds-dialog-actions class=\"sds-dialog-actions\">\r\n  <button class=\"usa-button usa-button--base bg-base-lighter\" (click)=\"onSkip()\">\r\n    Skip\r\n  </button>\r\n  <button cdkFocusInitial class=\"usa-button\" (click)=\"onAccept()\">\r\n    Go to Requests\r\n  </button>\r\n</div>\r\n" }]
        }], ctorParameters: () => [{ type: i1$1.SdsDialogRef }, { type: AuthService }, { type: i2$2.Router }, { type: UserAccessService }] });

class SemDvModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SemDvModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: SemDvModule, declarations: [SemDVModalComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SemDvModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SemDvModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SemDVModalComponent]
                }]
        }] });

class SystemBusyService {
    constructor(http) {
        this.http = http;
    }
    setEnviroment(enviroment) {
        this.enviroment = enviroment;
    }
    getMaxUserCount() {
        const params = {};
        if (!this.enviroment.production) {
            const apiKey = this.enviroment.apiKey;
            params["api_key"] = apiKey;
        }
        return this.http.get(`${this.enviroment.apiUrl}/role/feature/v1/read/limit_sessions/configs`, { params });
    }
    getMaxRegistationCount() {
        const params = {};
        if (!this.enviroment.production) {
            const apiKey = this.enviroment.apiKey;
            params["api_key"] = apiKey;
        }
        return this.http.get(`${this.enviroment.apiUrl}/role/feature/v1/read/limit_registrations/configs`, { params });
    }
    getCurrentUserCount() {
        const params = {};
        if (!this.enviroment.production) {
            const apiKey = this.enviroment.apiKey;
            params["api_key"] = apiKey;
        }
        return this.http.get(`${this.enviroment.apiUrl}/login/v1/sessions/metrics`, { params });
    }
    getCurrentUserLegacyCount() {
        const params = {};
        return this.http.get(`${this.enviroment.apiUrl}/sessions/metrics/legacy`, { params });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SystemBusyService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SystemBusyService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SystemBusyService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1.HttpClient }] });

const ICONS = {
    Glossary: 'book',
    Document: 'file-earmark',
    GOTO: 'arrow-right-circle-green',
    Video: 'play-btn',
    Search: 'search',
    Info: 'info-circle',
    External: 'window',
    User: 'person',
    List: 'files',
    Filter: 'filter-circle',
    Reset: 'arrow-clockwise',
    QSG: 'file-pdf',
    FAQ: 'question-circle',
};
class CMSService {
    constructor(api) {
        this.api = api;
    }
    pageContent(id) {
        const oApiParam = {
            name: 'cms',
            suffix: '/pages/' + id,
            method: 'GET',
        };
        return this.api.call(oApiParam);
    }
    formatSection(sections, sectionName) {
        return filter$1(sections, (section) => section.type.name === sectionName)
            .map((item) => ({
            order: item.displayOrder,
            head: { title: item.label },
            body: {
                content: this.formatSectionContent(item),
            },
        }))
            .sort((a, b) => a.order - b.order);
    }
    formatSectionContent(item) {
        const content = [];
        if (item.links) {
            content.push({
                component: new ComponentPortal(SdsLandingListComponent),
                inputs: {
                    list: {
                        iconList: true,
                        items: this.formatSectionLinks(item.links),
                    },
                },
            });
        }
        return content;
    }
    /*
    There are two ways a link can be external:
  
    1. When the link is not part of SAM.gov
    2. when the link doesn't belong to a page handled by Content MFE.
   */
    getExternalLinkURL(url) {
        if (url.startsWith('/')) {
            return `${location.protocol}//${location.hostname}${url}`;
        }
        return url;
    }
    formatSectionLinks(links) {
        return links.map((link) => ({
            link: {
                innerHtml: link.label,
                [link.external ? 'href' : 'routerLink']: link.external
                    ? this.getExternalLinkURL(link.url)
                    : link.url,
                target: link.target,
            },
            icon: {
                icon: ICONS[link.type.name],
            },
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: CMSService, deps: [{ token: WrapperService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: CMSService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: CMSService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: WrapperService }] });

class ErrorData {
}
class ErrorModalComponent {
    constructor(data, dialogRef) {
        this.data = data;
        this.dialogRef = dialogRef;
    }
    close() {
        this.dialogRef.close();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: ErrorModalComponent, deps: [{ token: SDS_DIALOG_DATA }, { token: i1$1.SdsDialogRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: ErrorModalComponent, selector: "dialog-error", ngImport: i0, template: `
<div class="grid-container">
      <div class="grid-row padding-bottom-1">
      <div class="grid-col width-full display-flex flex-align-center flex-justify-center">
        <div sds-dialog-title class="text-semibold font-sans-lg">Something went wrong</div>
      </div>
    </div>
    <div class="grid-row  padding-y-2">
      <div class="grid-col width-full display-flex flex-align-center flex-justify-center">
        <div sds-dialog-title class="text-semibold font-sans-lg">Please try again</div>
      </div>
    </div>
    <div class="grid-row padding-y-2">
      <div class="grid-col width-full display-flex flex-align-center flex-justify-center">
        <div>If you continue to experience an issue, please try again later</div>
      </div>
    </div>
    <div class="grid-row">
      <div class="grid-col width-full display-flex flex-align-center flex-justify-center">
        <button (click)="close()" class="usa-button usa-button--base bg-base-lighter">Close</button>
      </div>
    </div>
  </div>
 `, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: ErrorModalComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'dialog-error',
                    template: `
<div class="grid-container">
      <div class="grid-row padding-bottom-1">
      <div class="grid-col width-full display-flex flex-align-center flex-justify-center">
        <div sds-dialog-title class="text-semibold font-sans-lg">Something went wrong</div>
      </div>
    </div>
    <div class="grid-row  padding-y-2">
      <div class="grid-col width-full display-flex flex-align-center flex-justify-center">
        <div sds-dialog-title class="text-semibold font-sans-lg">Please try again</div>
      </div>
    </div>
    <div class="grid-row padding-y-2">
      <div class="grid-col width-full display-flex flex-align-center flex-justify-center">
        <div>If you continue to experience an issue, please try again later</div>
      </div>
    </div>
    <div class="grid-row">
      <div class="grid-col width-full display-flex flex-align-center flex-justify-center">
        <button (click)="close()" class="usa-button usa-button--base bg-base-lighter">Close</button>
      </div>
    </div>
  </div>
 `,
                }]
        }], ctorParameters: () => [{ type: ErrorData, decorators: [{
                    type: Inject,
                    args: [SDS_DIALOG_DATA]
                }] }, { type: i1$1.SdsDialogRef }] });

class ErrorModelModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: ErrorModelModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: ErrorModelModule, declarations: [ErrorModalComponent], imports: [CommonModule,
            FormsModule,
            ReactiveFormsModule, i1$2.NgxBootstrapIconsModule], exports: [ErrorModalComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: ErrorModelModule, imports: [CommonModule,
            FormsModule,
            ReactiveFormsModule,
            NgxBootstrapIconsModule.pick({ exclamationTriangle })] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: ErrorModelModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        ErrorModalComponent
                    ],
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        NgxBootstrapIconsModule.pick({ exclamationTriangle }),
                    ],
                    exports: [
                        ErrorModalComponent
                    ],
                    providers: [],
                }]
        }] });

class SystemConfigGenericHelp {
}

class GenericFSDHelpService {
    constructor(http, authService, environment) {
        this.http = http;
        this.authService = authService;
        this.environment = environment;
    }
    updatedIncidentDocumentV3(documentId, documentType, documentPurpose) {
        throw new Error('Method not implemented.');
    }
    createIncidentDocument(helpTicketId, file, documentType, documentPurpose) {
        throw new Error('Method not implemented.');
    }
    updatedIncidentDocument(documentId, documentType, documentPurpose) {
        throw new Error('Method not implemented.');
    }
    createIncidentDocumentV3(helpTicketId, file, documentType, documentPurposes) {
        throw new Error('Method not implemented.');
    }
    _options() {
        const params = {};
        return {
            headers: {
                'X-Auth-Token': this.authService.authToken()
            },
            params: params
        };
    }
    createIncident(incident) {
        this.loggedIn();
        const url = `${this.environment.API_UMBRELLA_URL}/helpdesk/v1/tickets`;
        return this.http.post(url, incident, this._options());
    }
    getIncident(helpTicketId) {
        this.loggedIn();
        const url = `${this.environment.API_UMBRELLA_URL}/helpdesk/v1/tickets/${helpTicketId}`;
        let op = this._options();
        return this.http.get(url, op);
    }
    updateIncident(helpTicketEntity, helpTicketId) {
        this.loggedIn();
        const url = `${this.environment.API_UMBRELLA_URL}/helpdesk/v1/tickets/${helpTicketId}`;
        let op = this._options();
        return this.http.patch(url, {
            "comments": helpTicketEntity.description
        }, op);
    }
    deleteIncident(helpTicketId) {
        this.loggedIn();
        const url = `${this.environment.API_UMBRELLA_URL}/helpdesk/v1/tickets/${helpTicketId}`;
        let op = this._options();
        return this.http.delete(url, op);
    }
    submitIncident(helpTicketId, helpTicketEntity) {
        this.loggedIn();
        const url = `${this.environment.API_UMBRELLA_URL}/helpdesk/v1/tickets/${helpTicketId}/submit`;
        let op = this._options();
        helpTicketEntity['comments'] = helpTicketEntity.description;
        return this.http.post(url, helpTicketEntity, op);
    }
    uploadIncidentDocument(helpTicketId, file) {
        this.loggedIn();
        let formData = new FormData();
        formData.append('file', file, file.name);
        let options = this._options();
        options["reportProgress"] = true;
        options["responseType"] = 'text';
        const url = `${this.environment.API_UMBRELLA_URL}/helpdesk/v1/documents?ticketId=${helpTicketId}`;
        return this.http.post(url, formData, options);
    }
    deleteIncidentDocument(documentId) {
        this.loggedIn();
        const url = `${this.environment.API_UMBRELLA_URL}/helpdesk/v1/documents/${documentId}`;
        let op = this._options();
        return this.http.delete(url, op);
    }
    downloadDocument(documentId) {
        this.loggedIn();
        const url = `${this.environment.API_UMBRELLA_URL}/helpdesk/v1/documents/download/${documentId}`;
        const params = {
            observe: 'response'
        };
        const options = {
            headers: {
                'X-Auth-Token': this.authService.authToken()
            },
            responseType: 'blob',
            params: params
        };
        return this.http.get(url, options).pipe(timeout(this.environment.API_TIMEOUT_MS));
    }
    getIncidentDocuments(helpTicketId) {
        this.loggedIn();
        const url = `${this.environment.API_UMBRELLA_URL}/helpdesk/v1/documents?ticketId=${helpTicketId}`;
        let op = this._options();
        return this.http.get(url, op);
    }
    loggedIn() {
        if (!this.authService.isLoggedIn()) {
            throw new Error('Must be authenticated');
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericFSDHelpService, deps: [{ token: i1.HttpClient }, { token: AuthService }, { token: SystemConfigGenericHelp }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericFSDHelpService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericFSDHelpService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: AuthService }, { type: SystemConfigGenericHelp, decorators: [{
                    type: Inject,
                    args: [SystemConfigGenericHelp]
                }] }] });
class HelpTicket {
    constructor(incidentData, issueType, subject) {
        this.incidentData = incidentData;
        this.issueType = issueType;
        this.subject = subject;
    }
}
class HelpTicketEntity {
    constructor(ticketId, helpDeskTicket, description, ticketStatus, ticketType, sourceRecordId, ticketTitle, applicationData) {
        this.ticketId = ticketId;
        this.helpDeskTicket = helpDeskTicket;
        this.description = description;
        this.ticketStatus = ticketStatus;
        this.ticketType = ticketType;
        this.sourceRecordId = sourceRecordId;
        this.ticketTitle = ticketTitle;
        this.applicationData = applicationData;
    }
}
class HelpTicketDocument {
    constructor(documentId, documentName, fileSize, fileType, status, ticketId, scanResult, requestFromAdmin, createdDate, documentType, documentPurpose, //old will remove
    attachmentPurposes) {
        this.documentId = documentId;
        this.documentName = documentName;
        this.fileSize = fileSize;
        this.fileType = fileType;
        this.status = status;
        this.ticketId = ticketId;
        this.scanResult = scanResult;
        this.requestFromAdmin = requestFromAdmin;
        this.createdDate = createdDate;
        this.documentType = documentType;
        this.documentPurpose = documentPurpose;
        this.attachmentPurposes = attachmentPurposes;
    }
}
class AttachmentPurpose {
    constructor(docPurpose) {
        this.docPurpose = docPurpose;
    }
}
class DocumentPurpose {
    constructor(documentId, docPurposeId, docPurpose, updateStatus) {
        this.documentId = documentId;
        this.docPurposeId = docPurposeId;
        this.docPurpose = docPurpose;
        this.updateStatus = updateStatus;
    }
}

//import { GenericFSDHelpMockService } from './generic-help-mock.service';
class GenericFSDModalComponent {
    constructor(data, dialogRef, genericFSDHelpService, toastr, cdr) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.genericFSDHelpService = genericFSDHelpService;
        this.toastr = toastr;
        this.cdr = cdr;
        this.FSDModalMode = FSDModalMode;
        this.FSDModalCloseStatus = FSDModalCloseStatus;
        this.issueType = '';
        this.subject = '';
        this.fileUploadCount = 0;
        this.mode = FSDModalMode.CREATE;
        this.intervalsElapsed = 0;
        this.form = new FormGroup({});
        this.model = { comment: '', file: [] };
        this.options = {};
        this.fileField = {
            key: 'file',
            type: SdsFormlyTypes.FILEINPUT,
            props: {
                label: 'Supporting Attachments',
                description: this.data.hideAttachmentsDescription ? '' : 'Please attach any documentation you have to verify your information.',
                hideLabel: this.data.hideAttachmentsLabel,
                multiple: true,
                hideOptional: true,
                clearFilesOnAdd: false,
                displayFileInfo: true,
                tableDisplay: true,
                disabled: false,
                acceptFileType: '.bmp,.gif,.jpeg,.jpg,.tex,.xls,.xlsx,.doc,.docx,.docx,.odt,.txt,.pdf,.png,.pptx,.ppt,.rtf,.AVI,.mov,.mpg,.mpeg,.mp4,.wmv,.flv,.f4v',
                required: true,
                type: SdsFormlyTypes.TABLE,
                tableName: 'Supporting Attachments Table',
                noDataText: 'No Attachments',
                tableColumns: [
                    { label: 'Attachment Name', columnName: 'name', property: 'name' },
                    { label: 'File Size (kB)', columnName: 'size', textFn: (file) => (file.size / 1000) },
                    { label: 'Upload Date', columnName: 'date', textFn: (file) => this.dateFormat(file) },
                    { label: 'Virus Scan', columnName: 'scan', property: 'scanResult' },
                    {
                        label: 'Action', columnName: 'action',
                        text: 'Remove',
                        onClick: this.removeFile.bind(this)
                    }
                ],
            }
        };
        this.commentFieldConfig = {
            key: 'comment',
            type: 'textarea',
            props: {
                label: this.data.customCommentsLabel || 'Please describe the issue below, or provide any additional details that might help customer service resolve your issue.',
                labelClass: this.data.commentsLabelClass || '',
                placeholder: '',
                description: this.data.customCommentsDescription || '',
                required: true,
                maxLength: 500
            },
        };
        this.service = genericFSDHelpService;
        this.toastr.toastrConfig.iconClasses = {
            error: 'sds-toast--error',
            info: 'sds-toast--info',
            success: 'sds-toast--success',
            warning: 'sds-toast--warning',
        };
        this.toastr.toastrConfig.closeButton = true;
        this.dialogRef.beforeClosed().subscribe(val => {
            if (!val || val === '') {
                this.cancelIncident();
            }
        });
    }
    ngOnInit() {
        this.mode = this.data.mode;
        if (this.data.serviceOverride) {
            this.service = this.data.serviceOverride;
        }
        this.headerInstructionText = this.data.headerInstructionText;
        this.allowFileDownload = this.data.allowFileDownload;
        if (this.mode === FSDModalMode.CREATE) {
            this.constantFields = [this.fileField, this.commentFieldConfig];
            this.initCreate();
        }
        else if (this.mode === FSDModalMode.UPDATE) {
            this.constantFields = [this.fileField, this.commentFieldConfig];
            this.initUpdate();
        }
        else if (this.mode === FSDModalMode.VIEW) {
            this.constantFields = [];
            this.initView();
        }
        else if (this.mode === FSDModalMode.VIEWDOCUMENT) {
            this.constantFields = [this.fileField];
            this.initView();
        }
    }
    dateFormat(file) {
        if (!file["createdDate"]) {
            file["createdDate"] = new Date();
        }
        const date = new DatePipe('en-US').transform(new Date(file["createdDate"]), 'medium', 'EDT');
        return date + ' EDT';
    }
    initView() {
        this.helpTicketId = this.data.helpTicketId;
        this.setupFormlyFields();
        this.searchListFields = this.data.searchListFields;
        this.getIncident(true);
    }
    initUpdate() {
        this.helpTicketId = this.data.helpTicketId;
        this.setupFormlyFields();
        this.searchListFields = this.data.searchListFields;
        this.getIncident(false);
    }
    initCreate() {
        this.helpTicketId = undefined;
        this.searchList = this.data.searchList;
        this.searchListFields = this.data.searchListFields;
        this.issueType = this.data.issueType;
        this.subject = this.data.subject;
        this.setupFormlyFields();
        if (this.data.customInputValues) {
            this.model = this.data.customInputValues;
        }
        this.createIncident();
    }
    setupFormlyFields() {
        //Deep copy
        if (this.data.customInputFields) {
            this.customFields = JSON.parse(JSON.stringify(this.data.customInputFields));
        }
        if (this.customFields) {
            this.fields = this.customFields.concat(this.constantFields);
        }
        else {
            this.fields = this.constantFields;
        }
    }
    removeFile(file, field) {
        if (file["documentId"] && file["documentId"] !== 'temp') {
            this.service.deleteIncidentDocument(file["documentId"]).subscribe((document) => {
                const tableFormControl = field.formControl;
                const newFiles = tableFormControl.value.filter((value) => value != file);
                tableFormControl.setValue(newFiles);
                this.fileUploadCount = newFiles.length;
            }, error => {
                console.error(error);
                this.toastr.error('An unknown error has occured. Please try again.', "");
            });
        }
    }
    downloadFile(file) {
        let documentId = file["documentId"];
        let filename = file["documentName"];
        try {
            this.service.downloadDocument(documentId).subscribe((data) => {
                var binaryData = [];
                binaryData.push(data);
                this.blob = new Blob(binaryData);
                const link = document.createElement('a');
                const downloadURL = window.URL.createObjectURL(this.blob);
                link.href = downloadURL;
                link.download = filename;
                document.body.appendChild(link);
                link.click();
            }, err => {
                console.error(err);
                this.toastr.error('An unknown error has occured. Please try again.', "");
            });
        }
        catch (e) {
            console.error(e);
            this.toastr.error('An unknown error has occured. Please try again.', "");
        }
    }
    createIncident() {
        let returnedTarget = Object.assign({}, this.model);
        delete returnedTarget.file;
        delete returnedTarget.comment;
        let response = this.service.createIncident(new HelpTicket(JSON.stringify({ searches: this.searchList, data: returnedTarget }), this.issueType, this.subject));
        response.subscribe((incidentReponse) => {
            this.helpTicketId = incidentReponse.ticketId;
        }, error => {
            console.error(error);
            this.toastr.error('An unknown error has occured. Please try again.', "");
            this.dialogRef.close();
        });
    }
    reloadVirusCheck() {
        const docResponse = new BehaviorSubject('Document');
        docResponse.subscribe(result => {
            let count = 0;
            for (let i = 0; i < this.model.file.length; i++) {
                let file = this.model.file[i];
                if (file['scanResult'] !== 'CLEAN' &&
                    file['scanResult'] !== 'INFECTED' &&
                    file['scanResult'] !== 'UNSUPPORTED FILE TYPE') {
                    count++;
                }
            }
            if (count === 0 || this.intervalsElapsed++ > 4) {
                clearInterval(this.intervalId);
            }
            this.cdr.detectChanges();
        });
        this.getDocuments(docResponse);
    }
    cancelIncident() {
        if (this.mode === FSDModalMode.CREATE && this.helpTicketId) {
            let response = this.service.deleteIncident(this.helpTicketId);
            response.subscribe((incidentReponse) => {
                this.close(FSDModalCloseStatus.DELETE);
            }, error => {
                console.error(error);
                this.toastr.error('An unknown error has occured. Please try again.', "");
                this.close(FSDModalCloseStatus.ERROR);
            });
        }
        else {
            this.close(FSDModalCloseStatus.CLOSE);
        }
        //Cancel/click away (delete)
    }
    saveIncident() {
        let comment = this.model.comment;
        let returnedTarget = Object.assign({}, this.model);
        delete returnedTarget.file;
        delete returnedTarget.comment;
        let response = this.service.updateIncident(new HelpTicketEntity(this.helpTicketId, null, comment, null, this.issueType, null, this.subject, JSON.stringify({ searches: this.searchList, data: returnedTarget })), this.helpTicketId);
        response.subscribe((incidentReponse) => {
            this.toastr.success('Incident Saved.', "");
            this.close(FSDModalCloseStatus.SAVE);
        }, error => {
            console.error(error);
            this.toastr.error('An unknown error has occured. Please try again.', "");
        });
        //  Save(Save not submit)
    }
    submitIncident() {
        this.submitLock = true;
        let comment = this.model.comment;
        let returnedTarget = Object.assign({}, this.model);
        delete returnedTarget.file;
        delete returnedTarget.comment;
        let response = this.service.submitIncident(this.helpTicketId, new HelpTicketEntity(this.helpTicketId, null, comment, null, this.issueType, null, this.subject, JSON.stringify({ searches: this.searchList, data: returnedTarget })));
        response.subscribe((incidentReponse) => {
            let helpDeskTicket = incidentReponse.helpDeskTicket;
            this.fsdTicketId = helpDeskTicket;
            this.toastr.success('Your FSD incident has been submitted. To see incident updates, please sign in to fsd.gov and view incident # ' + helpDeskTicket, "");
            this.close(FSDModalCloseStatus.SUBMIT);
        }, error => {
            this.submitLock = false;
            console.error(error);
            this.toastr.error('An unknown error has occured. Please try again.', "");
        });
    }
    getIncident(isReadOnly) {
        let response = this.service.getIncident(this.helpTicketId);
        const incidentComplete = new BehaviorSubject('Incident');
        const docResponse = new BehaviorSubject('Document');
        const joinedResponse = forkJoin([incidentComplete, docResponse]).subscribe((r) => {
            if (isReadOnly) {
                if (this.customFields) {
                    FormlyUtilsService.setReadonlyMode(true, this.customFields);
                }
            }
            this.cdr.detectChanges();
        });
        response.subscribe((incidentReponse) => {
            let applicationData = JSON.parse(incidentReponse.applicationData);
            if (applicationData["data"]) {
                Object.assign(this.model, applicationData["data"]);
            }
            if (applicationData["searches"]) {
                this.searchList = applicationData["searches"];
            }
            this.model.comment = incidentReponse.description;
            this.issueType = incidentReponse.ticketType;
            this.subject = incidentReponse.ticketTitle;
            this.form.patchValue(this.model);
            incidentComplete.complete();
        }, error => {
            console.error(error);
            this.toastr.error('An unknown error has occured. Please try again.', "");
            this.close(FSDModalCloseStatus.ERROR);
        });
        this.getDocuments(docResponse);
        return joinedResponse;
    }
    getDocuments(docResponse) {
        this.service.getIncidentDocuments(this.helpTicketId).subscribe((documents) => {
            for (let i = 0; i < documents.length; i++) {
                let doc = documents[i];
                doc['name'] = doc.documentName;
                doc['size'] = doc.fileSize;
                doc['type'] = doc.fileType;
                doc['date'] = doc.createdDate;
            }
            this.model.file = documents;
            this.form.patchValue(this.model);
            this.fileUploadCount = documents.length;
            docResponse.complete();
        });
    }
    close(status) {
        this.dialogRef.close({ 'status': status, 'ticketId': this.helpTicketId, 'helpDeskTicket': this.fsdTicketId, 'model': this.model });
    }
    onModelChange($event) {
        const fileList = $event.file;
        if (fileList) {
            if (fileList.length > this.fileUploadCount) {
                const list = fileList.filter(item => !item.documentId);
                for (let i = 0; i < list.length; i++) {
                    const file = list[i];
                    if (!file["documentId"]) {
                        file["documentId"] = 'temp';
                        this.uploadFile(file, $event);
                    }
                }
            }
        }
        ;
    }
    uploadFile(file, $event) {
        this.service.uploadIncidentDocument(this.helpTicketId, file)
            .subscribe((response) => {
            file["documentId"] = response;
            file["scanResult"] = 'PENDING';
            this.toastr.success('File uploaded successfully.', "");
            this.fileUploadCount++;
            this.intervalsElapsed = 0;
            //15 Sec
            if (this.intervalId) {
                clearInterval(this.intervalId);
            }
            this.intervalId = setInterval(this.reloadVirusCheck.bind(this), 15000);
        }, (err) => {
            $event.file = $event.file.filter(function (value, index, arr) {
                return value != file;
            });
            this.form.patchValue($event);
            this.toastr.error('An unknown error has occured uploading the document. Please try again.', "");
            this.fileUploadCount = $event.file.length;
            console.error(err);
        });
    }
    allowDownload(document) {
        return document.scanResult === 'CLEAN' && document.requestFromAdmin && this.allowFileDownload;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericFSDModalComponent, deps: [{ token: SDS_DIALOG_DATA }, { token: i1$1.SdsDialogRef }, { token: GenericFSDHelpService }, { token: i2$3.ToastrService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: GenericFSDModalComponent, selector: "contact-fsd-modal", ngImport: i0, template: "<div>\r\n  <!--Heading-->\r\n  <div>\r\n    <div *ngIf=\"mode===FSDModalMode.CREATE || mode===FSDModalMode.UPDATE\" class=\"margin-bottom-1\">\r\n      <h2>Create Incident</h2>\r\n    </div>\r\n    <div *ngIf=\"mode===FSDModalMode.VIEW \" class=\"margin-bottom-1\">\r\n      <h2>View Incident</h2>\r\n    </div>\r\n    <div *ngIf=\"headerInstructionText\">\r\n      <p>{{headerInstructionText}}</p>\r\n    </div>\r\n  </div>\r\n  <!-- Blue Section -->\r\n  <div class=\"usa-summary-box margin-bottom-1\">\r\n    <div class=\"\">\r\n      <div class=\"usa-summary-box__text\">\r\n        <div class=\"grid-container\">\r\n          <div class=\"grid-row\">\r\n            <div class=\"grid-col-4\">\r\n              <div>Issue Type</div>\r\n              <div>\r\n                <strong>\r\n                  {{issueType}}\r\n                </strong>\r\n              </div>\r\n            </div>\r\n            <div class=\"grid-col-4\">\r\n              <div>Subject</div>\r\n              <div>\r\n                <strong>\r\n                  {{subject}}\r\n                </strong>\r\n              </div>\r\n            </div>\r\n            <div class=\"grid-col-4\"></div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <!--Tables-->\r\n  <div *ngIf=\"searchListFields\" class=\"margin-bottom-1\">\r\n    <div id=\"srchTblDesc\" class=\"margin-bottom-1\">\r\n      <h2>Search History</h2>\r\n    </div>\r\n    <div>\r\n      <p> Your entity search history below will be provided to customer service to help understand and resolve the\r\n        issue.\r\n      </p>\r\n    </div>\r\n  </div>\r\n  <div *ngIf=\"searchListFields&&searchList\" class=\"margin-bottom-1\">\r\n    <strong>{{searchList.length}} Results</strong>\r\n  </div>\r\n  <div *ngIf=\"searchListFields\" class=\"sds-table__container\">\r\n    <table aria-describedby=\"srchTblDesc\" class=\"sds-table\">\r\n      <thead>\r\n        <tr class=\"sds-table__row\">\r\n          <th *ngFor=\"let searchListFieldItem of searchListFields;\" scope=\"col\">{{searchListFieldItem.columnTitle}}</th>\r\n        </tr>\r\n      </thead>\r\n      <tbody>\r\n        <tr *ngFor=\"let searchItem of searchList;\" class=\"sds-table__row\">\r\n          <td *ngFor=\"let searchListFieldItem of searchListFields;\">\r\n            <ng-container *ngIf=\"!searchListFieldItem.formater\">\r\n              {{searchItem[searchListFieldItem.rowValueProperty]}}\r\n            </ng-container>\r\n\r\n            <ng-container *ngIf=\"searchListFieldItem.formater\">\r\n              {{searchListFieldItem.formater(searchItem)}}\r\n            </ng-container>\r\n          </td>\r\n        </tr>\r\n      </tbody>\r\n    </table>\r\n  </div>\r\n  <!-- Formly Section (Custom, Attachment, Comment) -->\r\n  <form [formGroup]=\"form\">\r\n    <formly-form (modelChange)=\"onModelChange($event)\" [(model)]=\"model\" [fields]=\"fields\" [options]=\"options\"\r\n      [form]=\"form\"></formly-form>\r\n  </form>\r\n\r\n\r\n  <div *ngIf=\"mode===FSDModalMode.VIEW\" class=\"sds-table__container margin-top-2\">\r\n    <table aria-describedby=\"srchTblDesc\" class=\"sds-table\">\r\n      <thead>\r\n        <tr class=\"sds-table__row\">\r\n          <th scope=\"col\">Attachment Name</th>\r\n          <th scope=\"col\">File Size (kB)</th>\r\n          <th scope=\"col\">Upload Date</th>\r\n          <th scope=\"col\">Virus Scan</th>\r\n          <th scope=\"col\" *ngIf=\"allowFileDownload\">Actions</th>\r\n        </tr>\r\n      </thead>\r\n      <tbody *ngIf=\"this.model.file?.length===0\">\r\n        <div class=\"text-right margin-top-1 margin-left-neg-2\">\r\n          No Attachment\r\n        </div>\r\n      </tbody>\r\n      <tbody *ngIf=\"this.model.file?.length!==0\">\r\n        <tr *ngFor=\"let document of this.model.file\" class=\"sds-table__row\">\r\n          <td>{{document?.name}}</td>\r\n          <td>{{ (document.size / 1000)}} </td>\r\n          <td>{{ document.date | date : 'medium' : 'EDT'}} EDT</td>\r\n          <td>{{ document.scanResult }} </td>\r\n          <td *ngIf=\"allowFileDownload\">\r\n            <span *ngIf=\"!allowDownload(document)\">\r\n              <span> Please login from Admin VDI to Download </span>\r\n            </span>\r\n            <span><a *ngIf=\"allowDownload(document)\" (click)=\"downloadFile(document)\">Download</a></span>\r\n          </td>\r\n        </tr>\r\n      </tbody>\r\n    </table>\r\n  </div>\r\n\r\n\r\n  <div *ngIf=\"mode===FSDModalMode.VIEWDOCUMENT||mode===FSDModalMode.VIEW\" id=\"helpDeskComments\" class=\"margin-bottom-1\">\r\n    <div class=\"margin-bottom-1\">\r\n      <br>\r\n      <p>Additional details.\r\n      </p>\r\n    </div>\r\n    <div class=\"margin-bottom-1\" style=\"font-weight: bold;\">\r\n      {{this.model.comment}}\r\n    </div>\r\n  </div>\r\n\r\n\r\n  <ng-container *ngIf=\"mode===FSDModalMode.CREATE || mode===FSDModalMode.UPDATE\">\r\n    <button (click)=\"cancelIncident()\" class=\"usa-button usa-button--base bg-base-lighter\">Cancel</button>\r\n    <button *ngIf=\"!data.hideSaveButton\" [disabled]=\"form.invalid\" (click)=\"saveIncident()\"\r\n      class=\"usa-button usa-button bg-primary-lighter\">Save</button>\r\n    <button [disabled]=\"submitLock || form.invalid\" (click)=\"submitIncident()\" class=\"usa-button\">Submit</button>\r\n  </ng-container>\r\n  <ng-container *ngIf=\"mode===FSDModalMode.VIEWDOCUMENT||mode===FSDModalMode.VIEW\">\r\n    <button (click)=\"close(FSDModalCloseStatus.CLOSE)\" class=\"usa-button usa-button--base\">Close</button>\r\n  </ng-container>\r\n  <br>\r\n  <br>\r\n</div>\r\n", dependencies: [{ kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i4.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i4.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i4.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: i1$4.FormlyForm, selector: "formly-form", inputs: ["form", "model", "fields", "options"], outputs: ["modelChange"] }, { kind: "pipe", type: i2.DatePipe, name: "date" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericFSDModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'contact-fsd-modal', template: "<div>\r\n  <!--Heading-->\r\n  <div>\r\n    <div *ngIf=\"mode===FSDModalMode.CREATE || mode===FSDModalMode.UPDATE\" class=\"margin-bottom-1\">\r\n      <h2>Create Incident</h2>\r\n    </div>\r\n    <div *ngIf=\"mode===FSDModalMode.VIEW \" class=\"margin-bottom-1\">\r\n      <h2>View Incident</h2>\r\n    </div>\r\n    <div *ngIf=\"headerInstructionText\">\r\n      <p>{{headerInstructionText}}</p>\r\n    </div>\r\n  </div>\r\n  <!-- Blue Section -->\r\n  <div class=\"usa-summary-box margin-bottom-1\">\r\n    <div class=\"\">\r\n      <div class=\"usa-summary-box__text\">\r\n        <div class=\"grid-container\">\r\n          <div class=\"grid-row\">\r\n            <div class=\"grid-col-4\">\r\n              <div>Issue Type</div>\r\n              <div>\r\n                <strong>\r\n                  {{issueType}}\r\n                </strong>\r\n              </div>\r\n            </div>\r\n            <div class=\"grid-col-4\">\r\n              <div>Subject</div>\r\n              <div>\r\n                <strong>\r\n                  {{subject}}\r\n                </strong>\r\n              </div>\r\n            </div>\r\n            <div class=\"grid-col-4\"></div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <!--Tables-->\r\n  <div *ngIf=\"searchListFields\" class=\"margin-bottom-1\">\r\n    <div id=\"srchTblDesc\" class=\"margin-bottom-1\">\r\n      <h2>Search History</h2>\r\n    </div>\r\n    <div>\r\n      <p> Your entity search history below will be provided to customer service to help understand and resolve the\r\n        issue.\r\n      </p>\r\n    </div>\r\n  </div>\r\n  <div *ngIf=\"searchListFields&&searchList\" class=\"margin-bottom-1\">\r\n    <strong>{{searchList.length}} Results</strong>\r\n  </div>\r\n  <div *ngIf=\"searchListFields\" class=\"sds-table__container\">\r\n    <table aria-describedby=\"srchTblDesc\" class=\"sds-table\">\r\n      <thead>\r\n        <tr class=\"sds-table__row\">\r\n          <th *ngFor=\"let searchListFieldItem of searchListFields;\" scope=\"col\">{{searchListFieldItem.columnTitle}}</th>\r\n        </tr>\r\n      </thead>\r\n      <tbody>\r\n        <tr *ngFor=\"let searchItem of searchList;\" class=\"sds-table__row\">\r\n          <td *ngFor=\"let searchListFieldItem of searchListFields;\">\r\n            <ng-container *ngIf=\"!searchListFieldItem.formater\">\r\n              {{searchItem[searchListFieldItem.rowValueProperty]}}\r\n            </ng-container>\r\n\r\n            <ng-container *ngIf=\"searchListFieldItem.formater\">\r\n              {{searchListFieldItem.formater(searchItem)}}\r\n            </ng-container>\r\n          </td>\r\n        </tr>\r\n      </tbody>\r\n    </table>\r\n  </div>\r\n  <!-- Formly Section (Custom, Attachment, Comment) -->\r\n  <form [formGroup]=\"form\">\r\n    <formly-form (modelChange)=\"onModelChange($event)\" [(model)]=\"model\" [fields]=\"fields\" [options]=\"options\"\r\n      [form]=\"form\"></formly-form>\r\n  </form>\r\n\r\n\r\n  <div *ngIf=\"mode===FSDModalMode.VIEW\" class=\"sds-table__container margin-top-2\">\r\n    <table aria-describedby=\"srchTblDesc\" class=\"sds-table\">\r\n      <thead>\r\n        <tr class=\"sds-table__row\">\r\n          <th scope=\"col\">Attachment Name</th>\r\n          <th scope=\"col\">File Size (kB)</th>\r\n          <th scope=\"col\">Upload Date</th>\r\n          <th scope=\"col\">Virus Scan</th>\r\n          <th scope=\"col\" *ngIf=\"allowFileDownload\">Actions</th>\r\n        </tr>\r\n      </thead>\r\n      <tbody *ngIf=\"this.model.file?.length===0\">\r\n        <div class=\"text-right margin-top-1 margin-left-neg-2\">\r\n          No Attachment\r\n        </div>\r\n      </tbody>\r\n      <tbody *ngIf=\"this.model.file?.length!==0\">\r\n        <tr *ngFor=\"let document of this.model.file\" class=\"sds-table__row\">\r\n          <td>{{document?.name}}</td>\r\n          <td>{{ (document.size / 1000)}} </td>\r\n          <td>{{ document.date | date : 'medium' : 'EDT'}} EDT</td>\r\n          <td>{{ document.scanResult }} </td>\r\n          <td *ngIf=\"allowFileDownload\">\r\n            <span *ngIf=\"!allowDownload(document)\">\r\n              <span> Please login from Admin VDI to Download </span>\r\n            </span>\r\n            <span><a *ngIf=\"allowDownload(document)\" (click)=\"downloadFile(document)\">Download</a></span>\r\n          </td>\r\n        </tr>\r\n      </tbody>\r\n    </table>\r\n  </div>\r\n\r\n\r\n  <div *ngIf=\"mode===FSDModalMode.VIEWDOCUMENT||mode===FSDModalMode.VIEW\" id=\"helpDeskComments\" class=\"margin-bottom-1\">\r\n    <div class=\"margin-bottom-1\">\r\n      <br>\r\n      <p>Additional details.\r\n      </p>\r\n    </div>\r\n    <div class=\"margin-bottom-1\" style=\"font-weight: bold;\">\r\n      {{this.model.comment}}\r\n    </div>\r\n  </div>\r\n\r\n\r\n  <ng-container *ngIf=\"mode===FSDModalMode.CREATE || mode===FSDModalMode.UPDATE\">\r\n    <button (click)=\"cancelIncident()\" class=\"usa-button usa-button--base bg-base-lighter\">Cancel</button>\r\n    <button *ngIf=\"!data.hideSaveButton\" [disabled]=\"form.invalid\" (click)=\"saveIncident()\"\r\n      class=\"usa-button usa-button bg-primary-lighter\">Save</button>\r\n    <button [disabled]=\"submitLock || form.invalid\" (click)=\"submitIncident()\" class=\"usa-button\">Submit</button>\r\n  </ng-container>\r\n  <ng-container *ngIf=\"mode===FSDModalMode.VIEWDOCUMENT||mode===FSDModalMode.VIEW\">\r\n    <button (click)=\"close(FSDModalCloseStatus.CLOSE)\" class=\"usa-button usa-button--base\">Close</button>\r\n  </ng-container>\r\n  <br>\r\n  <br>\r\n</div>\r\n" }]
        }], ctorParameters: () => [{ type: ContactFSDModalData, decorators: [{
                    type: Inject,
                    args: [SDS_DIALOG_DATA]
                }] }, { type: i1$1.SdsDialogRef }, { type: GenericFSDHelpService }, { type: i2$3.ToastrService }, { type: i0.ChangeDetectorRef }] });
class ContactFSDModalData {
}
class SearchListField {
}
class FSDModalCloseModel {
}
var FSDModalMode;
(function (FSDModalMode) {
    FSDModalMode[FSDModalMode["UPDATE"] = 0] = "UPDATE";
    FSDModalMode[FSDModalMode["VIEW"] = 1] = "VIEW";
    FSDModalMode[FSDModalMode["CREATE"] = 2] = "CREATE";
    FSDModalMode[FSDModalMode["VIEWDOCUMENT"] = 3] = "VIEWDOCUMENT";
    FSDModalMode[FSDModalMode["VIEWREADONLY"] = 4] = "VIEWREADONLY";
    FSDModalMode[FSDModalMode["REVALIDATE"] = 5] = "REVALIDATE";
    FSDModalMode[FSDModalMode["CREATESPECIFIED"] = 6] = "CREATESPECIFIED";
})(FSDModalMode || (FSDModalMode = {}));
var FSDModalCloseStatus;
(function (FSDModalCloseStatus) {
    FSDModalCloseStatus[FSDModalCloseStatus["SAVE"] = 0] = "SAVE";
    FSDModalCloseStatus[FSDModalCloseStatus["SUBMIT"] = 1] = "SUBMIT";
    FSDModalCloseStatus[FSDModalCloseStatus["DELETE"] = 2] = "DELETE";
    FSDModalCloseStatus[FSDModalCloseStatus["CLOSE"] = 3] = "CLOSE";
    FSDModalCloseStatus[FSDModalCloseStatus["ERROR"] = 4] = "ERROR";
})(FSDModalCloseStatus || (FSDModalCloseStatus = {}));

class GenericFSDHelpMockService {
    constructor() {
        this.docPurposeCount = 3;
        this.documents = {};
        this.docCount = 0;
        this.helpTicketList = [];
        const nentity = new HelpTicketEntity("0", 'INC-123', 'SOME COMMENTS', 'SUBMIT', 'EVS ENQUIRY', 'ref', 'SUBJECT', JSON.stringify({
            workNotes: {}, searches: [
                {
                    addressLineOne: "SA1",
                    addressLineTwo: "SA2",
                    city: "Herndon",
                    countryCode: "US",
                    legalBusinessName: "LBN",
                    moreFilter: "",
                    state: "Virginia",
                    zipCode: "20170",
                    dba: 'Company'
                },
                {
                    addressLineOne: "SA1",
                    addressLineTwo: "SA2",
                    city: "Herndon",
                    countryCode: "US",
                    legalBusinessName: "LBN 2",
                    moreFilter: "",
                    state: "Virginia",
                    zipCode: "20170"
                }
            ], data: {},
            settings: {
                documentingTemplate: '<div>Contnet</div>',
                documentPurpose: [
                    {
                        documentGuidanceText: 'Option 1',
                        documentGuidanceCheckboxText: 'Option 1',
                        isRequired: true
                    }, {
                        documentGuidanceText: 'Option 2',
                        documentGuidanceCheckboxText: 'Option 2 Different Checkbox text',
                        isRequired: true
                    },
                    {
                        documentGuidanceText: 'Option 3',
                        documentGuidanceCheckboxText: 'Option 3',
                        isRequired: false
                    },
                    {
                        documentGuidanceText: "Option 4 Longer response",
                        documentGuidanceCheckboxText: "Option 4 Longer response",
                        isRequired: true
                    }
                ]
            }
        }));
        this.helpTicketList.push(nentity);
        const doc = new HelpTicketDocument('0', 'FILE.pdf', 1024, 'PDF', '', '0', 'CLEAN', true, new Date(Date.now()), 'Articles of incorporation/organization', 'Option 1,Option 3,Option 4', [{ docPurposeId: '1', docPurpose: "Option 1", docPurposeStatusId: 1 },
            { docPurposeId: '2', docPurpose: 'Option 3', docPurposeStatusId: 2 },
            { docPurposeId: '3', docPurpose: "Option 4 Longer response", docPurposeStatusId: 3 }]);
        const doc2 = new HelpTicketDocument('0', 'FILE2.pdf', 1024, 'PDF', '', '0', 'CLEAN', true, new Date(Date.now()), 'Articles of incorporation/organization', 'Option 1,Option 3,Option 4', [{ docPurposeId: '1', docPurpose: "Option 1", docPurposeStatusId: 1 },
            { docPurposeId: '2', docPurpose: 'Option 3', docPurposeStatusId: 2 },
            { docPurposeId: '3', docPurpose: "Option 4 Longer response", docPurposeStatusId: 3 }]);
        const doc3 = new HelpTicketDocument('0', 'FILE3.pdf', 1024, 'PDF', '', '0', 'CLEAN', true, new Date(Date.now()), 'Articles of incorporation/organization', 'Option 1,Option 3,Option 4', [{ docPurposeId: '1', docPurpose: "Option 1", docPurposeStatusId: 1 },
            { docPurposeId: '2', docPurpose: 'Option 3', docPurposeStatusId: 2 },
            { docPurposeId: '3', docPurpose: "Option 4 Longer response", docPurposeStatusId: 3 }]);
        this.documents['0'] = [doc, doc2, doc3];
    }
    updatedIncidentDocumentV3(documentId, documentType, documentPurpose) {
        console.log('updatedIncidentDocument v3-> documentId: ' + documentId);
        console.log(documentType);
        console.log(documentPurpose);
        const list = documentPurpose.filter(i => i.updateStatus === 'new' || i.updateStatus === 'updated');
        const attachmentPurposes = [];
        for (let index = 0; index < list.length; index++) {
            const item = list[index];
            const attachmentPurpose = new AttachmentPurpose(item.docPurpose);
            if (item.updateStatus === 'new') {
                attachmentPurpose.docPurposeId = item.docPurposeId;
            }
            else {
                attachmentPurpose.docPurposeId = (this.docPurposeCount++).toString();
            }
            attachmentPurpose.docPurposeStatusId = 1;
            attachmentPurposes.push(attachmentPurpose);
        }
        const inceKeys = Object.keys(this.documents);
        let toReturn;
        for (let index = 0; index < inceKeys.length; index++) {
            const docList = this.documents[inceKeys[index]];
            const docListFilt = docList.filter(u => u.documentId === documentId);
            if (docListFilt.length === 1) {
                toReturn = docListFilt[0];
                toReturn.documentType = documentType;
                toReturn.attachmentPurposes = attachmentPurposes;
                index = inceKeys.length;
            }
        }
        return of(toReturn);
    }
    createIncidentDocumentV3(helpTicketId, file, documentType, documentPurposes) {
        console.log('createIncidentDocument v3 -> incidentId: ' + helpTicketId);
        console.log(file);
        console.log(documentType);
        console.log(documentPurposes);
        file.documentId = this.docCount++;
        file.documentType = documentType;
        file.documentPurpose = documentPurposes;
        const attachmentPurposes = [];
        for (let index = 0; index < documentPurposes.length; index++) {
            const text = documentPurposes[index];
            const attachmentPurpose = new AttachmentPurpose(text);
            attachmentPurpose.docPurposeId = (this.docPurposeCount++).toString();
            attachmentPurpose.documentId = file.documentId;
            attachmentPurpose.docPurposeStatusId = 1;
            attachmentPurposes.push(attachmentPurpose);
        }
        file.attachmentPurposes = attachmentPurposes;
        let incident;
        if (this.documents[helpTicketId]) {
            incident = this.documents[helpTicketId];
        }
        else {
            incident = [];
            this.documents[helpTicketId] = incident;
        }
        incident.push(file);
        return of(file);
    }
    createIncident(incident) {
        const incidentId = this.helpTicketList.length.toString();
        const helpTicketEntity = new HelpTicketEntity(incidentId, null, null, null, incident.issueType, null, incident.subject, '{}');
        this.helpTicketList.push(helpTicketEntity);
        console.log('createIncident');
        console.log(incident);
        return of(helpTicketEntity);
    }
    getIncident(incidentId) {
        console.log('getIncident -> incidentId: ' + incidentId);
        console.log(incidentId);
        console.log(this.helpTicketList[incidentId]);
        return of(this.helpTicketList[incidentId]);
    }
    updateIncident(helpTicketEntity, helpTicketId) {
        console.log('updateIncident -> incidentId: ' + helpTicketId);
        console.log(helpTicketEntity);
        this.helpTicketList[helpTicketId] = helpTicketEntity;
        return of(helpTicketEntity);
    }
    deleteIncident(helpTicketId) {
        console.log('deleteIncident -> incidentId: ' + helpTicketId);
        this.helpTicketList[helpTicketId] = null;
        return of(null);
    }
    submitIncident(helpTicketId, helpTicketEntity) {
        console.log('submitIncident -> incidentId: ' + helpTicketId);
        console.log(helpTicketEntity);
        this.helpTicketList[helpTicketId] = helpTicketEntity;
        helpTicketEntity.helpDeskTicket = '';
        return of(helpTicketEntity);
    }
    uploadIncidentDocument(helpTicketId, file) {
        return of(null);
    }
    downloadDocument(documentId) {
        throw new Error('Method not implemented.');
    }
    createIncidentDocument(helpTicketId, file, documentType, documentPurpose) {
        console.log('createIncidentDocument -> incidentId: ' + helpTicketId);
        console.log(file);
        console.log(documentType);
        console.log(documentPurpose);
        file.documentId = this.docCount++;
        file.documentType = documentType;
        file.documentPurpose = documentPurpose;
        if (Array.isArray(documentPurpose)) {
            for (let index = 0; index < documentPurpose.length; index++) {
                const element = documentPurpose[index];
                element.id = (this.docPurposeCount++).toString();
            }
        }
        let incident;
        if (this.documents[helpTicketId]) {
            incident = this.documents[helpTicketId];
        }
        else {
            incident = [];
            this.documents[helpTicketId] = incident;
        }
        incident.push(file);
        return of(file.documentId);
    }
    updatedIncidentDocument(documentId, documentType, documentPurpose) {
        console.log('updatedIncidentDocument -> documentId: ' + documentId);
        console.log(documentType);
        console.log(documentPurpose);
        const inceKeys = Object.keys(this.documents);
        let toReturn;
        for (let index = 0; index < inceKeys.length; index++) {
            const docList = this.documents[inceKeys[index]];
            const docListFilt = docList.filter(u => u.documentId === documentId);
            if (docListFilt.length === 1) {
                toReturn = docListFilt[0];
                toReturn.documentType = documentType;
                toReturn.documentPurpose = documentPurpose;
                index = inceKeys.length;
            }
        }
        return of(toReturn);
    }
    deleteIncidentDocument(documentId) {
        console.log('deleteIncidentDocument -> documentId: ' + documentId);
        const inceKeys = Object.keys(this.documents);
        let toReturn;
        for (let index = 0; index < inceKeys.length; index++) {
            const docList = this.documents[inceKeys[index]];
            const docListFilt = docList.filter(u => u.documentId === documentId);
            if (docListFilt.length === 1) {
                toReturn = docListFilt[0];
                index = inceKeys.length;
                const indexItem = docList.map(e => e.documentId).indexOf(documentId);
                docList.splice(indexItem, 1);
            }
        }
        return of(toReturn);
    }
    getIncidentDocuments(helpTicketId) {
        console.log('getIncident -> helpTicketId: ' + helpTicketId);
        console.log(this.documents[helpTicketId]);
        return of(this.documents[helpTicketId]);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericFSDHelpMockService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericFSDHelpMockService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericFSDHelpMockService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [] });

class CardWrapperComponent extends FieldWrapper {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: CardWrapperComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: CardWrapperComponent, selector: "formly-wrapper-card", usesInheritance: true, ngImport: i0, template: `
    <div class="sds-card">
      <div class="sds-card__header sds-card__header--accent-cool">
        <h4 class="font-heading-xs text-normal text-uppercase">
          {{ to.title }}
        </h4>
      </div>
      <div class="sds-card__body">
        <ng-container #fieldComponent></ng-container>
      </div>
    </div>
  `, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: CardWrapperComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'formly-wrapper-card',
                    template: `
    <div class="sds-card">
      <div class="sds-card__header sds-card__header--accent-cool">
        <h4 class="font-heading-xs text-normal text-uppercase">
          {{ to.title }}
        </h4>
      </div>
      <div class="sds-card__body">
        <ng-container #fieldComponent></ng-container>
      </div>
    </div>
  `,
                }]
        }] });

class DisplayAddressWrapperComponent extends FieldWrapper {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DisplayAddressWrapperComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: DisplayAddressWrapperComponent, selector: "formly-wrapper-display-address", usesInheritance: true, ngImport: i0, template: `
    <div class="text-uppercase text-semibold margin-bottom-1">
      {{ to.name }}
    </div>
    <div class="text-light">Physical Address</div>
    <div class="text-uppercase">{{ to.streetAddress1 }}</div>
    <div class="text-uppercase">{{ to.city }}, {{ to.state }} {{ to.zip }}</div>
    <div class="text-uppercase">{{ to.country }}</div>
    <ng-container #fieldComponent></ng-container>
  `, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DisplayAddressWrapperComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'formly-wrapper-display-address',
                    template: `
    <div class="text-uppercase text-semibold margin-bottom-1">
      {{ to.name }}
    </div>
    <div class="text-light">Physical Address</div>
    <div class="text-uppercase">{{ to.streetAddress1 }}</div>
    <div class="text-uppercase">{{ to.city }}, {{ to.state }} {{ to.zip }}</div>
    <div class="text-uppercase">{{ to.country }}</div>
    <ng-container #fieldComponent></ng-container>
  `,
                }]
        }] });

class GenericFSDHelpModule {
    static forRoot(config) {
        return {
            ngModule: GenericFSDHelpModule,
            providers: [
                { provide: SystemConfigGenericHelp, useValue: config }
            ]
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericFSDHelpModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: GenericFSDHelpModule, declarations: [GenericFSDModalComponent], imports: [CommonModule,
            FormsModule,
            ReactiveFormsModule, i1$4.FormlyModule, SdsFormlyModule,
            SdsToastModule], exports: [GenericFSDModalComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericFSDHelpModule, providers: [GenericFSDHelpService, GenericFSDHelpMockService], imports: [CommonModule,
            FormsModule,
            ReactiveFormsModule,
            FormlyModule.forChild({
                wrappers: [
                    { name: 'card', component: CardWrapperComponent },
                    { name: 'display-address', component: DisplayAddressWrapperComponent },
                ],
            }),
            SdsFormlyModule,
            SdsToastModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericFSDHelpModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        GenericFSDModalComponent
                    ],
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        FormlyModule.forChild({
                            wrappers: [
                                { name: 'card', component: CardWrapperComponent },
                                { name: 'display-address', component: DisplayAddressWrapperComponent },
                            ],
                        }),
                        SdsFormlyModule,
                        SdsToastModule,
                    ],
                    exports: [
                        GenericFSDModalComponent
                    ],
                    providers: [GenericFSDHelpService, GenericFSDHelpMockService]
                }]
        }] });

/* eslint-disable @typescript-eslint/member-ordering */
class GenericFSDStandaloneComponent {
    constructor(genericFSDHelpService, dialog, renderer, cdr) {
        this.genericFSDHelpService = genericFSDHelpService;
        this.dialog = dialog;
        this.renderer = renderer;
        this.cdr = cdr;
        this.modelUpdated = new EventEmitter();
        this.fsdSubmitted = new EventEmitter();
        this.closeAction = new EventEmitter();
        this.ticketStatus = new EventEmitter();
        this.submitLockSubject = new BehaviorSubject(false);
        this.FSDModalMode = FSDModalMode;
        this.FSDModalCloseStatus = FSDModalCloseStatus;
        this.fileUploadCount = 0;
        this.form = new FormGroup({});
        this.formInvalid = this.form.invalid;
        this.options = {};
        this.model = { comment: '', file: [] };
        this.fields = [];
        this.finalCommentCount = 0;
        this.commentCount = 0;
        this.service = genericFSDHelpService;
    }
    createDocumentPopoverText() {
        const element = this.renderer.createElement('p');
        element.innerHTML = `
  <div class="margin-3 width-card-lg">
    <div>
      These acceptable documents are frequently used to prove entity information:
    </div>
    <ul class="margin-top-0">
      <li>Certified articles of incorporation/formation</li>
      <li>Certified business filing from your Secretary of State’s office</li>
      <li>Employer Identification Number (EIN) assignment letter from the IRS</li>
      <li>Recent bank statement (redacted, less than five years old)</li>
      <li>Recent utility bill (less than five years old)</li>
      <li> <a class="usa-link padding-right-2px" aria-label="Show more acceptable document types - opens in a new window"
          href="https://www.fsd.gov/gsafsd_sp?id=kb_article_view&sysparm_article=KB0055230" target="_blank">
          Show more acceptable document types
          <span class="margin-left-1px usa-link--external font-body-md"> </span></a> </li>
    </ul>
    <div>
      You may submit one or more documents to provide all the required evidence
    </div>
  </div>

   `;
        return element;
    }
    getField(key, fields) {
        for (let i = 0, len = fields.length; i < len; i++) {
            const f = fields[i];
            if (f.key === key) {
                return f;
            }
            if (f.fieldGroup && !f.key) {
                const cf = this.getField(key, f.fieldGroup);
                if (cf) {
                    return cf;
                }
            }
        }
    }
    getFileField(count) {
        return {
            key: 'file',
            type: 'document-section',
            props: {
                position: count,
                documentGuidances: this.config.documentGuidances,
                acceptableDocuments: this.config.acceptableDocuments,
                service: this.service,
                helpTicketId: this.getHelpTicketId(),
                //     documentPopoverText: this.createDocumentPopoverText(),
                allowFileDownload: this.config.allowFileDownload,
                mode: this.config.mode,
                acceptRejectPurposeButtons: this.config.acceptRejectPurposeButtons,
                isFlagLabelsDisabled: this.config.isFlagLabelsDisabled,
                isCompoundPurpose: this.config.isCompoundPurpose,
                isNonAgent: this.config.isNonAgent,
            }
        };
    }
    getFileUploadField(count) {
        return {
            key: 'file',
            type: 'document-upload',
            props: {
                position: count,
                documentGuidances: this.config.documentGuidances,
                acceptableDocuments: this.config.acceptableDocuments,
                service: this.service,
                helpTicketId: this.getHelpTicketId(),
                //  documentPopoverText: this.createDocumentPopoverText(),
                allowFileDownload: this.config.allowFileDownload,
                mode: this.config.mode,
                acceptRejectPurposeButtons: this.config.acceptRejectPurposeButtons,
                isFlagLabelsDisabled: this.config.isFlagLabelsDisabled,
                isCompoundPurpose: this.config.isCompoundPurpose,
                isNonAgent: this.config.isNonAgent
            }
        };
    }
    getcommentField(count) {
        this.commentCount = count;
        if (this.config.mode === FSDModalMode.REVALIDATE) {
            return {
                key: 'comment',
                type: 'textarea',
                className: 'margin-left-2',
                props: {
                    label: 'Input',
                    placeholder: '',
                    description: 'Please provide additional context for your specific situation, if necessary.',
                    labelTemplate: this.labelTemplate,
                    hideOptional: true,
                    labelContentClass: this.config.isFlagLabelsDisabled ? 'margin-left-2' : 'margin-left-10',
                    required: false,
                    maxLength: 500
                },
            };
        }
        else {
            return {
                key: 'comment',
                type: 'textarea',
                props: {
                    label: 'Input',
                    placeholder: '',
                    description: 'Please provide additional context for your specific situation, if necessary.',
                    labelTemplate: this.labelTemplate,
                    hideOptional: true,
                    labelContentClass: this.config.isFlagLabelsDisabled ? 'margin-left-2' : 'margin-left-10',
                    required: false,
                    maxLength: 500
                },
            };
        }
    }
    getDocumentInfoField(count) {
        return {
            key: 'review-docs',
            type: 'review-docs',
            props: {
                position: count,
                documentGuidances: this.config.documentGuidances,
                documentingField: this.config.documentingField,
                workNote: this.config.customWorkNotes,
                documentingTemplate: this.config.documentingTemplate,
                config: this.config,
                // documentPopoverText: this.createDocumentPopoverText(),
                mode: this.config.mode,
                isDocumentUploadOptional: this.config.isDocumentUploadOptional,
                isFlagLabelsDisabled: this.config.isFlagLabelsDisabled,
                isCompoundPurpose: this.config.isCompoundPurpose,
            }
        };
    }
    getDocTemplateSection(count) {
        return {
            key: 'doc-template-section',
            type: 'doc-template-section',
            props: {
                position: count,
                documentGuidances: this.config.documentGuidances,
                documentingField: this.config.documentingField,
                workNote: this.config.customWorkNotes,
                documentingTemplate: this.config.documentingTemplate,
                config: this.config,
                // documentPopoverText: this.createDocumentPopoverText(),
                mode: this.config.mode,
                isDocumentUploadOptional: this.config.isDocumentUploadOptional,
                isFlagLabelsDisabled: this.config.isFlagLabelsDisabled,
                isCompoundPurpose: this.config.isCompoundPurpose,
            }
        };
    }
    getSubmitField(count) {
        return {
            key: 'submit-update-component',
            type: 'submit-update-component',
            props: {
                position: count,
                isFlagLabelsDisabled: this.config.isFlagLabelsDisabled,
            }
        };
    }
    getSearchField(count) {
        return {
            key: 'search-list-section',
            type: 'search-list-section',
            props: {
                position: count,
                searchListFields: this.config.searchListFields,
                searchList: this.config.searchList,
                isFlagLabelsDisabled: this.config.isFlagLabelsDisabled,
            }
        };
    }
    ngOnDestroy() {
        this.cancelIncident();
    }
    ngAfterViewInit() {
        //Resolve inputs
        if (this.config.serviceOverride) {
            this.service = this.config.serviceOverride;
        }
        let count = 0;
        if (this.config.customInputFields) {
            count = this.config.customInputFields.length;
            count = count -
                (this.config.customInputFields.filter(i => { if (i.props) {
                    return i.props["skipNumber"] === true;
                }
                else {
                    return false;
                } }).length);
        }
        if (this.config.mode === FSDModalMode.CREATE) {
            this.constantFields = [this.getDocumentInfoField((++count) + 0), this.getFileField((++count) + 0), this.getcommentField((++count) + 0)];
            this.initCreate();
        }
        else if (this.config.mode === FSDModalMode.UPDATE) {
            this.constantFields = [this.getDocumentInfoField((++count) + 0), this.getFileField((++count) + 0), this.getcommentField((++count) + 0), this.getSubmitField((++count) + 0)];
            this.initUpdate();
        }
        else if (this.config.mode === FSDModalMode.VIEW || this.config.mode === FSDModalMode.VIEWREADONLY) {
            this.constantFields = [this.getDocumentInfoField((++count) + 0), this.getSearchField((++count) + 0), this.getFileField((++count) + 0)];
            this.commentCount = (++count) + 0;
            this.initView();
        }
        else if (this.config.mode === FSDModalMode.VIEWDOCUMENT) {
            this.constantFields = [this.getDocumentInfoField((++count) + 0), this.getFileField((++count) + 0), this.getSubmitField((++count) + 0)];
            this.initView();
        }
        else if (this.config.mode === FSDModalMode.REVALIDATE) {
            this.constantFields = [this.getDocumentInfoField((++count) + 0), this.getFileUploadField((++count) + 0), this.getcommentField((++count) + 0)];
            this.initUpdate();
        }
        else if (this.config.mode === FSDModalMode.CREATESPECIFIED) {
            //TO ADD new Section
            this.constantFields = [this.getDocTemplateSection(++count), this.getFileUploadField((++count) + 0), this.getcommentField((++count) + 0)];
            this.initCreate();
        }
        this.form.statusChanges.subscribe((u) => {
            if (this.config.isDocumentUploadOptional || !this.containGuidenceType(this.config.documentGuidances, true)) {
                this.modelUpdated.emit(this.form.invalid);
            }
            else {
                this.modelUpdated.emit(this.form.invalid || this.model.file.length === 0);
            }
        });
    }
    initView() {
        this.setupFormlyFields();
        this.getIncident(true);
    }
    initUpdate() {
        this.setupFormlyFields();
        this.getIncident(false);
    }
    initCreate() {
        //this.config.helpTicketId = undefined;
        this.setupFormlyFields();
        if (this.config.customInputValues) {
            Object.assign(this.model, this.config.customInputValues);
        }
        this.createIncident();
    }
    getHelpTicketId() {
        if (this.config.helpTicketId) {
            return this.config.helpTicketId;
        }
        else {
            return this.localHelpTicketId;
        }
    }
    setupFormlyFields() {
        //Deep copy
        if (this.config.customInputFields) {
            this.customFields = JSON.parse(JSON.stringify(this.config.customInputFields));
        }
        if (this.customFields) {
            this.fields = this.customFields.concat(this.constantFields);
        }
        else {
            this.fields = this.constantFields;
        }
    }
    createIncident() {
        const returnedTarget = Object.assign({}, this.model);
        delete returnedTarget.file;
        delete returnedTarget.comment;
        const response = this.service.createIncident(new HelpTicket(JSON.stringify({ searches: this.config.searchList, data: returnedTarget }), this.config.issueType, this.config.subject));
        response.subscribe((incidentReponse) => {
            this.localHelpTicketId = incidentReponse.ticketId + '';
            this.config.helpTicketId = incidentReponse.ticketId + '';
            const field = this.getField('file', this.fields);
            field.props.helpTicketId = incidentReponse.ticketId;
        }, error => {
            console.error(error);
            this.openErrorModal();
            // this.dialogRef.close();
        });
    }
    cancelIncident() {
        if (this.config.mode === FSDModalMode.CREATE && this.getHelpTicketId() && !this.fsdTicketId) {
            const response = this.service.deleteIncident(this.getHelpTicketId());
            response.subscribe((incidentReponse) => {
                this.close(FSDModalCloseStatus.DELETE);
            }, error => {
                console.error(error);
                this.openErrorModal();
                this.close(FSDModalCloseStatus.ERROR);
            });
        }
        else {
            this.close(FSDModalCloseStatus.CLOSE);
        }
        //Cancel/click away (delete)
    }
    createWorkNotes(workNotes) {
        for (let index = 0; index < this.config.dynamicWorkDataKeys.length; index++) {
            const element = this.config.dynamicWorkDataKeys[index];
            workNotes[element] = this.model[element];
        }
        return workNotes;
    }
    openErrorModal() {
        const errorDialog = this.dialog.open(ErrorModalComponent, {
            alert: 'error',
            width: 'Small',
            data: {},
        });
    }
    submitIncident() {
        this.submitLockSubject.next(true);
        this.submitLock = true;
        const comment = this.model.comment;
        const returnedTarget = Object.assign({}, this.model);
        delete returnedTarget.file;
        delete returnedTarget.comment;
        let workNotes = this.config.customWorkNotes;
        if (!workNotes && this.config.dynamicWorkDataKeys) {
            workNotes = this.createWorkNotes({});
        }
        else if (this.config.dynamicWorkDataKeys) {
            workNotes = this.createWorkNotes(workNotes);
        }
        const response = this.service.submitIncident(this.getHelpTicketId(), new HelpTicketEntity(this.getHelpTicketId(), null, comment, null, this.config.issueType, null, this.config.subject, JSON.stringify({ workNotes: workNotes, searches: this.config.searchList, data: returnedTarget, settings: { documentingTemplate: this.config.documentingTemplate, documentPurpose: this.config.documentGuidances } })));
        response.subscribe((incidentReponse) => {
            const helpDeskTicket = incidentReponse.helpDeskTicket;
            this.fsdTicketId = helpDeskTicket + '';
            this.close(FSDModalCloseStatus.SUBMIT);
            this.submitLockSubject.next(false);
        }, error => {
            this.submitLockSubject.next(false);
            this.submitLock = false;
            console.error(error);
            this.openErrorModal();
        });
        return this.submitLockSubject;
    }
    getIncident(isReadOnly) {
        const response = this.service.getIncident(this.getHelpTicketId());
        response.subscribe((incidentReponse) => {
            this.incidentReponse = incidentReponse;
            const applicationData = JSON.parse(incidentReponse.applicationData);
            if (applicationData["data"]) {
                Object.assign(this.model, applicationData["data"]);
            }
            if (applicationData["searches"]) {
                this.config.searchList = applicationData["searches"];
                const searchField = this.getField('search-list-section', this.fields);
                if (searchField) {
                    searchField.props.searchList = this.config.searchList;
                }
            }
            this.fsdTicketId = incidentReponse.helpDeskTicket + '';
            this.model.comment = incidentReponse.description;
            this.config.issueType = incidentReponse.ticketType;
            this.config.subject = incidentReponse.ticketTitle;
            const settings = applicationData["settings"];
            if (settings) {
                const reviewRequirementsField = this.getField('review-docs', this.fields);
                reviewRequirementsField.props.documentingTemplate = this.config.documentingTemplate;
                if (this.config.mode !== FSDModalMode.REVALIDATE) {
                    this.config.documentingTemplate = settings.documentingTemplate;
                    this.config.documentGuidances = settings.documentPurpose;
                }
                const field = this.getField('file', this.fields);
                field.props.documentGuidances = this.config.documentGuidances;
            }
            if (this.config.customInputFields) {
                for (let i = 0; i < this.config.customInputFields.length; i++) {
                    const cusField = this.config.customInputFields[i];
                    const field = this.getField(cusField.key.toString(), this.fields);
                    if (field.props) {
                        field.props.data = incidentReponse;
                    }
                }
            }
            this.form.patchValue(this.model);
            this.ticketStatusPropegate(incidentReponse.ticketStatus);
            if (isReadOnly) {
                FormlyUtilsService.setReadonlyMode(true, this.fields);
            }
            this.cdr.detectChanges();
        }, error => {
            console.error(error);
            this.openErrorModal();
        });
    }
    ticketStatusPropegate(status) {
        this.ticketStatus.emit(status);
        const statusLower = status.toLowerCase();
        if (statusLower === 'resolved' || statusLower === 'canceled' || statusLower === 'closed') {
            const field = this.getField('file', this.fields);
            field.props.isResolved = true;
            this.isResolved = true;
            const subUpPos = this.fields.map(e => e.key).indexOf('submit-update-component');
            if (subUpPos !== -1) {
                this.fields.splice(subUpPos, 1);
            }
            const commentPos = this.fields.map(e => e.key).indexOf('comment');
            if (commentPos !== -1) {
                this.fields.splice(commentPos, 1);
            }
        }
    }
    saveIncident() {
        const comment = this.model.comment;
        const returnedTarget = Object.assign({}, this.model);
        delete returnedTarget.file;
        delete returnedTarget.comment;
        this.incidentReponse.description = comment;
        const response = this.service.updateIncident(this.incidentReponse, this.getHelpTicketId());
        response.subscribe((incidentReponse) => {
            this.close(FSDModalCloseStatus.SAVE);
        }, error => {
            console.error(error);
            this.openErrorModal();
        });
        //  Save(Save not submit)
    }
    getModel() {
        return this.model;
    }
    close(status) {
        this.closeAction.emit({ 'status': status, 'ticketId': this.getHelpTicketId(), 'helpDeskTicket': this.fsdTicketId, 'model': this.model });
    }
    onModelChange(event) {
    }
    containGuidenceType(documentGuidances, type) {
        const list = this.filteredGuidenceType(documentGuidances, type);
        return list.length > 0;
    }
    filteredGuidenceType(documentGuidances, type) {
        const list = documentGuidances.filter(e => e.isRequired === type);
        return list;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericFSDStandaloneComponent, deps: [{ token: GenericFSDHelpMockService }, { token: i1$1.SdsDialogService }, { token: i0.Renderer2 }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: GenericFSDStandaloneComponent, selector: "generic-help-standalone", inputs: { config: "config" }, outputs: { modelUpdated: "modelUpdated", fsdSubmitted: "fsdSubmitted", closeAction: "closeAction", ticketStatus: "ticketStatus" }, host: { listeners: { "window:beforeunload": "ngOnDestroy()" } }, viewQueries: [{ propertyName: "labelTemplate", first: true, predicate: ["labelTemplate"], descendants: true }, { propertyName: "child", first: true, predicate: ["incidentComp"], descendants: true }], ngImport: i0, template: "<div>\r\n  <!--Heading-->\r\n  <div *ngIf=\"!config.hideHeader\">\r\n    <div class=\"margin-bottom-1\">\r\n      <h2 *ngIf=\"config.mode === FSDModalMode.CREATE\">Document Your {{config.headerTypeText}} Details</h2>\r\n      <h2\r\n        *ngIf=\"config.mode !== FSDModalMode.CREATE&&config.mode !== FSDModalMode.REVALIDATE&&config.mode !== FSDModalMode.CREATESPECIFIED \">\r\n        Review Your Submitted Documents </h2>\r\n      <h2 *ngIf=\"config.mode === FSDModalMode.CREATESPECIFIED\">Documentation</h2>\r\n    </div>\r\n\r\n    <div class=\"grid-row\">\r\n      <h2 *ngIf=\"config.mode === FSDModalMode.REVALIDATE\" class=\"text-bold text-base margin-left-2\">\r\n        Document Your {{config.headerTypeText}} Details\r\n      </h2>\r\n    </div>\r\n\r\n\r\n    <div *ngIf=\"config.headerInstructionText\">\r\n      <p>{{config.headerInstructionText}}</p>\r\n    </div>\r\n  </div>\r\n  <!-- Formly Section (Custom, Attachment, Comment) -->\r\n  <form [formGroup]=\"form\">\r\n    <formly-form (modelChange)=\"onModelChange($event)\" [(model)]=\"model\" [(fields)]=\"fields\" [options]=\"options\"\r\n      [form]=\"form\"></formly-form>\r\n  </form>\r\n  <br>\r\n  <br>\r\n</div>\r\n<div\r\n  *ngIf=\"config.mode === FSDModalMode.VIEW || config.mode === FSDModalMode.VIEWREADONLY ||(config.mode === FSDModalMode.UPDATE && isResolved)\">\r\n  <div class=\"grid-row\">\r\n    <sds-step-arrow *ngIf=\"!config.isFlagLabelsDisabled\" [number]=\"commentCount\" [status]=\"'active'\"></sds-step-arrow>\r\n    <div class=\"text-semibold font-sans-lg margin-top-05 \">Provide Details</div>\r\n  </div>\r\n  <div [class]=\"config.isFlagLabelsDisabled? 'margin-left-2':'margin-left-10' \">\r\n    {{model.comment}}\r\n  </div>\r\n</div>\r\n\r\n\r\n\r\n\r\n<ng-template #labelTemplate>\r\n  <div class=\"grid-row\">\r\n    <div class=\"margin-bottom-1\">\r\n      <sds-step-arrow *ngIf=\"!config.isFlagLabelsDisabled\" [number]=\"commentCount\" [status]=\"'active'\"></sds-step-arrow>\r\n      <span\r\n        [class]=\"config.isFlagLabelsDisabled? 'text-semibold font-sans-lg margin-top-05':'text-semibold font-sans-lg' \">\r\n        Comments (Optional)\r\n      </span>\r\n    </div>\r\n  </div>\r\n</ng-template>", dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i4.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i4.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i4.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: i1$1.SdsStepArrowComponent, selector: "sds-step-arrow", inputs: ["status", "number"] }, { kind: "component", type: i1$4.FormlyForm, selector: "formly-form", inputs: ["form", "model", "fields", "options"], outputs: ["modelChange"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericFSDStandaloneComponent, decorators: [{
            type: Component,
            args: [{ selector: 'generic-help-standalone', template: "<div>\r\n  <!--Heading-->\r\n  <div *ngIf=\"!config.hideHeader\">\r\n    <div class=\"margin-bottom-1\">\r\n      <h2 *ngIf=\"config.mode === FSDModalMode.CREATE\">Document Your {{config.headerTypeText}} Details</h2>\r\n      <h2\r\n        *ngIf=\"config.mode !== FSDModalMode.CREATE&&config.mode !== FSDModalMode.REVALIDATE&&config.mode !== FSDModalMode.CREATESPECIFIED \">\r\n        Review Your Submitted Documents </h2>\r\n      <h2 *ngIf=\"config.mode === FSDModalMode.CREATESPECIFIED\">Documentation</h2>\r\n    </div>\r\n\r\n    <div class=\"grid-row\">\r\n      <h2 *ngIf=\"config.mode === FSDModalMode.REVALIDATE\" class=\"text-bold text-base margin-left-2\">\r\n        Document Your {{config.headerTypeText}} Details\r\n      </h2>\r\n    </div>\r\n\r\n\r\n    <div *ngIf=\"config.headerInstructionText\">\r\n      <p>{{config.headerInstructionText}}</p>\r\n    </div>\r\n  </div>\r\n  <!-- Formly Section (Custom, Attachment, Comment) -->\r\n  <form [formGroup]=\"form\">\r\n    <formly-form (modelChange)=\"onModelChange($event)\" [(model)]=\"model\" [(fields)]=\"fields\" [options]=\"options\"\r\n      [form]=\"form\"></formly-form>\r\n  </form>\r\n  <br>\r\n  <br>\r\n</div>\r\n<div\r\n  *ngIf=\"config.mode === FSDModalMode.VIEW || config.mode === FSDModalMode.VIEWREADONLY ||(config.mode === FSDModalMode.UPDATE && isResolved)\">\r\n  <div class=\"grid-row\">\r\n    <sds-step-arrow *ngIf=\"!config.isFlagLabelsDisabled\" [number]=\"commentCount\" [status]=\"'active'\"></sds-step-arrow>\r\n    <div class=\"text-semibold font-sans-lg margin-top-05 \">Provide Details</div>\r\n  </div>\r\n  <div [class]=\"config.isFlagLabelsDisabled? 'margin-left-2':'margin-left-10' \">\r\n    {{model.comment}}\r\n  </div>\r\n</div>\r\n\r\n\r\n\r\n\r\n<ng-template #labelTemplate>\r\n  <div class=\"grid-row\">\r\n    <div class=\"margin-bottom-1\">\r\n      <sds-step-arrow *ngIf=\"!config.isFlagLabelsDisabled\" [number]=\"commentCount\" [status]=\"'active'\"></sds-step-arrow>\r\n      <span\r\n        [class]=\"config.isFlagLabelsDisabled? 'text-semibold font-sans-lg margin-top-05':'text-semibold font-sans-lg' \">\r\n        Comments (Optional)\r\n      </span>\r\n    </div>\r\n  </div>\r\n</ng-template>" }]
        }], ctorParameters: () => [{ type: GenericFSDHelpMockService }, { type: i1$1.SdsDialogService }, { type: i0.Renderer2 }, { type: i0.ChangeDetectorRef }], propDecorators: { config: [{
                type: Input
            }], modelUpdated: [{
                type: Output
            }], fsdSubmitted: [{
                type: Output
            }], closeAction: [{
                type: Output
            }], ticketStatus: [{
                type: Output
            }], labelTemplate: [{
                type: ViewChild,
                args: ['labelTemplate']
            }], child: [{
                type: ViewChild,
                args: ['incidentComp']
            }], ngOnDestroy: [{
                type: HostListener,
                args: ['window:beforeunload']
            }] } });
class FSDComponentStatusModel {
}
class ContactFSDModalV2Data {
}
class DocumentsToFilesMapping {
}
class DocumentGuidance {
}

var SuccessNavigationButtonStyle$1;
(function (SuccessNavigationButtonStyle) {
    SuccessNavigationButtonStyle[SuccessNavigationButtonStyle["PRIMARY"] = 0] = "PRIMARY";
    SuccessNavigationButtonStyle[SuccessNavigationButtonStyle["SECONDARY"] = 1] = "SECONDARY";
    SuccessNavigationButtonStyle[SuccessNavigationButtonStyle["BASE"] = 2] = "BASE";
})(SuccessNavigationButtonStyle$1 || (SuccessNavigationButtonStyle$1 = {}));
let SuccessNavigationAction$1 = class SuccessNavigationAction {
};
let SuccessData$1 = class SuccessData {
};
class GenericFSDModalV2Component {
    getFileField(count) {
        this.form.getRawValue;
        const fileField = {
            key: 'file',
            type: SdsFormlyTypes.FILEINPUT,
            props: {
                label: count + '. Attach documents.',
                description: this.data.hideAttachmentsDescription ? '' : 'You must attach documents that prove your current, correct information to complete entity validation.',
                hideLabel: this.data.hideAttachmentsLabel,
                multiple: true,
                hideOptional: true,
                clearFilesOnAdd: false,
                displayFileInfo: true,
                tableDisplay: true,
                disabled: false,
                acceptFileType: '.bmp,.gif,.jpeg,.jpg,.tex,.xls,.xlsx,.doc,.docx,.docx,.odt,.txt,.pdf,.png,.pptx,.ppt,.rtf,.AVI,.mov,.mpg,.mpeg,.mp4,.wmv,.flv,.f4v',
                required: true,
                labelClass: 'text-semibold font-sans-lg',
                type: SdsFormlyTypes.TABLE,
                tableName: 'Supporting Attachments Table',
                noDataText: 'No Attachments',
                tableColumns: [
                    { label: 'Attachment Name', columnName: 'name', property: 'name' },
                    { label: 'File Size (kB)', columnName: 'size', textFn: (file) => (file.size / 1000) },
                    { label: 'Upload Date', columnName: 'date', textFn: (file) => this.dateFormat(file) },
                    { label: 'Virus Scan', columnName: 'scan', property: 'scanResult' },
                    {
                        label: 'Action', columnName: 'action',
                        text: 'Remove',
                        onClick: this.removeFile.bind(this)
                    }
                ],
            }
        };
        return fileField;
    }
    getcommentField(count) {
        const commentFieldConfig = {
            key: 'comment',
            type: 'textarea',
            props: {
                label: count + '. Provide specific details.',
                labelClass: 'text-semibold font-sans-lg',
                placeholder: '',
                description: this.data.customCommentsDescription ||
                    `Please describe your specific situation. For example:
        <ul>
        <li>My current registration is correct and I’ve provided supporting
        documents.</li>
        <li>My legal business name has changed and I’ve provided supporting
        documents.</li>
        <li>My physical address has changed and I’ve provided supporting
        documents.</li>
        </ul>`,
                required: true,
                maxLength: 500
            },
        };
        return commentFieldConfig;
    }
    getDocumentInfoField(count) {
        const commentFieldConfig = {
            key: 'review-docs',
            type: 'review-docs',
            props: {
                position: count
            }
        };
        return commentFieldConfig;
    }
    constructor(data, dialogRef, genericFSDHelpService, toastr, cdr, dialog) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.genericFSDHelpService = genericFSDHelpService;
        this.toastr = toastr;
        this.cdr = cdr;
        this.dialog = dialog;
        this.FSDModalMode = FSDModalCloseModel;
        this.FSDModalCloseStatus = FSDModalCloseStatus;
        this.fileUploadCount = 0;
        this.form = new FormGroup({});
        this.model = { comment: '', file: [] };
        this.options = {};
        this.service = genericFSDHelpService;
        this.toastr.toastrConfig.iconClasses = {
            error: 'sds-toast--error',
            info: 'sds-toast--info',
            success: 'sds-toast--success',
            warning: 'sds-toast--warning',
        };
        this.toastr.toastrConfig.closeButton = true;
        this.dialogRef.beforeClosed().subscribe(val => {
            if (!val || val === '') {
                this.cancelIncident();
            }
        });
    }
    ngOnInit() {
        if (this.data.serviceOverride) {
            this.service = this.data.serviceOverride;
        }
        this.config = this.data;
        let count = 0;
        if (this.config.customInputFields) {
            count = this.config.customInputFields.length;
        }
        if (this.config.mode === FSDModalMode.CREATE) {
            this.constantFields = [this.getDocumentInfoField(++count), this.getFileField(++count), this.getcommentField(++count)];
            this.initCreate();
        }
        else if (this.config.mode === FSDModalMode.UPDATE) {
            this.constantFields = [this.getDocumentInfoField(++count), this.getFileField(++count), this.getcommentField(++count)];
            this.initUpdate();
        }
        else if (this.config.mode === FSDModalMode.VIEW) {
            this.constantFields = [];
            this.initView();
        }
        else if (this.config.mode === FSDModalMode.VIEWDOCUMENT) {
            this.constantFields = [this.getDocumentInfoField(++count), this.getFileField(++count)];
            this.initView();
        }
    }
    dateFormat(file) {
        if (!file["createdDate"]) {
            file["createdDate"] = new Date();
        }
        const date = new DatePipe('en-US').transform(new Date(file["createdDate"]), 'medium', 'EDT');
        return date + ' EDT';
    }
    initView() {
        this.setupFormlyFields();
        this.getIncident(true);
    }
    initUpdate() {
        this.setupFormlyFields();
        this.getIncident(false);
    }
    initCreate() {
        this.config.helpTicketId = undefined;
        this.setupFormlyFields();
        if (this.config.customInputValues) {
            this.model = this.config.customInputValues;
        }
        this.createIncident();
    }
    setupFormlyFields() {
        //Deep copy
        if (this.config.customInputFields) {
            this.customFields = JSON.parse(JSON.stringify(this.data.customInputFields));
        }
        if (this.customFields) {
            this.fields = this.customFields.concat(this.constantFields);
        }
        else {
            this.fields = this.constantFields;
        }
    }
    removeFile(file, field) {
        if (file["documentId"] && file["documentId"] !== 'temp') {
            this.service.deleteIncidentDocument(file["documentId"]).subscribe((document) => {
                const tableFormControl = field.formControl;
                const newFiles = tableFormControl.value.filter((value) => value != file);
                tableFormControl.setValue(newFiles);
                this.fileUploadCount = newFiles.length;
            }, error => {
                console.error(error);
                this.toastr.error('An unknown error has occured. Please try again.', "");
            });
        }
    }
    downloadFile(file) {
        let documentId = file["documentId"];
        let filename = file["documentName"];
        try {
            this.service.downloadDocument(documentId).subscribe((data) => {
                let binaryData = [];
                binaryData.push(data);
                this.blob = new Blob(binaryData);
                const link = document.createElement('a');
                const downloadURL = window.URL.createObjectURL(this.blob);
                link.href = downloadURL;
                link.download = filename;
                document.body.appendChild(link);
                link.click();
            }, err => {
                console.error(err);
                this.toastr.error('An unknown error has occured. Please try again.', "");
            });
        }
        catch (e) {
            console.error(e);
            this.toastr.error('An unknown error has occured. Please try again.', "");
        }
    }
    createIncident() {
        const returnedTarget = Object.assign({}, this.model);
        delete returnedTarget.file;
        delete returnedTarget.comment;
        const response = this.service.createIncident(new HelpTicket(JSON.stringify({ searches: this.config.searchList, data: returnedTarget }), this.config.issueType, this.config.subject));
        response.subscribe((incidentReponse) => {
            this.config.helpTicketId = incidentReponse.ticketId;
        }, error => {
            console.error(error);
            this.toastr.error('An unknown error has occured. Please try again.', "");
            this.dialogRef.close();
        });
    }
    reloadVirusCheck() {
        const docResponse = new BehaviorSubject('Document');
        docResponse.subscribe(result => {
            let count = 0;
            for (let i = 0; i < this.model.file.length; i++) {
                const file = this.model.file[i];
                if (file['scanResult'] !== 'CLEAN' &&
                    file['scanResult'] !== 'INFECTED' &&
                    file['scanResult'] !== 'UNSUPPORTED FILE TYPE') {
                    count++;
                }
            }
            if (count === 0 || this.intervalsElapsed++ > 4) {
                clearInterval(this.intervalId);
            }
            this.cdr.detectChanges();
        });
        this.getDocuments(docResponse);
    }
    cancelIncident() {
        if (this.config.mode === FSDModalMode.CREATE && this.config.helpTicketId) {
            const response = this.service.deleteIncident(this.config.helpTicketId);
            response.subscribe((incidentReponse) => {
                this.close(FSDModalCloseStatus.DELETE);
            }, error => {
                console.error(error);
                this.toastr.error('An unknown error has occured. Please try again.', "");
                this.close(FSDModalCloseStatus.ERROR);
            });
        }
        else {
            this.close(FSDModalCloseStatus.CLOSE);
        }
        //Cancel/click away (delete)
    }
    createWorkNotes(workNotes) {
        for (let index = 0; index < this.config.dynamicWorkDataKeys.length; index++) {
            const element = this.config.dynamicWorkDataKeys[index];
            workNotes[element] = this.model[element];
        }
        return workNotes;
    }
    openErrorModal() {
        const errorDialog = this.dialog.open(ErrorModalComponent, {
            alert: 'error',
            width: 'Small',
            data: {},
        });
    }
    submitIncident() {
        this.submitLock = true;
        const comment = this.model.comment;
        const returnedTarget = Object.assign({}, this.model);
        delete returnedTarget.file;
        delete returnedTarget.comment;
        let workNotes = this.config.customWorkNotes;
        if (!workNotes && this.config.dynamicWorkDataKeys) {
            workNotes = this.createWorkNotes({});
        }
        else if (this.config.dynamicWorkDataKeys) {
            workNotes = this.createWorkNotes(workNotes);
        }
        const response = this.service.submitIncident(this.config.helpTicketId, new HelpTicketEntity(this.config.helpTicketId, null, comment, null, this.config.issueType, null, this.config.subject, JSON.stringify({ workNotes: workNotes, searches: this.config.searchList, data: returnedTarget })));
        response.subscribe((incidentReponse) => {
            const helpDeskTicket = incidentReponse.helpDeskTicket;
            this.fsdTicketId = helpDeskTicket;
            const successDialog = this.dialog.open(SuccessFSDDialogComponent, {
                alert: 'success',
                width: 'Small',
                data: {
                    fsdTicketNumber: this.fsdTicketId,
                    successNavigationActions: this.config.successNavigationActions,
                    model: this.model,
                    headerTypeText: this.config.headerTypeText
                },
            });
            const afterClose = successDialog.afterClosed();
            afterClose.subscribe(res => {
                this.close(FSDModalCloseStatus.SUBMIT);
            });
        }, error => {
            this.submitLock = false;
            console.error(error);
            this.openErrorModal();
        });
    }
    getIncident(isReadOnly) {
        const response = this.service.getIncident(this.config.helpTicketId);
        const incidentComplete = new BehaviorSubject('Incident');
        const docResponse = new BehaviorSubject('Document');
        const joinedResponse = forkJoin([incidentComplete, docResponse]).subscribe((r) => {
            if (isReadOnly) {
                if (this.customFields) {
                    FormlyUtilsService.setReadonlyMode(true, this.customFields);
                }
            }
            this.cdr.detectChanges();
        });
        response.subscribe((incidentReponse) => {
            const applicationData = JSON.parse(incidentReponse.applicationData);
            if (applicationData["data"]) {
                Object.assign(this.model, applicationData["data"]);
            }
            if (applicationData["searches"]) {
                this.config.searchList = applicationData["searches"];
            }
            this.model.comment = incidentReponse.description;
            this.config.issueType = incidentReponse.ticketType;
            this.config.subject = incidentReponse.ticketTitle;
            this.form.patchValue(this.model);
            incidentComplete.complete();
        }, error => {
            console.error(error);
            this.toastr.error('An unknown error has occured. Please try again.', "");
            this.close(FSDModalCloseStatus.ERROR);
        });
        this.getDocuments(docResponse);
        return joinedResponse;
    }
    getDocuments(docResponse) {
        this.service.getIncidentDocuments(this.config.helpTicketId).subscribe((documents) => {
            for (let i = 0; i < documents.length; i++) {
                let doc = documents[i];
                doc['name'] = doc.documentName;
                doc['size'] = doc.fileSize;
                doc['type'] = doc.fileType;
                doc['date'] = doc.createdDate;
            }
            this.model.file = documents;
            this.form.patchValue(this.model);
            this.fileUploadCount = documents.length;
            docResponse.complete();
        });
    }
    close(status) {
        this.dialogRef.close({ 'status': status, 'ticketId': this.config.helpTicketId, 'helpDeskTicket': this.fsdTicketId, 'model': this.model });
    }
    onModelChange($event) {
        const fileList = $event.file;
        if (fileList) {
            if (fileList.length > this.fileUploadCount) {
                const list = fileList.filter(item => !item.documentId);
                for (let i = 0; i < list.length; i++) {
                    const file = list[i];
                    if (!file["documentId"]) {
                        file["documentId"] = 'temp';
                        this.uploadFile(file, $event);
                    }
                }
            }
        }
        ;
    }
    uploadFile(file, $event) {
        this.service.uploadIncidentDocument(this.config.helpTicketId, file)
            .subscribe((response) => {
            file["documentId"] = response;
            file["scanResult"] = 'PENDING';
            this.toastr.success('File uploaded successfully.', "");
            this.fileUploadCount++;
            this.intervalsElapsed = 0;
            //15 Sec
            if (this.intervalId) {
                clearInterval(this.intervalId);
            }
            this.intervalId = setInterval(this.reloadVirusCheck.bind(this), 15000);
        }, (err) => {
            $event.file = $event.file.filter(function (value, index, arr) {
                return value != file;
            });
            this.form.patchValue($event);
            this.toastr.error('An unknown error has occured uploading the document. Please try again.', "");
            this.fileUploadCount = $event.file.length;
            console.error(err);
        });
    }
    allowDownload(document) {
        return document.scanResult === 'CLEAN' && document.requestFromAdmin && this.config.allowFileDownload;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericFSDModalV2Component, deps: [{ token: SDS_DIALOG_DATA }, { token: i1$1.SdsDialogRef }, { token: GenericFSDHelpMockService }, { token: i2$3.ToastrService }, { token: i0.ChangeDetectorRef }, { token: i1$1.SdsDialogService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: GenericFSDModalV2Component, selector: "contact-fsd-modal-v2", ngImport: i0, template: "<div>\r\n  <!--Heading-->\r\n  <div>\r\n    <div class=\"margin-bottom-1\">\r\n      <h2>Verify {{config.headerTypeText}} Details</h2>\r\n    </div>\r\n    <div *ngIf=\"config.headerInstructionText\">\r\n      <p>{{config.headerInstructionText}}</p>\r\n    </div>\r\n  </div>\r\n  <!-- Formly Section (Custom, Attachment, Comment) -->\r\n  <form [formGroup]=\"form\">\r\n    <formly-form (modelChange)=\"onModelChange($event)\" [(model)]=\"model\" [fields]=\"fields\" [options]=\"options\"\r\n      [form]=\"form\"></formly-form>\r\n  </form>\r\n  <div class=\"grid-container padding-0 padding-bottom-1\">\r\n    <div class=\"grid-row flex-column flex-align-end\">\r\n      <div class=\"grid-col flex-fill\">\r\n        <div class=\"\">\r\n          <button (click)=\"cancelIncident()\" class=\"pos-right usa-button usa-button--base bg-base-lighter\">Cancel</button>\r\n          <button [disabled]=\"submitLock || form.invalid\" (click)=\"submitIncident()\" class=\"pos-right usa-button\">Submit</button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <br>\r\n  <br>\r\n</div>\r\n", dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i4.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i4.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i4.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: i1$4.FormlyForm, selector: "formly-form", inputs: ["form", "model", "fields", "options"], outputs: ["modelChange"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericFSDModalV2Component, decorators: [{
            type: Component,
            args: [{ selector: 'contact-fsd-modal-v2', template: "<div>\r\n  <!--Heading-->\r\n  <div>\r\n    <div class=\"margin-bottom-1\">\r\n      <h2>Verify {{config.headerTypeText}} Details</h2>\r\n    </div>\r\n    <div *ngIf=\"config.headerInstructionText\">\r\n      <p>{{config.headerInstructionText}}</p>\r\n    </div>\r\n  </div>\r\n  <!-- Formly Section (Custom, Attachment, Comment) -->\r\n  <form [formGroup]=\"form\">\r\n    <formly-form (modelChange)=\"onModelChange($event)\" [(model)]=\"model\" [fields]=\"fields\" [options]=\"options\"\r\n      [form]=\"form\"></formly-form>\r\n  </form>\r\n  <div class=\"grid-container padding-0 padding-bottom-1\">\r\n    <div class=\"grid-row flex-column flex-align-end\">\r\n      <div class=\"grid-col flex-fill\">\r\n        <div class=\"\">\r\n          <button (click)=\"cancelIncident()\" class=\"pos-right usa-button usa-button--base bg-base-lighter\">Cancel</button>\r\n          <button [disabled]=\"submitLock || form.invalid\" (click)=\"submitIncident()\" class=\"pos-right usa-button\">Submit</button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <br>\r\n  <br>\r\n</div>\r\n" }]
        }], ctorParameters: () => [{ type: ContactFSDModalV2Data, decorators: [{
                    type: Inject,
                    args: [SDS_DIALOG_DATA]
                }] }, { type: i1$1.SdsDialogRef }, { type: GenericFSDHelpMockService }, { type: i2$3.ToastrService }, { type: i0.ChangeDetectorRef }, { type: i1$1.SdsDialogService }] });
/**
 * ALERTS
 * ================================================
 */
// Error
class SuccessFSDDialogComponent {
    constructor(data, dialogRef) {
        this.data = data;
        this.dialogRef = dialogRef;
    }
    ngOnInit() {
        for (let index = 0; index < this.data.successNavigationActions.length; index++) {
            const element = this.data.successNavigationActions[index];
            if (element.fieldKey) {
                const value = this.data.model[element.fieldKey];
                if (value && value === element.fieldValue) {
                    this.successNavigationAction = element;
                    //Short out loop
                    index = this.data.successNavigationActions.length;
                }
            }
            else {
                //if no field value it will use an option that is not deterministic
                this.successNavigationAction = element;
            }
        }
        const buttonStyle = this.successNavigationAction.buttonStyle;
        switch (buttonStyle) {
            case SuccessNavigationButtonStyle$1.BASE:
                this.buttonClass = 'usa-button usa-button--base bg-base-lighter';
                break;
            case SuccessNavigationButtonStyle$1.PRIMARY:
                this.buttonClass = 'usa-button';
                break;
            case SuccessNavigationButtonStyle$1.SECONDARY:
                this.buttonClass = 'usa-button usa-button bg-primary-lighter';
                break;
            default:
                this.buttonClass = 'usa-button';
                break;
        }
    }
    action() {
        this.dialogRef.close({});
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SuccessFSDDialogComponent, deps: [{ token: SDS_DIALOG_DATA }, { token: i1$1.SdsDialogRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: SuccessFSDDialogComponent, selector: "dialog-success", ngImport: i0, template: `

<div class="grid-container">
  <div class="grid-row padding-bottom-1">
    <div class="grid-col width-full display-flex flex-align-center flex-justify-center">
      <div sds-dialog-title class="text-semibold font-sans-lg">{{data.headerTypeText}} Documentation Submitted</div>
    </div>
  </div>
  <div class="grid-row">
    <div class="grid-col width-full display-flex flex-align-center flex-justify-center">
      <div><a aria-label="Reference Number - opens in a new window" class="usa-link" href="https://www.fsd.gov/gsafsd_sp?id=kb_article_view&sysparm_article=KB0059269"> Reference Number <span class="margin-left-1px usa-link--external font-body-md"></span></a></div>
    </div>
  </div>
  <div class="grid-row padding-bottom-4">
    <div class="grid-col width-full display-flex flex-align-center flex-justify-center">
      <div class="text-bold font-sans-xl">{{data.fsdTicketNumber}}</div>
    </div>
  </div>
  <div class="grid-row padding-bottom-1">
    <div class="grid-col width-full display-flex flex-align-center flex-justify-center">
      <div>SAM.gov will review your documentation to finalize your entity uniqueness determination.
      </div>
    </div>
  </div>
  <div class="grid-row padding-bottom-1">
    <div class="grid-col width-full ">
      <div><a aria-label="What happens afer I submit entity documentation? - opens in a new window" class="usa-link" href="https://www.fsd.gov/gsafsd_sp?id=kb_article_view&sysparm_article=KB0058183">What happens afer I submit entity documentation?<span class="margin-left-1px usa-link--external font-body-md"></span></a></div>
    </div>
  </div>
  <div class="grid-row padding-y-2">
    <div class="grid-col width-full display-flex flex-align-center flex-justify-center">
      <button (click)="action()" [class]="buttonClass">{{successNavigationAction.buttonText}}</button>
    </div>
  </div>
</div>

 `, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SuccessFSDDialogComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'dialog-success',
                    template: `

<div class="grid-container">
  <div class="grid-row padding-bottom-1">
    <div class="grid-col width-full display-flex flex-align-center flex-justify-center">
      <div sds-dialog-title class="text-semibold font-sans-lg">{{data.headerTypeText}} Documentation Submitted</div>
    </div>
  </div>
  <div class="grid-row">
    <div class="grid-col width-full display-flex flex-align-center flex-justify-center">
      <div><a aria-label="Reference Number - opens in a new window" class="usa-link" href="https://www.fsd.gov/gsafsd_sp?id=kb_article_view&sysparm_article=KB0059269"> Reference Number <span class="margin-left-1px usa-link--external font-body-md"></span></a></div>
    </div>
  </div>
  <div class="grid-row padding-bottom-4">
    <div class="grid-col width-full display-flex flex-align-center flex-justify-center">
      <div class="text-bold font-sans-xl">{{data.fsdTicketNumber}}</div>
    </div>
  </div>
  <div class="grid-row padding-bottom-1">
    <div class="grid-col width-full display-flex flex-align-center flex-justify-center">
      <div>SAM.gov will review your documentation to finalize your entity uniqueness determination.
      </div>
    </div>
  </div>
  <div class="grid-row padding-bottom-1">
    <div class="grid-col width-full ">
      <div><a aria-label="What happens afer I submit entity documentation? - opens in a new window" class="usa-link" href="https://www.fsd.gov/gsafsd_sp?id=kb_article_view&sysparm_article=KB0058183">What happens afer I submit entity documentation?<span class="margin-left-1px usa-link--external font-body-md"></span></a></div>
    </div>
  </div>
  <div class="grid-row padding-y-2">
    <div class="grid-col width-full display-flex flex-align-center flex-justify-center">
      <button (click)="action()" [class]="buttonClass">{{successNavigationAction.buttonText}}</button>
    </div>
  </div>
</div>

 `,
                }]
        }], ctorParameters: () => [{ type: SuccessData$1, decorators: [{
                    type: Inject,
                    args: [SDS_DIALOG_DATA]
                }] }, { type: i1$1.SdsDialogRef }] });

let ReviewOfficialDocumentationRequirementsComponent$1 = class ReviewOfficialDocumentationRequirementsComponent extends FieldType {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: ReviewOfficialDocumentationRequirementsComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: ReviewOfficialDocumentationRequirementsComponent, selector: "review-official-documentation-requirements", usesInheritance: true, ngImport: i0, template: `
<br/>
 <div class="text-semibold font-sans-lg"> {{to.position}}. Review official documentation requirements.</div>
 <div><a class="usa-link" aria-label="Read the list of acceptable documents and file types. - opens in a new window" href="https://www.fsd.gov/gsafsd_sp?id=kb_article_view&sysparm_article=KB0055230">Read the list of acceptable documents and file types. <span class="margin-left-1px usa-link--external font-body-md"></span></a> </div>
 <div class="text-semibold">Official documentation must contain your: </div>
<ul class="usa-list">
<li>Legal business name and physical address in the same document. The document must be less than 5 years old.</li>
<li> Legal business name and date of incorporation in the same</li>
document
<li>U.S. state of incorporation (U.S. entities only)</li>
<li>National identifier (non-U.S. entities only)</li>
</ul>
 `, isInline: true }); }
};
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: ReviewOfficialDocumentationRequirementsComponent$1, decorators: [{
            type: Component,
            args: [{
                    selector: 'review-official-documentation-requirements',
                    template: `
<br/>
 <div class="text-semibold font-sans-lg"> {{to.position}}. Review official documentation requirements.</div>
 <div><a class="usa-link" aria-label="Read the list of acceptable documents and file types. - opens in a new window" href="https://www.fsd.gov/gsafsd_sp?id=kb_article_view&sysparm_article=KB0055230">Read the list of acceptable documents and file types. <span class="margin-left-1px usa-link--external font-body-md"></span></a> </div>
 <div class="text-semibold">Official documentation must contain your: </div>
<ul class="usa-list">
<li>Legal business name and physical address in the same document. The document must be less than 5 years old.</li>
<li> Legal business name and date of incorporation in the same</li>
document
<li>U.S. state of incorporation (U.S. entities only)</li>
<li>National identifier (non-U.S. entities only)</li>
</ul>
 `
                }]
        }] });

class GenericFSDHelpV2Module {
    static forRoot(config) {
        return {
            ngModule: GenericFSDHelpV2Module,
            providers: [
                { provide: SystemConfigGenericHelp, useValue: config }
            ]
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericFSDHelpV2Module, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: GenericFSDHelpV2Module, declarations: [GenericFSDModalV2Component], imports: [CommonModule,
            FormsModule,
            ReactiveFormsModule, i1$4.FormlyModule, SdsFormlyModule,
            SdsToastModule,
            ErrorModelModule], exports: [GenericFSDModalV2Component] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericFSDHelpV2Module, providers: [GenericFSDHelpService, GenericFSDHelpMockService], imports: [CommonModule,
            FormsModule,
            ReactiveFormsModule,
            FormlyModule.forChild({
                types: [
                    { name: 'review-docs', component: ReviewOfficialDocumentationRequirementsComponent$1 },
                ],
            }),
            SdsFormlyModule,
            SdsToastModule,
            ErrorModelModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericFSDHelpV2Module, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        GenericFSDModalV2Component
                    ],
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        FormlyModule.forChild({
                            types: [
                                { name: 'review-docs', component: ReviewOfficialDocumentationRequirementsComponent$1 },
                            ],
                        }),
                        SdsFormlyModule,
                        SdsToastModule,
                        ErrorModelModule
                    ],
                    exports: [
                        GenericFSDModalV2Component
                    ],
                    providers: [GenericFSDHelpService, GenericFSDHelpMockService],
                }]
        }] });

class ReviewOfficialDocumentationRequirementsComponent extends FieldType {
    constructor() {
        super();
        this.FSDModalMode = FSDModalMode;
    }
    ngOnInit() {
        // this.tipContent.elementRef.nativeElement.innerHTML =
        //   this.props.documentPopoverText;
    }
    containGuidenceType(documentGuidances, type) {
        const list = this.filteredGuidenceType(documentGuidances, type);
        return list.length > 0;
    }
    filteredGuidenceType(documentGuidances, type) {
        const list = documentGuidances.filter(e => e.isRequired === type);
        return list;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: ReviewOfficialDocumentationRequirementsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: ReviewOfficialDocumentationRequirementsComponent, selector: "review-official-documentation-requirements", viewQueries: [{ propertyName: "tipContent", first: true, predicate: ["tipContent"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div *ngIf=\"to.mode!== FSDModalMode.REVALIDATE\">\r\n  <br />\r\n</div>\r\n<div class=\"grid-row\">\r\n  <sds-step-arrow *ngIf=\"!to.isFlagLabelsDisabled\" [number]=\"to.position\" [status]=\"'active'\"></sds-step-arrow>\r\n  <div *ngIf=\"to.mode!== FSDModalMode.REVALIDATE\" class=\"text-semibold font-sans-lg margin-top-05\">Review Requirements\r\n  </div>\r\n</div>\r\n<div [class]=\"to.isFlagLabelsDisabled?'margin-bottom-3':'margin-left-8 margin-bottom-3'\">\r\n  <!--Warning-->\r\n  <div *ngIf=\"to.mode!== FSDModalMode.VIEW&&to.mode!==FSDModalMode.VIEWREADONLY&&to.mode!== FSDModalMode.REVALIDATE\"\r\n    class=\"sds-alert--expanded desktop:grid-col-12 tablet-lg:grid-col-12 mobile-lg:grid-col-12 margin-left-2\">\r\n    <div class=\"grid-container width-full maxw-full margin-0 padding-0\">\r\n      <div class=\"grid-row\">\r\n        <div class=\"grid-col-auto\">\r\n          <usa-icon [icon]=\"'alert-warning'\" class=\"text-warning margin-right-1\" [size]=\"'2x'\"></usa-icon>\r\n        </div>\r\n        <div class=\"grid-col-fill\">\r\n          <span class=\"sds-alert--expanded-content\">\r\n            View this list of\r\n            <ng-template #tipContent>\r\n              <div class=\"margin-3 width-card-lg\">\r\n                <div>\r\n                  These acceptable documents are frequently used to prove entity information:\r\n                </div>\r\n                <ul class=\"margin-top-0\">\r\n                  <li>Certified articles of incorporation/formation</li>\r\n                  <li>Certified business filing from your Secretary of State\u2019s office</li>\r\n                  <li>Employer Identification Number (EIN) assignment letter from the IRS</li>\r\n                  <li>Recent bank statement (redacted, less than five years old)</li>\r\n                  <li>Recent utility bill (less than five years old)</li>\r\n                  <li> <a class=\"usa-link padding-right-2px\"\r\n                      aria-label=\"Show more acceptable document types - opens in a new window\"\r\n                      href=\"https://www.fsd.gov/gsafsd_sp?id=kb_article_view&sysparm_article=KB0055230\" target=\"_blank\">\r\n                      Show more acceptable document types\r\n                      <span class=\"margin-left-1px usa-link--external font-body-md\"> </span></a> </li>\r\n                </ul>\r\n                <div>\r\n                  You may submit one or more documents to provide all the required evidence\r\n                </div>\r\n              </div>\r\n            </ng-template>\r\n            <button class=\"usa-button usa-button--unstyled\" [sdsPopover]=\"tipContent\" [position]=\"'bottom'\">\r\n              acceptable documents</button>\r\n            to understand the requirements.\r\n          </span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <!--Template-->\r\n  <div *ngIf=\"to.documentingTemplate\" class=\"sds-card margin-left-2 margin-bottom-1\">\r\n    <div class=\"bg-accent-cool-lighter sds-card__header sds-card__header--left\">\r\n      <div class=\"font-sans-xs margin-bottom-0 padding-bottom-0 margin-top-0 padding-top-0\">YOUR LEGAL ENTITY</div>\r\n    </div>\r\n    <div class=\"sds-card__body\" [innerHTML]=\"to.documentingTemplate\">\r\n\r\n    </div>\r\n  </div>\r\n\r\n</div>", dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i1$1.SdsStepArrowComponent, selector: "sds-step-arrow", inputs: ["status", "number"] }, { kind: "component", type: i3.IconComponent, selector: "usa-icon", inputs: ["icon", "rotate", "size", "classes", "skew"] }, { kind: "directive", type: i1$1.SdsPopover, selector: "[sdsPopover]", inputs: ["animation", "autoClose", "sdsPopover", "sdsPopoverTitle", "position", "popperOptions", "triggers", "positionTarget", "container", "disablePopover", "popoverClass", "popoverContext", "openDelay", "closeDelay"], outputs: ["shown", "hidden"], exportAs: ["sdsPopover"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: ReviewOfficialDocumentationRequirementsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'review-official-documentation-requirements', template: "<div *ngIf=\"to.mode!== FSDModalMode.REVALIDATE\">\r\n  <br />\r\n</div>\r\n<div class=\"grid-row\">\r\n  <sds-step-arrow *ngIf=\"!to.isFlagLabelsDisabled\" [number]=\"to.position\" [status]=\"'active'\"></sds-step-arrow>\r\n  <div *ngIf=\"to.mode!== FSDModalMode.REVALIDATE\" class=\"text-semibold font-sans-lg margin-top-05\">Review Requirements\r\n  </div>\r\n</div>\r\n<div [class]=\"to.isFlagLabelsDisabled?'margin-bottom-3':'margin-left-8 margin-bottom-3'\">\r\n  <!--Warning-->\r\n  <div *ngIf=\"to.mode!== FSDModalMode.VIEW&&to.mode!==FSDModalMode.VIEWREADONLY&&to.mode!== FSDModalMode.REVALIDATE\"\r\n    class=\"sds-alert--expanded desktop:grid-col-12 tablet-lg:grid-col-12 mobile-lg:grid-col-12 margin-left-2\">\r\n    <div class=\"grid-container width-full maxw-full margin-0 padding-0\">\r\n      <div class=\"grid-row\">\r\n        <div class=\"grid-col-auto\">\r\n          <usa-icon [icon]=\"'alert-warning'\" class=\"text-warning margin-right-1\" [size]=\"'2x'\"></usa-icon>\r\n        </div>\r\n        <div class=\"grid-col-fill\">\r\n          <span class=\"sds-alert--expanded-content\">\r\n            View this list of\r\n            <ng-template #tipContent>\r\n              <div class=\"margin-3 width-card-lg\">\r\n                <div>\r\n                  These acceptable documents are frequently used to prove entity information:\r\n                </div>\r\n                <ul class=\"margin-top-0\">\r\n                  <li>Certified articles of incorporation/formation</li>\r\n                  <li>Certified business filing from your Secretary of State\u2019s office</li>\r\n                  <li>Employer Identification Number (EIN) assignment letter from the IRS</li>\r\n                  <li>Recent bank statement (redacted, less than five years old)</li>\r\n                  <li>Recent utility bill (less than five years old)</li>\r\n                  <li> <a class=\"usa-link padding-right-2px\"\r\n                      aria-label=\"Show more acceptable document types - opens in a new window\"\r\n                      href=\"https://www.fsd.gov/gsafsd_sp?id=kb_article_view&sysparm_article=KB0055230\" target=\"_blank\">\r\n                      Show more acceptable document types\r\n                      <span class=\"margin-left-1px usa-link--external font-body-md\"> </span></a> </li>\r\n                </ul>\r\n                <div>\r\n                  You may submit one or more documents to provide all the required evidence\r\n                </div>\r\n              </div>\r\n            </ng-template>\r\n            <button class=\"usa-button usa-button--unstyled\" [sdsPopover]=\"tipContent\" [position]=\"'bottom'\">\r\n              acceptable documents</button>\r\n            to understand the requirements.\r\n          </span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <!--Template-->\r\n  <div *ngIf=\"to.documentingTemplate\" class=\"sds-card margin-left-2 margin-bottom-1\">\r\n    <div class=\"bg-accent-cool-lighter sds-card__header sds-card__header--left\">\r\n      <div class=\"font-sans-xs margin-bottom-0 padding-bottom-0 margin-top-0 padding-top-0\">YOUR LEGAL ENTITY</div>\r\n    </div>\r\n    <div class=\"sds-card__body\" [innerHTML]=\"to.documentingTemplate\">\r\n\r\n    </div>\r\n  </div>\r\n\r\n</div>" }]
        }], ctorParameters: () => [], propDecorators: { tipContent: [{
                type: ViewChild,
                args: ['tipContent']
            }] } });

class DocumentProcessModalComponent {
    constructor(data, dialogRef) {
        this.data = data;
        this.dialogRef = dialogRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DocumentProcessModalComponent, deps: [{ token: SDS_DIALOG_DATA }, { token: i1$1.SdsDialogRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: DocumentProcessModalComponent, selector: "document-process-modal", ngImport: i0, template: "<div class=\"font-sans-lg display-flex flex-align-center flex-justify-center\">\r\n  <div class=\"usa-file-input__preview-image is-loading\"></div>\r\n</div>\r\n<div class=\"font-sans-lg display-flex flex-align-center flex-justify-center\">\r\n  <div>We are verifying and processing your document.</div>\r\n</div>\r\n<div class=\"font-sans-lg display-flex flex-align-center flex-justify-center\">\r\n  <div>This can take some time.</div>\r\n</div>\r\n<div class=\"font-sans-lg display-flex flex-align-center flex-justify-center\">\r\n  <div>Do not close or refresh the page.</div>\r\n</div>\r\n<div class=\"font-sans-lg display-flex flex-align-center flex-justify-center\">\r\n  <div><strong>Thank you for your patience.</strong></div>\r\n</div>\r\n" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DocumentProcessModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'document-process-modal', template: "<div class=\"font-sans-lg display-flex flex-align-center flex-justify-center\">\r\n  <div class=\"usa-file-input__preview-image is-loading\"></div>\r\n</div>\r\n<div class=\"font-sans-lg display-flex flex-align-center flex-justify-center\">\r\n  <div>We are verifying and processing your document.</div>\r\n</div>\r\n<div class=\"font-sans-lg display-flex flex-align-center flex-justify-center\">\r\n  <div>This can take some time.</div>\r\n</div>\r\n<div class=\"font-sans-lg display-flex flex-align-center flex-justify-center\">\r\n  <div>Do not close or refresh the page.</div>\r\n</div>\r\n<div class=\"font-sans-lg display-flex flex-align-center flex-justify-center\">\r\n  <div><strong>Thank you for your patience.</strong></div>\r\n</div>\r\n" }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [SDS_DIALOG_DATA]
                }] }, { type: i1$1.SdsDialogRef }] });

var DocumentModalCloseStatus;
(function (DocumentModalCloseStatus) {
    DocumentModalCloseStatus[DocumentModalCloseStatus["CANCEL"] = 0] = "CANCEL";
    DocumentModalCloseStatus[DocumentModalCloseStatus["SAVE"] = 1] = "SAVE";
    DocumentModalCloseStatus[DocumentModalCloseStatus["UPDATE"] = 2] = "UPDATE";
    DocumentModalCloseStatus[DocumentModalCloseStatus["UPDATEDELETE"] = 3] = "UPDATEDELETE";
})(DocumentModalCloseStatus || (DocumentModalCloseStatus = {}));
var DocumentModalMode;
(function (DocumentModalMode) {
    DocumentModalMode[DocumentModalMode["CREATE"] = 0] = "CREATE";
    DocumentModalMode[DocumentModalMode["UPDATE"] = 1] = "UPDATE";
})(DocumentModalMode || (DocumentModalMode = {}));
class GenericDocumentFSDModal {
}
class GenericDocumentFSDModalComponent {
    constructor(data, dialogRef, dialog) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.dialog = dialog;
        this.form = new FormGroup({});
        this.options = {};
        this.isFilevalid = true;
        this.model = { documentGuidances: [] };
        this.fields = [];
        this.errorMessage = undefined;
        this.DocumentModalMode = DocumentModalMode;
    }
    ngOnInit() {
        this.model = { documentGuidances: [] };
        if (this.data.mode === DocumentModalMode.UPDATE) {
            this.qualifierText = 'Update Document';
        }
        else if (this.data.mode === DocumentModalMode.CREATE) {
            this.qualifierText = 'Add Document';
        }
        this.fields = this.getFileField();
        if (this.data.mode === DocumentModalMode.UPDATE) {
            this.tempDoc = JSON.parse(JSON.stringify(this.data.document));
            const filearray = [this.data.document];
            this.model.file = filearray;
            this.model.type = this.data.document.documentType;
            if (!this.data.isCompoundPurpose) {
                this.updateDocumentGuidanceString();
            }
            else {
                this.updateDocumentGuidanceModel();
            }
        }
    }
    updateDocumentGuidanceModel() {
        const documentGuidances = {};
        const items = this.data.document.attachmentPurposes;
        for (let index = 0; index < items.length; index++) {
            const item = items[index];
            documentGuidances[item.docPurpose] = true;
        }
        this.model.documentGuidances = documentGuidances;
    }
    updateDocumentGuidanceString() {
        const documentGuidances = {};
        const items = this.data.document.documentPurpose.split(',');
        for (let index = 0; index < items.length; index++) {
            const key = items[index];
            documentGuidances[key] = true;
        }
        this.model.documentGuidances = documentGuidances;
    }
    save() {
        this.errorMessage = undefined;
        this.timeoutId = setTimeout(this.openDocumentProcessModal.bind(this), 1000);
        if (!this.data.isCompoundPurpose) {
            this.saveStringPurpose();
        }
        else {
            this.saveModelPurpose();
        }
    }
    openDocumentProcessModal() {
        this.processDialog = this.dialog.open(DocumentProcessModalComponent, {
            width: 'large',
            data: {},
        });
    }
    closeProcessDialog() {
        if (this.processDialog) {
            this.processDialog.close();
        }
    }
    cleanUpProcessDialog() {
        clearTimeout(this.timeoutId);
        this.closeProcessDialog();
    }
    saveModelPurpose() {
        if (this.data.mode === DocumentModalMode.CREATE) {
            this.createModel();
        }
        else if (this.data.mode === DocumentModalMode.UPDATE) {
            if (this.model.file[0].documentId) {
                this.updateWithSameFileModel();
            }
            else {
                this.updateWithNewFileModel();
            }
        }
    }
    saveStringPurpose() {
        const selectedItems = [];
        const keys = Object.keys(this.model.documentGuidances);
        for (let index = 0; index < keys.length; index++) {
            const key = keys[index];
            if (this.model.documentGuidances[key]) {
                selectedItems.push(key);
            }
        }
        this.model.selectedItems = selectedItems.join(',');
        if (this.data.mode === DocumentModalMode.CREATE) {
            this.create(selectedItems);
        }
        else if (this.data.mode === DocumentModalMode.UPDATE) {
            if (this.model.file[0].documentId) {
                this.updateWithSameFile(selectedItems);
            }
            else {
                this.updateWithNewFile(selectedItems);
            }
        }
    }
    updateWithSameFile(selectedItems) {
        this.data.service.updatedIncidentDocument(this.data.document.documentId, this.model.type, selectedItems.join(',')).subscribe((document) => {
            this.cleanUpProcessDialog();
            const file = this.model.file[0];
            file.documentType = this.model.type;
            file.documentPurpose = selectedItems.join(',');
            this.dialogRef.close({ status: DocumentModalCloseStatus.UPDATE, document: file });
        }, error => {
            this.cleanUpProcessDialog();
            console.error(error);
            this.openErrorModal();
        });
    }
    updateWithSameFileModel() {
        this.data.service.updatedIncidentDocumentV3(this.data.document.documentId, this.model.type, this.createDocumentPurposesList()).subscribe((document) => {
            this.cleanUpProcessDialog();
            //this.model.file.documentId = document.documentId;
            const file = this.model.file[0];
            file.documentId = document.documentId;
            file.documentName = this.model.file[0].name;
            file.documentType = this.model.type;
            file.attachmentPurposes = document.attachmentPurposes;
            this.dialogRef.close({ status: DocumentModalCloseStatus.UPDATE, document: file });
        }, error => {
            this.cleanUpProcessDialog();
            console.error(error);
            this.openErrorModal();
        });
    }
    uploadNewSuccess(documentId) {
        this.cleanUpProcessDialog();
        this.model.file.documentId = documentId;
        const file = this.model.file[0];
        file.documentId = documentId;
        file.documentName = file.name;
        file.documentType = this.model.type;
        file.documentPurpose = this.model.selectedItems;
        this.dialogRef.close({ status: DocumentModalCloseStatus.UPDATEDELETE, document: file, oldDocument: this.tempDoc });
    }
    uploadErrorCheck(error) {
        if (error.status === 400) {
            this.isFilevalid = false;
            this.errorMessage = error.error;
            this.form.patchValue(this.model);
        }
        else {
            this.openErrorModal();
        }
    }
    getSelectedDocumentPurposes() {
        const list = [];
        const keys = Object.keys(this.model.documentGuidances);
        for (let index = 0; index < keys.length; index++) {
            const key = keys[index];
            if (this.model.documentGuidances[key]) {
                list.push(key);
            }
        }
        return list;
    }
    createDocumentPurposesList() {
        const documentPurposeList = [];
        for (let index = 0; index < this.data.document.attachmentPurposes.length; index++) {
            const item = this.data.document.attachmentPurposes[index];
            const documentPurpose = new DocumentPurpose(item.documentId, item.docPurposeId, item.docPurpose, 'deleted');
            documentPurposeList.push(documentPurpose);
        }
        const keys = Object.keys(this.model.documentGuidances);
        for (let index = 0; index < keys.length; index++) {
            const key = keys[index];
            if (this.model.documentGuidances[key]) {
                const purpose = documentPurposeList.find(item => item.docPurpose === key);
                //found and true needs to be added if not in purposes list
                if (!purpose) {
                    documentPurposeList.push(new DocumentPurpose(null, null, key, 'new'));
                }
                else {
                    purpose.updateStatus = 'updated';
                }
            }
        }
        return documentPurposeList;
    }
    updateWithNewFileModel() {
        this.data.service.deleteIncidentDocument(this.data.document.documentId).subscribe((document) => {
            this.data.service.createIncidentDocumentV3(this.data.helpTicketId, this.model.file[0], this.model.type, this.getSelectedDocumentPurposes()).subscribe((document) => {
                // this.tempDoc = JSON.parse(JSON.stringify(this.model.file[0]));
                this.cleanUpProcessDialog();
                //this.model.file.documentId = document.documentId;
                const file = this.model.file[0];
                file.documentId = document.documentId;
                file.documentName = this.model.file[0].name;
                file.documentType = this.model.type;
                file.attachmentPurposes = document.attachmentPurposes;
                this.dialogRef.close({ status: DocumentModalCloseStatus.UPDATEDELETE, document: file, oldDocument: this.tempDoc });
            }, error => {
                this.cleanUpProcessDialog();
                console.error(error);
                this.uploadErrorCheck(error);
            });
        }, error => {
            this.cleanUpProcessDialog();
            console.error(error);
            this.openErrorModal();
        });
    }
    updateWithNewFile(selectedItems) {
        this.data.service.deleteIncidentDocument(this.data.document.documentId).subscribe((document) => {
            this.data.service.createIncidentDocument(this.data.helpTicketId, this.model.file[0], this.model.type, selectedItems.join(',')).subscribe(this.uploadNewSuccess.bind(this), error => {
                this.cleanUpProcessDialog();
                console.error(error);
                this.uploadErrorCheck(error);
            });
        }, error => {
            this.cleanUpProcessDialog();
            console.error(error);
            this.openErrorModal();
        });
    }
    create(selectedItems) {
        this.data.service.createIncidentDocument(this.data.helpTicketId, this.model.file[0], this.model.type, selectedItems.join(',')).subscribe((documentId) => {
            this.cleanUpProcessDialog();
            this.model.file.documentId = documentId;
            const file = this.model.file[0];
            file.documentId = documentId;
            file.documentName = this.model.file[0].name;
            file.documentType = this.model.type;
            file.documentPurpose = selectedItems.join(',');
            this.dialogRef.close({ status: DocumentModalCloseStatus.SAVE, document: file });
        }, error => {
            this.cleanUpProcessDialog();
            console.error(error);
            this.uploadErrorCheck(error);
        });
    }
    createModel() {
        this.data.service.createIncidentDocumentV3(this.data.helpTicketId, this.model.file[0], this.model.type, this.getSelectedDocumentPurposes()).subscribe((document) => {
            this.cleanUpProcessDialog();
            const file = this.model.file[0];
            file.documentId = document.documentId;
            file.documentName = file.name;
            file.documentType = this.model.type;
            file.attachmentPurposes = document.attachmentPurposes;
            this.dialogRef.close({ status: DocumentModalCloseStatus.SAVE, document: file });
        }, error => {
            this.cleanUpProcessDialog();
            console.error(error);
            this.uploadErrorCheck(error);
        });
    }
    openErrorModal() {
        const errorDialog = this.dialog.open(ErrorModalComponent, {
            alert: 'error',
            width: 'Small',
            data: {},
        });
    }
    cancel() {
        //Delete
        this.cleanUpProcessDialog();
        this.dialogRef.close({ status: DocumentModalCloseStatus.CANCEL });
    }
    onModelChange($event) {
        this.isFilevalid = true;
    }
    getFileField() {
        const fileField = [{
                key: 'type',
                type: 'select',
                props: {
                    label: 'Select a Document Type',
                    required: true,
                    options: this.getDocumentTypesOptions()
                },
            },
            {
                key: 'documentGuidances',
                type: 'multicheckbox',
                validators: {
                    required: multiCheckboxRequired,
                },
                props: {
                    label: "Document Includes",
                    description: 'This document includes the following.  Select all that apply.',
                    required: true,
                    options: this.getDocumentGuidancesOptions()
                },
            },
            {
                key: 'file',
                type: 'fileinput',
                props: {
                    label: 'Select Document',
                    hideOptional: true,
                    hideLabel: false,
                    disabled: false,
                    displayFileInfo: true,
                    acceptFileType: '.bmp,.gif,.jpeg,.jpg,.tex,.xls,.xlsx,.doc,.docx,.docx,.odt,.txt,.pdf,.png,.pptx,.ppt,.rtf,.AVI,.mov,.mpg,.mpeg,.mp4,.wmv,.flv,.f4v',
                    required: true,
                    labelClass: 'text-semibold font-sans-lg'
                },
                validators: {
                    invalidDocument: {
                        expression: (c) => { return this.isFilevalid; },
                        message: (error, field) => this.errorMessage,
                    }
                },
            },];
        return fileField;
    }
    getDocumentTypesOptions() {
        const options = [];
        for (let index = 0; index < this.data.acceptableDocuments.length; index++) {
            const element = this.data.acceptableDocuments[index];
            options.push({ label: element, value: element });
        }
        return options;
    }
    getDocumentGuidancesOptions() {
        const options = [];
        if (this.data) {
            if (this.data.documentGuidances) {
                for (let index = 0; index < this.data.documentGuidances.length; index++) {
                    const element = this.data.documentGuidances[index];
                    options.push({ label: element.documentGuidanceCheckboxText, value: element.documentGuidanceCheckboxText });
                }
            }
        }
        return options;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericDocumentFSDModalComponent, deps: [{ token: SDS_DIALOG_DATA }, { token: i1$1.SdsDialogRef }, { token: i1$1.SdsDialogService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: GenericDocumentFSDModalComponent, selector: "document-fsd-modal", ngImport: i0, template: "<div class=\"grid-container\">\r\n<div class=\"grid-row padding-bottom-1\">\r\n  <div class=\"grid-col width-full display-flex\">\r\n    <div sds-dialog-title class=\"text-semibold font-sans-lg\">\r\n      <h2 class=\"usa-modal__heading\">\r\n        {{qualifierText}}\r\n      </h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"grid-row\">\r\n  <div class=\"grid-col \">\r\n    <form [formGroup]=\"form\">\r\n      <formly-form (modelChange)=\"onModelChange($event)\" [(model)]=\"model\" [(fields)]=\"fields\" [options]=\"options\"\r\n        [form]=\"form\">\r\n      </formly-form>\r\n    </form>\r\n\r\n  </div>\r\n</div>\r\n<div class=\"grid-row padding-y-2\">\r\n  <div class=\"grid-col width-full display-flex \">\r\n\r\n    <button (click)=\"cancel()\" class=\"usa-button usa-button--base bg-base-lighter\">Cancel</button>\r\n    <button (click)=\"save()\" [disabled]=\"form.invalid\" class=\"usa-button\">Submit</button>\r\n  </div>\r\n</div>\r\n</div>\r\n", dependencies: [{ kind: "directive", type: i4.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i4.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i4.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: i1$4.FormlyForm, selector: "formly-form", inputs: ["form", "model", "fields", "options"], outputs: ["modelChange"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericDocumentFSDModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'document-fsd-modal', template: "<div class=\"grid-container\">\r\n<div class=\"grid-row padding-bottom-1\">\r\n  <div class=\"grid-col width-full display-flex\">\r\n    <div sds-dialog-title class=\"text-semibold font-sans-lg\">\r\n      <h2 class=\"usa-modal__heading\">\r\n        {{qualifierText}}\r\n      </h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"grid-row\">\r\n  <div class=\"grid-col \">\r\n    <form [formGroup]=\"form\">\r\n      <formly-form (modelChange)=\"onModelChange($event)\" [(model)]=\"model\" [(fields)]=\"fields\" [options]=\"options\"\r\n        [form]=\"form\">\r\n      </formly-form>\r\n    </form>\r\n\r\n  </div>\r\n</div>\r\n<div class=\"grid-row padding-y-2\">\r\n  <div class=\"grid-col width-full display-flex \">\r\n\r\n    <button (click)=\"cancel()\" class=\"usa-button usa-button--base bg-base-lighter\">Cancel</button>\r\n    <button (click)=\"save()\" [disabled]=\"form.invalid\" class=\"usa-button\">Submit</button>\r\n  </div>\r\n</div>\r\n</div>\r\n" }]
        }], ctorParameters: () => [{ type: GenericDocumentFSDModal, decorators: [{
                    type: Inject,
                    args: [SDS_DIALOG_DATA]
                }] }, { type: i1$1.SdsDialogRef }, { type: i1$1.SdsDialogService }] });

class DocumentSectionComponent extends FieldType {
    constructor(dialog) {
        super();
        this.dialog = dialog;
        this.FSDModalMode = FSDModalMode;
        this.StatusIconMode = StatusIconMode$1;
        this.DoumentPurposeStatus = DoumentPurposeStatus$1;
        this.allSelected = false;
    }
    ngOnInit() {
        // this.tipContent.elementRef.nativeElement.innerHTML =
        // this.props.documentPopoverText;
    }
    containGuidenceType(documentGuidances, type) {
        const list = this.filteredGuidenceType(documentGuidances, type);
        return list.length > 0;
    }
    filteredGuidenceType(documentGuidances, type) {
        const list = documentGuidances.filter(e => e.isRequired === type);
        return list;
    }
    getStatusDisplayList(documentGuidances, type) {
        const list = documentGuidances.filter(e => e.isRequired === type);
        const toReturn = [];
        const fileList = this.model.file;
        if (this.props.mode === FSDModalMode.CREATE || !this.props.acceptRejectPurposeButtons) {
            for (let i = 0; i < list.length; i++) {
                const item = list[i];
                toReturn.push({ text: item.documentGuidanceText, mode: item.isSelected ? StatusIconMode$1.ACCEPTED : StatusIconMode$1.BLANK });
            }
        }
        else if (this.props.mode === FSDModalMode.UPDATE || this.props.mode === FSDModalMode.VIEW || this.props.mode == FSDModalMode.VIEWREADONLY) {
            this.methodStatusUpdateView(list, fileList, toReturn, type);
        }
        return toReturn;
    }
    isAccepted(doc) {
        const purposes = doc.attachmentPurposes;
        const list = purposes.filter(e => e.docPurposeStatusId === DoumentPurposeStatus$1.ACCEPTED);
        return list.length !== 0;
    }
    methodStatusUpdateView(list, fileList, toReturn, type) {
        for (let i = 0; i < list.length; i++) {
            const item = list[i];
            if (item.isSelected) {
                const acceptedCount = this.getDocumentsByPurposeStatusCount(fileList, item, DoumentPurposeStatus$1.ACCEPTED);
                if (acceptedCount > 0) {
                    toReturn.push({ text: item.documentGuidanceText, mode: StatusIconMode$1.ACCEPTED });
                }
                else {
                    // const rejectedCount = this.getDocumentsByPurposeStatusCount(fileList, item, DoumentPurposeStatus.REJECTED);
                    let rejectedCount = 0;
                    let totalCount = 0;
                    for (let i = 0; i < fileList.length; i++) {
                        const file = fileList[i];
                        for (let g = 0; g < file.attachmentPurposes.length; g++) {
                            const purpose = file.attachmentPurposes[g];
                            if (purpose.docPurpose === item.documentGuidanceText) {
                                totalCount++;
                                if (purpose.docPurposeStatusId === DoumentPurposeStatus$1.REJECTED) {
                                    rejectedCount++;
                                }
                            }
                        }
                    }
                    if (rejectedCount === totalCount) {
                        toReturn.push({ text: item.documentGuidanceText, mode: type ? StatusIconMode$1.REJECTED : StatusIconMode$1.NOTAPPLICABLE });
                    }
                    else {
                        toReturn.push({ text: item.documentGuidanceText, mode: StatusIconMode$1.PENDING });
                    }
                }
            }
            else {
                toReturn.push({ text: item.documentGuidanceText, mode: type ? StatusIconMode$1.REJECTED : StatusIconMode$1.NOTAPPLICABLE });
            }
        }
    }
    getDocumentsByPurposeStatusCount(fileList, item, status) {
        let count = 0;
        for (let i = 0; i < fileList.length; i++) {
            const file = fileList[i];
            for (let g = 0; g < file.attachmentPurposes.length; g++) {
                const purpose = file.attachmentPurposes[g];
                if (purpose.docPurpose === item.documentGuidanceText && purpose.docPurposeStatusId === status) {
                    count++;
                }
            }
        }
        return count;
    }
    allowDownload(document) {
        return document.scanResult === 'CLEAN' && document.requestFromAdmin && this.props.allowFileDownload;
    }
    acceptPurpose(document, documentId, purpose) {
        purpose.docPurposeStatusId = DoumentPurposeStatus$1.ACCEPTED;
    }
    rejectPurpose(document, documentId, purpose) {
        purpose.docPurposeStatusId = DoumentPurposeStatus$1.REJECTED;
    }
    getDocuments() {
        this.props.service.getIncidentDocuments(this.props.helpTicketId).subscribe((documents) => {
            for (let i = 0; i < documents.length; i++) {
                const doc = documents[i];
                doc['name'] = doc.documentName;
                doc['size'] = doc.fileSize;
                doc['type'] = doc.fileType;
                doc['date'] = doc.createdDate;
            }
            this.model.file = documents;
            this.form.patchValue(this.model);
            this.updatedSelected();
        });
    }
    ngAfterViewInit() {
        const mode = this.props.mode;
        if (mode !== FSDModalMode.CREATE) {
            this.getDocuments();
        }
    }
    downloadFile(file) {
        const documentId = file["documentId"];
        const filename = file["documentName"];
        try {
            this.props.service.downloadDocument(documentId).subscribe((data) => {
                const binaryData = [];
                binaryData.push(data);
                this.blob = new Blob(binaryData);
                const link = document.createElement('a');
                const downloadURL = window.URL.createObjectURL(this.blob);
                link.href = downloadURL;
                link.download = filename;
                document.body.appendChild(link);
                link.click();
            }, err => {
                console.error(err);
                this.openErrorModal();
            });
        }
        catch (e) {
            console.error(e);
            this.openErrorModal();
        }
    }
    updateDocument(document) {
        const successDialog = this.dialog.open(GenericDocumentFSDModalComponent, {
            width: 'large',
            data: {
                documentGuidances: this.props.documentGuidances,
                acceptableDocuments: this.props.acceptableDocuments,
                ticketId: this.props.ticketId,
                helpTicketId: this.props.helpTicketId,
                isCompoundPurpose: this.props.isCompoundPurpose,
                service: this.props.service,
                document: document,
                mode: DocumentModalMode.UPDATE
            },
        });
        const afterClose = successDialog.afterClosed();
        afterClose.subscribe(this.closedDocument.bind(this));
    }
    deleteDocument(documentId) {
        this.props.service.deleteIncidentDocument(documentId).subscribe((document) => {
            const index = this.model.file.map(e => e.documentId).indexOf(documentId);
            this.model.file.splice(index, 1);
            this.refreshUI();
            this.updatedSelected();
        }, error => {
            console.error(error);
            this.openErrorModal();
        });
    }
    openErrorModal() {
        const errorDialog = this.dialog.open(ErrorModalComponent, {
            alert: 'error',
            width: 'Small',
            data: {},
        });
    }
    openAddDocument() {
        const successDialog = this.dialog.open(GenericDocumentFSDModalComponent, {
            width: 'large',
            data: {
                documentGuidances: this.props.documentGuidances,
                acceptableDocuments: this.props.acceptableDocuments,
                helpTicketId: this.props.helpTicketId,
                service: this.props.service,
                mode: DocumentModalMode.CREATE,
                isCompoundPurpose: this.props.isCompoundPurpose,
            },
        });
        const afterClose = successDialog.afterClosed();
        afterClose.subscribe(this.closedDocument.bind(this));
    }
    closedDocument(res) {
        if (res) {
            if (res.status === DocumentModalCloseStatus.SAVE) {
                this.model.file.push(res.document);
            }
            else if (res.status === DocumentModalCloseStatus.UPDATE) {
                const index = this.model.file.map(e => e.documentId).indexOf(res.document.documentId);
                this.model.file[index] = res.document;
            }
            else if (res.status === DocumentModalCloseStatus.UPDATEDELETE) {
                const index = this.model.file.map(e => e.documentId).indexOf(res.oldDocument.documentId);
                this.model.file[index] = res.document;
            }
            this.refreshUI();
            this.updatedSelected();
        }
    }
    refreshUI() {
        this.form.patchValue(this.model);
    }
    updatedSelected() {
        const fileList = this.model.file;
        const selectedItems = [];
        for (let index = 0; index < fileList.length; index++) {
            const file = fileList[index];
            if (file.documentPurpose) {
                if (!this.props.isCompoundPurpose) {
                    const purposes = file.documentPurpose.split(',');
                    for (let index2 = 0; index2 < purposes.length; index2++) {
                        selectedItems.push(purposes[index2]);
                    }
                }
            }
            if (file.attachmentPurposes) {
                const purposes = file.attachmentPurposes;
                for (let index2 = 0; index2 < purposes.length; index2++) {
                    selectedItems.push(purposes[index2].docPurpose);
                }
            }
        }
        for (let index = 0; index < this.props.documentGuidances.length; index++) {
            const element = this.props.documentGuidances[index];
            element.isSelected = selectedItems.indexOf(element.documentGuidanceCheckboxText) !== -1;
        }
        this.allSelected = this.props.documentGuidances.filter(u => !u.isSelected && u.isRequired).length === 0;
        if (!this.props.isDocumentUploadOptional || !this.containGuidenceType(this.props.documentGuidances, true)) {
            this.formControl.markAsTouched();
            if (!this.allSelected) {
                this.formControl.setErrors({ 'incorrect': true });
            }
            else {
                this.formControl.setErrors(null);
            }
        }
    }
    getFilePreviewClass(fileName) {
        const fileNameLower = fileName.toLowerCase();
        if (fileNameLower.indexOf(".pdf") > 0) {
            return 'usa-file-input__preview-image usa-file-input__preview-image--pdf';
        }
        else if (fileNameLower.indexOf(".doc") > 0 ||
            fileNameLower.indexOf(".pages") > 0) {
            return 'usa-file-input__preview-image usa-file-input__preview-image--word';
        }
        else if (fileNameLower.indexOf(".xls") > 0 ||
            fileNameLower.indexOf(".numbers") > 0) {
            return 'usa-file-input__preview-image--excel';
        }
        else if (fileNameLower.indexOf(".mov") > 0 || fileNameLower.indexOf(".mp4") > 0) {
            return 'usa-file-input__preview-image usa-file-input__preview-image--video';
        }
        else {
            return 'usa-file-input__preview-image usa-file-input__preview-image--generic';
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DocumentSectionComponent, deps: [{ token: i1$1.SdsDialogService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: DocumentSectionComponent, selector: "document-section", viewQueries: [{ propertyName: "addButton", first: true, predicate: ["addButton"], descendants: true }, { propertyName: "tipContent", first: true, predicate: ["tipContent"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div class=\"grid-row\">\r\n  <sds-step-arrow *ngIf=\"!to.isFlagLabelsDisabled\" [number]=\"to.position\" [status]=\"'active'\"></sds-step-arrow>\r\n  <div class=\"text-semibold font-sans-lg margin-top-05 \">Attach Documents</div>\r\n</div>\r\n<div [class]=\"to.isFlagLabelsDisabled?'margin-left-2':'margin-left-10'\">\r\n  <div *ngIf=\"containGuidenceType(to.documentGuidances, true)\" class=\"padding-botton-1\">\r\n    <div *ngIf=\"(to.mode===FSDModalMode.VIEW||to.mode===FSDModalMode.VIEWREADONLY) && !to.isNonAgent\">\r\n      The list will update with your selection when you accept or reject a document.\r\n    </div>\r\n    <ng-template #tipContent>\r\n      <div class=\"margin-3 width-card-lg\">\r\n        <div>\r\n          These acceptable documents are frequently used to prove entity information:\r\n        </div>\r\n        <ul class=\"margin-top-0\">\r\n          <li>Certified articles of incorporation/formation</li>\r\n          <li>Certified business filing from your Secretary of State\u2019s office</li>\r\n          <li>Employer Identification Number (EIN) assignment letter from the IRS</li>\r\n          <li>Recent bank statement (redacted, less than five years old)</li>\r\n          <li>Recent utility bill (less than five years old)</li>\r\n          <li> <a class=\"usa-link padding-right-2px\"\r\n              aria-label=\"Show more acceptable document types - opens in a new window\"\r\n              href=\"https://www.fsd.gov/gsafsd_sp?id=kb_article_view&sysparm_article=KB0055230\" target=\"_blank\">\r\n              Show more acceptable document types\r\n              <span class=\"margin-left-1px usa-link--external font-body-md\"> </span></a> </li>\r\n        </ul>\r\n        <div>\r\n          You may submit one or more documents to provide all the required evidence\r\n        </div>\r\n      </div>\r\n    </ng-template>\r\n\r\n    <div *ngIf=\"(to.mode===FSDModalMode.VIEW||to.mode===FSDModalMode.VIEWREADONLY) && to.isNonAgent\">\r\n      You must attach one or more\r\n      <button class=\"usa-button usa-button--unstyled\" [sdsPopover]=\"tipContent\" [position]=\"'bottom'\">official\r\n        documents</button>\r\n      that prove each of the items listed. A check here confirms that the\r\n      proof you have provided for the required item has been accepted.\r\n    </div>\r\n\r\n\r\n    <div *ngIf=\"to.mode===FSDModalMode.CREATE\">\r\n      You must attach one or more\r\n      <button class=\"usa-button usa-button--unstyled\" [sdsPopover]=\"tipContent\" [position]=\"'bottom'\">official\r\n        documents</button>\r\n      that prove each of the items listed. A check here confirms you have provided proof for the required item.\r\n    </div>\r\n\r\n    <div *ngIf=\"to.mode===FSDModalMode.UPDATE\">\r\n\r\n      You must attach one or more\r\n      <button class=\"usa-button usa-button--unstyled\" [sdsPopover]=\"tipContent\" [position]=\"'bottom'\">official\r\n        documents</button>\r\n      that prove each of the items listed. A check here confirms that the\r\n      proof you have provided for the required item has been accepted.\r\n    </div>\r\n\r\n\r\n  </div>\r\n  <div *ngIf=\"to.documentGuidances\" class=\"padding-botton-1\">\r\n    <div *ngIf=\"containGuidenceType(to.documentGuidances, true)\">\r\n      <ul class=\"sds-list sds-list--icon margin-bottom-1\">\r\n        <li *ngFor=\"let item of getStatusDisplayList(to.documentGuidances, true)\">\r\n          <ng-container *ngTemplateOutlet=\"listIcon; context: { item: item }\"></ng-container>\r\n        </li>\r\n      </ul>\r\n    </div>\r\n    <div *ngIf=\"containGuidenceType(to.documentGuidances, false)\" class=\"padding-botton-1\">\r\n      <div class=\"text-semibold\">The documents you provide may additionally include: </div>\r\n      <ul class=\"sds-list sds-list--icon margin-bottom-1\">\r\n        <li *ngFor=\"let item of  getStatusDisplayList(to.documentGuidances, false)\">\r\n          <ng-container *ngTemplateOutlet=\"listIcon; context: { item: item }\"></ng-container>\r\n        </li>\r\n      </ul>\r\n    </div>\r\n  </div>\r\n\r\n  <div *ngIf=\"model.file\">\r\n    <div *ngIf=\"model.file.length>0\" class=\"margin-top-2 margin-bottom-1 text-semibold\">Showing 1 to\r\n      {{model.file.length}} of\r\n      {{model.file.length}}</div>\r\n    <div *ngFor=\"let item  of model.file\" class=\"sds-card margin-bottom-1\">\r\n      <div class=\"sds-card__body\">\r\n        <div class=\"grid-container\">\r\n          <div class=\"grid-row grid-gap-6s\">\r\n            <div class=\"grid-col flex-auto\">\r\n              <div [class]=\"getFilePreviewClass(item.documentName)\"></div>\r\n            </div>\r\n            <!--Document Name-->\r\n            <div class=\"grid-col-3\">\r\n              <div>\r\n                Document\r\n              </div>\r\n              <div class=\"text-semibold\">\r\n                <div *ngIf=\"!allowDownload(item)\">\r\n                  {{item.documentName}}\r\n                </div>\r\n                <button *ngIf=\"allowDownload(item)\" (click)=\"downloadFile(item)\"\r\n                  class=\"usa-button usa-button--unstyled\">\r\n                  {{item.documentName}}\r\n                </button>\r\n              </div>\r\n              <!-- Size -->\r\n              <div>\r\n                {{ (item.size / 1000)}} KB\r\n              </div>\r\n            </div>\r\n            <!--Document Type-->\r\n            <div *ngIf=\"item.documentType\" class=\"grid-col-3\">\r\n              <div>\r\n                Document Type\r\n              </div>\r\n              <div class=\"text-semibold\">\r\n                {{item.documentType.replace(\"/\",\"/ \")}}\r\n              </div>\r\n            </div>\r\n\r\n            <!-- Virus Scan -->\r\n            <div *ngIf=\"to.mode===FSDModalMode.VIEW || to.mode===FSDModalMode.VIEWREADONLY\"\r\n              class=\"grid-col-2 flex-fill\">\r\n              <div>\r\n                Virus Scan\r\n              </div>\r\n              <div class=\"text-semibold\">\r\n                {{item.scanResult}}\r\n              </div>\r\n            </div>\r\n\r\n            <!-- Upload Date -->\r\n\r\n            <div *ngIf=\"to.mode===FSDModalMode.VIEW || to.mode===FSDModalMode.VIEWREADONLY\"\r\n              class=\"grid-col-3 flex-fill\">\r\n              <div>\r\n                Upload Date\r\n              </div>\r\n              <div class=\"text-semibold\">\r\n                {{ item.date | date : 'medium' : 'EDT'}} EDT\r\n              </div>\r\n            </div>\r\n\r\n\r\n            <!-- Buttons -->\r\n            <div *ngIf=\"!to.allowFileDownload&&!isAccepted(item)\" class=\"grid-col-3 flex-fill\">\r\n              <div>\r\n                <div>\r\n                  <button\r\n                    *ngIf=\"!to.allowFileDownload&&to.mode!==FSDModalMode.VIEW&&to.mode!==FSDModalMode.VIEWREADONLY&&!to.isResolved\"\r\n                    class=\"usa-button usa-button--base bg-base-lighter\" (click)=\"updateDocument(item)\">Update</button>\r\n                </div>\r\n                <div>\r\n                  <button\r\n                    *ngIf=\"!to.allowFileDownload&&to.mode!==FSDModalMode.VIEW&&to.mode!==FSDModalMode.VIEWREADONLY&&!to.isResolved\"\r\n                    class=\"usa-button usa-button--base bg-base-lighter\"\r\n                    (click)=\"deleteDocument(item.documentId)\">Delete</button>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"grid-col-3 flex-fill\">\r\n              <button *ngIf=\"allowDownload(item)\" class=\"pin-right usa-button usa-button--base bg-base-lighter\"\r\n                (click)=\"downloadFile(item)\">Download</button>\r\n            </div>\r\n\r\n          </div>\r\n\r\n\r\n          <div *ngIf=\"item.documentPurpose || item.attachmentPurposes\" class=\"grid-row\">\r\n            <!--Document Purpose-->\r\n            <div class=\"grid-col  flex-fill\">\r\n              <div>\r\n                Includes:\r\n              </div>\r\n              <div>\r\n\r\n                <!--isCompoundPurpose false-->\r\n                <ul *ngIf=\"!to.isCompoundPurpose\" class=\"sds-list sds-list--icon margin-bottom-1 margin-top-0\">\r\n                  <li *ngFor=\"let purpose of  item.documentPurpose.split(',')\">\r\n                    <span class=\"sds-list__item-icon\">\r\n                      <div class=\"circle-1 bg-black margin-top-1 margin-right-2\"></div>\r\n                    </span>\r\n\r\n                    <span class=\"sds-list__item-content\">\r\n                      <span> {{purpose}}</span>\r\n                    </span>\r\n                  </li>\r\n                </ul>\r\n\r\n                <!--isCompoundPurpose true-->\r\n                <div role=\"list\" *ngIf=\"to.isCompoundPurpose\" class=\"grid\">\r\n                  <div role=\"listitem\" class=\"grid-row grid-gap-1 margin-bottom-1\"\r\n                    *ngFor=\"let purpose of  item.attachmentPurposes\">\r\n                    <div class=\"grid-col flex-auto\" *ngIf=\"(to.mode===FSDModalMode.VIEW && !to.isResolved) || (to.mode===FSDModalMode.CREATE)||\r\n                    (!to.acceptRejectPurposeButtons&&to.mode===FSDModalMode.UPDATE)\">\r\n                      <div class=\"circle-1 margin-top-1 bg-black\"></div>\r\n                    </div>\r\n                    <div\r\n                      *ngIf=\"to.acceptRejectPurposeButtons&&((to.mode===FSDModalMode.VIEW && to.isResolved)||to.mode===FSDModalMode.UPDATE || to.mode===FSDModalMode.VIEWREADONLY) && (to.mode!==FSDModalMode.CREATE)\"\r\n                      class=\"grid-col flex-auto\">\r\n                      <span *ngIf=\"purpose.docPurposeStatusId===DoumentPurposeStatus.ACCEPTED\">\r\n                        <usa-icon [icon]=\"'check-square-fill'\" class=\"text-success\" [size]=\"'x'\">\r\n                        </usa-icon>\r\n                        <span class=\"display-none\">Acepted</span>\r\n                      </span>\r\n                      <span *ngIf=\"purpose.docPurposeStatusId===DoumentPurposeStatus.REJECTED\">\r\n                        <usa-icon [icon]=\"'dash-circle'\" class=\"text-error\" [size]=\"'x'\">\r\n                        </usa-icon>\r\n                        <span class=\"display-none\">Rejected</span>\r\n                      </span>\r\n                      <span\r\n                        *ngIf=\"purpose.docPurposeStatusId!==DoumentPurposeStatus.REJECTED&&purpose.docPurposeStatusId!==DoumentPurposeStatus.ACCEPTED\">\r\n                        <usa-icon [icon]=\"'hourglass'\" class=\"text-warning-dark\" [size]=\"'x'\">\r\n                        </usa-icon>\r\n                        <span class=\"display-none\">Pending</span>\r\n                      </span>\r\n                    </div>\r\n                    <div class=\"grid-col-5\">\r\n                      <span> {{purpose.docPurpose}}</span>\r\n                    </div>\r\n                    <div class=\"grid-col-3\">\r\n                      <button *ngIf=\"to.acceptRejectPurposeButtons&&to.mode===FSDModalMode.VIEW&&!to.isResolved\"\r\n                        [class]=\"purpose.docPurposeStatusId===DoumentPurposeStatus.ACCEPTED? 'usa-button': 'usa-button usa-button--base bg-base-lighter'\"\r\n                        (click)=\"acceptPurpose(item,item.documentId,purpose)\">Accept\r\n                        <span class=\"display-none\"> </span></button>\r\n\r\n                      <button *ngIf=\"to.acceptRejectPurposeButtons&&to.mode===FSDModalMode.VIEW&&!to.isResolved\"\r\n                        [class]=\"purpose.docPurposeStatusId===DoumentPurposeStatus.REJECTED? 'usa-button sds-button--danger': 'usa-button usa-button--base bg-base-lighter'\"\r\n                        (click)=\"rejectPurpose(item,item.documentId,purpose)\">Reject\r\n                        <span class=\"display-none\"></span></button>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n        </div>\r\n\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"margin-top-2\">\r\n    <button #addButton\r\n      *ngIf=\"!to.allowFileDownload&&to.mode!==FSDModalMode.VIEW&&to.mode!==FSDModalMode.VIEWREADONLY&&!to.isResolved\"\r\n      class=\"usa-button usa-button bg-primary-lighter\" (click)=\"openAddDocument()\">Add\r\n      Document\r\n      <span class=\"display-none\">-opens in modal </span></button>\r\n  </div>\r\n</div>\r\n\r\n<ng-template #listIcon let-item=\"item\">\r\n  <span *ngIf=\"item.mode ===StatusIconMode.ACCEPTED\" class=\"sds-list__item-icon\">\r\n    <usa-icon [icon]=\"'check-square-fill'\" class=\"text-success text-semibold\" [size]=\"'2x'\"></usa-icon>\r\n    <span class=\"display-none\">Requirment met</span>\r\n  </span>\r\n  <span *ngIf=\"item.mode ===StatusIconMode.REJECTED\" class=\"sds-list__item-icon\">\r\n    <usa-icon [icon]=\"'dash-circle'\" class=\"text-error text-semibold\" [size]=\"'2x'\">\r\n    </usa-icon>\r\n    <span class=\"display-none\">Rejected</span>\r\n  </span>\r\n  <span *ngIf=\"item.mode ===StatusIconMode.PENDING\" class=\"sds-list__item-icon\">\r\n    <usa-icon [icon]=\"'hourglass'\" class=\"text-warning-dark text-semibold\" [size]=\"'2x'\">\r\n    </usa-icon>\r\n    <span class=\"display-none\">Requirment met</span>\r\n  </span>\r\n  <span *ngIf=\"item.mode ===StatusIconMode.NOTAPPLICABLE\" class=\"sds-list__item-icon\">\r\n    <usa-icon [icon]=\"'slashCircle'\" class=\"text-base text-semibold\" [size]=\"'2x'\">\r\n    </usa-icon>\r\n    <span class=\"display-none\">Not Applicable</span>\r\n  </span>\r\n  <span *ngIf=\"item.mode ===StatusIconMode.BLANK\" class=\"sds-list__item-icon\">\r\n    <div class=\"circle-1 bg-black margin-top-1 margin-right-2\"></div>\r\n  </span>\r\n  <span class=\"sds-list__item-content\"> {{item.text}}</span>\r\n</ng-template>", dependencies: [{ kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: i1$1.SdsStepArrowComponent, selector: "sds-step-arrow", inputs: ["status", "number"] }, { kind: "component", type: i3.IconComponent, selector: "usa-icon", inputs: ["icon", "rotate", "size", "classes", "skew"] }, { kind: "directive", type: i1$1.SdsPopover, selector: "[sdsPopover]", inputs: ["animation", "autoClose", "sdsPopover", "sdsPopoverTitle", "position", "popperOptions", "triggers", "positionTarget", "container", "disablePopover", "popoverClass", "popoverContext", "openDelay", "closeDelay"], outputs: ["shown", "hidden"], exportAs: ["sdsPopover"] }, { kind: "pipe", type: i2.DatePipe, name: "date" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DocumentSectionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'document-section', template: "<div class=\"grid-row\">\r\n  <sds-step-arrow *ngIf=\"!to.isFlagLabelsDisabled\" [number]=\"to.position\" [status]=\"'active'\"></sds-step-arrow>\r\n  <div class=\"text-semibold font-sans-lg margin-top-05 \">Attach Documents</div>\r\n</div>\r\n<div [class]=\"to.isFlagLabelsDisabled?'margin-left-2':'margin-left-10'\">\r\n  <div *ngIf=\"containGuidenceType(to.documentGuidances, true)\" class=\"padding-botton-1\">\r\n    <div *ngIf=\"(to.mode===FSDModalMode.VIEW||to.mode===FSDModalMode.VIEWREADONLY) && !to.isNonAgent\">\r\n      The list will update with your selection when you accept or reject a document.\r\n    </div>\r\n    <ng-template #tipContent>\r\n      <div class=\"margin-3 width-card-lg\">\r\n        <div>\r\n          These acceptable documents are frequently used to prove entity information:\r\n        </div>\r\n        <ul class=\"margin-top-0\">\r\n          <li>Certified articles of incorporation/formation</li>\r\n          <li>Certified business filing from your Secretary of State\u2019s office</li>\r\n          <li>Employer Identification Number (EIN) assignment letter from the IRS</li>\r\n          <li>Recent bank statement (redacted, less than five years old)</li>\r\n          <li>Recent utility bill (less than five years old)</li>\r\n          <li> <a class=\"usa-link padding-right-2px\"\r\n              aria-label=\"Show more acceptable document types - opens in a new window\"\r\n              href=\"https://www.fsd.gov/gsafsd_sp?id=kb_article_view&sysparm_article=KB0055230\" target=\"_blank\">\r\n              Show more acceptable document types\r\n              <span class=\"margin-left-1px usa-link--external font-body-md\"> </span></a> </li>\r\n        </ul>\r\n        <div>\r\n          You may submit one or more documents to provide all the required evidence\r\n        </div>\r\n      </div>\r\n    </ng-template>\r\n\r\n    <div *ngIf=\"(to.mode===FSDModalMode.VIEW||to.mode===FSDModalMode.VIEWREADONLY) && to.isNonAgent\">\r\n      You must attach one or more\r\n      <button class=\"usa-button usa-button--unstyled\" [sdsPopover]=\"tipContent\" [position]=\"'bottom'\">official\r\n        documents</button>\r\n      that prove each of the items listed. A check here confirms that the\r\n      proof you have provided for the required item has been accepted.\r\n    </div>\r\n\r\n\r\n    <div *ngIf=\"to.mode===FSDModalMode.CREATE\">\r\n      You must attach one or more\r\n      <button class=\"usa-button usa-button--unstyled\" [sdsPopover]=\"tipContent\" [position]=\"'bottom'\">official\r\n        documents</button>\r\n      that prove each of the items listed. A check here confirms you have provided proof for the required item.\r\n    </div>\r\n\r\n    <div *ngIf=\"to.mode===FSDModalMode.UPDATE\">\r\n\r\n      You must attach one or more\r\n      <button class=\"usa-button usa-button--unstyled\" [sdsPopover]=\"tipContent\" [position]=\"'bottom'\">official\r\n        documents</button>\r\n      that prove each of the items listed. A check here confirms that the\r\n      proof you have provided for the required item has been accepted.\r\n    </div>\r\n\r\n\r\n  </div>\r\n  <div *ngIf=\"to.documentGuidances\" class=\"padding-botton-1\">\r\n    <div *ngIf=\"containGuidenceType(to.documentGuidances, true)\">\r\n      <ul class=\"sds-list sds-list--icon margin-bottom-1\">\r\n        <li *ngFor=\"let item of getStatusDisplayList(to.documentGuidances, true)\">\r\n          <ng-container *ngTemplateOutlet=\"listIcon; context: { item: item }\"></ng-container>\r\n        </li>\r\n      </ul>\r\n    </div>\r\n    <div *ngIf=\"containGuidenceType(to.documentGuidances, false)\" class=\"padding-botton-1\">\r\n      <div class=\"text-semibold\">The documents you provide may additionally include: </div>\r\n      <ul class=\"sds-list sds-list--icon margin-bottom-1\">\r\n        <li *ngFor=\"let item of  getStatusDisplayList(to.documentGuidances, false)\">\r\n          <ng-container *ngTemplateOutlet=\"listIcon; context: { item: item }\"></ng-container>\r\n        </li>\r\n      </ul>\r\n    </div>\r\n  </div>\r\n\r\n  <div *ngIf=\"model.file\">\r\n    <div *ngIf=\"model.file.length>0\" class=\"margin-top-2 margin-bottom-1 text-semibold\">Showing 1 to\r\n      {{model.file.length}} of\r\n      {{model.file.length}}</div>\r\n    <div *ngFor=\"let item  of model.file\" class=\"sds-card margin-bottom-1\">\r\n      <div class=\"sds-card__body\">\r\n        <div class=\"grid-container\">\r\n          <div class=\"grid-row grid-gap-6s\">\r\n            <div class=\"grid-col flex-auto\">\r\n              <div [class]=\"getFilePreviewClass(item.documentName)\"></div>\r\n            </div>\r\n            <!--Document Name-->\r\n            <div class=\"grid-col-3\">\r\n              <div>\r\n                Document\r\n              </div>\r\n              <div class=\"text-semibold\">\r\n                <div *ngIf=\"!allowDownload(item)\">\r\n                  {{item.documentName}}\r\n                </div>\r\n                <button *ngIf=\"allowDownload(item)\" (click)=\"downloadFile(item)\"\r\n                  class=\"usa-button usa-button--unstyled\">\r\n                  {{item.documentName}}\r\n                </button>\r\n              </div>\r\n              <!-- Size -->\r\n              <div>\r\n                {{ (item.size / 1000)}} KB\r\n              </div>\r\n            </div>\r\n            <!--Document Type-->\r\n            <div *ngIf=\"item.documentType\" class=\"grid-col-3\">\r\n              <div>\r\n                Document Type\r\n              </div>\r\n              <div class=\"text-semibold\">\r\n                {{item.documentType.replace(\"/\",\"/ \")}}\r\n              </div>\r\n            </div>\r\n\r\n            <!-- Virus Scan -->\r\n            <div *ngIf=\"to.mode===FSDModalMode.VIEW || to.mode===FSDModalMode.VIEWREADONLY\"\r\n              class=\"grid-col-2 flex-fill\">\r\n              <div>\r\n                Virus Scan\r\n              </div>\r\n              <div class=\"text-semibold\">\r\n                {{item.scanResult}}\r\n              </div>\r\n            </div>\r\n\r\n            <!-- Upload Date -->\r\n\r\n            <div *ngIf=\"to.mode===FSDModalMode.VIEW || to.mode===FSDModalMode.VIEWREADONLY\"\r\n              class=\"grid-col-3 flex-fill\">\r\n              <div>\r\n                Upload Date\r\n              </div>\r\n              <div class=\"text-semibold\">\r\n                {{ item.date | date : 'medium' : 'EDT'}} EDT\r\n              </div>\r\n            </div>\r\n\r\n\r\n            <!-- Buttons -->\r\n            <div *ngIf=\"!to.allowFileDownload&&!isAccepted(item)\" class=\"grid-col-3 flex-fill\">\r\n              <div>\r\n                <div>\r\n                  <button\r\n                    *ngIf=\"!to.allowFileDownload&&to.mode!==FSDModalMode.VIEW&&to.mode!==FSDModalMode.VIEWREADONLY&&!to.isResolved\"\r\n                    class=\"usa-button usa-button--base bg-base-lighter\" (click)=\"updateDocument(item)\">Update</button>\r\n                </div>\r\n                <div>\r\n                  <button\r\n                    *ngIf=\"!to.allowFileDownload&&to.mode!==FSDModalMode.VIEW&&to.mode!==FSDModalMode.VIEWREADONLY&&!to.isResolved\"\r\n                    class=\"usa-button usa-button--base bg-base-lighter\"\r\n                    (click)=\"deleteDocument(item.documentId)\">Delete</button>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"grid-col-3 flex-fill\">\r\n              <button *ngIf=\"allowDownload(item)\" class=\"pin-right usa-button usa-button--base bg-base-lighter\"\r\n                (click)=\"downloadFile(item)\">Download</button>\r\n            </div>\r\n\r\n          </div>\r\n\r\n\r\n          <div *ngIf=\"item.documentPurpose || item.attachmentPurposes\" class=\"grid-row\">\r\n            <!--Document Purpose-->\r\n            <div class=\"grid-col  flex-fill\">\r\n              <div>\r\n                Includes:\r\n              </div>\r\n              <div>\r\n\r\n                <!--isCompoundPurpose false-->\r\n                <ul *ngIf=\"!to.isCompoundPurpose\" class=\"sds-list sds-list--icon margin-bottom-1 margin-top-0\">\r\n                  <li *ngFor=\"let purpose of  item.documentPurpose.split(',')\">\r\n                    <span class=\"sds-list__item-icon\">\r\n                      <div class=\"circle-1 bg-black margin-top-1 margin-right-2\"></div>\r\n                    </span>\r\n\r\n                    <span class=\"sds-list__item-content\">\r\n                      <span> {{purpose}}</span>\r\n                    </span>\r\n                  </li>\r\n                </ul>\r\n\r\n                <!--isCompoundPurpose true-->\r\n                <div role=\"list\" *ngIf=\"to.isCompoundPurpose\" class=\"grid\">\r\n                  <div role=\"listitem\" class=\"grid-row grid-gap-1 margin-bottom-1\"\r\n                    *ngFor=\"let purpose of  item.attachmentPurposes\">\r\n                    <div class=\"grid-col flex-auto\" *ngIf=\"(to.mode===FSDModalMode.VIEW && !to.isResolved) || (to.mode===FSDModalMode.CREATE)||\r\n                    (!to.acceptRejectPurposeButtons&&to.mode===FSDModalMode.UPDATE)\">\r\n                      <div class=\"circle-1 margin-top-1 bg-black\"></div>\r\n                    </div>\r\n                    <div\r\n                      *ngIf=\"to.acceptRejectPurposeButtons&&((to.mode===FSDModalMode.VIEW && to.isResolved)||to.mode===FSDModalMode.UPDATE || to.mode===FSDModalMode.VIEWREADONLY) && (to.mode!==FSDModalMode.CREATE)\"\r\n                      class=\"grid-col flex-auto\">\r\n                      <span *ngIf=\"purpose.docPurposeStatusId===DoumentPurposeStatus.ACCEPTED\">\r\n                        <usa-icon [icon]=\"'check-square-fill'\" class=\"text-success\" [size]=\"'x'\">\r\n                        </usa-icon>\r\n                        <span class=\"display-none\">Acepted</span>\r\n                      </span>\r\n                      <span *ngIf=\"purpose.docPurposeStatusId===DoumentPurposeStatus.REJECTED\">\r\n                        <usa-icon [icon]=\"'dash-circle'\" class=\"text-error\" [size]=\"'x'\">\r\n                        </usa-icon>\r\n                        <span class=\"display-none\">Rejected</span>\r\n                      </span>\r\n                      <span\r\n                        *ngIf=\"purpose.docPurposeStatusId!==DoumentPurposeStatus.REJECTED&&purpose.docPurposeStatusId!==DoumentPurposeStatus.ACCEPTED\">\r\n                        <usa-icon [icon]=\"'hourglass'\" class=\"text-warning-dark\" [size]=\"'x'\">\r\n                        </usa-icon>\r\n                        <span class=\"display-none\">Pending</span>\r\n                      </span>\r\n                    </div>\r\n                    <div class=\"grid-col-5\">\r\n                      <span> {{purpose.docPurpose}}</span>\r\n                    </div>\r\n                    <div class=\"grid-col-3\">\r\n                      <button *ngIf=\"to.acceptRejectPurposeButtons&&to.mode===FSDModalMode.VIEW&&!to.isResolved\"\r\n                        [class]=\"purpose.docPurposeStatusId===DoumentPurposeStatus.ACCEPTED? 'usa-button': 'usa-button usa-button--base bg-base-lighter'\"\r\n                        (click)=\"acceptPurpose(item,item.documentId,purpose)\">Accept\r\n                        <span class=\"display-none\"> </span></button>\r\n\r\n                      <button *ngIf=\"to.acceptRejectPurposeButtons&&to.mode===FSDModalMode.VIEW&&!to.isResolved\"\r\n                        [class]=\"purpose.docPurposeStatusId===DoumentPurposeStatus.REJECTED? 'usa-button sds-button--danger': 'usa-button usa-button--base bg-base-lighter'\"\r\n                        (click)=\"rejectPurpose(item,item.documentId,purpose)\">Reject\r\n                        <span class=\"display-none\"></span></button>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n        </div>\r\n\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"margin-top-2\">\r\n    <button #addButton\r\n      *ngIf=\"!to.allowFileDownload&&to.mode!==FSDModalMode.VIEW&&to.mode!==FSDModalMode.VIEWREADONLY&&!to.isResolved\"\r\n      class=\"usa-button usa-button bg-primary-lighter\" (click)=\"openAddDocument()\">Add\r\n      Document\r\n      <span class=\"display-none\">-opens in modal </span></button>\r\n  </div>\r\n</div>\r\n\r\n<ng-template #listIcon let-item=\"item\">\r\n  <span *ngIf=\"item.mode ===StatusIconMode.ACCEPTED\" class=\"sds-list__item-icon\">\r\n    <usa-icon [icon]=\"'check-square-fill'\" class=\"text-success text-semibold\" [size]=\"'2x'\"></usa-icon>\r\n    <span class=\"display-none\">Requirment met</span>\r\n  </span>\r\n  <span *ngIf=\"item.mode ===StatusIconMode.REJECTED\" class=\"sds-list__item-icon\">\r\n    <usa-icon [icon]=\"'dash-circle'\" class=\"text-error text-semibold\" [size]=\"'2x'\">\r\n    </usa-icon>\r\n    <span class=\"display-none\">Rejected</span>\r\n  </span>\r\n  <span *ngIf=\"item.mode ===StatusIconMode.PENDING\" class=\"sds-list__item-icon\">\r\n    <usa-icon [icon]=\"'hourglass'\" class=\"text-warning-dark text-semibold\" [size]=\"'2x'\">\r\n    </usa-icon>\r\n    <span class=\"display-none\">Requirment met</span>\r\n  </span>\r\n  <span *ngIf=\"item.mode ===StatusIconMode.NOTAPPLICABLE\" class=\"sds-list__item-icon\">\r\n    <usa-icon [icon]=\"'slashCircle'\" class=\"text-base text-semibold\" [size]=\"'2x'\">\r\n    </usa-icon>\r\n    <span class=\"display-none\">Not Applicable</span>\r\n  </span>\r\n  <span *ngIf=\"item.mode ===StatusIconMode.BLANK\" class=\"sds-list__item-icon\">\r\n    <div class=\"circle-1 bg-black margin-top-1 margin-right-2\"></div>\r\n  </span>\r\n  <span class=\"sds-list__item-content\"> {{item.text}}</span>\r\n</ng-template>" }]
        }], ctorParameters: () => [{ type: i1$1.SdsDialogService }], propDecorators: { addButton: [{
                type: ViewChild,
                args: ['addButton']
            }], tipContent: [{
                type: ViewChild,
                args: ['tipContent']
            }] } });
let DocumentPurposeListItem$1 = class DocumentPurposeListItem {
};
var StatusIconMode$1;
(function (StatusIconMode) {
    StatusIconMode[StatusIconMode["ACCEPTED"] = 0] = "ACCEPTED";
    StatusIconMode[StatusIconMode["REJECTED"] = 1] = "REJECTED";
    StatusIconMode[StatusIconMode["PENDING"] = 2] = "PENDING";
    StatusIconMode[StatusIconMode["BLANK"] = 3] = "BLANK";
    StatusIconMode[StatusIconMode["NOTAPPLICABLE"] = 4] = "NOTAPPLICABLE";
})(StatusIconMode$1 || (StatusIconMode$1 = {}));
var DoumentPurposeStatus$1;
(function (DoumentPurposeStatus) {
    DoumentPurposeStatus[DoumentPurposeStatus["ACCEPTED"] = 2] = "ACCEPTED";
    DoumentPurposeStatus[DoumentPurposeStatus["REJECTED"] = 3] = "REJECTED";
    DoumentPurposeStatus[DoumentPurposeStatus["PENDING"] = 1] = "PENDING";
})(DoumentPurposeStatus$1 || (DoumentPurposeStatus$1 = {}));

class DocumentUploadComponent extends FieldType {
    ;
    constructor(dialog, renderer) {
        super();
        this.dialog = dialog;
        this.renderer = renderer;
        this.FSDModalMode = FSDModalMode;
        this.StatusIconMode = StatusIconMode;
        this.DoumentPurposeStatus = DoumentPurposeStatus;
        this.columnHeaderArray = ['You are updating: ', 'You must provide in the same document: '];
        this.allSelected = false;
        this.isDocumentRequirementsExpanded = false;
    }
    ngOnInit() {
        //this.tipContentAcceptable.elementRef.nativeElement.innerHTML = this.props.documentPopoverText;
        //this.tipContentCreate.elementRef.nativeElement.innerHTML = this.createDocumentPopoverText();
    }
    invertIsDocumentRequirementsExpanded() {
        this.isDocumentRequirementsExpanded = !this.isDocumentRequirementsExpanded;
    }
    containGuidenceType(documentGuidances, type) {
        const list = this.filteredGuidenceType(documentGuidances, type);
        return list.length > 0;
    }
    filteredGuidenceType(documentGuidances, type) {
        const list = documentGuidances.filter(e => e.isRequired === type);
        return list;
    }
    getStatusDisplayListV2(documentGuidances, type) {
        const list = documentGuidances.filter(e => e.isRequired === type);
        const toReturn = [];
        const fileList = this.model.file;
        for (let i = 0; i < list.length; i++) {
            const item = list[i];
            toReturn.push({
                updatingField: item.documentsToFilesMapping.updatingField,
                provideDocumentDescription: item.documentsToFilesMapping.provideDocumentDescription,
                mode: item.isSelected ? StatusIconMode.ACCEPTED : StatusIconMode.BLANK
            });
        }
        return toReturn;
    }
    suiList(list) {
        let starter = {};
        console.log('---purposes ---');
        console.log(list);
        for (let i = 0; i < list.length; i++) {
            const item = list[i].docPurpose;
            const split = item.split(new RegExp(' and ', 'i'));
            if (starter[split[0]]) {
                starter[split[0]].push(split[1]);
            }
            else {
                starter[split[0]] = [split[1]];
            }
        }
        const keys = Object.keys(starter);
        const toReturn = [];
        console.log('---compiled object---');
        console.log(starter);
        for (let i = 0; i < keys.length; i++) {
            const KeyText = keys[i];
            const keyValueArray = starter[KeyText];
            if (keyValueArray.length === 1) {
                const text = KeyText + ' AND ' + keyValueArray[0];
                console.log(text);
                toReturn.push({ text: text, children: [] });
            }
            else if (keyValueArray.length > 1) {
                const text = KeyText + ' AND: ';
                console.log(text);
                const temp = { text: text, children: [] };
                for (let j = 0; j < keyValueArray.length; j++) {
                    const keyVal = keyValueArray[j];
                    console.log(' ... ' + keyVal);
                    temp.children.push(keyVal);
                }
                toReturn.push(temp);
            }
            else {
                console.error('Broken');
                console.error(KeyText);
                console.error(keyValueArray);
            }
        }
        // for (let i = 0; i < keys.length; i++) {
        //   const keyValue = starter[i];
        //   const KeyText = keys[i];
        //   if (keyValue.length === 1) {
        //     const text = KeyText + 'And' + keyValue[0];
        //     console.log(text);
        //     toReturn.push({ text: text, isBullet: false, isFirst: false, isLast: false });
        //   } else if (keyValue.length > 1) {
        //     const text = KeyText + 'And';
        //     console.log(text);
        //     toReturn.push({ text: text, isBullet: false, isFirst: true, isLast: false });
        //     for (let j = 0; j < keyValue.length; j++) {
        //       const keyVal = keyValue[j];
        //       console.log(' ... ' + keyVal);
        //       if (j === keyValue.length - 1) {
        //         toReturn.push({ text: keyVal, isBullet: true, isFirst: false, isLast: true });
        //       } else if (j === 0) {
        //         toReturn.push({ text: keyVal, isBullet: true, isFirst: true, isLast: false });
        //       }
        //       else {
        //         toReturn.push({ text: keyVal, isBullet: true, isFirst: false, isLast: false });
        //       }
        //     }
        //   } else {
        //     console.log('Broken')
        //     console.log(KeyText);
        //     console.log(keyValue);
        //   }
        // }
        return toReturn;
    }
    isAccepted(doc) {
        const purposes = doc.attachmentPurposes;
        const list = purposes.filter(e => e.docPurposeStatusId === DoumentPurposeStatus.ACCEPTED);
        return list.length !== 0;
    }
    allowDownload(document) {
        return document.scanResult === 'CLEAN' && document.requestFromAdmin && this.props.allowFileDownload;
    }
    refreshUI() {
        this.form.patchValue(this.model);
    }
    ngAfterViewInit() {
        const mode = this.props.mode;
        // if (mode !== FSDModalMode.CREATE) {
        //    this.getDocuments();
        // }
    }
    downloadFile(file) {
        const documentId = file["documentId"];
        const filename = file["documentName"];
        try {
            this.props.service.downloadDocument(documentId).subscribe((data) => {
                const binaryData = [];
                binaryData.push(data);
                this.blob = new Blob(binaryData);
                const link = document.createElement('a');
                const downloadURL = window.URL.createObjectURL(this.blob);
                link.href = downloadURL;
                link.download = filename;
                document.body.appendChild(link);
                link.click();
            }, err => {
                console.error(err);
                this.openErrorModal();
            });
        }
        catch (e) {
            console.error(e);
            this.openErrorModal();
        }
    }
    updateDocument(document) {
        const successDialog = this.dialog.open(GenericDocumentFSDModalComponent, {
            width: 'large',
            data: {
                documentGuidances: this.props.documentGuidances,
                acceptableDocuments: this.props.acceptableDocuments,
                ticketId: this.props.ticketId,
                helpTicketId: this.props.helpTicketId,
                isCompoundPurpose: this.props.isCompoundPurpose,
                service: this.props.service,
                document: document,
                mode: DocumentModalMode.UPDATE
            },
        });
        const afterClose = successDialog.afterClosed();
        afterClose.subscribe(this.closedDocument.bind(this));
    }
    deleteDocument(documentId) {
        this.props.service.deleteIncidentDocument(documentId).subscribe((document) => {
            const index = this.model.file.map(e => e.documentId).indexOf(documentId);
            this.model.file.splice(index, 1);
            this.refreshUI();
            this.updatedSelected();
        }, error => {
            console.error(error);
            this.openErrorModal();
        });
    }
    openErrorModal() {
        const errorDialog = this.dialog.open(ErrorModalComponent, {
            alert: 'error',
            width: 'Small',
            data: {},
        });
    }
    openAddDocument() {
        const successDialog = this.dialog.open(GenericDocumentFSDModalComponent, {
            width: 'large',
            data: {
                documentGuidances: this.props.documentGuidances,
                acceptableDocuments: this.props.acceptableDocuments,
                helpTicketId: this.props.helpTicketId,
                service: this.props.service,
                mode: DocumentModalMode.CREATE,
                isCompoundPurpose: this.props.isCompoundPurpose,
            },
        });
        const afterClose = successDialog.afterClosed();
        afterClose.subscribe(this.closedDocument.bind(this));
    }
    closedDocument(res) {
        if (res) {
            if (res.status === DocumentModalCloseStatus.SAVE) {
                this.model.file.push(res.document);
            }
            else if (res.status === DocumentModalCloseStatus.UPDATE) {
                const index = this.model.file.map(e => e.documentId).indexOf(res.document.documentId);
                this.model.file[index] = res.document;
            }
            else if (res.status === DocumentModalCloseStatus.UPDATEDELETE) {
                const index = this.model.file.map(e => e.documentId).indexOf(res.oldDocument.documentId);
                this.model.file[index] = res.document;
            }
            this.refreshUI();
            this.updatedSelected();
        }
    }
    updatedSelected() {
        const fileList = this.model.file;
        const selectedItems = [];
        for (let index = 0; index < fileList.length; index++) {
            const file = fileList[index];
            if (file.documentPurpose) {
                if (!this.props.isCompoundPurpose) {
                    const purposes = file.documentPurpose.split(',');
                    for (let index2 = 0; index2 < purposes.length; index2++) {
                        selectedItems.push(purposes[index2]);
                    }
                }
            }
            if (file.attachmentPurposes) {
                const purposes = file.attachmentPurposes;
                for (let index2 = 0; index2 < purposes.length; index2++) {
                    selectedItems.push(purposes[index2].docPurpose);
                }
            }
        }
        for (let index = 0; index < this.props.documentGuidances.length; index++) {
            const element = this.props.documentGuidances[index];
            element.isSelected = selectedItems.indexOf(element.documentGuidanceCheckboxText) !== -1;
        }
        this.allSelected = this.props.documentGuidances.filter(u => !u.isSelected && u.isRequired).length === 0;
        if (!this.props.isDocumentUploadOptional || !this.containGuidenceType(this.props.documentGuidances, true)) {
            this.formControl.markAsTouched();
            if (!this.allSelected) {
                this.formControl.setErrors({ 'incorrect': true });
            }
            else {
                this.formControl.setErrors(null);
            }
        }
    }
    getFilePreviewClass(fileName) {
        const fileNameLower = fileName.toLowerCase();
        if (fileNameLower.indexOf(".pdf") > 0) {
            return 'usa-file-input__preview-image usa-file-input__preview-image--pdf';
        }
        else if (fileNameLower.indexOf(".doc") > 0 ||
            fileNameLower.indexOf(".pages") > 0) {
            return 'usa-file-input__preview-image usa-file-input__preview-image--word';
        }
        else if (fileNameLower.indexOf(".xls") > 0 ||
            fileNameLower.indexOf(".numbers") > 0) {
            return 'usa-file-input__preview-image--excel';
        }
        else if (fileNameLower.indexOf(".mov") > 0 || fileNameLower.indexOf(".mp4") > 0) {
            return 'usa-file-input__preview-image usa-file-input__preview-image--video';
        }
        else {
            return 'usa-file-input__preview-image usa-file-input__preview-image--generic';
        }
    }
    createDocumentPopoverText() {
        const element = this.renderer.createElement('p');
        element.innerHTML = `
  <div class="margin-3 width-card-lg">
    <div>
      These acceptable documents are frequently used to prove entity information:
    </div>
    <ul class="margin-top-0">
      <li>Certified articles of incorporation/formation</li>
      <li>Certified business filing from your Secretary of State’s office</li>
      <li>Employer Identification Number (EIN) assignment letter from the IRS</li>
      <li>Recent bank statement (redacted, less than five years old)</li>
      <li>Recent utility bill (less than five years old)</li>
      <li> <a class="usa-link padding-right-2px" aria-label="Show more acceptable document types - opens in a new window"
          href="https://www.fsd.gov/gsafsd_sp?id=kb_article_view&sysparm_article=KB0055230" target="_blank">
          Show more acceptable document types
          <span class="margin-left-1px usa-link--external font-body-md"> </span></a> </li>
    </ul>
    <div>
      You may submit one or more documents to provide all the required evidence
    </div>
  </div>

   `;
        return element;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DocumentUploadComponent, deps: [{ token: i1$1.SdsDialogService }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: DocumentUploadComponent, selector: "document-upload", viewQueries: [{ propertyName: "tipContentAcceptable", first: true, predicate: ["tipContentAcceptable"], descendants: true }, { propertyName: "tipContentCreate", first: true, predicate: ["tipContentCreate"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div class=\"grid-row margin-2\">\r\n  <ng-template #tipContent>\r\n  </ng-template>\r\n  <sds-step-arrow *ngIf=\"!to.isFlagLabelsDisabled\" [number]=\"to.position\" [status]=\"'active'\"></sds-step-arrow>\r\n</div>\r\n\r\n<div [class]=\"to.isFlagLabelsDisabled?'margin-left-2':'margin-left-10'\">\r\n\r\n  <table class=\"usa-table\">\r\n\r\n    <thead>\r\n      <tr>\r\n        <th class=\"bg-accent-cool-lighter border-right-1px border-bottom-1px border-base-light\" scope=\"col\"\r\n          *ngFor=\"let columnHeader of columnHeaderArray;first as isFirst\">\r\n          {{columnHeader}}\r\n        </th>\r\n      </tr>\r\n    </thead>\r\n\r\n    <tbody>\r\n      <tr class=\"bg-base-lightest\"\r\n        *ngFor=\"let item of getStatusDisplayListV2(to.documentGuidances, true);last as isLast\">\r\n        <td class=\"border-right-1px border-bottom-1px border-base-light\"><ng-container\r\n            *ngTemplateOutlet=\"listIcon; context: { item: item }\"></ng-container></td>\r\n        <td class=\"border-bottom-1px border-base-light\" [innerHTML]=\"item.provideDocumentDescription\"></td>\r\n      </tr>\r\n      <tr *ngFor=\"let item of getStatusDisplayListV2(to.documentGuidances, false)\">\r\n        <td class=\"border-right-1px border-bottom-1px border-base-light\"><ng-container\r\n            *ngTemplateOutlet=\"listIcon; context: { item: item }\"></ng-container></td>\r\n        <td class=\"border-bottom-1px border-base-light\" [innerHTML]=\"item.provideDocumentDescription\"></td>\r\n      </tr>\r\n    </tbody>\r\n\r\n  </table>\r\n\r\n  <div class=\"margin-bottom-3 margin-top-3\">\r\n    <div class=\"text-base font-sans-lg margin-bottom-1\">Upload Documents</div>\r\n    <div class=\"text-base-light margin-top-05 \">\r\n      <div class=\"text-semibold margin-top-2 margin-bottom-1\">\r\n        You must attach one or more\r\n        <ng-template #tipContentCreate>\r\n          <div class=\"margin-3 width-card-lg\">\r\n            <div>\r\n              These acceptable documents are frequently used to prove entity information:\r\n            </div>\r\n            <ul class=\"margin-top-0\">\r\n              <li>Certified articles of incorporation/formation</li>\r\n              <li>Certified business filing from your Secretary of State\u2019s office</li>\r\n              <li>Employer Identification Number (EIN) assignment letter from the IRS</li>\r\n              <li>Recent bank statement (redacted, less than five years old)</li>\r\n              <li>Recent utility bill (less than five years old)</li>\r\n              <li> <a class=\"usa-link padding-right-2px\"\r\n                  aria-label=\"Show more acceptable document types - opens in a new window\"\r\n                  href=\"https://www.fsd.gov/gsafsd_sp?id=kb_article_view&sysparm_article=KB0055230\" target=\"_blank\">\r\n                  Show more acceptable document types\r\n                  <span class=\"margin-left-1px usa-link--external font-body-md\"> </span></a> </li>\r\n            </ul>\r\n            <div>\r\n              You may submit one or more documents to provide all the required evidence\r\n            </div>\r\n          </div>\r\n        </ng-template>\r\n        <button class=\"usa-button usa-button--unstyled\" [sdsPopover]=\"tipContentCreate\" [position]=\"'bottom'\">official\r\n          documents</button>\r\n        that prove each of the items highlighted to the right. View this list of acceptable documents to understand the\r\n        requirements.\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n\r\n  <!-- <div class=\"margin-bottom-3 margin-top-3\">\r\n    <div class=\"text-base font-sans-lg margin-bottom-1\">Upload Documents</div>\r\n    <div class=\"text-base-light margin-top-05 \">\r\n      View this list of\r\n      <ng-template #tipContentAcceptable>\r\n        <div class=\"margin-3 width-card-lg\">\r\n          <div>\r\n            These acceptable documents are frequently used to prove entity information:\r\n          </div>\r\n          <ul class=\"margin-top-0\">\r\n            <li>Certified articles of incorporation/formation</li>\r\n            <li>Certified business filing from your Secretary of State\u2019s office</li>\r\n            <li>Employer Identification Number (EIN) assignment letter from the IRS</li>\r\n            <li>Recent bank statement (redacted, less than five years old)</li>\r\n            <li>Recent utility bill (less than five years old)</li>\r\n            <li> <a class=\"usa-link padding-right-2px\"\r\n                aria-label=\"Show more acceptable document types - opens in a new window\"\r\n                href=\"https://www.fsd.gov/gsafsd_sp?id=kb_article_view&sysparm_article=KB0055230\" target=\"_blank\">\r\n                Show more acceptable document types\r\n                <span class=\"margin-left-1px usa-link--external font-body-md\"> </span></a> </li>\r\n          </ul>\r\n          <div>\r\n            You may submit one or more documents to provide all the required evidence\r\n          </div>\r\n        </div>\r\n      </ng-template>\r\n\r\n      <button class=\"usa-button usa-button--unstyled\" [sdsPopover]=\"tipContentAcceptable\"\r\n        [position]=\"'bottom'\">acceptable\r\n        documents</button>\r\n      to understand the requirements.\r\n    </div>\r\n  </div> -->\r\n\r\n\r\n  <div class=\"usa-accordion usa-accordion--bordered margin-bottom-3\">\r\n\r\n    <h2 class=\"usa-accordion__heading\">\r\n      <button class=\"usa-accordion__button  border-top-1px border-base-light \"\r\n        [attr.aria-expanded]=\"isDocumentRequirementsExpanded\" aria-controls=\"docReqSection\" \r\n        (click)=\"invertIsDocumentRequirementsExpanded()\">\r\n        Document Requirements\r\n      </button>\r\n    </h2>\r\n    <div id=\"docReqSection\" class=\"usa-accordion__content\" *ngIf=\"isDocumentRequirementsExpanded\">\r\n\r\n      <ul class=\"usa-list\">\r\n\r\n        <li class=\"margin-bottom-2\">\r\n          Use accepted documents. We do not accept unfiled IRS forms, insurance policies, leases, invoices, deeds,\r\n          DUNS\r\n          profiles, award documents, letterhead, or loan documents.\r\n        </li>\r\n\r\n        <li class=\"margin-bottom-2\">\r\n          Your SAM.gov entity details must match your documents exactly, including abbreviations, acronyms, and\r\n          suffixes.\r\n        </li>\r\n\r\n        <li class=\"margin-bottom-2\">\r\n          We do not accept a P.O. Box, virtual office, mailbox service, or co-working space for your physical address.\r\n        </li>\r\n\r\n        <li class=\"margin-bottom-2\">\r\n          Documents must be in English or translated by a certified translator into English. Submit copies of your\r\n          original documents and translated versions.\r\n        </li>\r\n      </ul>\r\n\r\n\r\n\r\n    </div>\r\n\r\n\r\n  </div>\r\n\r\n\r\n  <div class=\"sds-card bg-base-lighter margin-bottom-1 margin-left-1 margin-right-1 shadow-4\">\r\n\r\n    <div *ngIf=\"model.file\">\r\n      <div *ngFor=\"let item  of model.file\">\r\n        <div class=\"sds-card__body bg-base-lightest margin-top-1 margin-left-2 margin-right-2 shadow-4\">\r\n\r\n          <div class=\"margin-left-1 margin-top-1 grid-row grid-gap-3\">\r\n            <!-- <div class=\"grid-col flex-auto\">\r\n                <div [class]=\"getFilePreviewClass(item.documentName)\"></div>\r\n              </div> -->\r\n            <!--Document Name-->\r\n            <div class=\"grid-col-3\">\r\n              <div>\r\n                Document\r\n              </div>\r\n              <div class=\"text-semibold\">\r\n                <div *ngIf=\"!allowDownload(item)\">\r\n                  {{item.documentName}}\r\n                </div>\r\n                <button *ngIf=\"allowDownload(item)\" (click)=\"downloadFile(item)\"\r\n                  class=\"usa-button usa-button--unstyled\">\r\n                  {{item.documentName}}\r\n                </button>\r\n              </div>\r\n              <!-- Size -->\r\n              <div *ngIf=\"allowDownload(item)\">\r\n                {{ (item.size / 1000)}} KB\r\n              </div>\r\n            </div>\r\n            <!--Document Type-->\r\n            <div *ngIf=\"item.documentType\" class=\"grid-col-3\">\r\n              <div>\r\n                Document Type\r\n              </div>\r\n              <div class=\"text-semibold\">\r\n                {{item.documentType.replace(\"/\",\"/ \")}}\r\n              </div>\r\n            </div>\r\n            <!--Document Description-->\r\n            <div *ngIf=\"item.attachmentPurposes\" class=\"grid-col-3\">\r\n              <div>\r\n                Document Description\r\n              </div>\r\n              <div class=\"text-semibold\">\r\n                <ul class=\"sds-list sds-list--icon margin-bottom-1 margin-top-0\">\r\n                  <li *ngFor=\"let purpose of  suiList(item.attachmentPurposes)\">\r\n                    <span class=\"sds-list__item-content\">\r\n                      <span> {{purpose.text}}</span>\r\n\r\n                      <div>\r\n                        <ul class=\"sds-list sds-list--icon\" *ngIf=\"purpose.children.length!==0\">\r\n                          <li *ngFor=\"let section of purpose.children\">\r\n                            <span class=\"sds-list__item-icon\">\r\n                              <div class=\"circle-1 bg-black margin-top-1 margin-right-2\"></div>\r\n                            </span>\r\n                            <span class=\"sds-list__item-content\"> {{section}}</span>\r\n                          </li>\r\n                        </ul>\r\n                      </div>\r\n                    </span>\r\n                  </li>\r\n                </ul>\r\n              </div>\r\n\r\n            </div>\r\n\r\n            <!-- Buttons Update/Delete -->\r\n            <div *ngIf=\"!to.allowFileDownload&&!isAccepted(item)\" class=\"grid-col-3\">\r\n              <div>\r\n                <div class=\"margin-top-3 margin-bottom-3\">\r\n                  <button\r\n                    *ngIf=\"!to.allowFileDownload&&to.mode!==FSDModalMode.VIEW&&to.mode!==FSDModalMode.VIEWREADONLY&&!to.isResolved\"\r\n                    class=\"usa-button usa-button--unstyled\" (click)=\"updateDocument(item)\">\r\n                    <usa-icon [icon]=\"'pencil-square'\" size=\"2x\"></usa-icon>\r\n                    Update</button>\r\n                </div>\r\n                <div class=\"margin-top-3 margin-bottom-3\">\r\n                  <button\r\n                    *ngIf=\"!to.allowFileDownload&&to.mode!==FSDModalMode.VIEW&&to.mode!==FSDModalMode.VIEWREADONLY&&!to.isResolved\"\r\n                    class=\"usa-button usa-button--unstyled\" (click)=\"deleteDocument(item.documentId)\">\r\n                    <usa-icon [icon]=\"'trash'\" size=\"2x\"></usa-icon>\r\n                    Delete</button>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!-- Button Download -->\r\n            <div *ngIf=\"allowDownload(item)\" class=\"grid-col-3 flex-fill\">\r\n              <button class=\"pin-right usa-button usa-button--base bg-base-lighter\"\r\n                (click)=\"downloadFile(item)\">Download</button>\r\n            </div>\r\n\r\n          </div>\r\n          <!-- sdscard body ends below-->\r\n        </div>\r\n      </div>\r\n\r\n    </div>\r\n\r\n\r\n    <div class=\"margin-bottom-2 margin-top-2\">\r\n      <div>\r\n        <div style=\"text-align: center\">\r\n          <button\r\n            *ngIf=\"!to.allowFileDownload&&to.mode!==FSDModalMode.VIEW&&to.mode!==FSDModalMode.VIEWREADONLY&&!to.isResolved\"\r\n            class=\"padding-left-7 padding-right-7 usa-button usa-button--accent-cool bg-accent-cool-lighter center-align margin-top-1 margin-bottom-1\"\r\n            (click)=\"openAddDocument()\">Add\r\n            <span *ngIf=\"model.file.length>0\">Another</span>\r\n\r\n            Document\r\n            <span class=\"display-none\">-opens in modal </span>\r\n          </button>\r\n\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n  </div>\r\n\r\n</div>\r\n<ng-template #listIcon let-item=\"item\">\r\n  <span *ngIf=\"item.mode ===StatusIconMode.ACCEPTED\" class=\"sds-list__item-icon\">\r\n\r\n\r\n    <div class=\"circle-3 margin-top-1 margin-right-2 border-primary-dark border-2px display-inline\">\r\n      <usa-icon [size]=\"'1x'\" [icon]=\"'check'\" class=\"text-primary-dark\">\r\n      </usa-icon>\r\n    </div>\r\n    <span class=\"sds-list__item-content\"> {{item.updatingField}}</span>\r\n\r\n  </span>\r\n\r\n  <span *ngIf=\"item.mode ===StatusIconMode.BLANK\" class=\"sds-list__item-icon\">\r\n\r\n    <div class=\"circle-3 margin-top-1 margin-right-2 border-gold border-2px display-inline\">\r\n      <usa-icon [size]=\"'1x'\" [icon]=\"'hourglass'\" class=\"text-warning-dark text-semibold\">\r\n      </usa-icon>\r\n    </div>\r\n\r\n    <span class=\"sds-list__item-content\"> {{item.updatingField}}</span>\r\n  </span>\r\n  <span class=\"sds-list__item-content\"> {{item.text}}</span>\r\n</ng-template>", dependencies: [{ kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: i1$1.SdsStepArrowComponent, selector: "sds-step-arrow", inputs: ["status", "number"] }, { kind: "component", type: i3.IconComponent, selector: "usa-icon", inputs: ["icon", "rotate", "size", "classes", "skew"] }, { kind: "directive", type: i1$1.SdsPopover, selector: "[sdsPopover]", inputs: ["animation", "autoClose", "sdsPopover", "sdsPopoverTitle", "position", "popperOptions", "triggers", "positionTarget", "container", "disablePopover", "popoverClass", "popoverContext", "openDelay", "closeDelay"], outputs: ["shown", "hidden"], exportAs: ["sdsPopover"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DocumentUploadComponent, decorators: [{
            type: Component,
            args: [{ selector: 'document-upload', template: "<div class=\"grid-row margin-2\">\r\n  <ng-template #tipContent>\r\n  </ng-template>\r\n  <sds-step-arrow *ngIf=\"!to.isFlagLabelsDisabled\" [number]=\"to.position\" [status]=\"'active'\"></sds-step-arrow>\r\n</div>\r\n\r\n<div [class]=\"to.isFlagLabelsDisabled?'margin-left-2':'margin-left-10'\">\r\n\r\n  <table class=\"usa-table\">\r\n\r\n    <thead>\r\n      <tr>\r\n        <th class=\"bg-accent-cool-lighter border-right-1px border-bottom-1px border-base-light\" scope=\"col\"\r\n          *ngFor=\"let columnHeader of columnHeaderArray;first as isFirst\">\r\n          {{columnHeader}}\r\n        </th>\r\n      </tr>\r\n    </thead>\r\n\r\n    <tbody>\r\n      <tr class=\"bg-base-lightest\"\r\n        *ngFor=\"let item of getStatusDisplayListV2(to.documentGuidances, true);last as isLast\">\r\n        <td class=\"border-right-1px border-bottom-1px border-base-light\"><ng-container\r\n            *ngTemplateOutlet=\"listIcon; context: { item: item }\"></ng-container></td>\r\n        <td class=\"border-bottom-1px border-base-light\" [innerHTML]=\"item.provideDocumentDescription\"></td>\r\n      </tr>\r\n      <tr *ngFor=\"let item of getStatusDisplayListV2(to.documentGuidances, false)\">\r\n        <td class=\"border-right-1px border-bottom-1px border-base-light\"><ng-container\r\n            *ngTemplateOutlet=\"listIcon; context: { item: item }\"></ng-container></td>\r\n        <td class=\"border-bottom-1px border-base-light\" [innerHTML]=\"item.provideDocumentDescription\"></td>\r\n      </tr>\r\n    </tbody>\r\n\r\n  </table>\r\n\r\n  <div class=\"margin-bottom-3 margin-top-3\">\r\n    <div class=\"text-base font-sans-lg margin-bottom-1\">Upload Documents</div>\r\n    <div class=\"text-base-light margin-top-05 \">\r\n      <div class=\"text-semibold margin-top-2 margin-bottom-1\">\r\n        You must attach one or more\r\n        <ng-template #tipContentCreate>\r\n          <div class=\"margin-3 width-card-lg\">\r\n            <div>\r\n              These acceptable documents are frequently used to prove entity information:\r\n            </div>\r\n            <ul class=\"margin-top-0\">\r\n              <li>Certified articles of incorporation/formation</li>\r\n              <li>Certified business filing from your Secretary of State\u2019s office</li>\r\n              <li>Employer Identification Number (EIN) assignment letter from the IRS</li>\r\n              <li>Recent bank statement (redacted, less than five years old)</li>\r\n              <li>Recent utility bill (less than five years old)</li>\r\n              <li> <a class=\"usa-link padding-right-2px\"\r\n                  aria-label=\"Show more acceptable document types - opens in a new window\"\r\n                  href=\"https://www.fsd.gov/gsafsd_sp?id=kb_article_view&sysparm_article=KB0055230\" target=\"_blank\">\r\n                  Show more acceptable document types\r\n                  <span class=\"margin-left-1px usa-link--external font-body-md\"> </span></a> </li>\r\n            </ul>\r\n            <div>\r\n              You may submit one or more documents to provide all the required evidence\r\n            </div>\r\n          </div>\r\n        </ng-template>\r\n        <button class=\"usa-button usa-button--unstyled\" [sdsPopover]=\"tipContentCreate\" [position]=\"'bottom'\">official\r\n          documents</button>\r\n        that prove each of the items highlighted to the right. View this list of acceptable documents to understand the\r\n        requirements.\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n\r\n  <!-- <div class=\"margin-bottom-3 margin-top-3\">\r\n    <div class=\"text-base font-sans-lg margin-bottom-1\">Upload Documents</div>\r\n    <div class=\"text-base-light margin-top-05 \">\r\n      View this list of\r\n      <ng-template #tipContentAcceptable>\r\n        <div class=\"margin-3 width-card-lg\">\r\n          <div>\r\n            These acceptable documents are frequently used to prove entity information:\r\n          </div>\r\n          <ul class=\"margin-top-0\">\r\n            <li>Certified articles of incorporation/formation</li>\r\n            <li>Certified business filing from your Secretary of State\u2019s office</li>\r\n            <li>Employer Identification Number (EIN) assignment letter from the IRS</li>\r\n            <li>Recent bank statement (redacted, less than five years old)</li>\r\n            <li>Recent utility bill (less than five years old)</li>\r\n            <li> <a class=\"usa-link padding-right-2px\"\r\n                aria-label=\"Show more acceptable document types - opens in a new window\"\r\n                href=\"https://www.fsd.gov/gsafsd_sp?id=kb_article_view&sysparm_article=KB0055230\" target=\"_blank\">\r\n                Show more acceptable document types\r\n                <span class=\"margin-left-1px usa-link--external font-body-md\"> </span></a> </li>\r\n          </ul>\r\n          <div>\r\n            You may submit one or more documents to provide all the required evidence\r\n          </div>\r\n        </div>\r\n      </ng-template>\r\n\r\n      <button class=\"usa-button usa-button--unstyled\" [sdsPopover]=\"tipContentAcceptable\"\r\n        [position]=\"'bottom'\">acceptable\r\n        documents</button>\r\n      to understand the requirements.\r\n    </div>\r\n  </div> -->\r\n\r\n\r\n  <div class=\"usa-accordion usa-accordion--bordered margin-bottom-3\">\r\n\r\n    <h2 class=\"usa-accordion__heading\">\r\n      <button class=\"usa-accordion__button  border-top-1px border-base-light \"\r\n        [attr.aria-expanded]=\"isDocumentRequirementsExpanded\" aria-controls=\"docReqSection\" \r\n        (click)=\"invertIsDocumentRequirementsExpanded()\">\r\n        Document Requirements\r\n      </button>\r\n    </h2>\r\n    <div id=\"docReqSection\" class=\"usa-accordion__content\" *ngIf=\"isDocumentRequirementsExpanded\">\r\n\r\n      <ul class=\"usa-list\">\r\n\r\n        <li class=\"margin-bottom-2\">\r\n          Use accepted documents. We do not accept unfiled IRS forms, insurance policies, leases, invoices, deeds,\r\n          DUNS\r\n          profiles, award documents, letterhead, or loan documents.\r\n        </li>\r\n\r\n        <li class=\"margin-bottom-2\">\r\n          Your SAM.gov entity details must match your documents exactly, including abbreviations, acronyms, and\r\n          suffixes.\r\n        </li>\r\n\r\n        <li class=\"margin-bottom-2\">\r\n          We do not accept a P.O. Box, virtual office, mailbox service, or co-working space for your physical address.\r\n        </li>\r\n\r\n        <li class=\"margin-bottom-2\">\r\n          Documents must be in English or translated by a certified translator into English. Submit copies of your\r\n          original documents and translated versions.\r\n        </li>\r\n      </ul>\r\n\r\n\r\n\r\n    </div>\r\n\r\n\r\n  </div>\r\n\r\n\r\n  <div class=\"sds-card bg-base-lighter margin-bottom-1 margin-left-1 margin-right-1 shadow-4\">\r\n\r\n    <div *ngIf=\"model.file\">\r\n      <div *ngFor=\"let item  of model.file\">\r\n        <div class=\"sds-card__body bg-base-lightest margin-top-1 margin-left-2 margin-right-2 shadow-4\">\r\n\r\n          <div class=\"margin-left-1 margin-top-1 grid-row grid-gap-3\">\r\n            <!-- <div class=\"grid-col flex-auto\">\r\n                <div [class]=\"getFilePreviewClass(item.documentName)\"></div>\r\n              </div> -->\r\n            <!--Document Name-->\r\n            <div class=\"grid-col-3\">\r\n              <div>\r\n                Document\r\n              </div>\r\n              <div class=\"text-semibold\">\r\n                <div *ngIf=\"!allowDownload(item)\">\r\n                  {{item.documentName}}\r\n                </div>\r\n                <button *ngIf=\"allowDownload(item)\" (click)=\"downloadFile(item)\"\r\n                  class=\"usa-button usa-button--unstyled\">\r\n                  {{item.documentName}}\r\n                </button>\r\n              </div>\r\n              <!-- Size -->\r\n              <div *ngIf=\"allowDownload(item)\">\r\n                {{ (item.size / 1000)}} KB\r\n              </div>\r\n            </div>\r\n            <!--Document Type-->\r\n            <div *ngIf=\"item.documentType\" class=\"grid-col-3\">\r\n              <div>\r\n                Document Type\r\n              </div>\r\n              <div class=\"text-semibold\">\r\n                {{item.documentType.replace(\"/\",\"/ \")}}\r\n              </div>\r\n            </div>\r\n            <!--Document Description-->\r\n            <div *ngIf=\"item.attachmentPurposes\" class=\"grid-col-3\">\r\n              <div>\r\n                Document Description\r\n              </div>\r\n              <div class=\"text-semibold\">\r\n                <ul class=\"sds-list sds-list--icon margin-bottom-1 margin-top-0\">\r\n                  <li *ngFor=\"let purpose of  suiList(item.attachmentPurposes)\">\r\n                    <span class=\"sds-list__item-content\">\r\n                      <span> {{purpose.text}}</span>\r\n\r\n                      <div>\r\n                        <ul class=\"sds-list sds-list--icon\" *ngIf=\"purpose.children.length!==0\">\r\n                          <li *ngFor=\"let section of purpose.children\">\r\n                            <span class=\"sds-list__item-icon\">\r\n                              <div class=\"circle-1 bg-black margin-top-1 margin-right-2\"></div>\r\n                            </span>\r\n                            <span class=\"sds-list__item-content\"> {{section}}</span>\r\n                          </li>\r\n                        </ul>\r\n                      </div>\r\n                    </span>\r\n                  </li>\r\n                </ul>\r\n              </div>\r\n\r\n            </div>\r\n\r\n            <!-- Buttons Update/Delete -->\r\n            <div *ngIf=\"!to.allowFileDownload&&!isAccepted(item)\" class=\"grid-col-3\">\r\n              <div>\r\n                <div class=\"margin-top-3 margin-bottom-3\">\r\n                  <button\r\n                    *ngIf=\"!to.allowFileDownload&&to.mode!==FSDModalMode.VIEW&&to.mode!==FSDModalMode.VIEWREADONLY&&!to.isResolved\"\r\n                    class=\"usa-button usa-button--unstyled\" (click)=\"updateDocument(item)\">\r\n                    <usa-icon [icon]=\"'pencil-square'\" size=\"2x\"></usa-icon>\r\n                    Update</button>\r\n                </div>\r\n                <div class=\"margin-top-3 margin-bottom-3\">\r\n                  <button\r\n                    *ngIf=\"!to.allowFileDownload&&to.mode!==FSDModalMode.VIEW&&to.mode!==FSDModalMode.VIEWREADONLY&&!to.isResolved\"\r\n                    class=\"usa-button usa-button--unstyled\" (click)=\"deleteDocument(item.documentId)\">\r\n                    <usa-icon [icon]=\"'trash'\" size=\"2x\"></usa-icon>\r\n                    Delete</button>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!-- Button Download -->\r\n            <div *ngIf=\"allowDownload(item)\" class=\"grid-col-3 flex-fill\">\r\n              <button class=\"pin-right usa-button usa-button--base bg-base-lighter\"\r\n                (click)=\"downloadFile(item)\">Download</button>\r\n            </div>\r\n\r\n          </div>\r\n          <!-- sdscard body ends below-->\r\n        </div>\r\n      </div>\r\n\r\n    </div>\r\n\r\n\r\n    <div class=\"margin-bottom-2 margin-top-2\">\r\n      <div>\r\n        <div style=\"text-align: center\">\r\n          <button\r\n            *ngIf=\"!to.allowFileDownload&&to.mode!==FSDModalMode.VIEW&&to.mode!==FSDModalMode.VIEWREADONLY&&!to.isResolved\"\r\n            class=\"padding-left-7 padding-right-7 usa-button usa-button--accent-cool bg-accent-cool-lighter center-align margin-top-1 margin-bottom-1\"\r\n            (click)=\"openAddDocument()\">Add\r\n            <span *ngIf=\"model.file.length>0\">Another</span>\r\n\r\n            Document\r\n            <span class=\"display-none\">-opens in modal </span>\r\n          </button>\r\n\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n  </div>\r\n\r\n</div>\r\n<ng-template #listIcon let-item=\"item\">\r\n  <span *ngIf=\"item.mode ===StatusIconMode.ACCEPTED\" class=\"sds-list__item-icon\">\r\n\r\n\r\n    <div class=\"circle-3 margin-top-1 margin-right-2 border-primary-dark border-2px display-inline\">\r\n      <usa-icon [size]=\"'1x'\" [icon]=\"'check'\" class=\"text-primary-dark\">\r\n      </usa-icon>\r\n    </div>\r\n    <span class=\"sds-list__item-content\"> {{item.updatingField}}</span>\r\n\r\n  </span>\r\n\r\n  <span *ngIf=\"item.mode ===StatusIconMode.BLANK\" class=\"sds-list__item-icon\">\r\n\r\n    <div class=\"circle-3 margin-top-1 margin-right-2 border-gold border-2px display-inline\">\r\n      <usa-icon [size]=\"'1x'\" [icon]=\"'hourglass'\" class=\"text-warning-dark text-semibold\">\r\n      </usa-icon>\r\n    </div>\r\n\r\n    <span class=\"sds-list__item-content\"> {{item.updatingField}}</span>\r\n  </span>\r\n  <span class=\"sds-list__item-content\"> {{item.text}}</span>\r\n</ng-template>" }]
        }], ctorParameters: () => [{ type: i1$1.SdsDialogService }, { type: i0.Renderer2 }], propDecorators: { tipContentAcceptable: [{
                type: ViewChild,
                args: ['tipContentAcceptable']
            }], tipContentCreate: [{
                type: ViewChild,
                args: ['tipContentCreate']
            }] } });
class DocumentPurposeListItem {
}
class DocumentGuidanceViewList {
}
var StatusIconMode;
(function (StatusIconMode) {
    StatusIconMode[StatusIconMode["ACCEPTED"] = 0] = "ACCEPTED";
    StatusIconMode[StatusIconMode["REJECTED"] = 1] = "REJECTED";
    StatusIconMode[StatusIconMode["PENDING"] = 2] = "PENDING";
    StatusIconMode[StatusIconMode["BLANK"] = 3] = "BLANK";
    StatusIconMode[StatusIconMode["NOTAPPLICABLE"] = 4] = "NOTAPPLICABLE";
})(StatusIconMode || (StatusIconMode = {}));
var DoumentPurposeStatus;
(function (DoumentPurposeStatus) {
    DoumentPurposeStatus[DoumentPurposeStatus["ACCEPTED"] = 2] = "ACCEPTED";
    DoumentPurposeStatus[DoumentPurposeStatus["REJECTED"] = 3] = "REJECTED";
    DoumentPurposeStatus[DoumentPurposeStatus["PENDING"] = 1] = "PENDING";
})(DoumentPurposeStatus || (DoumentPurposeStatus = {}));

class SuccessNavigationAction {
    ;
}
var SuccessNavigationButtonStyle;
(function (SuccessNavigationButtonStyle) {
    SuccessNavigationButtonStyle[SuccessNavigationButtonStyle["PRIMARY"] = 0] = "PRIMARY";
    SuccessNavigationButtonStyle[SuccessNavigationButtonStyle["SECONDARY"] = 1] = "SECONDARY";
    SuccessNavigationButtonStyle[SuccessNavigationButtonStyle["BASE"] = 2] = "BASE";
})(SuccessNavigationButtonStyle || (SuccessNavigationButtonStyle = {}));
class SuccessData {
}
class SuccessFSDModalComponent {
    constructor(data, dialogRef) {
        this.data = data;
        this.dialogRef = dialogRef;
    }
    ngOnInit() {
        for (let index = 0; index < this.data.successNavigationActions.length; index++) {
            const element = this.data.successNavigationActions[index];
            if (element.fieldKey) {
                const value = this.data.model[element.fieldKey];
                if (value && value === element.fieldValue) {
                    this.successNavigationAction = element;
                    //Short out loop
                    index = this.data.successNavigationActions.length;
                }
            }
            else {
                //if no field value it will use an option that is not deterministic
                this.successNavigationAction = element;
            }
        }
        const buttonStyle = this.successNavigationAction.buttonStyle;
        switch (buttonStyle) {
            case SuccessNavigationButtonStyle.BASE:
                this.buttonClass = 'usa-button usa-button--base bg-base-lighter';
                break;
            case SuccessNavigationButtonStyle.PRIMARY:
                this.buttonClass = 'usa-button';
                break;
            case SuccessNavigationButtonStyle.SECONDARY:
                this.buttonClass = 'usa-button usa-button bg-primary-lighter';
                break;
            default:
                this.buttonClass = 'usa-button';
                break;
        }
    }
    action() {
        this.dialogRef.close({});
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SuccessFSDModalComponent, deps: [{ token: SDS_DIALOG_DATA }, { token: i1$1.SdsDialogRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: SuccessFSDModalComponent, selector: "success-fsd-modal", ngImport: i0, template: `

<div class="grid-container">
  <div class="grid-row padding-bottom-1">
    <div class="grid-col width-full display-flex flex-align-center flex-justify-center">
      <div sds-dialog-title class="text-semibold font-sans-lg">{{data.headerTypeText}} Documentation Submitted</div>
    </div>
  </div>
  <div class="grid-row">
    <div class="grid-col width-full display-flex flex-align-center flex-justify-center">
      <div><a aria-label="Reference Number - opens in a new window" target="_blank" class="usa-link" href="https://www.fsd.gov/gsafsd_sp?id=kb_article_view&sysparm_article=KB0059269"> Reference Number <span class="margin-left-1px usa-link--external font-body-md"></span></a></div>
    </div>
  </div>
  <div class="grid-row padding-bottom-4">
    <div class="grid-col width-full display-flex flex-align-center flex-justify-center">
      <div class="text-bold font-sans-xl">{{data.fsdTicketNumber}}</div>
    </div>
  </div>
  <div class="grid-row padding-bottom-1">
    <div class="grid-col width-full display-flex flex-align-center flex-justify-center">
      <div>SAM.gov will review your documentation to finalize your entity uniqueness determination.
      </div>
    </div>
  </div>
  <div class="grid-row padding-bottom-1">
    <div class="grid-col width-full ">
      <div><a aria-label="What happens after I submit entity documentation? - opens in a new window" target="_blank"class="usa-link" href="https://www.fsd.gov/gsafsd_sp?id=kb_article_view&sysparm_article=KB0058183">What happens afer I submit entity documentation?<span class="margin-left-1px usa-link--external font-body-md"></span></a></div>
    </div>
  </div>
  <div class="grid-row padding-y-2">
    <div class="grid-col width-full display-flex flex-align-center flex-justify-center">
      <button (click)="action()" [class]="buttonClass">{{successNavigationAction.buttonText}}</button>
    </div>
  </div>
</div>

 `, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SuccessFSDModalComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'success-fsd-modal',
                    template: `

<div class="grid-container">
  <div class="grid-row padding-bottom-1">
    <div class="grid-col width-full display-flex flex-align-center flex-justify-center">
      <div sds-dialog-title class="text-semibold font-sans-lg">{{data.headerTypeText}} Documentation Submitted</div>
    </div>
  </div>
  <div class="grid-row">
    <div class="grid-col width-full display-flex flex-align-center flex-justify-center">
      <div><a aria-label="Reference Number - opens in a new window" target="_blank" class="usa-link" href="https://www.fsd.gov/gsafsd_sp?id=kb_article_view&sysparm_article=KB0059269"> Reference Number <span class="margin-left-1px usa-link--external font-body-md"></span></a></div>
    </div>
  </div>
  <div class="grid-row padding-bottom-4">
    <div class="grid-col width-full display-flex flex-align-center flex-justify-center">
      <div class="text-bold font-sans-xl">{{data.fsdTicketNumber}}</div>
    </div>
  </div>
  <div class="grid-row padding-bottom-1">
    <div class="grid-col width-full display-flex flex-align-center flex-justify-center">
      <div>SAM.gov will review your documentation to finalize your entity uniqueness determination.
      </div>
    </div>
  </div>
  <div class="grid-row padding-bottom-1">
    <div class="grid-col width-full ">
      <div><a aria-label="What happens after I submit entity documentation? - opens in a new window" target="_blank"class="usa-link" href="https://www.fsd.gov/gsafsd_sp?id=kb_article_view&sysparm_article=KB0058183">What happens afer I submit entity documentation?<span class="margin-left-1px usa-link--external font-body-md"></span></a></div>
    </div>
  </div>
  <div class="grid-row padding-y-2">
    <div class="grid-col width-full display-flex flex-align-center flex-justify-center">
      <button (click)="action()" [class]="buttonClass">{{successNavigationAction.buttonText}}</button>
    </div>
  </div>
</div>

 `,
                }]
        }], ctorParameters: () => [{ type: SuccessData, decorators: [{
                    type: Inject,
                    args: [SDS_DIALOG_DATA]
                }] }, { type: i1$1.SdsDialogRef }] });

class SuccessFSDComponent {
    constructor() {
        this.action = new EventEmitter();
    }
    ngOnInit() {
        for (let index = 0; index < this.data.successNavigationActions.length; index++) {
            const element = this.data.successNavigationActions[index];
            if (element.fieldKey) {
                const value = this.data.model[element.fieldKey];
                if (value && value === element.fieldValue) {
                    this.successNavigationAction = element;
                    //Short out loop
                    index = this.data.successNavigationActions.length;
                }
            }
            else {
                //if no field value it will use an option that is not deterministic
                this.successNavigationAction = element;
            }
        }
        const buttonStyle = this.successNavigationAction.buttonStyle;
        switch (buttonStyle) {
            case SuccessNavigationButtonStyle.BASE:
                this.buttonClass = 'usa-button usa-button--base bg-base-lighter';
                break;
            case SuccessNavigationButtonStyle.PRIMARY:
                this.buttonClass = 'usa-button';
                break;
            case SuccessNavigationButtonStyle.SECONDARY:
                this.buttonClass = 'usa-button usa-button bg-primary-lighter';
                break;
            default:
                this.buttonClass = 'usa-button';
                break;
        }
    }
    actionClick() {
        this.action.emit({ helpDeskTicket: this.data.fsdTicketNumber, model: undefined, status: FSDModalCloseStatus.CLOSE, ticketId: undefined });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SuccessFSDComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: SuccessFSDComponent, selector: "success-fsd-panel", inputs: { data: "data" }, outputs: { action: "action" }, ngImport: i0, template: "<div class=\"grid-container\">\r\n  <div class=\"grid-row padding-bottom-1\">\r\n    <div class=\"grid-col width-full display-flex flex-align-center flex-justify-center\">\r\n      <usa-icon class=\"text-success\" [icon]=\"'check-circle'\" size=\"3x\"></usa-icon>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"grid-row padding-bottom-1\">\r\n    <div class=\"grid-col width-full display-flex flex-align-center flex-justify-center\">\r\n      <div sds-dialog-title class=\"text-semibold font-sans-lg\">{{data.headerTypeText}} Documentation\r\n        {{data.mode?data.mode:'Submitted'}}</div>\r\n    </div>\r\n  </div>\r\n  <div class=\"grid-row\">\r\n    <div class=\"grid-col width-full display-flex flex-align-center flex-justify-center\">\r\n      <div><a aria-label=\"Reference Number - opens in a new window\" target=\"_blank\" class=\"usa-link\"\r\n          href=\"https://www.fsd.gov/gsafsd_sp?id=kb_article_view&sysparm_article=KB0059269\"> Reference Number <span\r\n            class=\"margin-left-1px usa-link--external font-body-md\"></span></a></div>\r\n    </div>\r\n  </div>\r\n  <div class=\"grid-row padding-bottom-4\">\r\n    <div class=\"grid-col width-full display-flex flex-align-center flex-justify-center\">\r\n      <div class=\"text-bold font-sans-xl\">{{data.fsdTicketNumber}}</div>\r\n    </div>\r\n  </div>\r\n  <div class=\"grid-row padding-bottom-1\">\r\n    <div class=\"grid-col width-full display-flex\">\r\n      <div>SAM.gov will review your documentation and contact you if we have any questions.\r\n        <a aria-label=\"What happens after I submit entity documentation? - opens in a new window\" target=\"_blank\"\r\n          class=\"usa-link\" href=\"https://www.fsd.gov/gsafsd_sp?id=kb_article_view&sysparm_article=KB0058183\">\r\n          Read this article <span class=\"margin-left-1px usa-link--external font-body-md\"></span>\r\n        </a>\r\n        to learn more about what happens next.\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"grid-row padding-bottom-1\">\r\n    <div class=\"grid-col width-full display-flex\">\r\n      Please do not submit any documentation for your entity at FSD.gov. All documents must be submitted here at\r\n      SAM.gov.\r\n    </div>\r\n  </div>\r\n  <div class=\"grid-row padding-y-2\">\r\n    <div class=\"grid-col width-full display-flex flex-align-center flex-justify-center\">\r\n      <button (click)=\"actionClick()\" [class]=\"buttonClass\">{{successNavigationAction.buttonText}}</button>\r\n    </div>\r\n  </div>\r\n</div>\r\n", dependencies: [{ kind: "component", type: i3.IconComponent, selector: "usa-icon", inputs: ["icon", "rotate", "size", "classes", "skew"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SuccessFSDComponent, decorators: [{
            type: Component,
            args: [{ selector: 'success-fsd-panel', template: "<div class=\"grid-container\">\r\n  <div class=\"grid-row padding-bottom-1\">\r\n    <div class=\"grid-col width-full display-flex flex-align-center flex-justify-center\">\r\n      <usa-icon class=\"text-success\" [icon]=\"'check-circle'\" size=\"3x\"></usa-icon>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"grid-row padding-bottom-1\">\r\n    <div class=\"grid-col width-full display-flex flex-align-center flex-justify-center\">\r\n      <div sds-dialog-title class=\"text-semibold font-sans-lg\">{{data.headerTypeText}} Documentation\r\n        {{data.mode?data.mode:'Submitted'}}</div>\r\n    </div>\r\n  </div>\r\n  <div class=\"grid-row\">\r\n    <div class=\"grid-col width-full display-flex flex-align-center flex-justify-center\">\r\n      <div><a aria-label=\"Reference Number - opens in a new window\" target=\"_blank\" class=\"usa-link\"\r\n          href=\"https://www.fsd.gov/gsafsd_sp?id=kb_article_view&sysparm_article=KB0059269\"> Reference Number <span\r\n            class=\"margin-left-1px usa-link--external font-body-md\"></span></a></div>\r\n    </div>\r\n  </div>\r\n  <div class=\"grid-row padding-bottom-4\">\r\n    <div class=\"grid-col width-full display-flex flex-align-center flex-justify-center\">\r\n      <div class=\"text-bold font-sans-xl\">{{data.fsdTicketNumber}}</div>\r\n    </div>\r\n  </div>\r\n  <div class=\"grid-row padding-bottom-1\">\r\n    <div class=\"grid-col width-full display-flex\">\r\n      <div>SAM.gov will review your documentation and contact you if we have any questions.\r\n        <a aria-label=\"What happens after I submit entity documentation? - opens in a new window\" target=\"_blank\"\r\n          class=\"usa-link\" href=\"https://www.fsd.gov/gsafsd_sp?id=kb_article_view&sysparm_article=KB0058183\">\r\n          Read this article <span class=\"margin-left-1px usa-link--external font-body-md\"></span>\r\n        </a>\r\n        to learn more about what happens next.\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"grid-row padding-bottom-1\">\r\n    <div class=\"grid-col width-full display-flex\">\r\n      Please do not submit any documentation for your entity at FSD.gov. All documents must be submitted here at\r\n      SAM.gov.\r\n    </div>\r\n  </div>\r\n  <div class=\"grid-row padding-y-2\">\r\n    <div class=\"grid-col width-full display-flex flex-align-center flex-justify-center\">\r\n      <button (click)=\"actionClick()\" [class]=\"buttonClass\">{{successNavigationAction.buttonText}}</button>\r\n    </div>\r\n  </div>\r\n</div>\r\n" }]
        }], propDecorators: { data: [{
                type: Input
            }], action: [{
                type: Output
            }] } });

class SubmitUpdateSectionComponent extends FieldType {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SubmitUpdateSectionComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: SubmitUpdateSectionComponent, selector: "submit-update-section", usesInheritance: true, ngImport: i0, template: "<br />\r\n<div class=\"grid-row\">\r\n  <sds-step-arrow *ngIf=\"!to.isFlagLabelsDisabled\" [number]=\"to.position\" [status]=\"'active'\"></sds-step-arrow>\r\n  <div class=\"text-semibold font-sans-lg\">Submit Updates</div>\r\n</div>\r\n<div [class]=\"to.isFlagLabelsDisabled?'margin-left-2':'margin-left-8'\">\r\n  <div>\r\n    Select <span class=\"text-semibold\">Submit</span> to update your documentation. Select <span\r\n      class=\"text-semibold\">Cancel</span> if you reviewed your submission, and made no changes.\r\n  </div>\r\n\r\n</div>\r\n", dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i1$1.SdsStepArrowComponent, selector: "sds-step-arrow", inputs: ["status", "number"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SubmitUpdateSectionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'submit-update-section', template: "<br />\r\n<div class=\"grid-row\">\r\n  <sds-step-arrow *ngIf=\"!to.isFlagLabelsDisabled\" [number]=\"to.position\" [status]=\"'active'\"></sds-step-arrow>\r\n  <div class=\"text-semibold font-sans-lg\">Submit Updates</div>\r\n</div>\r\n<div [class]=\"to.isFlagLabelsDisabled?'margin-left-2':'margin-left-8'\">\r\n  <div>\r\n    Select <span class=\"text-semibold\">Submit</span> to update your documentation. Select <span\r\n      class=\"text-semibold\">Cancel</span> if you reviewed your submission, and made no changes.\r\n  </div>\r\n\r\n</div>\r\n" }]
        }] });

class GenericFSDStandaloneModalComponent {
    constructor(data, dialogRef, cdr, dialog) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.cdr = cdr;
        this.dialog = dialog;
        this.modelUpdated = new EventEmitter();
        this.fsdSubmitted = new EventEmitter();
        this.closeAction = new EventEmitter();
        this.FSDModalMode = FSDModalMode;
    }
    updateIncident() {
        this.child.saveIncident();
    }
    cancelIncident() {
        this.dialogRef.close();
    }
    closeActionMethod(event) {
        this.closeAction.emit(event);
        this.dialogRef.close();
        if (event.status === FSDModalCloseStatus.SAVE) {
            this.successData = {
                fsdTicketNumber: event.helpDeskTicket, model: undefined, headerTypeText: this.data.headerTypeText,
                successNavigationActions: [{
                        buttonStyle: SuccessNavigationButtonStyle.BASE, buttonText: 'Close',
                        fieldKey: undefined, fieldValue: undefined
                    }],
                mode: this.data.mode === FSDModalMode.UPDATE ? 'Updated' : undefined
            };
            this.successRef = this.dialog.open(this.successTemplate, {
                width: 'large',
                height: 'large'
            });
        }
    }
    action() {
        this.successRef.close();
    }
    modelUpdatedAction(event) {
        this.modelUpdated.emit(event);
    }
    fsdSubmittedAction(event) {
        this.fsdSubmitted.emit(event);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericFSDStandaloneModalComponent, deps: [{ token: SDS_DIALOG_DATA }, { token: i1$1.SdsDialogRef }, { token: i0.ChangeDetectorRef }, { token: i1$1.SdsDialogService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: GenericFSDStandaloneModalComponent, selector: "generic-help-modal", outputs: { modelUpdated: "modelUpdated", fsdSubmitted: "fsdSubmitted", closeAction: "closeAction" }, viewQueries: [{ propertyName: "child", first: true, predicate: ["incidentComp"], descendants: true }, { propertyName: "successTemplate", first: true, predicate: ["successTemplate"], descendants: true }], ngImport: i0, template: "<generic-help-standalone #incidentComp [config]=\"data\" (closeAction)=\"closeActionMethod($event)\"\r\n  (modelUpdated)=\"modelUpdatedAction($event)\" (fsdSubmitted)=\"fsdSubmittedAction($event)\">\r\n</generic-help-standalone>\r\n\r\n<div class=\"grid-container padding-0 padding-bottom-1\">\r\n  <div class=\"grid-row flex-column flex-align-end\">\r\n    <div class=\"grid-col flex-fill\">\r\n      <div class=\"\">\r\n        <button *ngIf=\"data.mode!== FSDModalMode.VIEW\" (click)=\"cancelIncident()\"\r\n          class=\"pos-right usa-button usa-button--base bg-base-lighter\">Cancel</button>\r\n        <button *ngIf=\"data.mode!== FSDModalMode.VIEW\" (click)=\"updateIncident()\"\r\n          class=\"pos-right usa-button\">Submit</button>\r\n        <button *ngIf=\"data.mode=== FSDModalMode.VIEW\" (click)=\"cancelIncident()\"\r\n          class=\"pos-right usa-button usa-button--base bg-base-lighter\">Close</button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<ng-template #successTemplate>\r\n  <success-fsd-panel (action)=\"action()\" [data]=\"successData\"></success-fsd-panel>\r\n</ng-template>\r\n", dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: GenericFSDStandaloneComponent, selector: "generic-help-standalone", inputs: ["config"], outputs: ["modelUpdated", "fsdSubmitted", "closeAction", "ticketStatus"] }, { kind: "component", type: SuccessFSDComponent, selector: "success-fsd-panel", inputs: ["data"], outputs: ["action"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericFSDStandaloneModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'generic-help-modal', template: "<generic-help-standalone #incidentComp [config]=\"data\" (closeAction)=\"closeActionMethod($event)\"\r\n  (modelUpdated)=\"modelUpdatedAction($event)\" (fsdSubmitted)=\"fsdSubmittedAction($event)\">\r\n</generic-help-standalone>\r\n\r\n<div class=\"grid-container padding-0 padding-bottom-1\">\r\n  <div class=\"grid-row flex-column flex-align-end\">\r\n    <div class=\"grid-col flex-fill\">\r\n      <div class=\"\">\r\n        <button *ngIf=\"data.mode!== FSDModalMode.VIEW\" (click)=\"cancelIncident()\"\r\n          class=\"pos-right usa-button usa-button--base bg-base-lighter\">Cancel</button>\r\n        <button *ngIf=\"data.mode!== FSDModalMode.VIEW\" (click)=\"updateIncident()\"\r\n          class=\"pos-right usa-button\">Submit</button>\r\n        <button *ngIf=\"data.mode=== FSDModalMode.VIEW\" (click)=\"cancelIncident()\"\r\n          class=\"pos-right usa-button usa-button--base bg-base-lighter\">Close</button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<ng-template #successTemplate>\r\n  <success-fsd-panel (action)=\"action()\" [data]=\"successData\"></success-fsd-panel>\r\n</ng-template>\r\n" }]
        }], ctorParameters: () => [{ type: ContactFSDModalV2Data, decorators: [{
                    type: Inject,
                    args: [SDS_DIALOG_DATA]
                }] }, { type: i1$1.SdsDialogRef }, { type: i0.ChangeDetectorRef }, { type: i1$1.SdsDialogService }], propDecorators: { modelUpdated: [{
                type: Output
            }], fsdSubmitted: [{
                type: Output
            }], closeAction: [{
                type: Output
            }], child: [{
                type: ViewChild,
                args: ['incidentComp']
            }], successTemplate: [{
                type: ViewChild,
                args: ['successTemplate']
            }] } });

class FSDSearchListSectionComponentComponent extends FieldType {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: FSDSearchListSectionComponentComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: FSDSearchListSectionComponentComponent, selector: "search-list-section", usesInheritance: true, ngImport: i0, template: "<div class=\"grid-row\">\r\n  <sds-step-arrow *ngIf=\"!to.isFlagLabelsDisabled\" [number]=\"to.position\" [status]=\"'active'\"></sds-step-arrow>\r\n  <div class=\"text-semibold font-sans-lg margin-top-05 \">Search History</div>\r\n</div>\r\n<div [class]=\"to.isFlagLabelsDisabled?'margin-bottom-3s':'margin-left-10 margin-bottom-3'\">\r\n  <div *ngIf=\"to.searchListFields\" class=\"sds-table__container\">\r\n    <table aria-describedby=\"srchTblDesc\" class=\"sds-table\">\r\n      <thead>\r\n        <tr class=\"sds-table__row\">\r\n          <th *ngFor=\"let searchListFieldItem of to.searchListFields;\" scope=\"col\">{{searchListFieldItem.columnTitle}}\r\n          </th>\r\n        </tr>\r\n      </thead>\r\n      <tbody *ngIf=\"to.searchList && to.searchList.length>0\">\r\n        <tr *ngFor=\"let searchItem of to.searchList;\" class=\"sds-table__row\">\r\n          <td *ngFor=\"let searchListFieldItem of to.searchListFields;\">\r\n            <ng-container *ngIf=\"!searchListFieldItem.formater\">\r\n              {{searchItem[searchListFieldItem.rowValueProperty]}}\r\n            </ng-container>\r\n\r\n            <ng-container *ngIf=\"searchListFieldItem.formater\">\r\n              {{searchListFieldItem.formater(searchItem)}}\r\n            </ng-container>\r\n          </td>\r\n        </tr>\r\n      </tbody>\r\n      <tbody *ngIf=\"!to.searchList || (to.searchList && to.searchList.length===0)\">\r\n        <tr class=\"sds-table__row\">\r\n          <td [colSpan]=\"to.searchListFields.length\">\r\n            No search history\r\n          </td>\r\n        </tr>\r\n      </tbody>\r\n    </table>\r\n  </div>\r\n</div>\r\n", dependencies: [{ kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i1$1.SdsStepArrowComponent, selector: "sds-step-arrow", inputs: ["status", "number"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: FSDSearchListSectionComponentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'search-list-section', template: "<div class=\"grid-row\">\r\n  <sds-step-arrow *ngIf=\"!to.isFlagLabelsDisabled\" [number]=\"to.position\" [status]=\"'active'\"></sds-step-arrow>\r\n  <div class=\"text-semibold font-sans-lg margin-top-05 \">Search History</div>\r\n</div>\r\n<div [class]=\"to.isFlagLabelsDisabled?'margin-bottom-3s':'margin-left-10 margin-bottom-3'\">\r\n  <div *ngIf=\"to.searchListFields\" class=\"sds-table__container\">\r\n    <table aria-describedby=\"srchTblDesc\" class=\"sds-table\">\r\n      <thead>\r\n        <tr class=\"sds-table__row\">\r\n          <th *ngFor=\"let searchListFieldItem of to.searchListFields;\" scope=\"col\">{{searchListFieldItem.columnTitle}}\r\n          </th>\r\n        </tr>\r\n      </thead>\r\n      <tbody *ngIf=\"to.searchList && to.searchList.length>0\">\r\n        <tr *ngFor=\"let searchItem of to.searchList;\" class=\"sds-table__row\">\r\n          <td *ngFor=\"let searchListFieldItem of to.searchListFields;\">\r\n            <ng-container *ngIf=\"!searchListFieldItem.formater\">\r\n              {{searchItem[searchListFieldItem.rowValueProperty]}}\r\n            </ng-container>\r\n\r\n            <ng-container *ngIf=\"searchListFieldItem.formater\">\r\n              {{searchListFieldItem.formater(searchItem)}}\r\n            </ng-container>\r\n          </td>\r\n        </tr>\r\n      </tbody>\r\n      <tbody *ngIf=\"!to.searchList || (to.searchList && to.searchList.length===0)\">\r\n        <tr class=\"sds-table__row\">\r\n          <td [colSpan]=\"to.searchListFields.length\">\r\n            No search history\r\n          </td>\r\n        </tr>\r\n      </tbody>\r\n    </table>\r\n  </div>\r\n</div>\r\n" }]
        }] });

let AverageWaitTimeResponse$1 = class AverageWaitTimeResponse {
};
class dateResponce {
}
class AverageWaitTimeService {
    constructor(oAPIService) {
        this.oAPIService = oAPIService;
    }
    getAverageWaitTime() {
        var oApiParam = {
            name: 'avgWaitTime',
            suffix: '/tickets/history/avg-wait-time',
            oParam: {},
            method: 'GET'
        };
        return this.oAPIService.call(oApiParam);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: AverageWaitTimeService, deps: [{ token: WrapperService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: AverageWaitTimeService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: AverageWaitTimeService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: WrapperService }] });

class AverageWaitTimeResponse {
}
class TimeWidgetModalComponent {
    constructor(averageWaitTimeService) {
        this.averageWaitTimeService = averageWaitTimeService;
        this.action = new EventEmitter();
    }
    ngOnInit() {
        this.averageWaitTimeService.getAverageWaitTime().subscribe((averageWaitTimeResponce) => {
            if (averageWaitTimeResponce) {
                this.parsedTime = this.parseMilliseconds(averageWaitTimeResponce.avgWaitTime);
                this.averageWaitTextHtml = this.averageWaitTime(this.parsedTime);
            }
        });
        for (let index = 0; index < this.data.successNavigationActions.length; index++) {
            const element = this.data.successNavigationActions[index];
            if (element.fieldKey) {
                const value = this.data.model[element.fieldKey];
                if (value && value === element.fieldValue) {
                    this.successNavigationAction = element;
                    //Short out loop
                    index = this.data.successNavigationActions.length;
                }
            }
            else {
                //if no field value it will use an option that is not deterministic
                this.successNavigationAction = element;
            }
        }
    }
    actionClick() {
        this.action.emit({ helpDeskTicket: this.data.fsdTicketNumber, model: undefined, status: FSDModalCloseStatus.CLOSE, ticketId: undefined });
    }
    parseMilliseconds(milliseconds) {
        const roundTowardsZero = milliseconds > 0 ? Math.floor : Math.ceil;
        let parsedWaitTime = {
            days: roundTowardsZero(milliseconds / 86400000) < 1 ? 1 : roundTowardsZero(milliseconds / 86400000),
            hours: roundTowardsZero(milliseconds / 3600000) % 24,
            minDays: "",
            maxDays: ""
        };
        let maxdaysNumber = parsedWaitTime.days;
        maxdaysNumber += Number(this.buffer);
        // average wait time cannot be less than 1 day, and half days need to be added
        if (parsedWaitTime.hours > 11) {
            parsedWaitTime.minDays = parsedWaitTime.days.toString() + ".5";
            parsedWaitTime.maxDays = maxdaysNumber.toString() + ".5";
        }
        else {
            parsedWaitTime.minDays = parsedWaitTime.days.toString();
            parsedWaitTime.maxDays = maxdaysNumber.toString();
        }
        return parsedWaitTime;
    }
    averageWaitTime(parsedTime) {
        // if the miliseconds convert to less than 11 hours then assume the average wait time is less than a day
        if (!parsedTime || parsedTime.days < 0) {
            this.showWaitTimeDisclaimer = false;
            return `Average wait time<br>for first review of documents<br>is currently unavailable.`;
        }
        else {
            this.showWaitTimeDisclaimer = true;
            return `We should review your documents in <br><span class="text-bold">${parsedTime.minDays}-${parsedTime.maxDays} business days.*</span>`;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: TimeWidgetModalComponent, deps: [{ token: AverageWaitTimeService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: TimeWidgetModalComponent, selector: "time-widget-modal", inputs: { data: "data", buffer: "buffer" }, outputs: { action: "action" }, ngImport: i0, template: "<div class=\"grid-container\">\r\n  <div class=\"grid-row padding-bottom-1\">\r\n    <div class=\"grid-col width-full display-flex flex-justify-center\">\r\n      <usa-icon class=\"text-success\" [icon]=\"'check-circle'\" size=\"5x\"></usa-icon>\r\n    </div>\r\n  </div>\r\n\r\n  <div sds-dialog-title class=\"text-bold font-sans-lg sds-dialog-title text-center\">\r\n    Documentation Successfully Submitted\r\n  </div>\r\n\r\n  <div sds-dialog-content class=\"sds-dialog-content border border-base-light shadow-1\">\r\n    <div class=\"grid-row border-bottom border-base-light display-flex flex-justify-center\">\r\n      \r\n      <div class=\"desktop:grid-col text-center display-flex flex-justify-center \" *ngIf=\"data\">\r\n        <div class=\"padding-1 grid-col text-center\">\r\n          <div class=\"text-bold font-sans grid-row flex-justify-center\">Reference Number</div>\r\n          <div class=\"margin-top-1 text-bold font-sans-xl grid-row flex-justify-center\">{{data.fsdTicketNumber}}</div>\r\n        </div>\r\n      </div> \r\n\r\n      <div *ngIf=\"!data\" class=\"padding-1\">\r\n        <div class=\"desktop:grid-col\">\r\n          <div>Incident Information</div>\r\n          <div>is currently unavailable</div>\r\n        </div>\r\n      </div>\r\n\r\n      <!-- this is a line -->\r\n      <div class=\"desktop:sds-field desktop:border-base-light desktop:border-left desktop:padding-left-4 desktop:margin-y-1\"></div>\r\n      <div class=\"grid-col-5 desktop:padding-2 padding-1 desktop:text-left text-center\" [innerHTML]=\"averageWaitTextHtml\"></div>\r\n    </div>\r\n\r\n    <div class=\"text-center display-flex flex-justify-center padding-2\">\r\n      <p>After we look at your documents, we will tell you how to<br> complete your validation.</p>\r\n    </div>\r\n  </div>\r\n\r\n  <div *ngIf=\"showWaitTimeDisclaimer\" class=\"margin-2 margin-left-5 display-flex flex-justify-center\">*This is an estimate of how many business days it will take us to respond. Business<br> days do not include weekends or U.S. federal holidays.</div>\r\n\r\n  <div class=\"sds-dialog-section--centered display-flex flex-justify-center\">\r\n    <button (click)=\"actionClick()\" class=\"usa-button usa-button--outline usa-button--active bg-base-lighter border-base-light\">Close</button>\r\n  </div>\r\n\r\n</div>", dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.IconComponent, selector: "usa-icon", inputs: ["icon", "rotate", "size", "classes", "skew"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: TimeWidgetModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'time-widget-modal', template: "<div class=\"grid-container\">\r\n  <div class=\"grid-row padding-bottom-1\">\r\n    <div class=\"grid-col width-full display-flex flex-justify-center\">\r\n      <usa-icon class=\"text-success\" [icon]=\"'check-circle'\" size=\"5x\"></usa-icon>\r\n    </div>\r\n  </div>\r\n\r\n  <div sds-dialog-title class=\"text-bold font-sans-lg sds-dialog-title text-center\">\r\n    Documentation Successfully Submitted\r\n  </div>\r\n\r\n  <div sds-dialog-content class=\"sds-dialog-content border border-base-light shadow-1\">\r\n    <div class=\"grid-row border-bottom border-base-light display-flex flex-justify-center\">\r\n      \r\n      <div class=\"desktop:grid-col text-center display-flex flex-justify-center \" *ngIf=\"data\">\r\n        <div class=\"padding-1 grid-col text-center\">\r\n          <div class=\"text-bold font-sans grid-row flex-justify-center\">Reference Number</div>\r\n          <div class=\"margin-top-1 text-bold font-sans-xl grid-row flex-justify-center\">{{data.fsdTicketNumber}}</div>\r\n        </div>\r\n      </div> \r\n\r\n      <div *ngIf=\"!data\" class=\"padding-1\">\r\n        <div class=\"desktop:grid-col\">\r\n          <div>Incident Information</div>\r\n          <div>is currently unavailable</div>\r\n        </div>\r\n      </div>\r\n\r\n      <!-- this is a line -->\r\n      <div class=\"desktop:sds-field desktop:border-base-light desktop:border-left desktop:padding-left-4 desktop:margin-y-1\"></div>\r\n      <div class=\"grid-col-5 desktop:padding-2 padding-1 desktop:text-left text-center\" [innerHTML]=\"averageWaitTextHtml\"></div>\r\n    </div>\r\n\r\n    <div class=\"text-center display-flex flex-justify-center padding-2\">\r\n      <p>After we look at your documents, we will tell you how to<br> complete your validation.</p>\r\n    </div>\r\n  </div>\r\n\r\n  <div *ngIf=\"showWaitTimeDisclaimer\" class=\"margin-2 margin-left-5 display-flex flex-justify-center\">*This is an estimate of how many business days it will take us to respond. Business<br> days do not include weekends or U.S. federal holidays.</div>\r\n\r\n  <div class=\"sds-dialog-section--centered display-flex flex-justify-center\">\r\n    <button (click)=\"actionClick()\" class=\"usa-button usa-button--outline usa-button--active bg-base-lighter border-base-light\">Close</button>\r\n  </div>\r\n\r\n</div>" }]
        }], ctorParameters: () => [{ type: AverageWaitTimeService }], propDecorators: { data: [{
                type: Input
            }], buffer: [{
                type: Input
            }], action: [{
                type: Output
            }] } });

class DocumentingTemplateSectionComponent extends FieldType {
    constructor() {
        super();
        this.FSDModalMode = FSDModalMode;
    }
    ngOnInit() {
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DocumentingTemplateSectionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: DocumentingTemplateSectionComponent, selector: "documenting-template-section", usesInheritance: true, ngImport: i0, template: "<div [class]=\"to.isFlagLabelsDisabled?'margin-bottom-3':'margin-left-8 margin-bottom-3'\">\r\n  <!--Template-->\r\n  <div *ngIf=\"to.documentingTemplate\" class=\"sds-card margin-left-2 margin-bottom-1\">\r\n    <div class=\"bg-accent-cool-lighter sds-card__header sds-card__header--left\">\r\n      <div class=\"font-sans-xs margin-bottom-0 padding-bottom-0 margin-top-0 padding-top-0\">YOUR LEGAL ENTITY</div>\r\n    </div>\r\n    <div class=\"sds-card__body\" [innerHTML]=\"to.documentingTemplate\">\r\n\r\n    </div>\r\n  </div>\r\n\r\n</div>", dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: DocumentingTemplateSectionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'documenting-template-section', template: "<div [class]=\"to.isFlagLabelsDisabled?'margin-bottom-3':'margin-left-8 margin-bottom-3'\">\r\n  <!--Template-->\r\n  <div *ngIf=\"to.documentingTemplate\" class=\"sds-card margin-left-2 margin-bottom-1\">\r\n    <div class=\"bg-accent-cool-lighter sds-card__header sds-card__header--left\">\r\n      <div class=\"font-sans-xs margin-bottom-0 padding-bottom-0 margin-top-0 padding-top-0\">YOUR LEGAL ENTITY</div>\r\n    </div>\r\n    <div class=\"sds-card__body\" [innerHTML]=\"to.documentingTemplate\">\r\n\r\n    </div>\r\n  </div>\r\n\r\n</div>" }]
        }], ctorParameters: () => [] });

class GenericFSDHelpStandaloneModule {
    static forRoot(config) {
        return {
            ngModule: GenericFSDHelpStandaloneModule,
            providers: [
                { provide: SystemConfigGenericHelp, useValue: config }
            ]
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericFSDHelpStandaloneModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: GenericFSDHelpStandaloneModule, declarations: [GenericFSDStandaloneComponent, DocumentingTemplateSectionComponent,
            ReviewOfficialDocumentationRequirementsComponent, DocumentSectionComponent, DocumentUploadComponent,
            GenericDocumentFSDModalComponent, SuccessFSDComponent, TimeWidgetModalComponent, SubmitUpdateSectionComponent,
            GenericFSDStandaloneModalComponent, FSDSearchListSectionComponentComponent], imports: [CommonModule,
            ReactiveFormsModule,
            SdsStepArrowModule,
            SdsFormlyModule,
            FormsModule, i1$4.FormlyModule, SdsToastModule,
            ErrorModelModule,
            IconModule,
            SdsPopoverModule, i1$2.NgxBootstrapIconsModule], exports: [GenericFSDStandaloneComponent, SuccessFSDComponent, TimeWidgetModalComponent, GenericFSDStandaloneModalComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericFSDHelpStandaloneModule, providers: [GenericFSDHelpService, GenericFSDHelpMockService], imports: [CommonModule,
            ReactiveFormsModule,
            SdsStepArrowModule,
            SdsFormlyModule,
            FormsModule,
            FormlyModule.forChild({
                types: [
                    { name: 'doc-template-section', component: DocumentingTemplateSectionComponent },
                    { name: 'review-docs', component: ReviewOfficialDocumentationRequirementsComponent },
                    { name: 'document-section', component: DocumentSectionComponent },
                    { name: 'document-upload', component: DocumentUploadComponent },
                    { name: 'submit-update-component', component: SubmitUpdateSectionComponent },
                    { name: 'search-list-section', component: FSDSearchListSectionComponentComponent },
                ],
            }),
            SdsToastModule,
            ErrorModelModule,
            IconModule,
            SdsPopoverModule,
            NgxBootstrapIconsModule.pick({ dashCircle, hourglass, alertError, alertWarning, slashCircle, check, circle, checkSquareFill, checkCircle, circleFill, trash, pencilSquare })] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericFSDHelpStandaloneModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        GenericFSDStandaloneComponent, DocumentingTemplateSectionComponent,
                        ReviewOfficialDocumentationRequirementsComponent, DocumentSectionComponent, DocumentUploadComponent,
                        GenericDocumentFSDModalComponent, SuccessFSDComponent, TimeWidgetModalComponent, SubmitUpdateSectionComponent,
                        GenericFSDStandaloneModalComponent, FSDSearchListSectionComponentComponent
                    ],
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        SdsStepArrowModule,
                        SdsFormlyModule,
                        FormsModule,
                        FormlyModule.forChild({
                            types: [
                                { name: 'doc-template-section', component: DocumentingTemplateSectionComponent },
                                { name: 'review-docs', component: ReviewOfficialDocumentationRequirementsComponent },
                                { name: 'document-section', component: DocumentSectionComponent },
                                { name: 'document-upload', component: DocumentUploadComponent },
                                { name: 'submit-update-component', component: SubmitUpdateSectionComponent },
                                { name: 'search-list-section', component: FSDSearchListSectionComponentComponent },
                            ],
                        }),
                        SdsToastModule,
                        ErrorModelModule,
                        IconModule,
                        SdsPopoverModule,
                        NgxBootstrapIconsModule.pick({ dashCircle, hourglass, alertError, alertWarning, slashCircle, check, circle, checkSquareFill, checkCircle, circleFill, trash, pencilSquare }),
                    ],
                    exports: [
                        GenericFSDStandaloneComponent, SuccessFSDComponent, TimeWidgetModalComponent, GenericFSDStandaloneModalComponent
                    ],
                    providers: [GenericFSDHelpService, GenericFSDHelpMockService],
                }]
        }] });

class EnviromentConfig {
}

class GenericIncidentEscalationService {
    constructor(http, authService, environment) {
        this.http = http;
        this.authService = authService;
        this.environment = environment;
    }
    saveEscalation(ticketId, request) {
        this.loggedIn();
        const url = `${this.environment.API_UMBRELLA_URL}/escalation/create?ticketId=${ticketId}`;
        return this.http.post(url, request, this._options());
    }
    getEscalationReason() {
        this.loggedIn();
        const url = `${this.environment.API_UMBRELLA_URL}/escalation/reasons/`;
        let op = this._options();
        return this.http.get(url, op);
    }
    loggedIn() {
        if (!this.authService.isLoggedIn()) {
            throw new Error('Must be authenticated');
        }
    }
    _options() {
        const params = {};
        return {
            headers: {
                'X-Auth-Token': this.authService.authToken()
            },
            params: params
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericIncidentEscalationService, deps: [{ token: i1.HttpClient }, { token: AuthService }, { token: EnviromentConfig }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericIncidentEscalationService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericIncidentEscalationService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: AuthService }, { type: EnviromentConfig, decorators: [{
                    type: Inject,
                    args: [EnviromentConfig]
                }] }] });
class GenericIncidentEscalationMockService {
    saveEscalation(ticketId, request) {
        console.log('saveEscalation');
        console.log(ticketId);
        console.log(request);
        return of('');
    }
    getEscalationReason() {
        const reasons = [];
        reasons.push({ escalationReason: 'Reason1', escalationReasonId: '1' });
        reasons.push({ escalationReason: 'Reason2', escalationReasonId: '2' });
        reasons.push({ escalationReason: 'Reason3', escalationReasonId: '3' });
        reasons.push({ escalationReason: 'Reason4', escalationReasonId: '4' });
        return of(reasons);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericIncidentEscalationMockService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericIncidentEscalationMockService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericIncidentEscalationMockService, decorators: [{
            type: Injectable
        }] });
class EscalationRequest {
}
class EscalationReason {
}

class IncidentEscalationComponent {
    constructor(dialog, config, toastr, genericIncidentEscalationService, dialogRef) {
        this.dialog = dialog;
        this.config = config;
        this.toastr = toastr;
        this.genericIncidentEscalationService = genericIncidentEscalationService;
        this.dialogRef = dialogRef;
        this.closeAction = new EventEmitter();
        this.model = { isFollowed: true };
        this.keyPair = [];
        this.fields = [
            {
                key: 'escalationReasonId',
                type: 'select',
                props: {
                    label: 'Primary Reason',
                    required: true,
                    options: this.keyPair
                }
            },
            {
                key: 'isFollowed',
                type: 'checkbox',
                props: {
                    label: 'Follow Incident',
                    hideOptional: true,
                },
            },
            {
                key: 'escalationNotes',
                type: 'textarea',
                props: {
                    label: 'Notes',
                    placeholder: '',
                    description: 'If necessary, please enter any additional information.',
                    required: false,
                    maxLength: 500
                },
            }
        ];
        this.form = new FormGroup({});
        this.options = {};
    }
    ngOnInit() {
        this.model = { isFollowed: true };
        if (this.config.serviceOverride) {
            this.service = this.config.serviceOverride;
        }
        else {
            this.service = this.genericIncidentEscalationService;
        }
        this.service.getEscalationReason().subscribe((reasons) => {
            const keyPair = [];
            for (let i = 0; i < reasons.length; i++) {
                const reason = reasons[i];
                keyPair.push({
                    value: reason.escalationReasonId,
                    label: reason.escalationReason
                });
            }
            const field = this.getField('escalationReasonId', this.fields);
            field.props.options = keyPair;
        }, err => {
            console.error(err);
            this.openErrorModal();
        });
    }
    onModelChange(event) {
    }
    submit() {
        this.service.saveEscalation(this.config.ticketId, this.model).subscribe((data) => {
            this.toastr.success('Escalated');
            this.dialogRef.close();
            this.closeAction.emit({});
        }, err => {
            console.error(err);
            this.openErrorModal();
        });
    }
    cancel() {
        this.dialogRef.close();
        this.closeAction.emit({});
    }
    getField(key, fields) {
        for (let i = 0, len = fields.length; i < len; i++) {
            const f = fields[i];
            if (f.key === key) {
                return f;
            }
            if (f.fieldGroup && !f.key) {
                const cf = this.getField(key, f.fieldGroup);
                if (cf) {
                    return cf;
                }
            }
        }
    }
    openErrorModal() {
        const errorDialog = this.dialog.open(ErrorModalComponent, {
            alert: 'error',
            width: 'Small',
            data: {},
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: IncidentEscalationComponent, deps: [{ token: i1$1.SdsDialogService }, { token: SDS_DIALOG_DATA }, { token: i2$3.ToastrService }, { token: GenericIncidentEscalationMockService }, { token: i1$1.SdsDialogRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: IncidentEscalationComponent, selector: "incident-escalation.component", outputs: { closeAction: "closeAction" }, ngImport: i0, template: "  <h2>Escalate Incident</h2>\r\n\r\n  <form [formGroup]=\"form\">\r\n    <formly-form (modelChange)=\"onModelChange($event)\" [(model)]=\"model\" [(fields)]=\"fields\" [options]=\"options\"\r\n      [form]=\"form\"></formly-form>\r\n  </form>\r\n  <div class=\"grid-container padding-0 padding-bottom-1\">\r\n    <div class=\"grid-row flex-column flex-align-end\">\r\n      <div class=\"grid-col flex-fill\">\r\n        <div class=\"\">\r\n          <button (click)=\"cancel()\" class=\"pos-right usa-button usa-button--base bg-base-lighter\">Cancel</button>\r\n          <button [disabled]=\"form.invalid\" (click)=\"submit()\" class=\"pos-right usa-button\">Submit</button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>", dependencies: [{ kind: "directive", type: i4.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i4.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i4.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: i1$4.FormlyForm, selector: "formly-form", inputs: ["form", "model", "fields", "options"], outputs: ["modelChange"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: IncidentEscalationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'incident-escalation.component', template: "  <h2>Escalate Incident</h2>\r\n\r\n  <form [formGroup]=\"form\">\r\n    <formly-form (modelChange)=\"onModelChange($event)\" [(model)]=\"model\" [(fields)]=\"fields\" [options]=\"options\"\r\n      [form]=\"form\"></formly-form>\r\n  </form>\r\n  <div class=\"grid-container padding-0 padding-bottom-1\">\r\n    <div class=\"grid-row flex-column flex-align-end\">\r\n      <div class=\"grid-col flex-fill\">\r\n        <div class=\"\">\r\n          <button (click)=\"cancel()\" class=\"pos-right usa-button usa-button--base bg-base-lighter\">Cancel</button>\r\n          <button [disabled]=\"form.invalid\" (click)=\"submit()\" class=\"pos-right usa-button\">Submit</button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>" }]
        }], ctorParameters: () => [{ type: i1$1.SdsDialogService }, { type: IncidentEscalationModel, decorators: [{
                    type: Inject,
                    args: [SDS_DIALOG_DATA]
                }] }, { type: i2$3.ToastrService }, { type: GenericIncidentEscalationMockService }, { type: i1$1.SdsDialogRef }], propDecorators: { closeAction: [{
                type: Output
            }] } });
class IncidentEscalationModel {
}

class GenericIncidentEscalationHelperService {
    constructor(dialog) {
        this.dialog = dialog;
    }
    openEscalationModal(incidentEscalationModel) {
        this.openedDialogRef = this.dialog.open(IncidentEscalationComponent, {
            hasBackdrop: true,
            displayCloseBtn: false,
            width: 'medium',
            height: 'large',
            data: incidentEscalationModel
        });
        return this.openedDialogRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericIncidentEscalationHelperService, deps: [{ token: i1$1.SdsDialogService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericIncidentEscalationHelperService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericIncidentEscalationHelperService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1$1.SdsDialogService }] });

class IncidentEscalationModalComponent {
    constructor(dialog, toastr, genericIncidentEscalationHelperService) {
        this.dialog = dialog;
        this.toastr = toastr;
        this.genericIncidentEscalationHelperService = genericIncidentEscalationHelperService;
    }
    buttonClicked() {
        if (!this.openedDialogRef) {
            this.openedDialogRef = this.genericIncidentEscalationHelperService.openEscalationModal(this.config);
        }
        else {
            this.onCloseSlideOut();
        }
    }
    onCloseSlideOut() {
        this.openedDialogRef.close();
        this.openedDialogRef = null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: IncidentEscalationModalComponent, deps: [{ token: i1$1.SdsDialogService }, { token: i2$3.ToastrService }, { token: GenericIncidentEscalationHelperService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: IncidentEscalationModalComponent, selector: "incident-escalation-modal", inputs: { config: "config" }, ngImport: i0, template: "<button\r\n  [class]=\"!openedDialogRef ? 'usa-button usa-button--outline usa-button bg-primary-lighter':'usa-button usa-button--outline usa-button bg-primary-lighter usa-button--active' \"\r\n  (click)=\"buttonClicked()\" [disabled]=\"config.isButtonDisabled\">\r\n  <span>Escalate</span>\r\n</button>" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: IncidentEscalationModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'incident-escalation-modal', template: "<button\r\n  [class]=\"!openedDialogRef ? 'usa-button usa-button--outline usa-button bg-primary-lighter':'usa-button usa-button--outline usa-button bg-primary-lighter usa-button--active' \"\r\n  (click)=\"buttonClicked()\" [disabled]=\"config.isButtonDisabled\">\r\n  <span>Escalate</span>\r\n</button>" }]
        }], ctorParameters: () => [{ type: i1$1.SdsDialogService }, { type: i2$3.ToastrService }, { type: GenericIncidentEscalationHelperService }], propDecorators: { config: [{
                type: Input
            }] } });

class IncidentEscalationModule {
    static forRoot(config) {
        return {
            ngModule: IncidentEscalationModule,
            providers: [
                { provide: EnviromentConfig, useValue: config }
            ]
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: IncidentEscalationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: IncidentEscalationModule, declarations: [IncidentEscalationModalComponent,
            IncidentEscalationComponent], imports: [CommonModule,
            FormsModule,
            ReactiveFormsModule, i1$4.FormlyModule, SdsFormlyModule,
            SdsToastModule, i2$3.ToastrModule, IconModule,
            HttpClientModule,
            ErrorModelModule, i1$2.NgxBootstrapIconsModule], exports: [IncidentEscalationModalComponent, IncidentEscalationComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: IncidentEscalationModule, providers: [GenericIncidentEscalationHelperService, GenericIncidentEscalationMockService, GenericIncidentEscalationService, ToastrService], imports: [CommonModule,
            FormsModule,
            ReactiveFormsModule,
            FormlyModule.forChild({
                wrappers: [],
            }),
            SdsFormlyModule,
            SdsToastModule,
            ToastrModule.forRoot(SdsToastSettings),
            IconModule,
            HttpClientModule,
            ErrorModelModule,
            NgxBootstrapIconsModule.pick({ chevronDown, chevronUp, chatLeftDots })] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: IncidentEscalationModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        IncidentEscalationModalComponent,
                        IncidentEscalationComponent
                    ],
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        FormlyModule.forChild({
                            wrappers: [],
                        }),
                        SdsFormlyModule,
                        SdsToastModule,
                        ToastrModule.forRoot(SdsToastSettings),
                        IconModule,
                        HttpClientModule,
                        ErrorModelModule,
                        NgxBootstrapIconsModule.pick({ chevronDown, chevronUp, chatLeftDots }),
                    ],
                    exports: [
                        IncidentEscalationModalComponent, IncidentEscalationComponent
                    ],
                    providers: [GenericIncidentEscalationHelperService, GenericIncidentEscalationMockService, GenericIncidentEscalationService, ToastrService]
                }]
        }] });

class SharedSystemConfig {
}

class TextBubbleComponent {
    constructor() {
        this.position = new BubblePosition();
        this.offsetTop = 0;
        this.offsetLeft = 0;
        this.expanded = false;
        this.bubbleStyle = '';
    }
    getExpandedClass() {
        if (this.bubbleDirection == BubbleDirection.TOP) {
            this.bubbleStyle = 'left: -38px';
            return "bubbleItem bubbleItem-expanded top";
        }
        else if (this.bubbleDirection == BubbleDirection.LEFT) {
            this.bubbleStyle = 'left: 200px; top:-17px';
            return "bubbleItem bubbleItem-expanded left";
        }
        else if (this.bubbleDirection == BubbleDirection.RIGHT) {
            this.bubbleStyle = 'left: -280px; top:-17px';
            return "bubbleItem bubbleItem-expanded right";
        }
        else if (this.bubbleDirection == BubbleDirection.BOTTOM) {
            this.bubbleStyle = 'left: -38px; top: -270px';
            return "bubbleItem bubbleItem-expanded bottom";
        }
        else {
            return "bubbleItem bubbleItem-expanded top";
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: TextBubbleComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: TextBubbleComponent, selector: "textBubble", inputs: { parentComponent: "parentComponent", page: "page", expanded: "expanded", bubbleDirection: "bubbleDirection" }, queries: [{ propertyName: "actionElement", first: true, predicate: ["actionElement"], descendants: true }, { propertyName: "bubbleContent", first: true, predicate: ["bubbleContent"], descendants: true }, { propertyName: "bubbleFooter", first: true, predicate: ["bubbleFooter"], descendants: true }, { propertyName: "textBubble", first: true, predicate: ["textBubble"], descendants: true }], ngImport: i0, template: "<div class=\"bubbleParent\">\r\n  <ng-container *ngTemplateOutlet=\"actionElement\">\r\n\r\n  </ng-container>\r\n  <div [class]=\"expanded? getExpandedClass() : 'bubbleItem' \" [style]=\"bubbleStyle\" class=\"radius-lg \">\r\n    <div class=\"\">\r\n      <ng-container *ngTemplateOutlet=\"bubbleContent\">\r\n\r\n      </ng-container>\r\n    </div>\r\n    <div class=\"bubbleFooter margin-top-1 margin-bottom-1\">\r\n      <ng-container *ngTemplateOutlet=\"bubbleFooter\">\r\n\r\n      </ng-container>\r\n    </div>\r\n  </div>\r\n</div>", styles: [".bubbleParent{position:relative}.bubbleParent .bubbleItem{visibility:hidden;text-align:center;padding:5px 0;position:absolute;z-index:100;margin-left:-145px;max-width:400px;min-height:150px;width:400px;background-color:#fff;box-shadow:0 0 24px #00000057}.bubbleItem-expanded{visibility:visible!important}.bubbleItem.top{margin-top:25px}.bubbleItem:after{content:\"\";border:20px solid transparent;position:absolute;z-index:100}.bottom.bubbleItem:after{border-top-color:#fff;border-bottom:0;color:#f5f5f0;bottom:-20px;left:50%;margin-left:-20px;z-index:100}.top.bubbleItem:after{border-bottom-color:#fff;border-top:0;top:-20px;left:50%;margin-left:-20px;z-index:100}.left.bubbleItem:after{border-right-color:#fff;border-left:0;left:-20px;top:34px;margin-top:-20px}.right.bubbleItem:after{border-left-color:#fff;border-right:0;right:-20px;top:34px;margin-top:-20px}.bubbleFooter{background:#f5f5f0}\n"], dependencies: [{ kind: "directive", type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: TextBubbleComponent, decorators: [{
            type: Component,
            args: [{ selector: "textBubble", template: "<div class=\"bubbleParent\">\r\n  <ng-container *ngTemplateOutlet=\"actionElement\">\r\n\r\n  </ng-container>\r\n  <div [class]=\"expanded? getExpandedClass() : 'bubbleItem' \" [style]=\"bubbleStyle\" class=\"radius-lg \">\r\n    <div class=\"\">\r\n      <ng-container *ngTemplateOutlet=\"bubbleContent\">\r\n\r\n      </ng-container>\r\n    </div>\r\n    <div class=\"bubbleFooter margin-top-1 margin-bottom-1\">\r\n      <ng-container *ngTemplateOutlet=\"bubbleFooter\">\r\n\r\n      </ng-container>\r\n    </div>\r\n  </div>\r\n</div>", styles: [".bubbleParent{position:relative}.bubbleParent .bubbleItem{visibility:hidden;text-align:center;padding:5px 0;position:absolute;z-index:100;margin-left:-145px;max-width:400px;min-height:150px;width:400px;background-color:#fff;box-shadow:0 0 24px #00000057}.bubbleItem-expanded{visibility:visible!important}.bubbleItem.top{margin-top:25px}.bubbleItem:after{content:\"\";border:20px solid transparent;position:absolute;z-index:100}.bottom.bubbleItem:after{border-top-color:#fff;border-bottom:0;color:#f5f5f0;bottom:-20px;left:50%;margin-left:-20px;z-index:100}.top.bubbleItem:after{border-bottom-color:#fff;border-top:0;top:-20px;left:50%;margin-left:-20px;z-index:100}.left.bubbleItem:after{border-right-color:#fff;border-left:0;left:-20px;top:34px;margin-top:-20px}.right.bubbleItem:after{border-left-color:#fff;border-right:0;right:-20px;top:34px;margin-top:-20px}.bubbleFooter{background:#f5f5f0}\n"] }]
        }], propDecorators: { parentComponent: [{
                type: Input
            }], page: [{
                type: Input
            }], actionElement: [{
                type: ContentChild,
                args: ['actionElement']
            }], bubbleContent: [{
                type: ContentChild,
                args: ['bubbleContent']
            }], bubbleFooter: [{
                type: ContentChild,
                args: ['bubbleFooter']
            }], textBubble: [{
                type: ContentChild,
                args: ['textBubble']
            }], expanded: [{
                type: Input
            }], bubbleDirection: [{
                type: Input
            }] } });
class BubblePosition {
}
var BubbleDirection;
(function (BubbleDirection) {
    BubbleDirection[BubbleDirection["BOTTOM"] = 0] = "BOTTOM";
    BubbleDirection[BubbleDirection["LEFT"] = 1] = "LEFT";
    BubbleDirection[BubbleDirection["RIGHT"] = 2] = "RIGHT";
    BubbleDirection[BubbleDirection["TOP"] = 3] = "TOP";
})(BubbleDirection || (BubbleDirection = {}));

class TextBubbleModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: TextBubbleModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: TextBubbleModule, declarations: [TextBubbleComponent], imports: [CommonModule], exports: [TextBubbleComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: TextBubbleModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: TextBubbleModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [TextBubbleComponent],
                    providers: [],
                    exports: [TextBubbleComponent]
                }]
        }] });

class SpotlightService {
    constructor(http, authService, environment) {
        this.http = http;
        this.authService = authService;
        this.environment = environment;
        this.spotlightSesssionStorageKey = 'spotlightSeen';
        this.seenSpotlightIds = [];
        const tempStroage = localStorage.getItem(this.spotlightSesssionStorageKey);
        if (tempStroage) {
            this.seenSpotlightIds = tempStroage.split(',');
        }
    }
    checkSeenCache(spotlightId) {
        if (this.seenSpotlightIds.indexOf(spotlightId) !== -1) {
            return true;
        }
    }
    saveSeenCache(spotlightId) {
        if (this.seenSpotlightIds.indexOf(spotlightId) === -1) {
            this.seenSpotlightIds.push(spotlightId);
            localStorage.setItem(this.spotlightSesssionStorageKey, this.seenSpotlightIds.join(','));
        }
    }
    getSeen(spotlightId) {
        this.loggedIn();
        const url = `${this.environment.API_UMBRELLA_URL}/spotlight/v1/spotlight/seen/?id=${spotlightId}`;
        const op = this._options();
        return this.http.get(url, op);
    }
    saveSeen(spotlightId) {
        this.loggedIn();
        const url = `${this.environment.API_UMBRELLA_URL}/spotlight/v1/spotlight/seen/`;
        const arg = {
            "spotlightId": spotlightId
        };
        return this.http.post(url, arg, this._options());
    }
    getFeedback(spotlightId) {
        this.loggedIn();
        const url = `${this.environment.API_UMBRELLA_URL}/spotlight/v1/spotlight/feedback/?id=${spotlightId}`;
        const op = this._options();
        return this.http.get(url, op);
    }
    saveFeedback(spotlightId, feedbackId) {
        this.loggedIn();
        const url = `${this.environment.API_UMBRELLA_URL}/spotlight/v1/spotlight/feedback/`;
        const arg = {
            "spotlightId": spotlightId,
            "statusId": feedbackId
        };
        return this.http.post(url, arg, this._options());
    }
    getSpotlight(spotlightId) {
        const url = `${this.environment.API_UMBRELLA_URL}/spotlight/v1/spotlight/?id=${spotlightId}`;
        const op = this._options();
        return this.http.get(url, op);
    }
    _options() {
        const params = {};
        return {
            headers: {
                'X-Auth-Token': this.authService.authToken()
            },
            params: params
        };
    }
    loggedIn() {
        if (!this.authService.isLoggedIn()) {
            throw new Error('Must be authenticated');
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SpotlightService, deps: [{ token: i1.HttpClient }, { token: AuthService }, { token: SharedSystemConfig }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SpotlightService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SpotlightService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: AuthService }, { type: SharedSystemConfig, decorators: [{
                    type: Inject,
                    args: [SharedSystemConfig]
                }] }] });
class SpotlightServiceMock {
    constructor() {
        this.spotlights = {};
        this.feedback = {};
        this.seen = {};
        this.spotlightSesssionStorageKey = 'spotlightSeen';
        this.seenSpotlightIds = [];
        for (let i = 0; i < 8; i++) {
            const iToString = i.toString();
            this.spotlights[iToString] = {
                spotlightId: iToString,
                content: iToString + ' American kestrel is the smallest raptor in America. It  has three basic vocalizations – the "klee" or "killy", the "whine"',
                imageLocation: 'https://www.allaboutbirds.org/guide/assets/photo/302366931-480px.jpg'
            };
            const seen = i < 4;
            this.seen[iToString] = { exist: seen };
            const feedback = i % 4;
            this.feedback[iToString] = { statusId: feedback };
        }
        const tempStroage = localStorage.getItem(this.spotlightSesssionStorageKey);
        if (tempStroage) {
            this.seenSpotlightIds = tempStroage.split(',');
        }
    }
    checkSeenCache(spotlightId) {
        if (this.seenSpotlightIds.indexOf(spotlightId) !== -1) {
            return true;
        }
    }
    saveSeenCache(spotlightId) {
        if (this.seenSpotlightIds.indexOf(spotlightId) === -1) {
            this.seenSpotlightIds.push(spotlightId);
            localStorage.setItem(this.spotlightSesssionStorageKey, this.seenSpotlightIds.join(','));
        }
    }
    getSeen(spotlightId) {
        console.log("Saving Seen of " + spotlightId);
        return of(this.seen[spotlightId]);
    }
    saveSeen(spotlightId) {
        console.log("Save Seen API of " + spotlightId);
        this.seen[spotlightId] = { exist: true };
        return of({});
    }
    getFeedback(spotlightId) {
        console.log("Get feedback API of " + spotlightId);
        return of(this.feedback[spotlightId]);
    }
    saveFeedback(spotlightId, feedbackId) {
        console.log("Saving feedback of " + spotlightId);
        this.feedback[spotlightId] = { statusId: feedbackId };
        return of({});
    }
    getSpotlight(spotlightId) {
        return of(this.spotlights[spotlightId]);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SpotlightServiceMock, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SpotlightServiceMock }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SpotlightServiceMock, decorators: [{
            type: Injectable
        }], ctorParameters: () => [] });
class SpotlightSeen {
}
class SpotlightFeedback {
}
class Spotlight {
}

class SpotlightComponent {
    constructor(spotlightServiceMock, spotlightService, authService, el) {
        this.spotlightServiceMock = spotlightServiceMock;
        this.spotlightService = spotlightService;
        this.authService = authService;
        this.el = el;
        this.loggedIn = false;
        this.spotlightId = '';
        this.expanded = false;
        this.feedbackValue = FeedbackStatus.UNSELECTED;
        this.spotlight = new Spotlight();
    }
    ngOnInit() {
        this.loggedIn = this.authService.isLoggedIn();
    }
    calculateAndSetDirection() {
        console.log("spotlightId:" + this.spotlightId);
        const pos = this.el.nativeElement.getBoundingClientRect();
        console.log(pos);
        if (pos.left < 100) {
            console.log('To close to left side');
            if (pos.top < 100) {
                console.log('Left < and Top < Diagram 1');
            }
            else {
                if (pos.bottom < 100) {
                    console.log('Left < and Bottom < Diagram 7');
                }
                else {
                    console.log('Left <  < Diagram 4');
                }
            }
        }
        else if (pos.right < 100) {
            console.log('to close to right');
            if (pos.top < 100) {
                console.log('Right < and Top < Diagram 3');
            }
            else {
                if (pos.bottom < 100) {
                    console.log('Right < and Bottom < Diagram 9');
                }
                else {
                    console.log('Right <  < Diagram 6');
                }
            }
        }
        else if (pos.top < 100) {
            console.log('Top < Diagram 2');
        }
        else if (pos.bottom < 100) {
            console.log('bottom < Diagram 8');
        }
        else {
            console.log('Swiss  Diagram 5');
        }
    }
    ngAfterViewInit() {
        // this.calculateAndSetDirection();
        this.service = this.spotlightService;
        if (this.debug) {
            console.log('debug');
            this.service = this.spotlightServiceMock;
        }
        this.service.getSpotlight(this.spotlightId)
            .subscribe(val => {
            this.spotlight = val;
        });
        if (this.service.checkSeenCache(this.spotlightId)) {
            this.expanded = false;
        }
        else {
            if (this.loggedIn) {
                this.service.getSeen(this.spotlightId).subscribe(val => {
                    console.log(val);
                    if (val) {
                        if (val.seen) {
                            this.expanded = false;
                            this.populateSeen();
                        }
                        else {
                            this.expanded = true;
                        }
                    }
                });
            }
            else {
                this.expanded = true;
            }
        }
        if (this.loggedIn) {
            this.service.getFeedback(this.spotlightId).subscribe(val => {
                if (val) {
                    if (val.statusId) {
                        this.feedbackValue = parseInt(val.statusId);
                    }
                }
            });
        }
    }
    toggleSpotlight(e) {
        e.stopPropagation();
        if (this.expanded) {
            this.saveFeedback();
            this.saveSeen();
        }
        this.expanded = !this.expanded;
    }
    close(e) {
        e.stopPropagation();
        this.saveFeedback();
        this.saveSeen();
        this.expanded = false;
    }
    populateSeen() {
        this.service.saveSeenCache(this.spotlightId);
    }
    saveSeen() {
        if (this.loggedIn) {
            this.service.saveSeen(this.spotlightId).subscribe(val => {
                console.log(val);
            });
        }
        this.populateSeen();
    }
    saveFeedback() {
        if (this.feedbackValue !== FeedbackStatus.UNSELECTED && this.loggedIn) {
            this.service.saveFeedback(this.spotlightId, this.feedbackValue.toString()).subscribe(val => {
                console.log(val);
            });
        }
    }
    selectFeedBack(e, feedback) {
        e.stopPropagation();
        this.feedbackValue = feedback;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SpotlightComponent, deps: [{ token: SpotlightServiceMock }, { token: SpotlightService }, { token: AuthService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: SpotlightComponent, selector: "spotlightComponent", inputs: { bubbleDirection: "bubbleDirection" }, viewQueries: [{ propertyName: "iconButton", first: true, predicate: ["iconButton"], descendants: true }, { propertyName: "textBubble", first: true, predicate: ["textBubble"], descendants: true }], ngImport: i0, template: "<textBubble #textBubble [expanded]=\"expanded\" [bubbleDirection]=\"bubbleDirection\" [parentComponent]=\"template\">\r\n    <ng-template #actionElement>\r\n        <button (click)=\"toggleSpotlight($event)\"\r\n            class=\"usa-button sds-button--circle bg-white buttonColor usa-button--active m margin-1\" #iconButton>\r\n            <usa-icon [icon]=\"'lightbulb'\" [size]=\"'x'\" class=\"iconColor\">\r\n                <div class=\"usa-sr-only\">Feature Spotlight</div>\r\n            </usa-icon>\r\n        </button>\r\n    </ng-template>\r\n    <ng-template #bubbleContent>\r\n        <div class=\"grid-container\">\r\n            <div class=\"grid-row\">\r\n                <div class=\"tablet:grid-col\">\r\n                    <div class=\"text-right\">\r\n                        <button class=\"usa-button usa-button--unstyled\" (click)=\"close($event)\">\r\n                            <usa-icon [icon]=\"'x'\" [size]=\"'2x'\" class=\" text-black iconHover\">\r\n                                <div class=\"usa-sr-only\">close</div>\r\n                            </usa-icon>\r\n                        </button>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class=\" grid-row\">\r\n                <div class=\"tablet:grid-col\">\r\n                    <div class=\"text-left\">\r\n                        {{spotlight.content}}\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div *ngIf=\"spotlight.imageLocation\" class=\"grid-row grid-row padding-top-1 grid-row padding-bottom-1\">\r\n                <div class=\"tablet:grid-col\">\r\n                    <div class=\"text-left\">\r\n                        <img [src]=\"spotlight.imageLocation\" alt=\"Image of component for the help text\"\r\n                            width=\"190px\" />\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class=\"grid-row padding-bottom-1\">\r\n                <div class=\"tablet:grid-col\">\r\n                    <div class=\"text-right\">\r\n                        <button class=\"usa-button usa-button--secondary usa-button--small\" (click)=\"close($event)\">\r\n                            Got it\r\n                        </button>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </ng-template>\r\n    <ng-template #bubbleFooter *ngIf=\"loggedIn\">\r\n        <div class=\"grid-container padding-bottom-1 padding-top-1\">\r\n            <div class=\"grid-row\">\r\n                <div class=\"tablet:grid-col\">\r\n                    <div class=\"text-blue padding-top-1\">\r\n                        Did you find this helpful?\r\n                    </div>\r\n                </div>\r\n                <div class=\"tablet:grid-col\">\r\n                    <button (click)=\"selectFeedBack($event,3)\"\r\n                        [class]=\" feedbackValue !== 3 ?'usa-button usa-button--unstyled sds-button--circle margin-left-2  bg-white':'usa-button usa-button--unstyled sds-button--circle margin-left-2 usa-focus bg-white'\">\r\n                        <usa-icon class=\"text-red \" [icon]=\"'emojiFrown'\" [size]=\"'2x'\">\r\n                            <div class=\"usa-sr-only\">Unsatisfied</div>\r\n                        </usa-icon>\r\n                    </button>\r\n                    <button (click)=\"selectFeedBack($event,2)\"\r\n                        [class]=\" feedbackValue !== 2 ?'usa-button usa-button--unstyled sds-button--circle margin-left-2  bg-white':'usa-button usa-button--unstyled sds-button--circle margin-left-2 usa-focus  bg-white'\">\r\n                        <usa-icon class=\"text-gold\" [icon]=\"'emojiNeutral'\" [size]=\"'2x'\">\r\n                            <div class=\"usa-sr-only\">Neutral</div>\r\n                        </usa-icon>\r\n                    </button>\r\n                    <button (click)=\"selectFeedBack($event,1)\"\r\n                        [class]=\" feedbackValue !== 1 ?'usa-button usa-button--unstyled sds-button--circle margin-left-2  bg-white':'usa-button usa-button--unstyled sds-button--circle margin-left-2 usa-focus  bg-white'\">\r\n                        <usa-icon class=\"text-mint\" [icon]=\"'emojiSmile'\" [size]=\"'2x'\">\r\n                            <div class=\"usa-sr-only\">Satisfied</div>\r\n                        </usa-icon>\r\n                    </button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </ng-template>\r\n</textBubble>", styles: [".parentClass{position:relative}.parentClass .tooltiptext{visibility:hidden;width:120px;background-color:#000;color:#fff;text-align:center;border-radius:6px;padding:5px 0;position:absolute;z-index:1;margin-left:-45px}.parentClass:hover .tooltiptext{visibility:visible}.iconHover:hover{cursor:pointer}.buttonColor{border-color:#00bde3}.iconColor{color:#00bde3}\n"], dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.IconComponent, selector: "usa-icon", inputs: ["icon", "rotate", "size", "classes", "skew"] }, { kind: "component", type: TextBubbleComponent, selector: "textBubble", inputs: ["parentComponent", "page", "expanded", "bubbleDirection"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SpotlightComponent, decorators: [{
            type: Component,
            args: [{ selector: "spotlightComponent", template: "<textBubble #textBubble [expanded]=\"expanded\" [bubbleDirection]=\"bubbleDirection\" [parentComponent]=\"template\">\r\n    <ng-template #actionElement>\r\n        <button (click)=\"toggleSpotlight($event)\"\r\n            class=\"usa-button sds-button--circle bg-white buttonColor usa-button--active m margin-1\" #iconButton>\r\n            <usa-icon [icon]=\"'lightbulb'\" [size]=\"'x'\" class=\"iconColor\">\r\n                <div class=\"usa-sr-only\">Feature Spotlight</div>\r\n            </usa-icon>\r\n        </button>\r\n    </ng-template>\r\n    <ng-template #bubbleContent>\r\n        <div class=\"grid-container\">\r\n            <div class=\"grid-row\">\r\n                <div class=\"tablet:grid-col\">\r\n                    <div class=\"text-right\">\r\n                        <button class=\"usa-button usa-button--unstyled\" (click)=\"close($event)\">\r\n                            <usa-icon [icon]=\"'x'\" [size]=\"'2x'\" class=\" text-black iconHover\">\r\n                                <div class=\"usa-sr-only\">close</div>\r\n                            </usa-icon>\r\n                        </button>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class=\" grid-row\">\r\n                <div class=\"tablet:grid-col\">\r\n                    <div class=\"text-left\">\r\n                        {{spotlight.content}}\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div *ngIf=\"spotlight.imageLocation\" class=\"grid-row grid-row padding-top-1 grid-row padding-bottom-1\">\r\n                <div class=\"tablet:grid-col\">\r\n                    <div class=\"text-left\">\r\n                        <img [src]=\"spotlight.imageLocation\" alt=\"Image of component for the help text\"\r\n                            width=\"190px\" />\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class=\"grid-row padding-bottom-1\">\r\n                <div class=\"tablet:grid-col\">\r\n                    <div class=\"text-right\">\r\n                        <button class=\"usa-button usa-button--secondary usa-button--small\" (click)=\"close($event)\">\r\n                            Got it\r\n                        </button>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </ng-template>\r\n    <ng-template #bubbleFooter *ngIf=\"loggedIn\">\r\n        <div class=\"grid-container padding-bottom-1 padding-top-1\">\r\n            <div class=\"grid-row\">\r\n                <div class=\"tablet:grid-col\">\r\n                    <div class=\"text-blue padding-top-1\">\r\n                        Did you find this helpful?\r\n                    </div>\r\n                </div>\r\n                <div class=\"tablet:grid-col\">\r\n                    <button (click)=\"selectFeedBack($event,3)\"\r\n                        [class]=\" feedbackValue !== 3 ?'usa-button usa-button--unstyled sds-button--circle margin-left-2  bg-white':'usa-button usa-button--unstyled sds-button--circle margin-left-2 usa-focus bg-white'\">\r\n                        <usa-icon class=\"text-red \" [icon]=\"'emojiFrown'\" [size]=\"'2x'\">\r\n                            <div class=\"usa-sr-only\">Unsatisfied</div>\r\n                        </usa-icon>\r\n                    </button>\r\n                    <button (click)=\"selectFeedBack($event,2)\"\r\n                        [class]=\" feedbackValue !== 2 ?'usa-button usa-button--unstyled sds-button--circle margin-left-2  bg-white':'usa-button usa-button--unstyled sds-button--circle margin-left-2 usa-focus  bg-white'\">\r\n                        <usa-icon class=\"text-gold\" [icon]=\"'emojiNeutral'\" [size]=\"'2x'\">\r\n                            <div class=\"usa-sr-only\">Neutral</div>\r\n                        </usa-icon>\r\n                    </button>\r\n                    <button (click)=\"selectFeedBack($event,1)\"\r\n                        [class]=\" feedbackValue !== 1 ?'usa-button usa-button--unstyled sds-button--circle margin-left-2  bg-white':'usa-button usa-button--unstyled sds-button--circle margin-left-2 usa-focus  bg-white'\">\r\n                        <usa-icon class=\"text-mint\" [icon]=\"'emojiSmile'\" [size]=\"'2x'\">\r\n                            <div class=\"usa-sr-only\">Satisfied</div>\r\n                        </usa-icon>\r\n                    </button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </ng-template>\r\n</textBubble>", styles: [".parentClass{position:relative}.parentClass .tooltiptext{visibility:hidden;width:120px;background-color:#000;color:#fff;text-align:center;border-radius:6px;padding:5px 0;position:absolute;z-index:1;margin-left:-45px}.parentClass:hover .tooltiptext{visibility:visible}.iconHover:hover{cursor:pointer}.buttonColor{border-color:#00bde3}.iconColor{color:#00bde3}\n"] }]
        }], ctorParameters: () => [{ type: SpotlightServiceMock }, { type: SpotlightService }, { type: AuthService }, { type: i0.ElementRef }], propDecorators: { bubbleDirection: [{
                type: Input
            }], iconButton: [{
                type: ViewChild,
                args: ['iconButton']
            }], textBubble: [{
                type: ViewChild,
                args: ['textBubble']
            }] } });
var FeedbackStatus;
(function (FeedbackStatus) {
    FeedbackStatus[FeedbackStatus["UNSELECTED"] = 0] = "UNSELECTED";
    FeedbackStatus[FeedbackStatus["SMILE"] = 1] = "SMILE";
    FeedbackStatus[FeedbackStatus["NEUTRAL"] = 2] = "NEUTRAL";
    FeedbackStatus[FeedbackStatus["FROWN"] = 3] = "FROWN";
})(FeedbackStatus || (FeedbackStatus = {}));

class SpotlightDirective {
    constructor(element, viewContainerRef, renderer) {
        this.element = element;
        this.viewContainerRef = viewContainerRef;
        this.renderer = renderer;
        this.spotlightId = '';
        this.position = '';
        this.spotlightDisabled = false;
        this.debug = false;
    }
    ngOnInit() {
        console.log(this.spotlightId + ':' + this.spotlightDisabled);
        if (!this.spotlightDisabled) {
            this.setBubbleDirection();
            const componentRef = this.viewContainerRef.createComponent(SpotlightComponent, { index: 0 });
            componentRef.instance.spotlightId = this.spotlightId;
            componentRef.instance.debug = this.debug;
            componentRef.instance.template = this.element;
            componentRef.instance.bubbleDirection = this.bubblePosition;
        }
    }
    setBubbleDirection() {
        switch (this.position) {
            case 'LEFT': {
                this.bubblePosition = BubbleDirection.LEFT;
                break;
            }
            case 'RIGHT': {
                this.bubblePosition = BubbleDirection.RIGHT;
                break;
            }
            case 'TOP': {
                this.bubblePosition = BubbleDirection.TOP;
                break;
            }
            case 'BOTTOM': {
                this.bubblePosition = BubbleDirection.BOTTOM;
                break;
            }
            default: {
                console.log("HAS BEEN DEFAULTED");
                this.bubblePosition = BubbleDirection.TOP;
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SpotlightDirective, deps: [{ token: i0.ElementRef }, { token: i0.ViewContainerRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.5", type: SpotlightDirective, selector: "[spotlight]", inputs: { spotlightId: "spotlightId", position: "position", spotlightDisabled: "spotlightDisabled", debug: "debug" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SpotlightDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[spotlight]'
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.ViewContainerRef }, { type: i0.Renderer2 }], propDecorators: { spotlightId: [{
                type: Input,
                args: ['spotlightId']
            }], position: [{
                type: Input,
                args: ['position']
            }], spotlightDisabled: [{
                type: Input,
                args: ['spotlightDisabled']
            }], debug: [{
                type: Input,
                args: ['debug']
            }] } });
class SpotlightConfiguration {
    constructor() {
        this.system = '';
        this.page = '';
        this.feature = '';
        this.position = SpotlightPosition.BOTTOM;
    }
}
var SpotlightPosition;
(function (SpotlightPosition) {
    SpotlightPosition[SpotlightPosition["BOTTOM"] = 0] = "BOTTOM";
    SpotlightPosition[SpotlightPosition["TOP"] = 1] = "TOP";
    SpotlightPosition[SpotlightPosition["RIGHT"] = 2] = "RIGHT";
    SpotlightPosition[SpotlightPosition["LEFT"] = 3] = "LEFT";
})(SpotlightPosition || (SpotlightPosition = {}));

class SpotlightModule {
    static forRoot(config) {
        return {
            ngModule: SpotlightModule,
            providers: [
                { provide: SharedSystemConfig, useValue: config }
            ]
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SpotlightModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: SpotlightModule, declarations: [SpotlightDirective, SpotlightComponent], imports: [CommonModule,
            IconModule,
            TextBubbleModule, i1$2.NgxBootstrapIconsModule], exports: [SpotlightDirective, SpotlightComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SpotlightModule, providers: [SpotlightService, SpotlightServiceMock], imports: [CommonModule,
            IconModule,
            TextBubbleModule,
            NgxBootstrapIconsModule.pick({
                save, lightbulb, x,
                emojiSmile, emojiNeutral, emojiFrown
            })] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SpotlightModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule,
                        IconModule,
                        TextBubbleModule,
                        NgxBootstrapIconsModule.pick({
                            save, lightbulb, x,
                            emojiSmile, emojiNeutral, emojiFrown
                        })],
                    exports: [SpotlightDirective, SpotlightComponent],
                    declarations: [SpotlightDirective, SpotlightComponent],
                    providers: [SpotlightService, SpotlightServiceMock]
                }]
        }] });

class OtpService {
    constructor(http, authService, environment) {
        this.http = http;
        this.authService = authService;
        this.environment = environment;
    }
    requestOtpKey(otpType) {
        const url = `${this.environment.API_UMBRELLA_URL}/rms/v1/otp/send?type=${otpType}`;
        const op = this._options();
        const arg = {};
        return this.http.post(url, arg, this._options());
    }
    verifyOtpKey(optKey, otpType) {
        const url = `${this.environment.API_UMBRELLA_URL}/rms/v1/otp/validate?type=${otpType}&otp=${optKey}`;
        const options = this._options();
        options['responseType'] = 'text';
        return this.http.post(url, null, options);
    }
    _options() {
        const params = {};
        return {
            headers: {
                'X-Auth-Token': this.authService.authToken()
            },
            params: params
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: OtpService, deps: [{ token: i1.HttpClient }, { token: AuthService }, { token: SharedSystemConfig }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: OtpService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: OtpService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: AuthService }, { type: SharedSystemConfig, decorators: [{
                    type: Inject,
                    args: [SharedSystemConfig]
                }] }] });
class OtpServiceMock {
    requestOtpKey(otpType) {
        this.generateAccessKey();
        return of('');
    }
    verifyOtpKey(optKey, otpType) {
        console.log(this.activeKey + "==" + optKey);
        if (this.activeKey == optKey) {
            return of('otp valid');
        }
        else {
            return of('otp invalid');
        }
    }
    generateAccessKey() {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        let counter = 0;
        while (counter < 6) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
            counter += 1;
        }
        this.activeKey = result;
        console.log('Test key: ' + result);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: OtpServiceMock, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: OtpServiceMock }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: OtpServiceMock, decorators: [{
            type: Injectable
        }] });

class otpConfig {
}
class otpResult {
}
var OTPSTATUS;
(function (OTPSTATUS) {
    OTPSTATUS[OTPSTATUS["PASSED"] = 0] = "PASSED";
    OTPSTATUS[OTPSTATUS["ERROR"] = 1] = "ERROR";
    OTPSTATUS[OTPSTATUS["CLOSED"] = 2] = "CLOSED";
})(OTPSTATUS || (OTPSTATUS = {}));

class OTPModalComponent {
    constructor(otpService, otpServiceMock, data, dialogRef, dialog, userAccessService, authUserService) {
        this.otpService = otpService;
        this.otpServiceMock = otpServiceMock;
        this.data = data;
        this.dialogRef = dialogRef;
        this.dialog = dialog;
        this.userAccessService = userAccessService;
        this.authUserService = authUserService;
        this.form = new FormGroup({});
        this.options = {};
        this.model = { otpCode: '' };
        this.isValidOTP = true;
        this.fields = [{
                key: 'otpCode',
                type: 'input',
                props: {
                    label: 'Enter Password',
                    placeholder: '',
                    required: true
                },
                validators: {
                    invalidDocument: {
                        expression: (c) => { return this.isValidOTP; },
                        message: 'Invalid password',
                    }
                }
            },];
        if (this.data.service) {
            this.service = this.data.service;
        }
        else {
            if (this.data.debug) {
                this.service = this.otpServiceMock;
            }
            else {
                this.service = this.otpService;
            }
        }
        if (this.data.otpType) {
            this.otpType = this.data.otpType;
        }
        else {
            this.otpType = 'tou';
        }
        this.userAccessService.getUserDetailsFromSession().subscribe(() => {
            this.email = this.authUserService.getLoggedInUserId();
        });
        this.resend();
    }
    submit() {
        this.service.verifyOtpKey(this.otpCode, this.otpType).subscribe({
            next: (res) => {
                if (res) {
                    this.dialogRef.close({ status: OTPSTATUS.PASSED });
                }
                else {
                    this.setInvalidOTP();
                }
            },
            error: (err) => {
                this.setInvalidOTP();
            }
        });
    }
    resend() {
        this.service.requestOtpKey(this.otpType).subscribe((res) => {
            //
        });
    }
    back() {
        this.dialogRef.close({ status: OTPSTATUS.CLOSED });
    }
    onModelChange(event) {
        this.isValidOTP = true;
        this.otpCode = event.otpCode;
        this.form.patchValue(this.model);
    }
    setInvalidOTP() {
        this.isValidOTP = false;
        this.form.patchValue(this.model);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: OTPModalComponent, deps: [{ token: OtpService }, { token: OtpServiceMock }, { token: SDS_DIALOG_DATA }, { token: i1$1.SdsDialogRef }, { token: i1$1.SdsDialogService }, { token: UserAccessService }, { token: AuthUserService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: OTPModalComponent, selector: "otp-modal", ngImport: i0, template: "<div class=\"grid\">\r\n  <div class=\"grid-row\">\r\n    <div class=\"grid-col\">\r\n      <div class=\"grid\">\r\n        <div class=\"grid-row padding-bottom-1\">\r\n          <div class=\"grid-col\">\r\n            <h1>Enter Your One-Time Password</h1>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"grid-row\">\r\n          <div class=\"grid-col\">\r\n            We just emailed you a one-time password at\r\n            <span>{{ email }}</span\r\n            >. Enter it here to complete signing.\r\n          </div>\r\n        </div>\r\n        <div class=\"grid-row margin-bottom-6\">\r\n          <div class=\"grid-col\">\r\n            <!-- One-time Password -->\r\n\r\n            <form [formGroup]=\"form\" style=\"max-width: 330px;\">\r\n              <formly-form\r\n                (modelChange)=\"onModelChange($event)\"\r\n                [(model)]=\"model\"\r\n                [(fields)]=\"fields\"\r\n                [options]=\"options\"\r\n                [form]=\"form\"\r\n              ></formly-form>\r\n            </form>\r\n\r\n            <!-- Invalid one-time password -->\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"grid-row padding-top-2 padding-bottom-4\">\r\n    <div class=\"grid-col\">\r\n      <div class=\"pin-right margin-right-1 grid-row\">\r\n        <div class=\"grid-col\">\r\n          <button\r\n            class=\"usa-button sds-button--small sa-button--base bg-base-lighter\"\r\n            (click)=\"back()\"\r\n          >\r\n            Back\r\n          </button>\r\n        </div>\r\n        <div class=\"grid-col\">\r\n          \r\n            <button\r\n              class=\"usa-button sds-button--small usa-button--accent-cool bg-accent-cool-lighter\"\r\n              (click)=\"resend()\"\r\n            >\r\n              <usa-icon\r\n                [icon]=\"'arrow-repeat'\"\r\n                [size]=\"'x'\"\r\n                class=\"\"\r\n              ></usa-icon>\r\n              Resend\r\n            </button>\r\n          \r\n        </div>\r\n        <div class=\"grid-col\">\r\n          <button\r\n            [disabled]=\"!otpCode\"\r\n            class=\"usa-button sds-button--small\"\r\n            (click)=\"submit()\"\r\n          >\r\n            Submit\r\n          </button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>", styles: [""], dependencies: [{ kind: "component", type: i3.IconComponent, selector: "usa-icon", inputs: ["icon", "rotate", "size", "classes", "skew"] }, { kind: "directive", type: i4.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i4.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i4.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: i1$4.FormlyForm, selector: "formly-form", inputs: ["form", "model", "fields", "options"], outputs: ["modelChange"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: OTPModalComponent, decorators: [{
            type: Component,
            args: [{ selector: "otp-modal", template: "<div class=\"grid\">\r\n  <div class=\"grid-row\">\r\n    <div class=\"grid-col\">\r\n      <div class=\"grid\">\r\n        <div class=\"grid-row padding-bottom-1\">\r\n          <div class=\"grid-col\">\r\n            <h1>Enter Your One-Time Password</h1>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"grid-row\">\r\n          <div class=\"grid-col\">\r\n            We just emailed you a one-time password at\r\n            <span>{{ email }}</span\r\n            >. Enter it here to complete signing.\r\n          </div>\r\n        </div>\r\n        <div class=\"grid-row margin-bottom-6\">\r\n          <div class=\"grid-col\">\r\n            <!-- One-time Password -->\r\n\r\n            <form [formGroup]=\"form\" style=\"max-width: 330px;\">\r\n              <formly-form\r\n                (modelChange)=\"onModelChange($event)\"\r\n                [(model)]=\"model\"\r\n                [(fields)]=\"fields\"\r\n                [options]=\"options\"\r\n                [form]=\"form\"\r\n              ></formly-form>\r\n            </form>\r\n\r\n            <!-- Invalid one-time password -->\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"grid-row padding-top-2 padding-bottom-4\">\r\n    <div class=\"grid-col\">\r\n      <div class=\"pin-right margin-right-1 grid-row\">\r\n        <div class=\"grid-col\">\r\n          <button\r\n            class=\"usa-button sds-button--small sa-button--base bg-base-lighter\"\r\n            (click)=\"back()\"\r\n          >\r\n            Back\r\n          </button>\r\n        </div>\r\n        <div class=\"grid-col\">\r\n          \r\n            <button\r\n              class=\"usa-button sds-button--small usa-button--accent-cool bg-accent-cool-lighter\"\r\n              (click)=\"resend()\"\r\n            >\r\n              <usa-icon\r\n                [icon]=\"'arrow-repeat'\"\r\n                [size]=\"'x'\"\r\n                class=\"\"\r\n              ></usa-icon>\r\n              Resend\r\n            </button>\r\n          \r\n        </div>\r\n        <div class=\"grid-col\">\r\n          <button\r\n            [disabled]=\"!otpCode\"\r\n            class=\"usa-button sds-button--small\"\r\n            (click)=\"submit()\"\r\n          >\r\n            Submit\r\n          </button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>" }]
        }], ctorParameters: () => [{ type: OtpService }, { type: OtpServiceMock }, { type: otpConfig, decorators: [{
                    type: Inject,
                    args: [SDS_DIALOG_DATA]
                }] }, { type: i1$1.SdsDialogRef }, { type: i1$1.SdsDialogService }, { type: UserAccessService }, { type: AuthUserService }] });

class OtpServiceStart {
    constructor(dialog) {
        this.dialog = dialog;
    }
    open(data) {
        const dialog = this.dialog.open(OTPModalComponent, { width: 'medium', height: 'large', data: data });
        return dialog;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: OtpServiceStart, deps: [{ token: i1$1.SdsDialogService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: OtpServiceStart }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: OtpServiceStart, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1$1.SdsDialogService }] });

class OTPInlineComponent {
    constructor(otpService, otpServiceMock, userAccessService, authUserService) {
        this.otpService = otpService;
        this.otpServiceMock = otpServiceMock;
        this.userAccessService = userAccessService;
        this.authUserService = authUserService;
        this.submitUpdate = new EventEmitter();
        this.form = new FormGroup({});
        this.options = {};
        this.model = { otpCode: '' };
        this.isValidOTP = true;
        this.fields = [{
                key: 'otpCode',
                type: 'input',
                props: {
                    label: 'Enter Password',
                    placeholder: '',
                    required: true
                },
                validators: {
                    invalidDocument: {
                        expression: (c) => { return this.isValidOTP; },
                        message: 'Invalid password',
                    }
                }
            },];
    }
    ngOnInit() {
        if (this.data.service) {
            this.service = this.data.service;
        }
        else {
            if (this.data.debug) {
                this.service = this.otpServiceMock;
            }
            else {
                this.service = this.otpService;
            }
        }
        if (this.data.otpType) {
            this.otpType = this.data.otpType;
        }
        else {
            this.otpType = 'tou';
        }
        this.userAccessService.getUserDetailsFromSession().subscribe(() => {
            this.email = this.authUserService.getLoggedInUserId();
        });
        this.resend();
    }
    submit() {
        this.service.verifyOtpKey(this.otpCode, this.otpType).subscribe((res) => {
            if (res) {
                this.submitUpdate.emit({ status: OTPSTATUS.PASSED });
            }
            else {
                this.setInvalidOTP();
                this.submitUpdate.emit({ status: OTPSTATUS.ERROR });
            }
        });
    }
    onModelChange(event) {
        this.isValidOTP = true;
        this.otpCode = event.otpCode;
        //this.otpCodeChange.emit(event.otpCode);
        this.form.patchValue(this.model);
    }
    setInvalidOTP() {
        this.isValidOTP = false;
        this.form.patchValue(this.model);
    }
    resend() {
        this.service.requestOtpKey(this.otpType).subscribe((res) => {
            //
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: OTPInlineComponent, deps: [{ token: OtpService }, { token: OtpServiceMock }, { token: UserAccessService }, { token: AuthUserService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: OTPInlineComponent, selector: "otp-inline", inputs: { data: "data" }, outputs: { submitUpdate: "submitUpdate" }, ngImport: i0, template: "<div class=\"grid\">\r\n  <div class=\"grid-row padding-bottom-1\">\r\n    <div class=\"grid-col\">\r\n      <h1>Enter Your One-Time Password</h1>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"grid-row\">\r\n    <div class=\"grid-col\">\r\n      We just emailed you a one-time password at\r\n      <span>{{ email }}</span\r\n      >. Enter it here to complete signing.\r\n    </div>\r\n  </div>\r\n  <div class=\"grid-row\">\r\n    <div class=\"grid-col\">\r\n      <!-- One-time Password -->\r\n\r\n      <form [formGroup]=\"form\">\r\n        <formly-form\r\n          (modelChange)=\"onModelChange($event)\"\r\n          [(model)]=\"model\"\r\n          [(fields)]=\"fields\"\r\n          [options]=\"options\"\r\n          [form]=\"form\"\r\n        ></formly-form>\r\n      </form>\r\n\r\n \r\n      <!-- Invalid one-time password -->\r\n    </div>\r\n    <div class=\"grid-col\">\r\n      <div class=\"margin-left-2 pin-bottom\">\r\n        <button\r\n          class=\"usa-button sds-button--small usa-button--accent-cool bg-accent-cool-lighter\"\r\n          (click)=\"resend()\"\r\n        >\r\n          <usa-icon [icon]=\"'arrow-repeat'\" [size]=\"'x'\" class=\"\"></usa-icon>\r\n          Resend\r\n        </button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>", styles: [""], dependencies: [{ kind: "component", type: i3.IconComponent, selector: "usa-icon", inputs: ["icon", "rotate", "size", "classes", "skew"] }, { kind: "directive", type: i4.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i4.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i4.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: i1$4.FormlyForm, selector: "formly-form", inputs: ["form", "model", "fields", "options"], outputs: ["modelChange"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: OTPInlineComponent, decorators: [{
            type: Component,
            args: [{ selector: "otp-inline", template: "<div class=\"grid\">\r\n  <div class=\"grid-row padding-bottom-1\">\r\n    <div class=\"grid-col\">\r\n      <h1>Enter Your One-Time Password</h1>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"grid-row\">\r\n    <div class=\"grid-col\">\r\n      We just emailed you a one-time password at\r\n      <span>{{ email }}</span\r\n      >. Enter it here to complete signing.\r\n    </div>\r\n  </div>\r\n  <div class=\"grid-row\">\r\n    <div class=\"grid-col\">\r\n      <!-- One-time Password -->\r\n\r\n      <form [formGroup]=\"form\">\r\n        <formly-form\r\n          (modelChange)=\"onModelChange($event)\"\r\n          [(model)]=\"model\"\r\n          [(fields)]=\"fields\"\r\n          [options]=\"options\"\r\n          [form]=\"form\"\r\n        ></formly-form>\r\n      </form>\r\n\r\n \r\n      <!-- Invalid one-time password -->\r\n    </div>\r\n    <div class=\"grid-col\">\r\n      <div class=\"margin-left-2 pin-bottom\">\r\n        <button\r\n          class=\"usa-button sds-button--small usa-button--accent-cool bg-accent-cool-lighter\"\r\n          (click)=\"resend()\"\r\n        >\r\n          <usa-icon [icon]=\"'arrow-repeat'\" [size]=\"'x'\" class=\"\"></usa-icon>\r\n          Resend\r\n        </button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>" }]
        }], ctorParameters: () => [{ type: OtpService }, { type: OtpServiceMock }, { type: UserAccessService }, { type: AuthUserService }], propDecorators: { data: [{
                type: Input
            }], submitUpdate: [{
                type: Output
            }] } });

class OTPModule {
    static forRoot(config) {
        return {
            ngModule: OTPModule,
            providers: [
                { provide: SharedSystemConfig, useValue: config }
            ]
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: OTPModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: OTPModule, declarations: [OTPInlineComponent, OTPModalComponent], imports: [CommonModule,
            IconModule, i1$2.NgxBootstrapIconsModule, FormsModule,
            ReactiveFormsModule, i1$4.FormlyModule, SdsFormlyModule], exports: [OTPInlineComponent, OTPModalComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: OTPModule, providers: [OtpService, OtpServiceStart, OtpServiceMock, SdsDialogService,
            UserAccessService
        ], imports: [CommonModule,
            IconModule,
            NgxBootstrapIconsModule.pick({
                arrowRepeat
            }),
            FormsModule,
            ReactiveFormsModule,
            FormlyModule.forChild({
                wrappers: [],
            }),
            SdsFormlyModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: OTPModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule,
                        IconModule,
                        NgxBootstrapIconsModule.pick({
                            arrowRepeat
                        }),
                        FormsModule,
                        ReactiveFormsModule,
                        FormlyModule.forChild({
                            wrappers: [],
                        }),
                        SdsFormlyModule,
                    ],
                    exports: [
                        OTPInlineComponent, OTPModalComponent
                    ],
                    declarations: [OTPInlineComponent, OTPModalComponent],
                    providers: [OtpService, OtpServiceStart, OtpServiceMock, SdsDialogService,
                        UserAccessService
                    ]
                }]
        }] });

class termsOfUseConfig {
}

class TermsOfUseService {
    constructor(http, authService, environment) {
        this.http = http;
        this.authService = authService;
        this.environment = environment;
    }
    getUserSignedDate() {
        const url = `${this.environment.API_UMBRELLA_URL}/rms/v1/agreements?type=ty7NM1Flgx`;
        const op = this._options();
        return this.http.get(url, op);
    }
    signTerms() {
        const url = `${this.environment.API_UMBRELLA_URL}/rms/v1/agreements`;
        const body = {
            "type": "ty7NM1Flgx"
        };
        return this.http.post(url, body, this._options());
    }
    _options() {
        const params = {};
        return {
            headers: {
                'X-Auth-Token': this.authService.authToken()
            },
            params: params
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: TermsOfUseService, deps: [{ token: i1.HttpClient }, { token: AuthService }, { token: SharedSystemConfig }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: TermsOfUseService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: TermsOfUseService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: AuthService }, { type: SharedSystemConfig, decorators: [{
                    type: Inject,
                    args: [SharedSystemConfig]
                }] }] });
class AgreementItem {
}
class TermsOfUseServiceMock {
    constructor() {
    }
    getUserSignedDate() {
        return of([
            {
                id: '',
                agreementType: '',
                createdDate: (new Date()).toString(),
                createdBy: '',
                expiredDate: '',
                organizationId: '',
                pointOfContact: '',
                userAgreementVersion: '',
            }
        ]);
    }
    signTerms() {
        return of({});
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: TermsOfUseServiceMock, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: TermsOfUseServiceMock }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: TermsOfUseServiceMock, decorators: [{
            type: Injectable
        }], ctorParameters: () => [] });

class TermsOfUseComponent {
    constructor(termsOfUseService, termsOfUseServiceMock, route, router) {
        this.termsOfUseService = termsOfUseService;
        this.termsOfUseServiceMock = termsOfUseServiceMock;
        this.route = route;
        this.router = router;
        this.termsOfUseConfig = { authenticatedUser: false, debug: false, showDates: false };
        this.effectiveDate = new Date(2024, 0, 12, 21, 0);
        this.signedDate = new Date();
    }
    ngOnInit() {
        if (this.termsOfUseConfig.debug) {
            this.service = this.termsOfUseServiceMock;
        }
        else {
            this.service = this.termsOfUseService;
        }
        if (this.termsOfUseConfig.authenticatedUser) {
            this.service.getUserSignedDate().subscribe((agreements) => {
                agreements = agreements.sort((a, b) => (a.userAgreementVersion < b.userAgreementVersion) ? 1 : -1);
                if (agreements && agreements.length > 0) {
                    this.signedDate = new Date(agreements[0].createdDate);
                }
            });
        }
        if (this.termsOfUseConfig.effectiveDateOverride) {
            this.effectiveDate = this.termsOfUseConfig.effectiveDateOverride;
        }
        const section = this.route.snapshot.data['section'];
        if (section) {
            if (section === 'privacy') {
                this.privacyEle.nativeElement.scrollIntoView();
            }
            else if (section === 'restricted-data-use') {
                this.restrictedEle.nativeElement.scrollIntoView();
            }
        }
    }
    getDateFormat(date) {
        let hours = date.getHours();
        if (hours === 0) {
            hours = 12;
        }
        else if (hours > 12) {
            hours = hours - 12;
        }
        return this.getWordMonth(date.getMonth()) + ' ' + date.getDate() + ', ' + date.getFullYear() + ' ' + hours + ':' + (date.getMinutes() < 10 ? '0' : '') + date.getMinutes() + ' ' + ((date.getHours() >= 12 && date.getHours() <= 23) ? 'PM' : 'AM') + ' ET';
    }
    getWordMonth(num) {
        let monthTxt = '';
        //off by one
        switch (num + 1) {
            case 1:
                monthTxt = 'Jan';
                break;
            case 2:
                monthTxt = 'Feb';
                break;
            case 3:
                monthTxt = 'Mar';
                break;
            case 4:
                monthTxt = 'Apr';
                break;
            case 5:
                monthTxt = 'May';
                break;
            case 6:
                monthTxt = 'Jun';
                break;
            case 7:
                monthTxt = 'Jul';
                break;
            case 8:
                monthTxt = 'Aug';
                break;
            case 9:
                monthTxt = 'Sep';
                break;
            case 10:
                monthTxt = 'Oct';
                break;
            case 11:
                monthTxt = 'Nov';
                break;
            case 12:
                monthTxt = 'Dec';
                break;
            default:
                break;
        }
        return monthTxt;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: TermsOfUseComponent, deps: [{ token: TermsOfUseService }, { token: TermsOfUseServiceMock }, { token: i2$2.ActivatedRoute }, { token: i2$2.Router }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: TermsOfUseComponent, selector: "terms-of-use", inputs: { termsOfUseConfig: "termsOfUseConfig" }, viewQueries: [{ propertyName: "privacyEle", first: true, predicate: ["privacy"], descendants: true }, { propertyName: "restrictedEle", first: true, predicate: ["restricted"], descendants: true }], ngImport: i0, template: "<!-- Date section -->\r\n<div *ngIf=\"termsOfUseConfig.showDates\" class=\"padding-1\">\r\n  <div class=\"grid-row\">\r\n    <div class=\"grid-col\">Effective Date</div>\r\n    <div *ngIf=\"termsOfUseConfig.authenticatedUser\" class=\"grid-col\">\r\n      Signed Date\r\n    </div>\r\n  </div>\r\n  <div class=\"grid-row padding-top-05\">\r\n    <div class=\"grid-col text-semibold\">\r\n      {{ getDateFormat(effectiveDate) }}\r\n    </div>\r\n    <div\r\n      *ngIf=\"termsOfUseConfig.authenticatedUser\"\r\n      class=\"grid-col text-semibold\"\r\n    >\r\n      {{ getDateFormat(signedDate) }}\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<!-- Intro Section-->\r\n<div class=\"padding-1\">\r\n  <div>\r\n    <div class=\"padding-bottom-1\">\r\n      SAM.gov is a federal government website. When you use this site, you must\r\n      follow these terms. If you do not, you may lose access to SAM.gov and we\r\n      may take other legal action.\r\n    </div>\r\n    <div class=\"padding-bottom-1\">\r\n      All of the terms apply to you, even if they cover activities you don\u2019t\r\n      currently do or data you don\u2019t currently use.\r\n    </div>\r\n    <div class=\"padding-bottom-1\">There are seven sets of terms.</div>\r\n  </div>\r\n  <ol>\r\n    <li>Changing Site Data</li>\r\n    <li>Data Access</li>\r\n    <li>Sensitive Data</li>\r\n    <li>Privacy Policy</li>\r\n    <li>Restricted Data Use</li>\r\n    <li>Non-Federal Administrator Roles</li>\r\n    <li>Signing in to SAM.gov</li>\r\n  </ol>\r\n  <div>\r\n    <div class=\"padding-bottom-1\">\r\n      We explain the terms and provide any legal language.\r\n    </div>\r\n    <div>\r\n      When you agree to the terms, you agree to both the explanations and the\r\n      legal language.\r\n    </div>\r\n  </div>\r\n</div>\r\n<!--Changing Site Data-->\r\n<div id=\"change\">\r\n  <h2 class=\"padding-1\">Changing Site Data</h2>\r\n  <!--Plain Language-->\r\n  <div class=\"plainLanguageSection border margin-1 padding-2\">\r\n    Do not try to upload or change data on SAM.gov without permission. Do not\r\n    upload viruses or other data that could cause damage. We don\u2019t allow it, and\r\n    it may be against the law.\r\n  </div>\r\n  <!--Legal Section-->\r\n  <div\r\n    class=\"legalSection padding-top-2 padding-right-2 padding-bottom-2 padding-left-3\"\r\n  >\r\n    <h3>Full Legal Language</h3>\r\n    <div>\r\n      <div class=\"padding-bottom-1\">\r\n        For site security purposes and to ensure that this service remains\r\n        available to all users, our web servers use industry-standard methods to\r\n        monitor network traffic to identify unauthorized attempts to upload or\r\n        change information, or otherwise cause damage by automated accesses.\r\n      </div>\r\n      <div>\r\n        Unauthorized attempts to upload information or change information on\r\n        this service are strictly prohibited and may be punishable under the\r\n        Computer Fraud and Abuse Act of 1986 and the National Information\r\n        Infrastructure Protection Act. General Services Administration / Federal\r\n        Acquisition Services/Technology Transformation Services will enforce the\r\n        law to its greatest extent to any individual who tampers with\r\n        information made available on this site.\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<!--Data Access-->\r\n<div id=\"data\">\r\n  <h2 class=\"padding-1\">Data Access</h2>\r\n  <!--Plain Language-->\r\n  <div\r\n    class=\"plainLanguageSection border margin-1 padding-left-2 padding-right-2 padding-top-1 padding-bottom-1\"\r\n  >\r\n    <ul>\r\n      <li>\r\n        Do not use bots to download or copy restricted or sensitive data from\r\n        SAM.gov.\r\n      </li>\r\n      <li>\r\n        Do not use your SAM.gov login for data mining, bots, or other data\r\n        gathering and extraction tools.\r\n      </li>\r\n      <li>\r\n        With permission, you may use software to\r\n        <a target=\"_blank\" href=\"https://open.gsa.gov/api/\"\r\n          >connect to\r\n          <span class=\"padding-right-1 usa-link--external font-body-md\"\r\n            ><span class=\"usa-sr-only\">- opens in a new window</span>\r\n          </span></a\r\n        >\r\n        some SAM.gov data.\r\n      </li>\r\n      <li>\r\n        You may also\r\n        <a target=\"_blank\" href=\"https://sam.gov/data-services\"\r\n          >download\r\n          <span class=\"padding-right-1 usa-link--external font-body-md\"\r\n            ><span class=\"usa-sr-only\">- opens in a new window</span>\r\n          </span></a\r\n        >some SAM.gov data.\r\n      </li>\r\n      <li>Only access data you are allowed to access.</li>\r\n    </ul>\r\n    <h3>System Accounts and API Keys</h3>\r\n    <ul>\r\n      <li>Update your API key and system account password every 90 days.</li>\r\n      <li>Do not share your individual account API key with anyone.</li>\r\n      <li>\r\n        Do not share your system account API key or password with anyone except\r\n        people from the organization associated with your system account.\r\n      </li>\r\n      <li>\r\n        You are responsible for making sure everyone who uses APIs via your\r\n        system account follows these terms.\r\n      </li>\r\n      <li>\r\n        If you want to share data publicly, only share data from public versions\r\n        of APIs.\r\n      </li>\r\n      <li>\r\n        The terms for sensitive data apply to sensitive data you submit and\r\n        receive via API.\r\n      </li>\r\n    </ul>\r\n  </div>\r\n  <!--Legal Language-->\r\n  <div\r\n    class=\"legalSection padding-top-2 padding-right-2 padding-bottom-2 padding-left-3\"\r\n  >\r\n    <h3>Full Legal Language</h3>\r\n    <div>\r\n      <div>\r\n        <div class=\"padding-bottom-1\">\r\n          SAM.gov makes certain data available via APIs and extracts with URLs\r\n          \u201Chttps://open.gsa.gov/api/\u201D and \u201Chttps://sam.gov/data-services.\u201D\r\n          Automated data gathering, web scraping tools are prohibited and, if\r\n          detected, will result in the associated account(s) being denied access\r\n          to SAM.gov via Login.gov.\r\n        </div>\r\n        <div>\r\n          I accept the responsibility for the information and U.S. Federal\r\n          Government system to which I am granted access and will not exceed my\r\n          authorization level of system access. I understand that my access may\r\n          be revoked or terminated for non-compliance with Government security\r\n          policies. I accept responsibility to safeguard the information\r\n          contained in these systems from unauthorized or inadvertent\r\n          modification, disclosure, destruction, and use. I understand and\r\n          accept that my use of the system and any API calls with my system\r\n          account API key may be monitored as part of managing the system,\r\n          protecting against unauthorized access and verifying security\r\n          problems. I agree to notify the appropriate organization that issued\r\n          my account(s) when access is no longer required.\r\n        </div>\r\n      </div>\r\n      <div>\r\n        <h4 class=\"padding-top-1\">For Official Use Only (FOUO) Information</h4>\r\n        <div>\r\n          <div class=\"padding-bottom-1\">\r\n            You are allowed to use the Federal Hierarchy FOUO API for internal,\r\n            U.S. Government business purposes. You are not allowed to display or\r\n            disseminate outside the U.S. Government any values received in a\r\n            Federal Hierarchy FOUO API response unless that value is directly\r\n            associated with a Federal award record.\r\n          </div>\r\n          <div class=\"padding-bottom-1\">\r\n            For financial assistance awards only, you are allowed to use the\r\n            awarding and funding Activity Address Codes (AACs) submitted in\r\n            association with a financial assistance award to derive the\r\n            respective Office Name, Sub-Tier Agency Code, Sub-Tier Agency Name,\r\n            Department/Independent Agency Code, and Department/Independent\r\n            Agency Name from the Federal Hierarchy FOUO API. You may publicly\r\n            display and disseminate the awarding and funding AACs, and the five\r\n            specified Federal Hierarchy FOUO API-derived values from those AACs,\r\n            in connection with the financial assistance awards.\r\n          </div>\r\n          <div class=\"padding-bottom-1\">\r\n            You may not use the Federal Hierarchy FOUO API to build out a public\r\n            view of either the partial or complete Federal Hierarchy. You must\r\n            use the Federal Hierarchy Public API if you wish to display or\r\n            disseminate the public-facing Department and Sub-Tier information.\r\n          </div>\r\n          <div class=\"padding-bottom-1\">\r\n            You may not use the Entity Management FOUO API to build out a public\r\n            view of the data. You must use the public version of any API if you\r\n            wish to display or disseminate the public-facing data.\r\n          </div>\r\n          <div class=\"padding-bottom-1\">\r\n            You agree to be bound by these Terms of Use when you submit any SAM\r\n            FOUO API request as well as when you receive any SAM FOUO API\r\n            response.\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div>\r\n        <h4 class=\"padding-top-1\">Sensitive Information</h4>\r\n        <div>\r\n          <div class=\"padding-bottom-1\">\r\n            You are allowed to use the Contract Opportunities and Entity\r\n            Management APIs for internal, U.S. Government business purposes. You\r\n            are not allowed to display or disseminate outside the U.S.\r\n            Government any values received in a sensitive API response.\r\n          </div>\r\n          <div class=\"padding-bottom-1\">\r\n            You may not use any sensitive API to build out a public view of any\r\n            SAM data. You must use the public version of any API if you wish to\r\n            display or disseminate the public-facing data.\r\n          </div>\r\n          <div class=\"padding-bottom-1\">\r\n            You agree to be bound by these Terms of Use when you submit a\r\n            sensitive API request as well as when you receive a sensitive API\r\n            response.\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div>\r\n        <h4 class=\"padding-top-1\">Confirmation of Agency Policy</h4>\r\n        <div>\r\n          User affirms compliance with agency annual privacy and information\r\n          security training.\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<!--Sensitive Data-->\r\n<div id=\"sensitive\">\r\n  <h2>Sensitive Data</h2>\r\n  <div class=\"plainLanguageSection border margin-1 padding-2\">\r\n    <div>\r\n      Some information in SAM.gov is sensitive. Public exposure of sensitive\r\n      information could harm individual people, the U.S. government, national\r\n      security, or all of these.\r\n    </div>\r\n    <div class=\"padding-top-1\">\r\n      <h3>Viewing and using sensitive data</h3>\r\n      <div class=\"padding-bottom-1\">\r\n        <div class=\"padding-bottom-1\">\r\n          Protect any sensitive data you view, download, or copy from SAM.gov.\r\n        </div>\r\n        <div class=\"padding-bottom-1\">\r\n          When you delete or discard downloaded or copied data or printouts,\r\n          make sure no one can access the deleted data and shred the paper.\r\n        </div>\r\n        <div class=\"padding-bottom-1\">\r\n          Do not enter or upload classified information in the system.\r\n        </div>\r\n        <div class=\"padding-bottom-1\">\r\n          If you put sensitive information where SAM.gov doesn\u2019t ask for it, you\r\n          are responsible for any public exposure of the information.\r\n        </div>\r\n        <div class=\"padding-bottom-1\">\r\n          If you enter any sensitive information where it can be seen publicly,\r\n          contact the\r\n          <a target=\"_blank\" href=\"https://www.fsd.gov/gsafsd_sp\"\r\n            >Federal Service Desk\r\n            <span class=\"padding-right-1 usa-link--external font-body-md\"\r\n              ><span class=\"usa-sr-only\">- opens in a new window</span>\r\n            </span></a\r\n          >\r\n          immediately. If you are a federal user, also contact your own agency.\r\n        </div>\r\n      </div>\r\n      <div>\r\n        <h3>For Official Use Only (FOUO) and Sensitive Information</h3>\r\n        <div>\r\n          If you are a federal user who can view FOUO and sensitive data\r\n        </div>\r\n        <ul>\r\n          <li>You may only use this data for your job.</li>\r\n          <li>\r\n            If you no longer need access to the data, tell your agency to remove\r\n            your role.\r\n          </li>\r\n          <li>\r\n            Only share this data with others who are also allowed to view and\r\n            use it.\r\n          </li>\r\n          <li>\r\n            Do not share this data with contractors unless they have a written\r\n            agreement as part of their active contract that allows them to view\r\n            and use this data.\r\n          </li>\r\n          <li>\r\n            Comply with your agency\u2019s privacy and information security training\r\n            requirements.\r\n          </li>\r\n        </ul>\r\n        <div>\r\n          Federal agencies that receive FOUO and sensitive data from SAM.gov may\r\n          only put that data in systems that are compliant with the FISMA\r\n          moderate standard.\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div\r\n    class=\"legalSection padding-top-2 padding-right-2 padding-bottom-2 padding-left-3\"\r\n  >\r\n    <h3>Full Legal Language</h3>\r\n    <div>\r\n      This system contains Personally Identifiable Information (PII) and\r\n      Controlled Unclassified Information (CUI). Individuals entering data into\r\n      this system must only enter PII and/or CUI when it is specifically\r\n      requested. Exposure of PII and/or CUI as a result of an individual\r\n      inadvertently entering PII and/or CUI into a public data field where it is\r\n      not required is the sole responsibility of the individual entering the\r\n      data. Failure to follow these instructions may result in your record being\r\n      deactivated. Individuals viewing, reproducing or disposing of this\r\n      information are required to protect it in accordance with 32 CFR Part 2002\r\n      and GSA Order CIO 2103.2 CUI Policy.\r\n      <div>\r\n        <h3 class=\"padding-top-1\">Rules of Behavior</h3>\r\n        <div class=\"padding-bottom-1\">\r\n          Classified information may never be submitted into the system under\r\n          any circumstances. In such cases that classified information is\r\n          submitted, IAE and IAE security must immediately be notified and an\r\n          incident file opened.\r\n        </div>\r\n        <div class=\"padding-bottom-1\">\r\n          Controlled Unclassified Information (CUI) may only be submitted as\r\n          non-public information. In such case that CUI is submitted\r\n          incorrectly, IAE must be notified immediately.\r\n        </div>\r\n        <div class=\"padding-bottom-1\">\r\n          No submissions to SAM shall include malicious files, viruses,\r\n          executable files, or any other code that would cause damage to SAM or\r\n          other users who obtain data from SAM.\r\n        </div>\r\n        <div class=\"padding-bottom-1\">\r\n          I understand that my system is only given access only to those domains\r\n          to which my system require access in the performance of official\r\n          duties. My system will not attempt to access areas of SAM my system is\r\n          not authorized to access.\r\n        </div>\r\n        <div class=\"padding-bottom-1\">\r\n          I will update my system account password and API key every 90 days in\r\n          accordance with GSA security policy. Under no circumstances will I\r\n          share my system account password or API key with other users or\r\n          systems.\r\n        </div>\r\n      </div>\r\n      <div>\r\n        <h3>Non-Disclosure Agreement</h3>\r\n        <ol>\r\n          <li>\r\n            To carry out the duties as the information dissemination (ID) source\r\n            for the System for Award Management (SAM), the General Services\r\n            Administration (GSA) may disclose information to authorized\r\n            representatives of the United States (U.S.) Government. These\r\n            authorized representatives are known as Data Receivers and their\r\n            agencies as the Receiving Agency.\r\n          </li>\r\n          <li>\r\n            This Non-Disclosure Agreement (\"Agreement\") covers information\r\n            provided to the U.S. Government under a mandate for federal\r\n            contractors as described in 48 CFR, Parts 204, 212, and 252 and the\r\n            Debt Collection Improvement Act of 1996, Public Law 104-134 and for\r\n            federal assistance recipients under 2 CFR Part 180 and 2 CFR,\r\n            Subtitle A, Chapter I, & Part 25. The disclosure of such information\r\n            to the public, or those outside of the Government, shall be in\r\n            accordance with all conditions and limitations set forth herein.\r\n          </li>\r\n          <li>\r\n            The Data Receiver has a requirement(s) for such data to perform\r\n            certain tasks on behalf of the U. S. Federal Government. Because of\r\n            this requirement(s), the Data Receiver is considered \"authorized\"\r\n            for the purpose of this Agreement.\r\n          </li>\r\n          <li>\r\n            GSA hereby determines that disclosure of information is necessary so\r\n            that the Data Receiver may perform the duties required of them by\r\n            the U. S. Federal Government.\r\n          </li>\r\n          <li>\r\n            GSA shall grant access to the information described for each year\r\n            that a completed Non-Disclosure Agreement form is filled out,\r\n            submitted, and approved. The Data Receiver may request termination\r\n            of access or GSA may terminate access. This Non-Disclosure Agreement\r\n            must be renewed each year.\r\n          </li>\r\n          <li>\r\n            The Data Receiver accepts the obligations contained in this\r\n            Agreement in consideration of being granted access to Controlled\r\n            Unclassified Information (CUI). The Data Receiver acknowledges that\r\n            all obligations imposed by this Agreement concerning the use and\r\n            disclosure of such information apply for the duration of the\r\n            requirement and at all times thereafter.\r\n          </li>\r\n          <li>\r\n            The Data Receiver agrees that it shall use the information obtained\r\n            from SAM for the purpose of the work required by the U. S. Federal\r\n            Government and shall not use such data for commercial purposes not\r\n            covered by the terms of this Agreement.\r\n          </li>\r\n          <li>\r\n            The Data Receiver agrees it shall not disclose or provide access to\r\n            information obtained from SAM to anyone unless it has verified that\r\n            the recipient has been properly authorized to receive such\r\n            information, e.g., employees of the Data Receiver or contractors who\r\n            have signed Employee/Sub-contractor Non-Disclosure Agreements\r\n            pursuant to this Agreement.\r\n          </li>\r\n          <li>\r\n            The Data Receiver agrees to adopt operating procedures and physical\r\n            security measures to properly safeguard such information from\r\n            unauthorized use and from disclosure or release to unauthorized\r\n            third parties.\r\n          </li>\r\n          <li>\r\n            The Data Receiver agrees to return to GSA all copies of any\r\n            abstracts or extracts of data, of which it has possession pursuant\r\n            to this Agreement, upon request of GSA or the completion or\r\n            termination of the tasks set forth by the U.S. Federal Government,\r\n            whichever comes first.\r\n          </li>\r\n          <li>\r\n            The Data Receiver agrees to obtain a written agreement to honor the\r\n            terms of the Agreement from each contractor, sub-contractor and\r\n            employee of the contractor or subcontractor who will have access to\r\n            such information before the contractor, sub-contractor or employee\r\n            is allowed such access.\r\n          </li>\r\n          <li>\r\n            The Data Receiver hereby acknowledges that no contractor,\r\n            sub-contractor, consultant or employee who will have access to such\r\n            information is debarred, suspended or otherwise ineligible to\r\n            perform on an U. S. Federal Government contract.\r\n          </li>\r\n          <li>\r\n            The Data Receiver hereby acknowledges that any violation or breach\r\n            of this Agreement on the part of a contractor, sub-contractor,\r\n            consultant or any employee of a contractor or sub-contractor shall\r\n            constitute grounds for termination of access to such information;\r\n            suit for damages; suit to enforce the Agreement, including but not\r\n            limited to, application for a court order prohibiting disclosure or\r\n            use of information in violation or breach of this Agreement; and or\r\n            suit for civil fines or penalties. The Data Receiver further\r\n            acknowledges that the unauthorized use, disclosure or retention of\r\n            the information may constitute a violation of the U.S. criminal\r\n            laws, including provisions of sections 641, 793, 794, and 1905,\r\n            title 18 U. S. Code, and that nothing in this Agreement constitutes\r\n            a waiver by the U. S. of the right to prosecute for any statutory\r\n            violation.\r\n          </li>\r\n        </ol>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<!--Privacy Policy-->\r\n<div id=\"privacy\" #privacy>\r\n  <h2 class=\"padding-1\">Privacy Policy</h2>\r\n  <div class=\"plainLanguageSection border margin-1 padding-2\">\r\n    <div>\r\n      GSA will collect no personal information about you other than statistical\r\n      information that can be used to make the site more effective.\r\n    </div>\r\n\r\n    <h3>Information We Gather</h3>\r\n    <div>\r\n      We use Google Analytics to collect and store information about your visit\r\n      to our site. This information includes:\r\n    </div>\r\n    <ul>\r\n      <li>\r\n        Environmental information such as the location of your IP address, the\r\n        language you are browsing in, and the technical specifications of the\r\n        device and browser you are using;\r\n      </li>\r\n      <li>\r\n        Behavioral information such as the date and time of your visit, the\r\n        pages you visit, links you clicked on the site, and the name of the\r\n        domain from which you access the Internet (i.e., DHS.gov if you are\r\n        connecting from a DHS account, or GMU.edu if you are connecting from\r\n        George Mason University\u2019s domain); and\r\n      </li>\r\n      <li>\r\n        Acquisition information such as the Internet address of the website you\r\n        came from if it linked you directly to SAM.gov and search terms that you\r\n        enter into the SAM.gov search tool.\r\n      </li>\r\n    </ul>\r\n    <div class=\"padding-bottom-1\">\r\n      If your browser accepts cookies, we may use a session cookie to learn how\r\n      many different visitors come to SAM.gov. We use this information for\r\n      statistical purposes and to help us make our site more useful. We do not\r\n      collect personally identifiable information nor do we sell this data to\r\n      anyone.\r\n    </div>\r\n    <div>\r\n      <a target=\"_blank\" href=\"https://www.usa.gov/optout-instructions\"\r\n        >Learn more about how Google Analytics safeguards data\r\n        <span class=\"padding-right-1 usa-link--external font-body-md\"\r\n          ><span class=\"usa-sr-only\">- opens in a new window</span>\r\n        </span> </a\r\n      >.\r\n    </div>\r\n    <h3>Cookies and SAM.gov</h3>\r\n    <div class=\"padding-bottom-1\">\r\n      Use of Cookies on SAM.gov: GSA creates a session cookie when you visit and\r\n      destroys it as soon as you close your browser. Google Analytics as\r\n      configured on SAM.gov also uses first-party (persistent) cookies to:\r\n    </div>\r\n    <ul>\r\n      <li>\r\n        Distinguish unique users (last for up to 2 years if you never clear your\r\n        cookies)\r\n      </li>\r\n      <li>Throttle the request rate (last for up to 1 minute)</li>\r\n    </ul>\r\n    <div class=\"padding-bottom-1\">\r\n      If you don\u2019t want to accept cookies, you can edit your browser\u2019s options\r\n      to stop accepting persistent cookies or to prompt you before accepting a\r\n      cookie from the websites you visit. Here\u2019s how you can\r\n      <a target=\"_blank\" href=\"https://www.usa.gov/optout-instructions\">\r\n        disable cookies and/or Google Demographic and Interests reports\r\n        <span class=\"usa-link--external font-body-md\"\r\n          ><span class=\"usa-sr-only\">- opens in a new window</span>\r\n        </span> </a\r\n      >.\r\n    </div>\r\n    <div class=\"padding-bottom-1\">\r\n      Although using persistent cookies allows us to deliver a better experience\r\n      for you, this site will also work without them.\r\n    </div>\r\n    <div class=\"padding-bottom-1\">\r\n      For more information on privacy and security,\r\n      <a target=\"_blank\" href=\"https://www.gsa.gov/node/87279\"\r\n        >see our Privacy and Security Policy\r\n        <span class=\"padding-right-1 usa-link--external font-body-md\"\r\n          ><span class=\"usa-sr-only\">- opens in a new window</span>\r\n        </span> </a\r\n      >.\r\n    </div>\r\n    <h3>Information You Send Us</h3>\r\n    <div class=\"padding-bottom-1\">\r\n      When you send us personal information (e.g., in an electronic mail message\r\n      containing a question or comment) or by filling out a form that email us\r\n      this information, we only use this information to respond to your request.\r\n      Such application information is carefully protected by the agency and not\r\n      available in or retained by web tracking software. We may forward your\r\n      email to the government employee who can best answer your questions. We do\r\n      not disclose, give, sell, or transfer any personal information about our\r\n      visitors, unless required for law enforcement or statute.\r\n    </div>\r\n    <div>\r\n      We want to make it clear that we will not obtain personally identifying\r\n      information about you when you visit our site, unless you choose to\r\n      provide that information to us. Except for authorized law enforcement\r\n      investigations, or as otherwise required by law, we do not share any\r\n      information we receive with anyone else.\r\n    </div>\r\n    <h3>Security</h3>\r\n    <div class=\"padding-bottom-1\">\r\n      For site security purposes and to ensure that this service remains\r\n      available to all users, our web servers use industry-standard methods to\r\n      monitor network traffic to identify unauthorized attempts to upload or\r\n      change information, or otherwise cause damage. Unauthorized attempts to\r\n      upload information or change information on GSA servers are strictly\r\n      prohibited and may be punishable by law, including the Computer Fraud and\r\n      Abuse Act of 1986 and the National Information Infrastructure Protection\r\n      Act.\r\n    </div>\r\n    <div>\r\n      The\r\n      <a target=\"_blank\" href=\"https://www.gsa.gov/node/137922\"\r\n        >Vulnerability Disclosure Policy\r\n        <span class=\"padding-right-1 usa-link--external font-body-md\"\r\n          ><span class=\"usa-sr-only\">- opens in a new window</span>\r\n        </span>\r\n      </a>\r\n      describes what systems and types of research are covered under this\r\n      policy, how to send vulnerability reports, and how long we ask security\r\n      researchers to wait before publicly disclosing vulnerabilities.\r\n    </div>\r\n    <h3>Reuse and Copyright</h3>\r\n    <div>\r\n      Most material on our site is free of copyright and may be copied and\r\n      distributed without permission. Works produced by federal government\r\n      employees in the course of their employment are generally not protected by\r\n      copyright and are in the public domain in the U.S. Citation of the GSA\r\n      site and a link back is much appreciated.\r\n    </div>\r\n    <div>\r\n      We sometimes use photos or graphics that we licensed or that are\r\n      restricted. Check to see if there is a copyright or photo credit. You\r\n      should determine for yourself whether or not an item is protected by\r\n      copyright or in the public domain, and then satisfy any copyright or use\r\n      restrictions when publishing or distributing materials from our website.\r\n      You need to request permission from the original source to use those\r\n      materials. Transmission or reproduction of protected items beyond what is\r\n      allowed by fair use or other exemptions requires written permission from\r\n      the copyright holder.\r\n    </div>\r\n    <div>\r\n      If you have any questions about these policies, please\r\n      <a target=\"_blank\" href=\"https://www.gsa.gov/about-us/contact-us\"\r\n        >contact us\r\n        <span class=\"padding-right-1 usa-link--external font-body-md\"\r\n          ><span class=\"usa-sr-only\">- opens in a new window</span>\r\n        </span> </a\r\n      >.\r\n    </div>\r\n\r\n    \r\n  </div>\r\n</div>\r\n<!--Restricted Data Use-->\r\n<div id=\"restricted\" #restricted>\r\n  <h2 class=\"padding-1\">Restricted Data Use</h2>\r\n  <div class=\"plainLanguageSection border margin-1 padding-2\">\r\n    SAM.gov has data supplied by Dun and Bradstreet (D&B). D&B owns this data\r\n    and restricts its use. Some entities in SAM.gov have \u201CD&B Open Data,\u201D which\r\n    includes\r\n    <ul>\r\n      <li>Legal business name</li>\r\n      <li>Street address</li>\r\n      <li>City name</li>\r\n      <li>State or province name</li>\r\n      <li>State or province code</li>\r\n      <li>State or province abbreviation</li>\r\n      <li>Country name</li>\r\n      <li>County code</li>\r\n      <li>ZIP or postal code</li>\r\n    </ul>\r\n    <div class=\"padding-bottom-1\">\r\n      D&B Open Data may be in entity registration records last updated before\r\n      April 4, 2022, and exclusion records created before April 4, 2022.\r\n    </div>\r\n    <div class=\"padding-bottom-1\">\r\n      Entity registration records with D&B data show that data source in APIs\r\n      and extracts.\r\n    </div>\r\n    <div>You may use D&B Open Data with these limits:</div>\r\n\r\n    <ul>\r\n      <li>You must state in writing that D&B is the data source.</li>\r\n      <li>\r\n        You may not share D&B Open Data in bulk (that is, enough records that\r\n        someone could use them as an original data source or a substitute for\r\n        getting data from D&B).\r\n      </li>\r\n    </ul>\r\n    You may use all D&B data with these limits:\r\n    <ul>\r\n      <li>\r\n        You may not use D&B data (except for D&B Open Data) for commercial,\r\n        resale, or marketing purposes.\r\n      </li>\r\n      <li>\r\n        Federal agencies may use D&B data (including subcontractor data) from\r\n        the point of establishing agency needs for contract support through\r\n        contract closeout and for reporting about federal awards.\r\n      </li>\r\n      <li>There is no warranty for D&B data.</li>\r\n      <li>\r\n        D&B and any third-party information suppliers are not liable for how\r\n        others use D&B data.\r\n      </li>\r\n    </ul>\r\n  </div>\r\n  <div\r\n    class=\"legalSection padding-top-2 padding-right-2 padding-bottom-2 padding-left-3\"\r\n  >\r\n    <h3>Full Legal Language</h3>\r\n    <div id=\"limitation-terms\">\r\n      <h4>D&B Limitation Terms</h4>\r\n      <div>\r\n        <div class=\"padding-bottom-1\">\r\n          The System for Award Management contains data supplied by third party\r\n          information suppliers, one of which is Dun & Bradstreet. In order to\r\n          frame the terms of permissible use, these definitions are used in this\r\n          section:\r\n        </div>\r\n        <div class=\"padding-bottom-1\">Acquisition</div>\r\n        <div class=\"padding-bottom-1\">\r\n          \u2018Acquisition\u2019 as used in the term Acquisition purposes is defined in\r\n          FAR Subpart 2.1, and \"... means the acquiring by contract with\r\n          appropriated funds of supplies or services (including construction) by\r\n          and for the use of the Federal Government through purchase or lease,\r\n          whether the supplies or services are already in existence or must be\r\n          created, developed, demonstrated, and evaluated. Acquisition begins at\r\n          the point when agency needs are established and includes the\r\n          description of requirements to satisfy agency needs, solicitation and\r\n          selection of sources, award of contracts, contract financing, contract\r\n          performance, contract administration, and those technical and\r\n          management functions directly related to the process of fulfilling\r\n          agency needs by contract.\"\r\n        </div>\r\n        <div class=\"padding-bottom-1\">Federal Award</div>\r\n        <div class=\"padding-bottom-1\">\r\n          \u2018Federal Award\u2019 as used herein is defined as either a contract (an\r\n          acquisition award) or a Federal Financial Assistance Award, including\r\n          both ARRA awards and Federal Awards as defined under Federal Funding\r\n          Accountability and Transparency Act of 2006 (FFATA), 31 U.S.C. 6101,\r\n          Note \u00A72(a)(4).\r\n        </div>\r\n        <div class=\"padding-bottom-1\">Federal Award Management</div>\r\n        <div class=\"padding-bottom-1\">\r\n          \u2018Federal Award Management\u2019 as used herein is defined as the activities\r\n          supporting agency requirements for acquisition (as defined in FAR\r\n          Subpart 2.1) purposes and the parallel functions for grants and loans\r\n          awards.\r\n        </div>\r\n        <div class=\"padding-bottom-1\">Federal Financial Assistance Award</div>\r\n        <div class=\"padding-bottom-1\">\r\n          \u2018Federal Financial Assistance Award\u2019 as used herein is defined under 2\r\n          CFR 25.305 as an award of Federal financial assistance that a\r\n          non-Federal entity described in \u00A7 25.110(a) receives or administers in\r\n          the form of a grant; a cooperative agreement (which does not include a\r\n          cooperative research and development agreement pursuant to the Federal\r\n          Technology Transfer Act of 1986, as amended (15 U.S.C. 3710a)); a\r\n          loan; a loan guarantee; a subsidy; insurance; food commodities; a\r\n          direct appropriation; assessed or voluntary contributions; or any\r\n          other financial assistance transaction that authorizes the non-Federal\r\n          entity's expenditure of Federal funds, and includes Federal financial\r\n          assistance and expenditures as defined in FFATA, 31 U.S.C. 6101, Note\r\n          \u00A72(a)(4)(A).\r\n        </div>\r\n        <div class=\"padding-bottom-1\">\r\n          Limitation on Permissible Use of Dun & Bradstreet, Inc. Data\r\n        </div>\r\n        <div class=\"padding-bottom-1\">\r\n          This website has data supplied by third party information suppliers,\r\n          including Dun & Bradstreet (D&B). For the purposes of the following\r\n          limitation on permissible use of D&B data, which includes each\r\n          entity's DUNS Number and its associated business information, \"D&B\r\n          Open Data\" is defined as the following data elements: Legal Business\r\n          Name, Street Address, City Name, State/Province Name, Country Name,\r\n          County Code, State/Province Code, State/Province Abbreviation,\r\n          ZIP/Postal Code, Country Name and Country Code. Entity registration,\r\n          exclusion, or contract award records in SAM may contain D&B-supplied\r\n          data. Applicable records containing D&B data include all entity\r\n          registration records with a last updated date earlier than 4/4/2022,\r\n          all exclusions records with a created date earlier than 4/4/2022, and\r\n          all base award notices with an award date earlier than 4/4/2022. These\r\n          records show D&B as the Entity Validation Service (EVS) Source in\r\n          records with D&B data.\r\n        </div>\r\n        <div class=\"padding-bottom-1\">\r\n          D&B hereby grants you, the user, a license for a limited,\r\n          non-exclusive right to use D&B Open Data within the limitations set\r\n          forth herein. By using this website you agree that you shall not use\r\n          D&B Open Data without giving written attribution to the source of such\r\n          data (i.e., D&B) and shall not access, use or disseminate D&B Open\r\n          Data in bulk (i.e., in amounts sufficient for use as an original\r\n          source or as a substitute for the product and/or service being\r\n          licensed hereunder).\r\n        </div>\r\n        <div class=\"padding-bottom-1\">\r\n          Except for data elements identified above as D&B Open Data, under no\r\n          circumstances are you authorized to use any other D&B data for\r\n          commercial, resale or marketing purposes (e.g., identifying,\r\n          quantifying, segmenting and/or analyzing customers and prospective\r\n          customers). Systematic access (electronic harvesting) or extraction of\r\n          content from the website, including the use of \"bots\" or \"spiders,\" is\r\n          prohibited. Federal government entities are authorized to use the D&B\r\n          data for purposes of acquisition as defined in FAR 2.101 and for the\r\n          purpose of managing Federal awards, including sub-awards, or reporting\r\n          Federal award information.\r\n        </div>\r\n        <div class=\"padding-bottom-1\">\r\n          GSA assumes no liability for the use of the D&B data once it is\r\n          downloaded or accessed. D&B data is provided \"as is\" without warranty\r\n          of any kind. The D&B data is the intellectual property of D&B. In no\r\n          event will D&B or any third party information supplier be liable in\r\n          any way with regard to the use of the D&B data. For more information\r\n          about the scope of permissible use of D&B data licensed hereunder,\r\n          please contact D&B at datause_govt&#64;dnb.com.\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<!--Non-Federal Administrator Roles-->\r\n<div id=\"nonFed\">\r\n  <h2 class=\"padding-1\">Non-Federal Administrator Roles</h2>\r\n  <div class=\"plainLanguageSection border margin-1 padding-2\">\r\n    <div class=\"padding-bottom-1\">\r\n      If you have any administrator role with an entity that is not part of the\r\n      U.S. federal government, you may not assign an administrator role (for\r\n      entity registration, entity reporting, or contract opportunities) to\r\n      someone who is not directly connected to your entity like an officer,\r\n      board member, or employee.\r\n    </div>\r\n    <div class=\"padding-bottom-1\">\r\n      You may not use an Entity Administrator Appointment Letter to assign an\r\n      Entity Administrator role to someone who is not directly connected to your\r\n      entity.\r\n    </div>\r\n    <div class=\"padding-bottom-1\">\r\n      If you are not directly connected to an entity, you may not seek or accept\r\n      an administrator role for the entity. If you are not directly connected to\r\n      an entity and you have an administrator role, you may not keep it. You\r\n      must immediately contact the entity and the\r\n      <a target=\"_blank\" href=\"https://www.fsd.gov/gsafsd_sp\"\r\n        >Federal Service Desk\r\n        <span class=\"padding-right-1 usa-link--external font-body-md\"\r\n          ><span class=\"usa-sr-only\">- opens in a new window</span>\r\n        </span></a\r\n      >\r\n      and ask them to remove the role.\r\n    </div>\r\n  </div>\r\n</div>\r\n<!--Signing in to SAM.gov-->\r\n<div id=\"signing\">\r\n  <h2 class=\"padding-1\">Signing in to SAM.gov</h2>\r\n  <div class=\"plainLanguageSection border margin-1 padding-2\">\r\n    SAM.gov accounts are for individual people, not groups. Do not share email\r\n    addresses to sign in.\r\n  </div>\r\n</div>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: TermsOfUseComponent, decorators: [{
            type: Component,
            args: [{ selector: "terms-of-use", template: "<!-- Date section -->\r\n<div *ngIf=\"termsOfUseConfig.showDates\" class=\"padding-1\">\r\n  <div class=\"grid-row\">\r\n    <div class=\"grid-col\">Effective Date</div>\r\n    <div *ngIf=\"termsOfUseConfig.authenticatedUser\" class=\"grid-col\">\r\n      Signed Date\r\n    </div>\r\n  </div>\r\n  <div class=\"grid-row padding-top-05\">\r\n    <div class=\"grid-col text-semibold\">\r\n      {{ getDateFormat(effectiveDate) }}\r\n    </div>\r\n    <div\r\n      *ngIf=\"termsOfUseConfig.authenticatedUser\"\r\n      class=\"grid-col text-semibold\"\r\n    >\r\n      {{ getDateFormat(signedDate) }}\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<!-- Intro Section-->\r\n<div class=\"padding-1\">\r\n  <div>\r\n    <div class=\"padding-bottom-1\">\r\n      SAM.gov is a federal government website. When you use this site, you must\r\n      follow these terms. If you do not, you may lose access to SAM.gov and we\r\n      may take other legal action.\r\n    </div>\r\n    <div class=\"padding-bottom-1\">\r\n      All of the terms apply to you, even if they cover activities you don\u2019t\r\n      currently do or data you don\u2019t currently use.\r\n    </div>\r\n    <div class=\"padding-bottom-1\">There are seven sets of terms.</div>\r\n  </div>\r\n  <ol>\r\n    <li>Changing Site Data</li>\r\n    <li>Data Access</li>\r\n    <li>Sensitive Data</li>\r\n    <li>Privacy Policy</li>\r\n    <li>Restricted Data Use</li>\r\n    <li>Non-Federal Administrator Roles</li>\r\n    <li>Signing in to SAM.gov</li>\r\n  </ol>\r\n  <div>\r\n    <div class=\"padding-bottom-1\">\r\n      We explain the terms and provide any legal language.\r\n    </div>\r\n    <div>\r\n      When you agree to the terms, you agree to both the explanations and the\r\n      legal language.\r\n    </div>\r\n  </div>\r\n</div>\r\n<!--Changing Site Data-->\r\n<div id=\"change\">\r\n  <h2 class=\"padding-1\">Changing Site Data</h2>\r\n  <!--Plain Language-->\r\n  <div class=\"plainLanguageSection border margin-1 padding-2\">\r\n    Do not try to upload or change data on SAM.gov without permission. Do not\r\n    upload viruses or other data that could cause damage. We don\u2019t allow it, and\r\n    it may be against the law.\r\n  </div>\r\n  <!--Legal Section-->\r\n  <div\r\n    class=\"legalSection padding-top-2 padding-right-2 padding-bottom-2 padding-left-3\"\r\n  >\r\n    <h3>Full Legal Language</h3>\r\n    <div>\r\n      <div class=\"padding-bottom-1\">\r\n        For site security purposes and to ensure that this service remains\r\n        available to all users, our web servers use industry-standard methods to\r\n        monitor network traffic to identify unauthorized attempts to upload or\r\n        change information, or otherwise cause damage by automated accesses.\r\n      </div>\r\n      <div>\r\n        Unauthorized attempts to upload information or change information on\r\n        this service are strictly prohibited and may be punishable under the\r\n        Computer Fraud and Abuse Act of 1986 and the National Information\r\n        Infrastructure Protection Act. General Services Administration / Federal\r\n        Acquisition Services/Technology Transformation Services will enforce the\r\n        law to its greatest extent to any individual who tampers with\r\n        information made available on this site.\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<!--Data Access-->\r\n<div id=\"data\">\r\n  <h2 class=\"padding-1\">Data Access</h2>\r\n  <!--Plain Language-->\r\n  <div\r\n    class=\"plainLanguageSection border margin-1 padding-left-2 padding-right-2 padding-top-1 padding-bottom-1\"\r\n  >\r\n    <ul>\r\n      <li>\r\n        Do not use bots to download or copy restricted or sensitive data from\r\n        SAM.gov.\r\n      </li>\r\n      <li>\r\n        Do not use your SAM.gov login for data mining, bots, or other data\r\n        gathering and extraction tools.\r\n      </li>\r\n      <li>\r\n        With permission, you may use software to\r\n        <a target=\"_blank\" href=\"https://open.gsa.gov/api/\"\r\n          >connect to\r\n          <span class=\"padding-right-1 usa-link--external font-body-md\"\r\n            ><span class=\"usa-sr-only\">- opens in a new window</span>\r\n          </span></a\r\n        >\r\n        some SAM.gov data.\r\n      </li>\r\n      <li>\r\n        You may also\r\n        <a target=\"_blank\" href=\"https://sam.gov/data-services\"\r\n          >download\r\n          <span class=\"padding-right-1 usa-link--external font-body-md\"\r\n            ><span class=\"usa-sr-only\">- opens in a new window</span>\r\n          </span></a\r\n        >some SAM.gov data.\r\n      </li>\r\n      <li>Only access data you are allowed to access.</li>\r\n    </ul>\r\n    <h3>System Accounts and API Keys</h3>\r\n    <ul>\r\n      <li>Update your API key and system account password every 90 days.</li>\r\n      <li>Do not share your individual account API key with anyone.</li>\r\n      <li>\r\n        Do not share your system account API key or password with anyone except\r\n        people from the organization associated with your system account.\r\n      </li>\r\n      <li>\r\n        You are responsible for making sure everyone who uses APIs via your\r\n        system account follows these terms.\r\n      </li>\r\n      <li>\r\n        If you want to share data publicly, only share data from public versions\r\n        of APIs.\r\n      </li>\r\n      <li>\r\n        The terms for sensitive data apply to sensitive data you submit and\r\n        receive via API.\r\n      </li>\r\n    </ul>\r\n  </div>\r\n  <!--Legal Language-->\r\n  <div\r\n    class=\"legalSection padding-top-2 padding-right-2 padding-bottom-2 padding-left-3\"\r\n  >\r\n    <h3>Full Legal Language</h3>\r\n    <div>\r\n      <div>\r\n        <div class=\"padding-bottom-1\">\r\n          SAM.gov makes certain data available via APIs and extracts with URLs\r\n          \u201Chttps://open.gsa.gov/api/\u201D and \u201Chttps://sam.gov/data-services.\u201D\r\n          Automated data gathering, web scraping tools are prohibited and, if\r\n          detected, will result in the associated account(s) being denied access\r\n          to SAM.gov via Login.gov.\r\n        </div>\r\n        <div>\r\n          I accept the responsibility for the information and U.S. Federal\r\n          Government system to which I am granted access and will not exceed my\r\n          authorization level of system access. I understand that my access may\r\n          be revoked or terminated for non-compliance with Government security\r\n          policies. I accept responsibility to safeguard the information\r\n          contained in these systems from unauthorized or inadvertent\r\n          modification, disclosure, destruction, and use. I understand and\r\n          accept that my use of the system and any API calls with my system\r\n          account API key may be monitored as part of managing the system,\r\n          protecting against unauthorized access and verifying security\r\n          problems. I agree to notify the appropriate organization that issued\r\n          my account(s) when access is no longer required.\r\n        </div>\r\n      </div>\r\n      <div>\r\n        <h4 class=\"padding-top-1\">For Official Use Only (FOUO) Information</h4>\r\n        <div>\r\n          <div class=\"padding-bottom-1\">\r\n            You are allowed to use the Federal Hierarchy FOUO API for internal,\r\n            U.S. Government business purposes. You are not allowed to display or\r\n            disseminate outside the U.S. Government any values received in a\r\n            Federal Hierarchy FOUO API response unless that value is directly\r\n            associated with a Federal award record.\r\n          </div>\r\n          <div class=\"padding-bottom-1\">\r\n            For financial assistance awards only, you are allowed to use the\r\n            awarding and funding Activity Address Codes (AACs) submitted in\r\n            association with a financial assistance award to derive the\r\n            respective Office Name, Sub-Tier Agency Code, Sub-Tier Agency Name,\r\n            Department/Independent Agency Code, and Department/Independent\r\n            Agency Name from the Federal Hierarchy FOUO API. You may publicly\r\n            display and disseminate the awarding and funding AACs, and the five\r\n            specified Federal Hierarchy FOUO API-derived values from those AACs,\r\n            in connection with the financial assistance awards.\r\n          </div>\r\n          <div class=\"padding-bottom-1\">\r\n            You may not use the Federal Hierarchy FOUO API to build out a public\r\n            view of either the partial or complete Federal Hierarchy. You must\r\n            use the Federal Hierarchy Public API if you wish to display or\r\n            disseminate the public-facing Department and Sub-Tier information.\r\n          </div>\r\n          <div class=\"padding-bottom-1\">\r\n            You may not use the Entity Management FOUO API to build out a public\r\n            view of the data. You must use the public version of any API if you\r\n            wish to display or disseminate the public-facing data.\r\n          </div>\r\n          <div class=\"padding-bottom-1\">\r\n            You agree to be bound by these Terms of Use when you submit any SAM\r\n            FOUO API request as well as when you receive any SAM FOUO API\r\n            response.\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div>\r\n        <h4 class=\"padding-top-1\">Sensitive Information</h4>\r\n        <div>\r\n          <div class=\"padding-bottom-1\">\r\n            You are allowed to use the Contract Opportunities and Entity\r\n            Management APIs for internal, U.S. Government business purposes. You\r\n            are not allowed to display or disseminate outside the U.S.\r\n            Government any values received in a sensitive API response.\r\n          </div>\r\n          <div class=\"padding-bottom-1\">\r\n            You may not use any sensitive API to build out a public view of any\r\n            SAM data. You must use the public version of any API if you wish to\r\n            display or disseminate the public-facing data.\r\n          </div>\r\n          <div class=\"padding-bottom-1\">\r\n            You agree to be bound by these Terms of Use when you submit a\r\n            sensitive API request as well as when you receive a sensitive API\r\n            response.\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div>\r\n        <h4 class=\"padding-top-1\">Confirmation of Agency Policy</h4>\r\n        <div>\r\n          User affirms compliance with agency annual privacy and information\r\n          security training.\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<!--Sensitive Data-->\r\n<div id=\"sensitive\">\r\n  <h2>Sensitive Data</h2>\r\n  <div class=\"plainLanguageSection border margin-1 padding-2\">\r\n    <div>\r\n      Some information in SAM.gov is sensitive. Public exposure of sensitive\r\n      information could harm individual people, the U.S. government, national\r\n      security, or all of these.\r\n    </div>\r\n    <div class=\"padding-top-1\">\r\n      <h3>Viewing and using sensitive data</h3>\r\n      <div class=\"padding-bottom-1\">\r\n        <div class=\"padding-bottom-1\">\r\n          Protect any sensitive data you view, download, or copy from SAM.gov.\r\n        </div>\r\n        <div class=\"padding-bottom-1\">\r\n          When you delete or discard downloaded or copied data or printouts,\r\n          make sure no one can access the deleted data and shred the paper.\r\n        </div>\r\n        <div class=\"padding-bottom-1\">\r\n          Do not enter or upload classified information in the system.\r\n        </div>\r\n        <div class=\"padding-bottom-1\">\r\n          If you put sensitive information where SAM.gov doesn\u2019t ask for it, you\r\n          are responsible for any public exposure of the information.\r\n        </div>\r\n        <div class=\"padding-bottom-1\">\r\n          If you enter any sensitive information where it can be seen publicly,\r\n          contact the\r\n          <a target=\"_blank\" href=\"https://www.fsd.gov/gsafsd_sp\"\r\n            >Federal Service Desk\r\n            <span class=\"padding-right-1 usa-link--external font-body-md\"\r\n              ><span class=\"usa-sr-only\">- opens in a new window</span>\r\n            </span></a\r\n          >\r\n          immediately. If you are a federal user, also contact your own agency.\r\n        </div>\r\n      </div>\r\n      <div>\r\n        <h3>For Official Use Only (FOUO) and Sensitive Information</h3>\r\n        <div>\r\n          If you are a federal user who can view FOUO and sensitive data\r\n        </div>\r\n        <ul>\r\n          <li>You may only use this data for your job.</li>\r\n          <li>\r\n            If you no longer need access to the data, tell your agency to remove\r\n            your role.\r\n          </li>\r\n          <li>\r\n            Only share this data with others who are also allowed to view and\r\n            use it.\r\n          </li>\r\n          <li>\r\n            Do not share this data with contractors unless they have a written\r\n            agreement as part of their active contract that allows them to view\r\n            and use this data.\r\n          </li>\r\n          <li>\r\n            Comply with your agency\u2019s privacy and information security training\r\n            requirements.\r\n          </li>\r\n        </ul>\r\n        <div>\r\n          Federal agencies that receive FOUO and sensitive data from SAM.gov may\r\n          only put that data in systems that are compliant with the FISMA\r\n          moderate standard.\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div\r\n    class=\"legalSection padding-top-2 padding-right-2 padding-bottom-2 padding-left-3\"\r\n  >\r\n    <h3>Full Legal Language</h3>\r\n    <div>\r\n      This system contains Personally Identifiable Information (PII) and\r\n      Controlled Unclassified Information (CUI). Individuals entering data into\r\n      this system must only enter PII and/or CUI when it is specifically\r\n      requested. Exposure of PII and/or CUI as a result of an individual\r\n      inadvertently entering PII and/or CUI into a public data field where it is\r\n      not required is the sole responsibility of the individual entering the\r\n      data. Failure to follow these instructions may result in your record being\r\n      deactivated. Individuals viewing, reproducing or disposing of this\r\n      information are required to protect it in accordance with 32 CFR Part 2002\r\n      and GSA Order CIO 2103.2 CUI Policy.\r\n      <div>\r\n        <h3 class=\"padding-top-1\">Rules of Behavior</h3>\r\n        <div class=\"padding-bottom-1\">\r\n          Classified information may never be submitted into the system under\r\n          any circumstances. In such cases that classified information is\r\n          submitted, IAE and IAE security must immediately be notified and an\r\n          incident file opened.\r\n        </div>\r\n        <div class=\"padding-bottom-1\">\r\n          Controlled Unclassified Information (CUI) may only be submitted as\r\n          non-public information. In such case that CUI is submitted\r\n          incorrectly, IAE must be notified immediately.\r\n        </div>\r\n        <div class=\"padding-bottom-1\">\r\n          No submissions to SAM shall include malicious files, viruses,\r\n          executable files, or any other code that would cause damage to SAM or\r\n          other users who obtain data from SAM.\r\n        </div>\r\n        <div class=\"padding-bottom-1\">\r\n          I understand that my system is only given access only to those domains\r\n          to which my system require access in the performance of official\r\n          duties. My system will not attempt to access areas of SAM my system is\r\n          not authorized to access.\r\n        </div>\r\n        <div class=\"padding-bottom-1\">\r\n          I will update my system account password and API key every 90 days in\r\n          accordance with GSA security policy. Under no circumstances will I\r\n          share my system account password or API key with other users or\r\n          systems.\r\n        </div>\r\n      </div>\r\n      <div>\r\n        <h3>Non-Disclosure Agreement</h3>\r\n        <ol>\r\n          <li>\r\n            To carry out the duties as the information dissemination (ID) source\r\n            for the System for Award Management (SAM), the General Services\r\n            Administration (GSA) may disclose information to authorized\r\n            representatives of the United States (U.S.) Government. These\r\n            authorized representatives are known as Data Receivers and their\r\n            agencies as the Receiving Agency.\r\n          </li>\r\n          <li>\r\n            This Non-Disclosure Agreement (\"Agreement\") covers information\r\n            provided to the U.S. Government under a mandate for federal\r\n            contractors as described in 48 CFR, Parts 204, 212, and 252 and the\r\n            Debt Collection Improvement Act of 1996, Public Law 104-134 and for\r\n            federal assistance recipients under 2 CFR Part 180 and 2 CFR,\r\n            Subtitle A, Chapter I, & Part 25. The disclosure of such information\r\n            to the public, or those outside of the Government, shall be in\r\n            accordance with all conditions and limitations set forth herein.\r\n          </li>\r\n          <li>\r\n            The Data Receiver has a requirement(s) for such data to perform\r\n            certain tasks on behalf of the U. S. Federal Government. Because of\r\n            this requirement(s), the Data Receiver is considered \"authorized\"\r\n            for the purpose of this Agreement.\r\n          </li>\r\n          <li>\r\n            GSA hereby determines that disclosure of information is necessary so\r\n            that the Data Receiver may perform the duties required of them by\r\n            the U. S. Federal Government.\r\n          </li>\r\n          <li>\r\n            GSA shall grant access to the information described for each year\r\n            that a completed Non-Disclosure Agreement form is filled out,\r\n            submitted, and approved. The Data Receiver may request termination\r\n            of access or GSA may terminate access. This Non-Disclosure Agreement\r\n            must be renewed each year.\r\n          </li>\r\n          <li>\r\n            The Data Receiver accepts the obligations contained in this\r\n            Agreement in consideration of being granted access to Controlled\r\n            Unclassified Information (CUI). The Data Receiver acknowledges that\r\n            all obligations imposed by this Agreement concerning the use and\r\n            disclosure of such information apply for the duration of the\r\n            requirement and at all times thereafter.\r\n          </li>\r\n          <li>\r\n            The Data Receiver agrees that it shall use the information obtained\r\n            from SAM for the purpose of the work required by the U. S. Federal\r\n            Government and shall not use such data for commercial purposes not\r\n            covered by the terms of this Agreement.\r\n          </li>\r\n          <li>\r\n            The Data Receiver agrees it shall not disclose or provide access to\r\n            information obtained from SAM to anyone unless it has verified that\r\n            the recipient has been properly authorized to receive such\r\n            information, e.g., employees of the Data Receiver or contractors who\r\n            have signed Employee/Sub-contractor Non-Disclosure Agreements\r\n            pursuant to this Agreement.\r\n          </li>\r\n          <li>\r\n            The Data Receiver agrees to adopt operating procedures and physical\r\n            security measures to properly safeguard such information from\r\n            unauthorized use and from disclosure or release to unauthorized\r\n            third parties.\r\n          </li>\r\n          <li>\r\n            The Data Receiver agrees to return to GSA all copies of any\r\n            abstracts or extracts of data, of which it has possession pursuant\r\n            to this Agreement, upon request of GSA or the completion or\r\n            termination of the tasks set forth by the U.S. Federal Government,\r\n            whichever comes first.\r\n          </li>\r\n          <li>\r\n            The Data Receiver agrees to obtain a written agreement to honor the\r\n            terms of the Agreement from each contractor, sub-contractor and\r\n            employee of the contractor or subcontractor who will have access to\r\n            such information before the contractor, sub-contractor or employee\r\n            is allowed such access.\r\n          </li>\r\n          <li>\r\n            The Data Receiver hereby acknowledges that no contractor,\r\n            sub-contractor, consultant or employee who will have access to such\r\n            information is debarred, suspended or otherwise ineligible to\r\n            perform on an U. S. Federal Government contract.\r\n          </li>\r\n          <li>\r\n            The Data Receiver hereby acknowledges that any violation or breach\r\n            of this Agreement on the part of a contractor, sub-contractor,\r\n            consultant or any employee of a contractor or sub-contractor shall\r\n            constitute grounds for termination of access to such information;\r\n            suit for damages; suit to enforce the Agreement, including but not\r\n            limited to, application for a court order prohibiting disclosure or\r\n            use of information in violation or breach of this Agreement; and or\r\n            suit for civil fines or penalties. The Data Receiver further\r\n            acknowledges that the unauthorized use, disclosure or retention of\r\n            the information may constitute a violation of the U.S. criminal\r\n            laws, including provisions of sections 641, 793, 794, and 1905,\r\n            title 18 U. S. Code, and that nothing in this Agreement constitutes\r\n            a waiver by the U. S. of the right to prosecute for any statutory\r\n            violation.\r\n          </li>\r\n        </ol>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<!--Privacy Policy-->\r\n<div id=\"privacy\" #privacy>\r\n  <h2 class=\"padding-1\">Privacy Policy</h2>\r\n  <div class=\"plainLanguageSection border margin-1 padding-2\">\r\n    <div>\r\n      GSA will collect no personal information about you other than statistical\r\n      information that can be used to make the site more effective.\r\n    </div>\r\n\r\n    <h3>Information We Gather</h3>\r\n    <div>\r\n      We use Google Analytics to collect and store information about your visit\r\n      to our site. This information includes:\r\n    </div>\r\n    <ul>\r\n      <li>\r\n        Environmental information such as the location of your IP address, the\r\n        language you are browsing in, and the technical specifications of the\r\n        device and browser you are using;\r\n      </li>\r\n      <li>\r\n        Behavioral information such as the date and time of your visit, the\r\n        pages you visit, links you clicked on the site, and the name of the\r\n        domain from which you access the Internet (i.e., DHS.gov if you are\r\n        connecting from a DHS account, or GMU.edu if you are connecting from\r\n        George Mason University\u2019s domain); and\r\n      </li>\r\n      <li>\r\n        Acquisition information such as the Internet address of the website you\r\n        came from if it linked you directly to SAM.gov and search terms that you\r\n        enter into the SAM.gov search tool.\r\n      </li>\r\n    </ul>\r\n    <div class=\"padding-bottom-1\">\r\n      If your browser accepts cookies, we may use a session cookie to learn how\r\n      many different visitors come to SAM.gov. We use this information for\r\n      statistical purposes and to help us make our site more useful. We do not\r\n      collect personally identifiable information nor do we sell this data to\r\n      anyone.\r\n    </div>\r\n    <div>\r\n      <a target=\"_blank\" href=\"https://www.usa.gov/optout-instructions\"\r\n        >Learn more about how Google Analytics safeguards data\r\n        <span class=\"padding-right-1 usa-link--external font-body-md\"\r\n          ><span class=\"usa-sr-only\">- opens in a new window</span>\r\n        </span> </a\r\n      >.\r\n    </div>\r\n    <h3>Cookies and SAM.gov</h3>\r\n    <div class=\"padding-bottom-1\">\r\n      Use of Cookies on SAM.gov: GSA creates a session cookie when you visit and\r\n      destroys it as soon as you close your browser. Google Analytics as\r\n      configured on SAM.gov also uses first-party (persistent) cookies to:\r\n    </div>\r\n    <ul>\r\n      <li>\r\n        Distinguish unique users (last for up to 2 years if you never clear your\r\n        cookies)\r\n      </li>\r\n      <li>Throttle the request rate (last for up to 1 minute)</li>\r\n    </ul>\r\n    <div class=\"padding-bottom-1\">\r\n      If you don\u2019t want to accept cookies, you can edit your browser\u2019s options\r\n      to stop accepting persistent cookies or to prompt you before accepting a\r\n      cookie from the websites you visit. Here\u2019s how you can\r\n      <a target=\"_blank\" href=\"https://www.usa.gov/optout-instructions\">\r\n        disable cookies and/or Google Demographic and Interests reports\r\n        <span class=\"usa-link--external font-body-md\"\r\n          ><span class=\"usa-sr-only\">- opens in a new window</span>\r\n        </span> </a\r\n      >.\r\n    </div>\r\n    <div class=\"padding-bottom-1\">\r\n      Although using persistent cookies allows us to deliver a better experience\r\n      for you, this site will also work without them.\r\n    </div>\r\n    <div class=\"padding-bottom-1\">\r\n      For more information on privacy and security,\r\n      <a target=\"_blank\" href=\"https://www.gsa.gov/node/87279\"\r\n        >see our Privacy and Security Policy\r\n        <span class=\"padding-right-1 usa-link--external font-body-md\"\r\n          ><span class=\"usa-sr-only\">- opens in a new window</span>\r\n        </span> </a\r\n      >.\r\n    </div>\r\n    <h3>Information You Send Us</h3>\r\n    <div class=\"padding-bottom-1\">\r\n      When you send us personal information (e.g., in an electronic mail message\r\n      containing a question or comment) or by filling out a form that email us\r\n      this information, we only use this information to respond to your request.\r\n      Such application information is carefully protected by the agency and not\r\n      available in or retained by web tracking software. We may forward your\r\n      email to the government employee who can best answer your questions. We do\r\n      not disclose, give, sell, or transfer any personal information about our\r\n      visitors, unless required for law enforcement or statute.\r\n    </div>\r\n    <div>\r\n      We want to make it clear that we will not obtain personally identifying\r\n      information about you when you visit our site, unless you choose to\r\n      provide that information to us. Except for authorized law enforcement\r\n      investigations, or as otherwise required by law, we do not share any\r\n      information we receive with anyone else.\r\n    </div>\r\n    <h3>Security</h3>\r\n    <div class=\"padding-bottom-1\">\r\n      For site security purposes and to ensure that this service remains\r\n      available to all users, our web servers use industry-standard methods to\r\n      monitor network traffic to identify unauthorized attempts to upload or\r\n      change information, or otherwise cause damage. Unauthorized attempts to\r\n      upload information or change information on GSA servers are strictly\r\n      prohibited and may be punishable by law, including the Computer Fraud and\r\n      Abuse Act of 1986 and the National Information Infrastructure Protection\r\n      Act.\r\n    </div>\r\n    <div>\r\n      The\r\n      <a target=\"_blank\" href=\"https://www.gsa.gov/node/137922\"\r\n        >Vulnerability Disclosure Policy\r\n        <span class=\"padding-right-1 usa-link--external font-body-md\"\r\n          ><span class=\"usa-sr-only\">- opens in a new window</span>\r\n        </span>\r\n      </a>\r\n      describes what systems and types of research are covered under this\r\n      policy, how to send vulnerability reports, and how long we ask security\r\n      researchers to wait before publicly disclosing vulnerabilities.\r\n    </div>\r\n    <h3>Reuse and Copyright</h3>\r\n    <div>\r\n      Most material on our site is free of copyright and may be copied and\r\n      distributed without permission. Works produced by federal government\r\n      employees in the course of their employment are generally not protected by\r\n      copyright and are in the public domain in the U.S. Citation of the GSA\r\n      site and a link back is much appreciated.\r\n    </div>\r\n    <div>\r\n      We sometimes use photos or graphics that we licensed or that are\r\n      restricted. Check to see if there is a copyright or photo credit. You\r\n      should determine for yourself whether or not an item is protected by\r\n      copyright or in the public domain, and then satisfy any copyright or use\r\n      restrictions when publishing or distributing materials from our website.\r\n      You need to request permission from the original source to use those\r\n      materials. Transmission or reproduction of protected items beyond what is\r\n      allowed by fair use or other exemptions requires written permission from\r\n      the copyright holder.\r\n    </div>\r\n    <div>\r\n      If you have any questions about these policies, please\r\n      <a target=\"_blank\" href=\"https://www.gsa.gov/about-us/contact-us\"\r\n        >contact us\r\n        <span class=\"padding-right-1 usa-link--external font-body-md\"\r\n          ><span class=\"usa-sr-only\">- opens in a new window</span>\r\n        </span> </a\r\n      >.\r\n    </div>\r\n\r\n    \r\n  </div>\r\n</div>\r\n<!--Restricted Data Use-->\r\n<div id=\"restricted\" #restricted>\r\n  <h2 class=\"padding-1\">Restricted Data Use</h2>\r\n  <div class=\"plainLanguageSection border margin-1 padding-2\">\r\n    SAM.gov has data supplied by Dun and Bradstreet (D&B). D&B owns this data\r\n    and restricts its use. Some entities in SAM.gov have \u201CD&B Open Data,\u201D which\r\n    includes\r\n    <ul>\r\n      <li>Legal business name</li>\r\n      <li>Street address</li>\r\n      <li>City name</li>\r\n      <li>State or province name</li>\r\n      <li>State or province code</li>\r\n      <li>State or province abbreviation</li>\r\n      <li>Country name</li>\r\n      <li>County code</li>\r\n      <li>ZIP or postal code</li>\r\n    </ul>\r\n    <div class=\"padding-bottom-1\">\r\n      D&B Open Data may be in entity registration records last updated before\r\n      April 4, 2022, and exclusion records created before April 4, 2022.\r\n    </div>\r\n    <div class=\"padding-bottom-1\">\r\n      Entity registration records with D&B data show that data source in APIs\r\n      and extracts.\r\n    </div>\r\n    <div>You may use D&B Open Data with these limits:</div>\r\n\r\n    <ul>\r\n      <li>You must state in writing that D&B is the data source.</li>\r\n      <li>\r\n        You may not share D&B Open Data in bulk (that is, enough records that\r\n        someone could use them as an original data source or a substitute for\r\n        getting data from D&B).\r\n      </li>\r\n    </ul>\r\n    You may use all D&B data with these limits:\r\n    <ul>\r\n      <li>\r\n        You may not use D&B data (except for D&B Open Data) for commercial,\r\n        resale, or marketing purposes.\r\n      </li>\r\n      <li>\r\n        Federal agencies may use D&B data (including subcontractor data) from\r\n        the point of establishing agency needs for contract support through\r\n        contract closeout and for reporting about federal awards.\r\n      </li>\r\n      <li>There is no warranty for D&B data.</li>\r\n      <li>\r\n        D&B and any third-party information suppliers are not liable for how\r\n        others use D&B data.\r\n      </li>\r\n    </ul>\r\n  </div>\r\n  <div\r\n    class=\"legalSection padding-top-2 padding-right-2 padding-bottom-2 padding-left-3\"\r\n  >\r\n    <h3>Full Legal Language</h3>\r\n    <div id=\"limitation-terms\">\r\n      <h4>D&B Limitation Terms</h4>\r\n      <div>\r\n        <div class=\"padding-bottom-1\">\r\n          The System for Award Management contains data supplied by third party\r\n          information suppliers, one of which is Dun & Bradstreet. In order to\r\n          frame the terms of permissible use, these definitions are used in this\r\n          section:\r\n        </div>\r\n        <div class=\"padding-bottom-1\">Acquisition</div>\r\n        <div class=\"padding-bottom-1\">\r\n          \u2018Acquisition\u2019 as used in the term Acquisition purposes is defined in\r\n          FAR Subpart 2.1, and \"... means the acquiring by contract with\r\n          appropriated funds of supplies or services (including construction) by\r\n          and for the use of the Federal Government through purchase or lease,\r\n          whether the supplies or services are already in existence or must be\r\n          created, developed, demonstrated, and evaluated. Acquisition begins at\r\n          the point when agency needs are established and includes the\r\n          description of requirements to satisfy agency needs, solicitation and\r\n          selection of sources, award of contracts, contract financing, contract\r\n          performance, contract administration, and those technical and\r\n          management functions directly related to the process of fulfilling\r\n          agency needs by contract.\"\r\n        </div>\r\n        <div class=\"padding-bottom-1\">Federal Award</div>\r\n        <div class=\"padding-bottom-1\">\r\n          \u2018Federal Award\u2019 as used herein is defined as either a contract (an\r\n          acquisition award) or a Federal Financial Assistance Award, including\r\n          both ARRA awards and Federal Awards as defined under Federal Funding\r\n          Accountability and Transparency Act of 2006 (FFATA), 31 U.S.C. 6101,\r\n          Note \u00A72(a)(4).\r\n        </div>\r\n        <div class=\"padding-bottom-1\">Federal Award Management</div>\r\n        <div class=\"padding-bottom-1\">\r\n          \u2018Federal Award Management\u2019 as used herein is defined as the activities\r\n          supporting agency requirements for acquisition (as defined in FAR\r\n          Subpart 2.1) purposes and the parallel functions for grants and loans\r\n          awards.\r\n        </div>\r\n        <div class=\"padding-bottom-1\">Federal Financial Assistance Award</div>\r\n        <div class=\"padding-bottom-1\">\r\n          \u2018Federal Financial Assistance Award\u2019 as used herein is defined under 2\r\n          CFR 25.305 as an award of Federal financial assistance that a\r\n          non-Federal entity described in \u00A7 25.110(a) receives or administers in\r\n          the form of a grant; a cooperative agreement (which does not include a\r\n          cooperative research and development agreement pursuant to the Federal\r\n          Technology Transfer Act of 1986, as amended (15 U.S.C. 3710a)); a\r\n          loan; a loan guarantee; a subsidy; insurance; food commodities; a\r\n          direct appropriation; assessed or voluntary contributions; or any\r\n          other financial assistance transaction that authorizes the non-Federal\r\n          entity's expenditure of Federal funds, and includes Federal financial\r\n          assistance and expenditures as defined in FFATA, 31 U.S.C. 6101, Note\r\n          \u00A72(a)(4)(A).\r\n        </div>\r\n        <div class=\"padding-bottom-1\">\r\n          Limitation on Permissible Use of Dun & Bradstreet, Inc. Data\r\n        </div>\r\n        <div class=\"padding-bottom-1\">\r\n          This website has data supplied by third party information suppliers,\r\n          including Dun & Bradstreet (D&B). For the purposes of the following\r\n          limitation on permissible use of D&B data, which includes each\r\n          entity's DUNS Number and its associated business information, \"D&B\r\n          Open Data\" is defined as the following data elements: Legal Business\r\n          Name, Street Address, City Name, State/Province Name, Country Name,\r\n          County Code, State/Province Code, State/Province Abbreviation,\r\n          ZIP/Postal Code, Country Name and Country Code. Entity registration,\r\n          exclusion, or contract award records in SAM may contain D&B-supplied\r\n          data. Applicable records containing D&B data include all entity\r\n          registration records with a last updated date earlier than 4/4/2022,\r\n          all exclusions records with a created date earlier than 4/4/2022, and\r\n          all base award notices with an award date earlier than 4/4/2022. These\r\n          records show D&B as the Entity Validation Service (EVS) Source in\r\n          records with D&B data.\r\n        </div>\r\n        <div class=\"padding-bottom-1\">\r\n          D&B hereby grants you, the user, a license for a limited,\r\n          non-exclusive right to use D&B Open Data within the limitations set\r\n          forth herein. By using this website you agree that you shall not use\r\n          D&B Open Data without giving written attribution to the source of such\r\n          data (i.e., D&B) and shall not access, use or disseminate D&B Open\r\n          Data in bulk (i.e., in amounts sufficient for use as an original\r\n          source or as a substitute for the product and/or service being\r\n          licensed hereunder).\r\n        </div>\r\n        <div class=\"padding-bottom-1\">\r\n          Except for data elements identified above as D&B Open Data, under no\r\n          circumstances are you authorized to use any other D&B data for\r\n          commercial, resale or marketing purposes (e.g., identifying,\r\n          quantifying, segmenting and/or analyzing customers and prospective\r\n          customers). Systematic access (electronic harvesting) or extraction of\r\n          content from the website, including the use of \"bots\" or \"spiders,\" is\r\n          prohibited. Federal government entities are authorized to use the D&B\r\n          data for purposes of acquisition as defined in FAR 2.101 and for the\r\n          purpose of managing Federal awards, including sub-awards, or reporting\r\n          Federal award information.\r\n        </div>\r\n        <div class=\"padding-bottom-1\">\r\n          GSA assumes no liability for the use of the D&B data once it is\r\n          downloaded or accessed. D&B data is provided \"as is\" without warranty\r\n          of any kind. The D&B data is the intellectual property of D&B. In no\r\n          event will D&B or any third party information supplier be liable in\r\n          any way with regard to the use of the D&B data. For more information\r\n          about the scope of permissible use of D&B data licensed hereunder,\r\n          please contact D&B at datause_govt&#64;dnb.com.\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<!--Non-Federal Administrator Roles-->\r\n<div id=\"nonFed\">\r\n  <h2 class=\"padding-1\">Non-Federal Administrator Roles</h2>\r\n  <div class=\"plainLanguageSection border margin-1 padding-2\">\r\n    <div class=\"padding-bottom-1\">\r\n      If you have any administrator role with an entity that is not part of the\r\n      U.S. federal government, you may not assign an administrator role (for\r\n      entity registration, entity reporting, or contract opportunities) to\r\n      someone who is not directly connected to your entity like an officer,\r\n      board member, or employee.\r\n    </div>\r\n    <div class=\"padding-bottom-1\">\r\n      You may not use an Entity Administrator Appointment Letter to assign an\r\n      Entity Administrator role to someone who is not directly connected to your\r\n      entity.\r\n    </div>\r\n    <div class=\"padding-bottom-1\">\r\n      If you are not directly connected to an entity, you may not seek or accept\r\n      an administrator role for the entity. If you are not directly connected to\r\n      an entity and you have an administrator role, you may not keep it. You\r\n      must immediately contact the entity and the\r\n      <a target=\"_blank\" href=\"https://www.fsd.gov/gsafsd_sp\"\r\n        >Federal Service Desk\r\n        <span class=\"padding-right-1 usa-link--external font-body-md\"\r\n          ><span class=\"usa-sr-only\">- opens in a new window</span>\r\n        </span></a\r\n      >\r\n      and ask them to remove the role.\r\n    </div>\r\n  </div>\r\n</div>\r\n<!--Signing in to SAM.gov-->\r\n<div id=\"signing\">\r\n  <h2 class=\"padding-1\">Signing in to SAM.gov</h2>\r\n  <div class=\"plainLanguageSection border margin-1 padding-2\">\r\n    SAM.gov accounts are for individual people, not groups. Do not share email\r\n    addresses to sign in.\r\n  </div>\r\n</div>\r\n" }]
        }], ctorParameters: () => [{ type: TermsOfUseService }, { type: TermsOfUseServiceMock }, { type: i2$2.ActivatedRoute }, { type: i2$2.Router }], propDecorators: { termsOfUseConfig: [{
                type: Input,
                args: ['termsOfUseConfig']
            }], privacyEle: [{
                type: ViewChild,
                args: ['privacy']
            }], restrictedEle: [{
                type: ViewChild,
                args: ['restricted']
            }] } });
class TermsOfUseModalComponent {
    constructor(locationStrategy, data, dialogRef, dialog, cdr) {
        this.locationStrategy = locationStrategy;
        this.data = data;
        this.dialogRef = dialogRef;
        this.dialog = dialog;
        this.cdr = cdr;
        this.scrollComplete = false;
    }
    ngOnInit() {
        if (this.data.assetsUrl) {
            this.imageSource = this.locationStrategy.getBaseHref() + this.data.assetsUrl;
        }
        else {
            this.imageSource = this.locationStrategy.getBaseHref() + 'assets/img/trademark-logo-sam.svg';
        }
    }
    ngAfterViewInit() {
        this.cdr.detectChanges(); // Detect changes to ensure UI updates
    }
    onScroll(event) {
        if (event.target.offsetHeight + event.target.scrollTop >= (event.target.scrollHeight - 10)) {
            this.scrollComplete = true;
            this.cdr.detectChanges();
        }
    }
    cancel() {
        this.dialogRef.close({ "termsOfUseModalCloseStatus": TermsOfUseModalCloseStatus.CANCEL });
    }
    accept() {
        this.dialogRef.close({ "termsOfUseModalCloseStatus": TermsOfUseModalCloseStatus.ACCEPT });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: TermsOfUseModalComponent, deps: [{ token: i2.LocationStrategy }, { token: SDS_DIALOG_DATA }, { token: i1$1.SdsDialogRef }, { token: i1$1.SdsDialogService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: TermsOfUseModalComponent, selector: "terms-of-use-modal", ngImport: i0, template: "<div class=\"sds-dialog-section--centered margin-y-205\">\r\n  <img alt=\"sam logo\" [attr.src]=\"imageSource\" width=\"170\" />\r\n</div>\r\n<div\r\n  sds-dialog-content=\"\"\r\n  (scroll)=\"onScroll($event)\"\r\n  class=\"sds-dialog-content height-mobile\"\r\n>\r\n  <terms-of-use [termsOfUseConfig]=\"data\"></terms-of-use>\r\n</div>\r\n<div sds-dialog-actions class=\"sds-dialog-section--centered\">\r\n  <div class=\"text-italic margin-top-1\">\r\n    Keep your login information confidential.\r\n  </div>\r\n</div>\r\n<div class=\"sds-dialog-section--centered margin-top-2\">\r\n  <button\r\n    (click)=\"cancel()\"\r\n    class=\"usa-button usa-button--base bg-base-lighter\"\r\n  >\r\n    Cancel\r\n  </button>\r\n  <button (click)=\"accept()\" [disabled]=\"!scrollComplete\" class=\"usa-button\">\r\n    Accept\r\n  </button>\r\n</div>\r\n", dependencies: [{ kind: "component", type: TermsOfUseComponent, selector: "terms-of-use", inputs: ["termsOfUseConfig"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: TermsOfUseModalComponent, decorators: [{
            type: Component,
            args: [{ selector: "terms-of-use-modal", template: "<div class=\"sds-dialog-section--centered margin-y-205\">\r\n  <img alt=\"sam logo\" [attr.src]=\"imageSource\" width=\"170\" />\r\n</div>\r\n<div\r\n  sds-dialog-content=\"\"\r\n  (scroll)=\"onScroll($event)\"\r\n  class=\"sds-dialog-content height-mobile\"\r\n>\r\n  <terms-of-use [termsOfUseConfig]=\"data\"></terms-of-use>\r\n</div>\r\n<div sds-dialog-actions class=\"sds-dialog-section--centered\">\r\n  <div class=\"text-italic margin-top-1\">\r\n    Keep your login information confidential.\r\n  </div>\r\n</div>\r\n<div class=\"sds-dialog-section--centered margin-top-2\">\r\n  <button\r\n    (click)=\"cancel()\"\r\n    class=\"usa-button usa-button--base bg-base-lighter\"\r\n  >\r\n    Cancel\r\n  </button>\r\n  <button (click)=\"accept()\" [disabled]=\"!scrollComplete\" class=\"usa-button\">\r\n    Accept\r\n  </button>\r\n</div>\r\n" }]
        }], ctorParameters: () => [{ type: i2.LocationStrategy }, { type: termsOfUseConfig, decorators: [{
                    type: Inject,
                    args: [SDS_DIALOG_DATA]
                }] }, { type: i1$1.SdsDialogRef }, { type: i1$1.SdsDialogService }, { type: i0.ChangeDetectorRef }] });
var TermsOfUseModalCloseStatus;
(function (TermsOfUseModalCloseStatus) {
    TermsOfUseModalCloseStatus[TermsOfUseModalCloseStatus["CANCEL"] = 0] = "CANCEL";
    TermsOfUseModalCloseStatus[TermsOfUseModalCloseStatus["ACCEPT"] = 1] = "ACCEPT";
})(TermsOfUseModalCloseStatus || (TermsOfUseModalCloseStatus = {}));

class TermsOfUseModalStartService {
    constructor(dialog) {
        this.dialog = dialog;
    }
    open(data) {
        const dialog = this.dialog.open(TermsOfUseModalComponent, { width: 'medium', height: 'large', data: data });
        return dialog;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: TermsOfUseModalStartService, deps: [{ token: i1$1.SdsDialogService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: TermsOfUseModalStartService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: TermsOfUseModalStartService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1$1.SdsDialogService }] });

class TermsOfUseModule {
    static forRoot(config) {
        return {
            ngModule: TermsOfUseModule,
            providers: [
                { provide: SharedSystemConfig, useValue: config }
            ]
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: TermsOfUseModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: TermsOfUseModule, declarations: [TermsOfUseComponent, TermsOfUseModalComponent], imports: [CommonModule,
            IconModule, i1$2.NgxBootstrapIconsModule], exports: [TermsOfUseComponent,
            TermsOfUseModalComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: TermsOfUseModule, providers: [TermsOfUseService, TermsOfUseServiceMock, TermsOfUseModalStartService, AuthService], imports: [CommonModule,
            IconModule,
            NgxBootstrapIconsModule.pick({})] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: TermsOfUseModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule,
                        IconModule,
                        NgxBootstrapIconsModule.pick({})
                    ],
                    exports: [TermsOfUseComponent,
                        TermsOfUseModalComponent,],
                    declarations: [TermsOfUseComponent, TermsOfUseModalComponent,],
                    providers: [TermsOfUseService, TermsOfUseServiceMock, TermsOfUseModalStartService, AuthService]
                }]
        }] });

class UnleashModule {
    static init(config) {
        if (!isValidUrl(config.url.toString()))
            config.url = window.location.origin + config.url;
        return {
            ngModule: UnleashModule,
            providers: [
                { provide: UnleashConfigToken, useValue: config },
                {
                    provide: APP_INITIALIZER,
                    useFactory: (unleashToggleService) => () => unleashToggleService.onInitialized,
                    deps: [UnleashToggleService],
                    multi: true,
                },
            ],
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: UnleashModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: UnleashModule, imports: [CommonModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: UnleashModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: UnleashModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                }]
        }] });
const isValidUrl = (urlString) => {
    try {
        return Boolean(new URL(urlString));
    }
    catch (e) {
        return false;
    }
};

class UnleashResolver {
    constructor(unleashToggleService) {
        this.unleashToggleService = unleashToggleService;
    }
    resolve(route, state) {
        if (route.data.featureKey) {
            return this.unleashToggleService.isEnabled(route.data['featureKey']);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: UnleashResolver, deps: [{ token: UnleashToggleService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: UnleashResolver, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: UnleashResolver, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: UnleashToggleService }] });

function unleashToggleGuard() {
    return (route, state) => {
        const unleash = inject(UnleashToggleService);
        const router = inject(Router);
        const featureKey = route.data['featureKey'];
        const redirectUrl = route.data['redirectUrl'];
        const shouldBe = route.data['shouldBe'] ?? true;
        if (!featureKey) {
            return false;
        }
        if (unleash.isEnabled(featureKey) === shouldBe) {
            return true;
        }
        if (redirectUrl) {
            router.navigateByUrl(redirectUrl);
        }
        return false;
    };
}

/**
 * Generated bundle index. Do not edit.
 */

export { AgencyFilterComponent, AgencyModalComponent, AgencyPickerModalDialog, AgreementItem, ApiInterceptor, ApiNoCacheInterceptor, AttachmentPurpose, AuthErrorInterceptor, AuthInterceptor, AuthService, AuthUserService, AverageWaitTimeResponse, BubbleDirection, BubblePosition, CMSService, ContactFSDModalData, ContactFSDModalV2Data, DocumentGuidance, DocumentPurpose, DocumentsToFilesMapping, EmailAddressQueryEncoder, ErrorData, ErrorModalComponent, ErrorModelModule, EscalationReason, EscalationRequest, FSDComponentStatusModel, FSDModalCloseModel, FSDModalCloseStatus, FSDModalMode, FeatureToggleService, FeedbackService, FeedbackStatus, GenericFSDHelpModule, GenericFSDHelpService, GenericFSDHelpStandaloneModule, GenericFSDHelpV2Module, GenericFSDModalComponent, GenericFSDModalV2Component, GenericFSDStandaloneComponent, GenericFSDStandaloneModalComponent, GenericIncidentEscalationHelperService, GenericIncidentEscalationMockService, GenericIncidentEscalationService, HelpTicket, HelpTicketDocument, HelpTicketEntity, IENoCacheInterceptor, IncidentEscalationComponent, IncidentEscalationModalComponent, IncidentEscalationModel, IncidentEscalationModule, LoginModalComponent, OTPInlineComponent, OTPModalComponent, OTPModule, OTPSTATUS, OtpService, OtpServiceMock, OtpServiceStart, SdsAgencyPickerComponent, SdsAgencyPickersModule, SdsAgencySelectorComponent, SdsTextChildComponent, SdsTextComponent, SdsTextModule, SearchListField, SemDVModalComponent, SemDvModule, SessionModule, SessionService, SharedFormlyModule, SharedSystemConfig, Spotlight, SpotlightComponent, SpotlightConfiguration, SpotlightDirective, SpotlightFeedback, SpotlightModule, SpotlightPosition, SpotlightSeen, SpotlightService, SpotlightServiceMock, SuccessData$1 as SuccessData, SuccessFSDComponent, SuccessFSDDialogComponent, SuccessNavigationAction$1 as SuccessNavigationAction, SuccessNavigationButtonStyle$1 as SuccessNavigationButtonStyle, SystemAlertConfig, SystemAlertsService, SystemBusyService, SystemConfigFooter, SystemConfigHeader, TabCommunicationService, TermsOfUseComponent, TermsOfUseModalCloseStatus, TermsOfUseModalComponent, TermsOfUseModalStartService, TermsOfUseModule, TermsOfUseService, TermsOfUseServiceMock, TextBubbleComponent, TextBubbleModule, TimeWidgetModalComponent, UnleashModule, UnleashResolver, UnleashToggleService, UserAccessService, authRedirectGuard, cookies, featureToggleGuard, otpConfig, otpResult, termsOfUseConfig, unleashToggleGuard };
